import { gql } from 'apollo-angular';
import { Injectable } from '@angular/core';
import * as Apollo from 'apollo-angular';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  /**
   * The `Date` scalar type represents a Date
   * value as specified by
   * [iso8601](https://en.wikipedia.org/wiki/ISO_8601).
   */
  Date: any;
  /**
   * The `DateTime` scalar type represents a DateTime
   * value as specified by
   * [iso8601](https://en.wikipedia.org/wiki/ISO_8601).
   */
  DateTime: any;
  /**
   * Allows use of a JSON String for input / output from the GraphQL schema.
   *
   * Use of this type is *not recommended* as you lose the benefits of having a defined, static
   * schema (one of the key benefits of GraphQL).
   */
  JSONString: any;
  /**
   * The `Time` scalar type represents a Time value as
   * specified by
   * [iso8601](https://en.wikipedia.org/wiki/ISO_8601).
   */
  Time: any;
  /**
   * Leverages the internal Python implmeentation of UUID (uuid.UUID) to provide native UUID objects
   * in fields, resolvers and input.
   */
  UUID: any;
  /**
   * The upload of a file.
   *
   * Variables of this type must be set to null in mutations. They will be
   * replaced with a filename from a following multipart part containing a
   * binary file.
   *
   * See: https://github.com/jaydenseric/graphql-multipart-request-spec
   */
  UploadType: any;
};

export type ActionCategoryType = Node & {
  __typename?: 'ActionCategoryType';
  createCompletedTask: Scalars['Boolean'];
  createdAt: Scalars['DateTime'];
  createdBy: UserProfileMType;
  escalateToAssignee: Scalars['Boolean'];
  escalationMetricGroup?: Maybe<MetricGroupType>;
  /** The ID of the object. */
  id: Scalars['ID'];
  isActive: Scalars['Boolean'];
  metricgroupSet: MetricGroupTypeConnection;
  order: Scalars['Int'];
  taskCategory?: Maybe<SaCategoryType>;
  taskSet: TaskTypeConnection;
  title?: Maybe<Scalars['String']>;
};


export type ActionCategoryTypeMetricgroupSetArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type ActionCategoryTypeTaskSetArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};

export type ActionCategoryTypeConnection = {
  __typename?: 'ActionCategoryTypeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<ActionCategoryTypeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** The total count of objects in this query. */
  totalCount?: Maybe<Scalars['Int']>;
};

/** A Relay edge containing a `ActionCategoryType` and its cursor. */
export type ActionCategoryTypeEdge = {
  __typename?: 'ActionCategoryTypeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<ActionCategoryType>;
};

export type AggregatedMetricValueType = Node & {
  __typename?: 'AggregatedMetricValueType';
  candidate?: Maybe<CandidateType>;
  /** Channel used for the activity (Email or Phone) */
  channel?: Maybe<MetricValueChannel>;
  client?: Maybe<CompanyType>;
  createdAt: Scalars['DateTime'];
  createdBy?: Maybe<UserProfileMType>;
  date: Scalars['Date'];
  escalatedAt?: Maybe<Scalars['DateTime']>;
  escalatedBy?: Maybe<UserProfileMType>;
  escalatedFrom?: Maybe<DashboardType>;
  escalatedTo?: Maybe<DashboardType>;
  escalatedToDashboards: DashboardTypeConnection;
  escalations: MetricValueEscalationTypeConnection;
  goal?: Maybe<Scalars['Float']>;
  /** The ID of the object. */
  id: Scalars['ID'];
  isImportant: Scalars['Boolean'];
  /** Key to identify specific metric variant (e.g., conversion type) */
  key?: Maybe<Scalars['String']>;
  manager?: Maybe<UserProfileMType>;
  metricGroup?: Maybe<MetricGroupType>;
  metricvaluecommentSet?: Maybe<Array<Maybe<MetricValueCommentType>>>;
  nextTask?: Maybe<TaskType>;
  nextTaskId?: Maybe<Scalars['Int']>;
  nextTaskLevel2?: Maybe<TaskType>;
  nextTaskLevel2Id?: Maybe<Scalars['Int']>;
  order?: Maybe<OrderType>;
  orderId?: Maybe<Scalars['Int']>;
  regionGroup?: Maybe<RegionGroupType>;
  relatedActivity: RequestsActivityTypeConnection;
  subvalue?: Maybe<Scalars['Float']>;
  updatedAt: Scalars['DateTime'];
  value: Scalars['Float'];
  /** If true, metric is related to  Workis; LOGO will be shown on the standup board. */
  workis?: Maybe<Scalars['Boolean']>;
};


export type AggregatedMetricValueTypeEscalatedToDashboardsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type AggregatedMetricValueTypeEscalationsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type AggregatedMetricValueTypeRelatedActivityArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};

export type AssignmentTagInput = {
  comment?: InputMaybe<Scalars['String']>;
  tagId?: InputMaybe<Scalars['Int']>;
};

export type CancellationReasonAssignmentType = Node & {
  __typename?: 'CancellationReasonAssignmentType';
  cancellationReason: CancellationReasonType;
  createDate: Scalars['DateTime'];
  createdBy?: Maybe<UserProfileMType>;
  /** The ID of the object. */
  id: Scalars['ID'];
  offerProposition: OfferPropositionType;
};

export type CancellationReasonAssignmentTypeConnection = {
  __typename?: 'CancellationReasonAssignmentTypeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<CancellationReasonAssignmentTypeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `CancellationReasonAssignmentType` and its cursor. */
export type CancellationReasonAssignmentTypeEdge = {
  __typename?: 'CancellationReasonAssignmentTypeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<CancellationReasonAssignmentType>;
};

export type CancellationReasonGroupType = Node & {
  __typename?: 'CancellationReasonGroupType';
  cancellationReasons: CancellationReasonTypeConnection;
  country?: Maybe<CountryType>;
  /** The ID of the object. */
  id: Scalars['ID'];
  order: Scalars['Int'];
  title: Scalars['String'];
};


export type CancellationReasonGroupTypeCancellationReasonsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Scalars['String']>;
};

export type CancellationReasonGroupTypeConnection = {
  __typename?: 'CancellationReasonGroupTypeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<CancellationReasonGroupTypeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `CancellationReasonGroupType` and its cursor. */
export type CancellationReasonGroupTypeEdge = {
  __typename?: 'CancellationReasonGroupTypeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<CancellationReasonGroupType>;
};

export type CancellationReasonType = Node & {
  __typename?: 'CancellationReasonType';
  cancellationreasonassignmentSet: CancellationReasonAssignmentTypeConnection;
  group: CancellationReasonGroupType;
  /** The ID of the object. */
  id: Scalars['ID'];
  isActive: Scalars['Boolean'];
  offerpropositionSet: OfferPropositionTypeConnection;
  order: Scalars['Int'];
  rejectedPropositions: OfferPropositionTypeConnection;
  title: Scalars['String'];
  titleEn?: Maybe<Scalars['String']>;
};


export type CancellationReasonTypeCancellationreasonassignmentSetArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offerProposition?: InputMaybe<Scalars['ID']>;
};


export type CancellationReasonTypeOfferpropositionSetArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type CancellationReasonTypeRejectedPropositionsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};

export type CancellationReasonTypeConnection = {
  __typename?: 'CancellationReasonTypeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<CancellationReasonTypeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `CancellationReasonType` and its cursor. */
export type CancellationReasonTypeEdge = {
  __typename?: 'CancellationReasonTypeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<CancellationReasonType>;
};

export type CandidateEventType = Node & {
  __typename?: 'CandidateEventType';
  candidate: CandidateType;
  clientComment?: Maybe<Scalars['String']>;
  clientId?: Maybe<Scalars['Int']>;
  /** Field for client to enter proposed new dates and time slots (hence text) */
  clientProposedNewDatetime?: Maybe<Scalars['String']>;
  clientProposedPosition?: Maybe<Scalars['String']>;
  clientStatus?: Maybe<EventClientStatus>;
  createdAt: Scalars['DateTime'];
  createdBy?: Maybe<UserProfileMType>;
  deleted: Scalars['Boolean'];
  description?: Maybe<Scalars['String']>;
  eventType: EventEventType;
  /** The ID of the object. */
  id: Scalars['ID'];
  /** If true, the event is considered problematic and is used as flag to show in daily standups */
  isProblematicInterview: Scalars['Boolean'];
  offerPropositions: OfferPropositionTypeConnection;
  problematicInterviewBy?: Maybe<UserProfileMType>;
  relatedOffer?: Maybe<OfferPropositionType>;
  resolutionStatus?: Maybe<EventResolutionStatus>;
  source: EventSource;
  startDatetime?: Maybe<Scalars['DateTime']>;
};


export type CandidateEventTypeOfferPropositionsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};

export type CandidateEventTypeConnection = {
  __typename?: 'CandidateEventTypeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<CandidateEventTypeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `CandidateEventType` and its cursor. */
export type CandidateEventTypeEdge = {
  __typename?: 'CandidateEventTypeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<CandidateEventType>;
};

export type CandidateOrderStatsType = {
  __typename?: 'CandidateOrderStatsType';
  companyId?: Maybe<Scalars['ID']>;
  femaleCandidates?: Maybe<Scalars['Int']>;
  healthCheckPending?: Maybe<Scalars['Int']>;
  longListedLast1Day?: Maybe<Scalars['Int']>;
  longListedLast7Days?: Maybe<Scalars['Int']>;
  maleCandidates?: Maybe<Scalars['Int']>;
  offeredFromDate?: Maybe<Scalars['Int']>;
  offeredLast1Day?: Maybe<Scalars['Int']>;
  offeredLast7Days?: Maybe<Scalars['Int']>;
  orderId?: Maybe<Scalars['ID']>;
  presentedClient?: Maybe<Scalars['Int']>;
  presentedClientFailed?: Maybe<Scalars['Int']>;
  presentedClientSuccess?: Maybe<Scalars['Int']>;
  toBeEmployed?: Maybe<Scalars['Int']>;
  toBeInterviewed?: Maybe<Scalars['Int']>;
  toBeInterviewedClient?: Maybe<Scalars['Int']>;
  unknownCandidates?: Maybe<Scalars['Int']>;
};

export type CandidateRequirementsEvaluationInput = {
  description?: InputMaybe<Scalars['String']>;
  offerPropositionId: Scalars['String'];
  recordType: Scalars['String'];
  requirementId?: InputMaybe<Scalars['String']>;
};

/** An enumeration. */
export enum CandidateRequirementsEvaluationRecordType {
  /** Other info */
  OtherInfo = 'OTHER_INFO',
  /** Requirement */
  Requirement = 'REQUIREMENT',
  /** Starts working */
  StartsWorking = 'STARTS_WORKING',
  /** Work experience */
  WorkExperience = 'WORK_EXPERIENCE'
}

export type CandidateRequirementsEvaluationType = Node & {
  __typename?: 'CandidateRequirementsEvaluationType';
  createdAt: Scalars['DateTime'];
  createdBy: UserType;
  description?: Maybe<Scalars['String']>;
  /** The ID of the object. */
  id: Scalars['ID'];
  offerProposition: OfferPropositionType;
  recordType: CandidateRequirementsEvaluationRecordType;
  requirement?: Maybe<RequirementType>;
};

export type CandidateRequirementsEvaluationTypeConnection = {
  __typename?: 'CandidateRequirementsEvaluationTypeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<CandidateRequirementsEvaluationTypeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `CandidateRequirementsEvaluationType` and its cursor. */
export type CandidateRequirementsEvaluationTypeEdge = {
  __typename?: 'CandidateRequirementsEvaluationTypeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<CandidateRequirementsEvaluationType>;
};

export type CandidateStats = {
  __typename?: 'CandidateStats';
  interested?: Maybe<Scalars['Int']>;
  signed?: Maybe<Scalars['Int']>;
  total?: Maybe<Scalars['Int']>;
};

export type CandidateStatusType = Node & {
  __typename?: 'CandidateStatusType';
  candidateSet: CandidateTypeConnection;
  /** The ID of the object. */
  id: Scalars['ID'];
  key?: Maybe<Scalars['String']>;
  livasId: Scalars['Int'];
  titleEe?: Maybe<Scalars['String']>;
  titleLt?: Maybe<Scalars['String']>;
  titleLv?: Maybe<Scalars['String']>;
};


export type CandidateStatusTypeCandidateSetArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  livasId_In?: InputMaybe<Scalars['Int']>;
};

export type CandidateStatusTypeConnection = {
  __typename?: 'CandidateStatusTypeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<CandidateStatusTypeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `CandidateStatusType` and its cursor. */
export type CandidateStatusTypeEdge = {
  __typename?: 'CandidateStatusTypeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<CandidateStatusType>;
};

export type CandidateType = Node & {
  __typename?: 'CandidateType';
  country: CountryType;
  createdAt: Scalars['DateTime'];
  createdWithFunc?: Maybe<Scalars['String']>;
  employeeLivasId?: Maybe<Scalars['Int']>;
  eventSet: CandidateEventTypeConnection;
  firstName: Scalars['String'];
  /** The ID of the object. */
  id: Scalars['ID'];
  lastName: Scalars['String'];
  livasId: Scalars['Int'];
  livasStatus?: Maybe<CandidateStatusType>;
  livasStatusid?: Maybe<Scalars['Int']>;
  metricvalueSet: MetricValueTypeConnection;
  metricvaluecommentSet: MetricValueCommentTypeConnection;
  offerpropositionSet: OfferPropositionTypeConnection;
  requestsactivitySet: RequestsActivityTypeConnection;
  searchresultsSet: SearchResultsTypeConnection;
  taskSet: TaskTypeConnection;
};


export type CandidateTypeEventSetArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  deleted?: InputMaybe<Scalars['Boolean']>;
  eventType?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  startDatetime_Gte?: InputMaybe<Scalars['DateTime']>;
  startDatetime_Lte?: InputMaybe<Scalars['DateTime']>;
};


export type CandidateTypeMetricvalueSetArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  cardId?: InputMaybe<Scalars['ID']>;
  channel?: InputMaybe<Scalars['String']>;
  dashboardId?: InputMaybe<Scalars['ID']>;
  dashboardRegion?: InputMaybe<Scalars['ID']>;
  date?: InputMaybe<Scalars['Date']>;
  dateFrom?: InputMaybe<Scalars['Date']>;
  dateTo?: InputMaybe<Scalars['Date']>;
  escalatedFrom?: InputMaybe<Scalars['ID']>;
  escalatedTo?: InputMaybe<Scalars['ID']>;
  escalatedToDashboard?: InputMaybe<Scalars['ID']>;
  first?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['ID']>;
  includeEscalated?: InputMaybe<Scalars['Boolean']>;
  isImportant?: InputMaybe<Scalars['Boolean']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type CandidateTypeMetricvaluecommentSetArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type CandidateTypeOfferpropositionSetArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type CandidateTypeRequestsactivitySetArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type CandidateTypeSearchresultsSetArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  createdAt_Gte?: InputMaybe<Scalars['DateTime']>;
  createdAt_Lte?: InputMaybe<Scalars['DateTime']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  task?: InputMaybe<Scalars['ID']>;
};


export type CandidateTypeTaskSetArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};

export type CandidateTypeConnection = {
  __typename?: 'CandidateTypeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<CandidateTypeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** The total count of objects in this query. */
  totalCount?: Maybe<Scalars['Int']>;
};

/** A Relay edge containing a `CandidateType` and its cursor. */
export type CandidateTypeEdge = {
  __typename?: 'CandidateTypeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<CandidateType>;
};

/** An enumeration. */
export enum CardType {
  /** Aggregated Metric Table */
  AggregatedMetricTable = 'AGGREGATED_METRIC_TABLE',
  /** Candidate refusal table */
  CandidateRefusalTable = 'CANDIDATE_REFUSAL_TABLE',
  /** Filtered tasks table */
  ClientMeetingTasks = 'CLIENT_MEETING_TASKS',
  /** Conversion rates matrix */
  ConversionRatesMatrix = 'CONVERSION_RATES_MATRIX',
  /** Conversion rates transregional matrix */
  ConversionRatesTransregionalMatrix = 'CONVERSION_RATES_TRANSREGIONAL_MATRIX',
  /** Critical orders table */
  CriticalOrdersTable = 'CRITICAL_ORDERS_TABLE',
  /** Dynamic tasks table */
  DynamicTasksTable = 'DYNAMIC_TASKS_TABLE',
  /** Escalated Metrics */
  EscalatedMetrics = 'ESCALATED_METRICS',
  /** Interested per hour matrix */
  InterestedPerHourMatrix = 'INTERESTED_PER_HOUR_MATRIX',
  /** MetricTable */
  MetricTable = 'METRIC_TABLE',
  /** OverdueTaskTable */
  OverdueTaskTable = 'OVERDUE_TASK_TABLE',
  /** Promises to client matrix */
  PromisesToClientMatrix = 'PROMISES_TO_CLIENT_MATRIX',
  /** Region hours matrix */
  RegionHoursMatrix = 'REGION_HOURS_MATRIX',
  /** Weekly Barchart */
  WeeklyBarchart = 'WEEKLY_BARCHART'
}

export type CategoryType = {
  __typename?: 'CategoryType';
  durationMinutes?: Maybe<Scalars['Int']>;
  eventSet: EventTypeConnection;
  hint?: Maybe<Scalars['String']>;
  icon?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  key?: Maybe<Scalars['String']>;
  title: Scalars['String'];
};


export type CategoryTypeEventSetArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  date_Gte?: InputMaybe<Scalars['Date']>;
  date_Lte?: InputMaybe<Scalars['Date']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Scalars['ID']>;
};

export type CertificateType = {
  __typename?: 'CertificateType';
  country?: Maybe<CountryType>;
  id: Scalars['ID'];
  specifications: Array<SpecificationType>;
  /** Deprecated */
  title?: Maybe<Scalars['String']>;
};

export type ChangeEventStatus = {
  __typename?: 'ChangeEventStatus';
  event?: Maybe<EventType>;
  ok?: Maybe<Scalars['Boolean']>;
};

export type ChangeOrderStatus = {
  __typename?: 'ChangeOrderStatus';
  ok?: Maybe<Scalars['Boolean']>;
  order?: Maybe<OrderType>;
};

export type ChannelType = {
  __typename?: 'ChannelType';
  color?: Maybe<Scalars['String']>;
  eventSet: EventTypeConnection;
  icon?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  title: Scalars['String'];
};


export type ChannelTypeEventSetArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  date_Gte?: InputMaybe<Scalars['Date']>;
  date_Lte?: InputMaybe<Scalars['Date']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Scalars['ID']>;
};

export type CityType = Node & {
  __typename?: 'CityType';
  externalId?: Maybe<Scalars['Int']>;
  /** The ID of the object. */
  id: Scalars['ID'];
  isActive: Scalars['Boolean'];
  region?: Maybe<RegionType>;
  title: Scalars['String'];
};

export type CityTypeConnection = {
  __typename?: 'CityTypeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<CityTypeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** The total count of objects in this query. */
  totalCount?: Maybe<Scalars['Int']>;
};

/** A Relay edge containing a `CityType` and its cursor. */
export type CityTypeEdge = {
  __typename?: 'CityTypeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<CityType>;
};

export type ClientInterviewClientUpdateMutationInput = {
  clientComment?: InputMaybe<Scalars['String']>;
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** Field for client to enter proposed new dates and time slots (hence text) */
  clientProposedNewDatetime?: InputMaybe<Scalars['String']>;
  clientProposedPosition?: InputMaybe<Scalars['String']>;
  clientStatus?: InputMaybe<EventClientStatus>;
  /** The ID of the object. */
  id: Scalars['ID'];
};

export type ClientInterviewClientUpdateMutationPayload = {
  __typename?: 'ClientInterviewClientUpdateMutationPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  /** List of errors that occurred while executing the mutation. */
  errors?: Maybe<Array<MutationErrorType>>;
  /** The mutated object. */
  event?: Maybe<CandidateEventType>;
};

export type ClientInterviewCreateMutationInput = {
  agencyProcessStandart?: InputMaybe<Scalars['String']>;
  clientMutationId?: InputMaybe<Scalars['String']>;
  companyRepresentation?: InputMaybe<Scalars['String']>;
  competences1?: InputMaybe<Scalars['String']>;
  competences2?: InputMaybe<Scalars['String']>;
  order: Scalars['ID'];
  requirements?: InputMaybe<Scalars['String']>;
  selectionProcess?: InputMaybe<Scalars['String']>;
  workConditions?: InputMaybe<Scalars['String']>;
  workFunctions?: InputMaybe<Scalars['String']>;
};

export type ClientInterviewCreateMutationPayload = {
  __typename?: 'ClientInterviewCreateMutationPayload';
  /** The mutated object. */
  clientInterview?: Maybe<ClientInterviewType>;
  clientMutationId?: Maybe<Scalars['String']>;
  /** List of errors that occurred while executing the mutation. */
  errors?: Maybe<Array<MutationErrorType>>;
};

export type ClientInterviewType = Node & {
  __typename?: 'ClientInterviewType';
  agencyProcessStandart?: Maybe<Scalars['String']>;
  companyRepresentation?: Maybe<Scalars['String']>;
  competences1?: Maybe<Scalars['String']>;
  competences2?: Maybe<Scalars['String']>;
  /** The ID of the object. */
  id: Scalars['ID'];
  order: OrderType;
  requirements?: Maybe<Scalars['String']>;
  selectionProcess?: Maybe<Scalars['String']>;
  workConditions?: Maybe<Scalars['String']>;
  workFunctions?: Maybe<Scalars['String']>;
};

export type ClientInterviewUpdateMutationInput = {
  agencyProcessStandart?: InputMaybe<Scalars['String']>;
  clientMutationId?: InputMaybe<Scalars['String']>;
  companyRepresentation?: InputMaybe<Scalars['String']>;
  competences1?: InputMaybe<Scalars['String']>;
  competences2?: InputMaybe<Scalars['String']>;
  /** The ID of the object. */
  id: Scalars['ID'];
  order?: InputMaybe<Scalars['ID']>;
  requirements?: InputMaybe<Scalars['String']>;
  selectionProcess?: InputMaybe<Scalars['String']>;
  workConditions?: InputMaybe<Scalars['String']>;
  workFunctions?: InputMaybe<Scalars['String']>;
};

export type ClientInterviewUpdateMutationPayload = {
  __typename?: 'ClientInterviewUpdateMutationPayload';
  /** The mutated object. */
  clientInterview?: Maybe<ClientInterviewType>;
  clientMutationId?: Maybe<Scalars['String']>;
  /** List of errors that occurred while executing the mutation. */
  errors?: Maybe<Array<MutationErrorType>>;
};

export type CompanyHistoryType = Node & {
  __typename?: 'CompanyHistoryType';
  address?: Maybe<Scalars['String']>;
  color: HistoricalCompanyColor;
  country?: Maybe<CountryType>;
  description?: Maybe<Scalars['String']>;
  historyChangeReason?: Maybe<Scalars['String']>;
  historyDate: Scalars['DateTime'];
  historyId: Scalars['ID'];
  historyUser?: Maybe<UserType>;
  /** The ID of the object. */
  id: Scalars['ID'];
  insightlyId?: Maybe<Scalars['Int']>;
  invoiceContact?: Maybe<ContactType>;
  keyAccountManager?: Maybe<UserProfileMType>;
  legalEntityCode?: Maybe<Scalars['String']>;
  livasId?: Maybe<Scalars['Int']>;
  name: Scalars['String'];
  projectManager1?: Maybe<UserProfileMType>;
  projectManager2?: Maybe<UserProfileMType>;
  recruiter1?: Maybe<UserProfileMType>;
  recruiter2?: Maybe<UserProfileMType>;
  registrationId?: Maybe<Scalars['String']>;
  salesQuestionnaire?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  substituteManager1?: Maybe<UserProfileMType>;
  substituteManager2?: Maybe<UserProfileMType>;
  substituteRecruiter1?: Maybe<UserProfileMType>;
  substituteRecruiter2?: Maybe<UserProfileMType>;
  vatNumber?: Maybe<Scalars['String']>;
};

export type CompanyInput = {
  color?: InputMaybe<Scalars['String']>;
  companyDescription?: InputMaybe<Scalars['String']>;
  companyId?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['String']>;
  insightlyId?: InputMaybe<Scalars['Int']>;
  livasId?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  salesQuestionnaire?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
};

/** An enumeration. */
export enum CompanyLights {
  Blue = 'BLUE',
  Green = 'GREEN',
  GreenA = 'GREEN_A',
  GreenB = 'GREEN_B',
  GreenC = 'GREEN_C',
  Red = 'RED',
  Yellow = 'YELLOW'
}

export type CompanyMetricType = Node & {
  __typename?: 'CompanyMetricType';
  company: CompanyType;
  effortConversion?: Maybe<Scalars['Float']>;
  /** The ID of the object. */
  id: Scalars['ID'];
  interviewSuccessRatio?: Maybe<Scalars['Float']>;
  lifetime?: Maybe<Scalars['Int']>;
  successfulCalls?: Maybe<Scalars['Int']>;
  successfulInterviews?: Maybe<Scalars['Int']>;
  totalCalls?: Maybe<Scalars['Int']>;
  totalInverviews?: Maybe<Scalars['Int']>;
};

export type CompanyModelType = Node & {
  __typename?: 'CompanyModelType';
  address?: Maybe<Scalars['String']>;
  color: HistoricalCompanyColor;
  companymetrics?: Maybe<CompanyMetricType>;
  contactSet: ContactTypeConnection;
  contractSet: Array<ContractType>;
  country?: Maybe<CountryType>;
  description?: Maybe<Scalars['String']>;
  historyChanges?: Maybe<Array<Maybe<CompanyHistoryType>>>;
  /** The ID of the object. */
  id: Scalars['ID'];
  insightlyId?: Maybe<Scalars['Int']>;
  invoiceContact?: Maybe<ContactType>;
  keyAccountManager?: Maybe<UserProfileMType>;
  labels: LabelTypeConnection;
  legalEntityCode?: Maybe<Scalars['String']>;
  livasId?: Maybe<Scalars['Int']>;
  metricvalueSet: MetricValueTypeConnection;
  metricvaluecommentSet: MetricValueCommentTypeConnection;
  name: Scalars['String'];
  offboardingRoles: OffboardingRoleTypeConnection;
  orderSet: OrderTypeConnection;
  projectManager1?: Maybe<UserProfileMType>;
  projectManager2?: Maybe<UserProfileMType>;
  recruiter1?: Maybe<UserProfileMType>;
  recruiter2?: Maybe<UserProfileMType>;
  registrationId?: Maybe<Scalars['String']>;
  salesQuestionnaire?: Maybe<Scalars['String']>;
  specificationSet: Array<SpecificationType>;
  status?: Maybe<Scalars['String']>;
  substituteManager1?: Maybe<UserProfileMType>;
  substituteManager2?: Maybe<UserProfileMType>;
  substituteRecruiter1?: Maybe<UserProfileMType>;
  substituteRecruiter2?: Maybe<UserProfileMType>;
  taskSet: TaskTypeConnection;
  vatNumber?: Maybe<Scalars['String']>;
};


export type CompanyModelTypeContactSetArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type CompanyModelTypeLabelsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['ID']>;
  first?: InputMaybe<Scalars['Int']>;
  group_Key?: InputMaybe<Scalars['String']>;
  key?: InputMaybe<Scalars['String']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type CompanyModelTypeMetricvalueSetArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  cardId?: InputMaybe<Scalars['ID']>;
  channel?: InputMaybe<Scalars['String']>;
  dashboardId?: InputMaybe<Scalars['ID']>;
  dashboardRegion?: InputMaybe<Scalars['ID']>;
  date?: InputMaybe<Scalars['Date']>;
  dateFrom?: InputMaybe<Scalars['Date']>;
  dateTo?: InputMaybe<Scalars['Date']>;
  escalatedFrom?: InputMaybe<Scalars['ID']>;
  escalatedTo?: InputMaybe<Scalars['ID']>;
  escalatedToDashboard?: InputMaybe<Scalars['ID']>;
  first?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['ID']>;
  includeEscalated?: InputMaybe<Scalars['Boolean']>;
  isImportant?: InputMaybe<Scalars['Boolean']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type CompanyModelTypeMetricvaluecommentSetArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type CompanyModelTypeOffboardingRolesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  company?: InputMaybe<Scalars['ID']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type CompanyModelTypeOrderSetArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type CompanyModelTypeTaskSetArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};

export type CompanyModelTypeConnection = {
  __typename?: 'CompanyModelTypeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<CompanyModelTypeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `CompanyModelType` and its cursor. */
export type CompanyModelTypeEdge = {
  __typename?: 'CompanyModelTypeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<CompanyModelType>;
};

export type CompanyType = Node & {
  __typename?: 'CompanyType';
  address?: Maybe<Scalars['String']>;
  color: HistoricalCompanyColor;
  companymetrics?: Maybe<CompanyMetricType>;
  contactSet: ContactTypeConnection;
  contractSet: Array<ContractType>;
  country?: Maybe<CountryType>;
  description?: Maybe<Scalars['String']>;
  historyChanges?: Maybe<Array<Maybe<CompanyHistoryType>>>;
  /** The ID of the object. */
  id: Scalars['ID'];
  insightlyId?: Maybe<Scalars['Int']>;
  invoiceContact?: Maybe<ContactType>;
  keyAccountManager?: Maybe<UserProfileMType>;
  labels: LabelTypeConnection;
  lastColorChange?: Maybe<Scalars['DateTime']>;
  legalEntityCode?: Maybe<Scalars['String']>;
  livasId?: Maybe<Scalars['Int']>;
  metricvalueSet: MetricValueTypeConnection;
  metricvaluecommentSet: MetricValueCommentTypeConnection;
  name: Scalars['String'];
  offboardingRoles?: Maybe<Array<Maybe<OffboardingRoleType>>>;
  orderSet: OrderTypeConnection;
  projectManager1?: Maybe<UserProfileMType>;
  projectManager2?: Maybe<UserProfileMType>;
  recruiter1?: Maybe<UserProfileMType>;
  recruiter2?: Maybe<UserProfileMType>;
  registrationId?: Maybe<Scalars['String']>;
  salesQuestionnaire?: Maybe<Scalars['String']>;
  specificationSet: Array<SpecificationType>;
  status?: Maybe<Scalars['String']>;
  substituteManager1?: Maybe<UserProfileMType>;
  substituteManager2?: Maybe<UserProfileMType>;
  substituteRecruiter1?: Maybe<UserProfileMType>;
  substituteRecruiter2?: Maybe<UserProfileMType>;
  taskSet: TaskTypeConnection;
  vatNumber?: Maybe<Scalars['String']>;
};


export type CompanyTypeContactSetArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type CompanyTypeLabelsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['ID']>;
  first?: InputMaybe<Scalars['Int']>;
  group_Key?: InputMaybe<Scalars['String']>;
  key?: InputMaybe<Scalars['String']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type CompanyTypeMetricvalueSetArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  cardId?: InputMaybe<Scalars['ID']>;
  channel?: InputMaybe<Scalars['String']>;
  dashboardId?: InputMaybe<Scalars['ID']>;
  dashboardRegion?: InputMaybe<Scalars['ID']>;
  date?: InputMaybe<Scalars['Date']>;
  dateFrom?: InputMaybe<Scalars['Date']>;
  dateTo?: InputMaybe<Scalars['Date']>;
  escalatedFrom?: InputMaybe<Scalars['ID']>;
  escalatedTo?: InputMaybe<Scalars['ID']>;
  escalatedToDashboard?: InputMaybe<Scalars['ID']>;
  first?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['ID']>;
  includeEscalated?: InputMaybe<Scalars['Boolean']>;
  isImportant?: InputMaybe<Scalars['Boolean']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type CompanyTypeMetricvaluecommentSetArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type CompanyTypeOrderSetArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type CompanyTypeTaskSetArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};

export type CompanyTypeConnection = {
  __typename?: 'CompanyTypeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<CompanyTypeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** A Relay edge containing a `CompanyType` and its cursor. */
export type CompanyTypeEdge = {
  __typename?: 'CompanyTypeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<CompanyType>;
};

export type CompanyUpdateInput = {
  employerId: Scalars['Int'];
  externalCountryId: Scalars['Int'];
  externalId: Scalars['Int'];
};

export type CompetenceType = Node & {
  __typename?: 'CompetenceType';
  color?: Maybe<Scalars['String']>;
  country?: Maybe<CountryType>;
  /** The ID of the object. */
  id: Scalars['ID'];
  specificationSet: Array<SpecificationType>;
  title: Scalars['String'];
};

export type CompetenceTypeConnection = {
  __typename?: 'CompetenceTypeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<CompetenceTypeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `CompetenceType` and its cursor. */
export type CompetenceTypeEdge = {
  __typename?: 'CompetenceTypeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<CompetenceType>;
};

export type ContactInput = {
  canUseInOrder?: InputMaybe<Scalars['Boolean']>;
  comment?: InputMaybe<Scalars['String']>;
  companyId?: InputMaybe<Scalars['ID']>;
  email?: InputMaybe<Scalars['String']>;
  firstName?: InputMaybe<Scalars['String']>;
  lastName?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
};

export type ContactType = Node & {
  __typename?: 'ContactType';
  additionalOrders: OrderTypeConnection;
  canUseInOrder: Scalars['Boolean'];
  comment?: Maybe<Scalars['String']>;
  company: CompanyType;
  createdAt: Scalars['DateTime'];
  createdBy?: Maybe<UserProfileMType>;
  email?: Maybe<Scalars['String']>;
  firstName: Scalars['String'];
  /** The ID of the object. */
  id: Scalars['ID'];
  insightlyId?: Maybe<Scalars['Int']>;
  invoiceContactForCompanies: CompanyTypeConnection;
  lastName?: Maybe<Scalars['String']>;
  orderSet: OrderTypeConnection;
  phone?: Maybe<Scalars['String']>;
  requestsactivitySet: RequestsActivityTypeConnection;
  updatedAt?: Maybe<Scalars['DateTime']>;
};


export type ContactTypeAdditionalOrdersArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type ContactTypeInvoiceContactForCompaniesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type ContactTypeOrderSetArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type ContactTypeRequestsactivitySetArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};

export type ContactTypeConnection = {
  __typename?: 'ContactTypeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<ContactTypeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** The total count of objects in this query. */
  totalCount?: Maybe<Scalars['Int']>;
};

/** A Relay edge containing a `ContactType` and its cursor. */
export type ContactTypeEdge = {
  __typename?: 'ContactTypeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<ContactType>;
};

/** An enumeration. */
export enum ContractContractType {
  /** Advertisement */
  Advertisement = 'ADVERTISEMENT',
  /** Selection only */
  Selection = 'SELECTION',
  /** Temp. Staffing */
  Staffing = 'STAFFING'
}

export type ContractType = {
  __typename?: 'ContractType';
  allowedLogoUse: Scalars['Boolean'];
  company: CompanyType;
  contractType?: Maybe<ContractContractType>;
  contractor?: Maybe<ContractorType>;
  createDate: Scalars['Date'];
  id: Scalars['ID'];
  importLivasDate: Scalars['Date'];
  insightlyId?: Maybe<Scalars['Int']>;
  isSigned: Scalars['Boolean'];
  livasId?: Maybe<Scalars['Int']>;
  orderSet: OrderTypeConnection;
  updatedAt?: Maybe<Scalars['DateTime']>;
  validFromDate?: Maybe<Scalars['Date']>;
  validTillDate?: Maybe<Scalars['Date']>;
};


export type ContractTypeOrderSetArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};

export type ContractorType = Node & {
  __typename?: 'ContractorType';
  address?: Maybe<Scalars['String']>;
  contractSet: Array<ContractType>;
  country?: Maybe<CountryType>;
  createDate: Scalars['DateTime'];
  externalId: Scalars['Int'];
  /** The ID of the object. */
  id: Scalars['ID'];
  infoEmail?: Maybe<Scalars['String']>;
  invoiceEmail?: Maybe<Scalars['String']>;
  legalEntityCode?: Maybe<Scalars['String']>;
  livasUrl?: Maybe<Scalars['String']>;
  logo?: Maybe<Scalars['String']>;
  logoUrl?: Maybe<Scalars['String']>;
  title: Scalars['String'];
  vatCode?: Maybe<Scalars['String']>;
};

export type ContractorTypeConnection = {
  __typename?: 'ContractorTypeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<ContractorTypeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `ContractorType` and its cursor. */
export type ContractorTypeEdge = {
  __typename?: 'ContractorTypeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<ContractorType>;
};

/** Type for transregional conversion rates matrix data */
export type ConversionRatesTransregionalType = {
  __typename?: 'ConversionRatesTransregionalType';
  conversionType?: Maybe<Scalars['String']>;
  ordersBelowAverageCount?: Maybe<Scalars['Int']>;
  regionAverage?: Maybe<Scalars['Float']>;
  regionGroup?: Maybe<RegionGroupType>;
  regionGroupId?: Maybe<Scalars['ID']>;
};

export type CopySpecification = {
  __typename?: 'CopySpecification';
  ok?: Maybe<Scalars['Boolean']>;
  specification?: Maybe<SpecificationType>;
};

export enum CountryEnum {
  Ee = 'EE',
  Lt = 'LT',
  Lv = 'LV'
}

export type CountryType = Node & {
  __typename?: 'CountryType';
  cancellationreasongroupSet: CancellationReasonGroupTypeConnection;
  candidateSet: CandidateTypeConnection;
  certificateSet: Array<CertificateType>;
  companySet: CompanyTypeConnection;
  competenceSet: CompetenceTypeConnection;
  contractorSet: ContractorTypeConnection;
  eventSet: EventTypeConnection;
  /** The ID of the object. */
  id: Scalars['ID'];
  /** ISO-3166 */
  isoCode?: Maybe<Scalars['String']>;
  labelgroupSet: LabelGroupTypeConnection;
  /** ISO-639-1 */
  languageIsoCode?: Maybe<Scalars['String']>;
  medicalfactorSet: Array<RiskFactorType>;
  personalprotectiveequipmentSet: Array<PersonalProtectiveEquipmentType>;
  reasonsgroupSet: ReasonsGroupTypeConnection;
  regionSet: Array<RegionType>;
  requestsactivitySet: RequestsActivityTypeConnection;
  requirementSet: Array<RequirementType>;
  sacategorygroupSet: SaCategoryGroupTypeConnection;
  scheduletypeSet: Array<ScheduleTypeType>;
  taggroupSet: Array<TagGroupType>;
  taskSet: TaskTypeConnection;
  title: Scalars['String'];
};


export type CountryTypeCancellationreasongroupSetArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['ID']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Scalars['String']>;
};


export type CountryTypeCandidateSetArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  livasId_In?: InputMaybe<Scalars['Int']>;
};


export type CountryTypeCompanySetArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type CountryTypeCompetenceSetArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['ID']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type CountryTypeContractorSetArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['ID']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type CountryTypeEventSetArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  date_Gte?: InputMaybe<Scalars['Date']>;
  date_Lte?: InputMaybe<Scalars['Date']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Scalars['ID']>;
};


export type CountryTypeLabelgroupSetArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type CountryTypeReasonsgroupSetArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type CountryTypeRequestsactivitySetArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type CountryTypeSacategorygroupSetArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['ID']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  createdBy?: InputMaybe<Scalars['ID']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  title?: InputMaybe<Scalars['String']>;
};


export type CountryTypeTaskSetArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};

export type CountryTypeConnection = {
  __typename?: 'CountryTypeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<CountryTypeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** The total count of objects in this query. */
  totalCount?: Maybe<Scalars['Int']>;
};

/** A Relay edge containing a `CountryType` and its cursor. */
export type CountryTypeEdge = {
  __typename?: 'CountryTypeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<CountryType>;
};

export type CreateCancellationReasonAssignmentMutation = {
  __typename?: 'CreateCancellationReasonAssignmentMutation';
  ok?: Maybe<Scalars['Boolean']>;
};

export type CreateCompany = {
  __typename?: 'CreateCompany';
  company?: Maybe<CompanyType>;
  ok?: Maybe<Scalars['Boolean']>;
};

export type CreateContact = {
  __typename?: 'CreateContact';
  contact?: Maybe<ContactType>;
  ok?: Maybe<Scalars['Boolean']>;
};

export type CreateCustomLinkInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  createdBy?: InputMaybe<Scalars['ID']>;
  dashboard: Scalars['ID'];
  title: Scalars['String'];
  url: Scalars['String'];
};

export type CreateCustomLinkPayload = {
  __typename?: 'CreateCustomLinkPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  /** The mutated object. */
  customLink?: Maybe<CustomLinkType>;
  /** List of errors that occurred while executing the mutation. */
  errors?: Maybe<Array<MutationErrorType>>;
};

export type CreateDocumentMutationInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  confirmationMethod: DocumentConfirmationMethod;
  documentDate?: InputMaybe<Scalars['Date']>;
  order: Scalars['ID'];
  orderPeriods: Array<InputMaybe<Scalars['ID']>>;
};

export type CreateDocumentMutationPayload = {
  __typename?: 'CreateDocumentMutationPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  /** The mutated object. */
  document?: Maybe<DocumentType>;
  /** List of errors that occurred while executing the mutation. */
  errors?: Maybe<Array<MutationErrorType>>;
};

export type CreateJobAdLivas = {
  __typename?: 'CreateJobAdLivas';
  response?: Maybe<Scalars['JSONString']>;
};

export type CreateMetricValueCommentInput = {
  candidates?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  clientMutationId?: InputMaybe<Scalars['String']>;
  clients?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  comment?: InputMaybe<Scalars['String']>;
  metricClientReason?: InputMaybe<Scalars['ID']>;
  metricValue: Scalars['ID'];
};

export type CreateMetricValueCommentPayload = {
  __typename?: 'CreateMetricValueCommentPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  /** List of errors that occurred while executing the mutation. */
  errors?: Maybe<Array<MutationErrorType>>;
  /** The mutated object. */
  metricValueComment?: Maybe<MetricValueCommentType>;
};

export type CreateMetricValueInput = {
  candidate?: InputMaybe<Scalars['ID']>;
  /** Channel used for the activity (Email or Phone) */
  channel?: InputMaybe<MetricValueChannel>;
  client?: InputMaybe<Scalars['ID']>;
  clientMutationId?: InputMaybe<Scalars['String']>;
  createdBy?: InputMaybe<Scalars['ID']>;
  date: Scalars['Date'];
  escalatedAt?: InputMaybe<Scalars['DateTime']>;
  escalatedBy?: InputMaybe<Scalars['ID']>;
  escalatedFrom?: InputMaybe<Scalars['ID']>;
  escalatedTo?: InputMaybe<Scalars['ID']>;
  escalatedToDashboards?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  goal?: InputMaybe<Scalars['Float']>;
  isImportant: Scalars['Boolean'];
  /** Key to identify specific metric variant (e.g., conversion type) */
  key?: InputMaybe<Scalars['String']>;
  manager?: InputMaybe<Scalars['ID']>;
  metricGroup: Scalars['ID'];
  nextTask?: InputMaybe<Scalars['ID']>;
  nextTaskLevel2?: InputMaybe<Scalars['ID']>;
  order?: InputMaybe<Scalars['ID']>;
  regionGroup?: InputMaybe<Scalars['ID']>;
  relatedActivity?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  relatedObjects?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  subvalue?: InputMaybe<Scalars['Float']>;
  value: Scalars['Float'];
  /** If true, metric is related to  Workis; LOGO will be shown on the standup board. */
  workis?: InputMaybe<Scalars['Boolean']>;
};

export type CreateMetricValuePayload = {
  __typename?: 'CreateMetricValuePayload';
  clientMutationId?: Maybe<Scalars['String']>;
  /** List of errors that occurred while executing the mutation. */
  errors?: Maybe<Array<MutationErrorType>>;
  /** The mutated object. */
  metricValue?: Maybe<MetricValueType>;
};

export type CreateOffboardingRole = {
  __typename?: 'CreateOffboardingRole';
  offboardingRole?: Maybe<OffboardingRoleType>;
  ok?: Maybe<Scalars['Boolean']>;
};

export type CreateOfferPropositionCommentInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  createdBy?: InputMaybe<Scalars['ID']>;
  livasId?: InputMaybe<Scalars['Int']>;
  offerProposition: Scalars['ID'];
  text?: InputMaybe<Scalars['String']>;
};

export type CreateOfferPropositionCommentPayload = {
  __typename?: 'CreateOfferPropositionCommentPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  /** List of errors that occurred while executing the mutation. */
  errors?: Maybe<Array<MutationErrorType>>;
  /** The mutated object. */
  offerPropositionComment?: Maybe<OfferPropositionCommentType>;
};

export type CreateOperationsTaskInput = {
  /** Users assigned to this task. Migrate from completed_by */
  assignees?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  candidate?: InputMaybe<Scalars['ID']>;
  /** Employee Livas ID to find or associate a candidate */
  candidateLivasEmployeeId?: InputMaybe<Scalars['ID']>;
  category?: InputMaybe<Scalars['ID']>;
  clientMutationId?: InputMaybe<Scalars['String']>;
  comment: Scalars['String'];
  company?: InputMaybe<Scalars['ID']>;
  completedAt?: InputMaybe<Scalars['DateTime']>;
  completedBy?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  country?: InputMaybe<Scalars['ID']>;
  createdBy?: InputMaybe<Scalars['ID']>;
  createdBySchedule?: InputMaybe<Scalars['ID']>;
  dashboard?: InputMaybe<Scalars['ID']>;
  dashboards?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  date: Scalars['Date'];
  deleted?: InputMaybe<Scalars['DateTime']>;
  durationMinutes?: InputMaybe<Scalars['Int']>;
  isImportant?: InputMaybe<Scalars['Boolean']>;
  key?: InputMaybe<Scalars['String']>;
  lastOverdueUpdate?: InputMaybe<Scalars['Date']>;
  /** Set list of metric values */
  metricvalueLevel2?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Set list of metric values */
  metricvalueSet?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  nextActionCategory?: InputMaybe<Scalars['ID']>;
  nextActionDate?: InputMaybe<Scalars['Date']>;
  nextTaskAssignee?: InputMaybe<Scalars['ID']>;
  numPreviousTasks?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Scalars['ID']>;
  overdueCount?: InputMaybe<Scalars['Int']>;
  parentTask?: InputMaybe<Scalars['ID']>;
  result?: InputMaybe<Scalars['String']>;
  searchResults?: InputMaybe<Scalars['ID']>;
  /** Set list of selection action completions */
  selectionactioncompletionSet?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  sendNotificationToAssignee?: InputMaybe<Scalars['Boolean']>;
  status?: InputMaybe<TaskStatus>;
  /** Set list of tasks */
  taskSet?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
};

export type CreateOperationsTaskPayload = {
  __typename?: 'CreateOperationsTaskPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  /** List of errors that occurred while executing the mutation. */
  errors?: Maybe<Array<MutationErrorType>>;
  /** The mutated object. */
  task?: Maybe<TaskType>;
};

export type CreateOrder = {
  __typename?: 'CreateOrder';
  ok?: Maybe<Scalars['Boolean']>;
  order?: Maybe<OrderType>;
};

export type CreateOrderClientContactedMutationInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  date: Scalars['Date'];
  order: Scalars['ID'];
};

export type CreateOrderClientContactedMutationPayload = {
  __typename?: 'CreateOrderClientContactedMutationPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  /** List of errors that occurred while executing the mutation. */
  errors?: Maybe<Array<MutationErrorType>>;
  /** The mutated object. */
  orderClientContacted?: Maybe<OrderClientContactedType>;
};

export type CreateOrderCommentInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  comment?: InputMaybe<Scalars['String']>;
  order: Scalars['ID'];
};

export type CreateOrderCommentPayload = {
  __typename?: 'CreateOrderCommentPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  /** List of errors that occurred while executing the mutation. */
  errors?: Maybe<Array<MutationErrorType>>;
  /** The mutated object. */
  orderComment?: Maybe<OrderCommentType>;
};

export type CreateOrderErrorInput = {
  assignedTo?: InputMaybe<Scalars['ID']>;
  category: Scalars['ID'];
  clientMutationId?: InputMaybe<Scalars['String']>;
  comment: Scalars['String'];
  createdBy?: InputMaybe<Scalars['ID']>;
  order: Scalars['ID'];
};

export type CreateOrderErrorPayload = {
  __typename?: 'CreateOrderErrorPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  /** List of errors that occurred while executing the mutation. */
  errors?: Maybe<Array<MutationErrorType>>;
  /** The mutated object. */
  orderError?: Maybe<OrderErrorType>;
};

export type CreateOrderModelMutationInput = {
  additionalClientContacts?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  additionalRegions?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  adsIds?: InputMaybe<Array<Scalars['Int']>>;
  biuroSignee?: InputMaybe<Scalars['ID']>;
  canGetBonuses?: InputMaybe<Scalars['Boolean']>;
  canIncreaseSalary?: InputMaybe<Scalars['Boolean']>;
  cancellationPeriod?: InputMaybe<Scalars['Int']>;
  candidatesToBeProvided?: InputMaybe<Scalars['String']>;
  clientContact: Scalars['ID'];
  clientMutationId?: InputMaybe<Scalars['String']>;
  company: Scalars['ID'];
  compensationForRecruitment: Scalars['String'];
  confirmed?: InputMaybe<Scalars['Boolean']>;
  confirmedDatetime?: InputMaybe<Scalars['DateTime']>;
  contract?: InputMaybe<Scalars['ID']>;
  createdBy?: InputMaybe<Scalars['ID']>;
  createdDate?: InputMaybe<Scalars['DateTime']>;
  createdFromBlank?: InputMaybe<Scalars['Boolean']>;
  demand?: InputMaybe<Scalars['Int']>;
  displayPlannedTermForProvision?: InputMaybe<Scalars['Boolean']>;
  /** Set list of events */
  eventSet?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Field for freetext requirements to be included in document instead of selecting from the list */
  exportFreetextRequirements?: InputMaybe<Scalars['Boolean']>;
  generatedDocument?: InputMaybe<Scalars['UploadType']>;
  hourRateBruttoPermanent?: InputMaybe<Scalars['Float']>;
  hourRateBruttoTrial?: InputMaybe<Scalars['Float']>;
  hourRateNettoPermanent?: InputMaybe<Scalars['Float']>;
  hourRateNettoTrial?: InputMaybe<Scalars['Float']>;
  /** Information about indefinite/long-term orders */
  indefiniteOrderInfo?: InputMaybe<Scalars['String']>;
  insightlyId?: InputMaybe<Scalars['Int']>;
  isCompanyInternational?: InputMaybe<Scalars['Boolean']>;
  isCompanyModern?: InputMaybe<Scalars['Boolean']>;
  isLogoPublicAllowed?: InputMaybe<Scalars['Boolean']>;
  /** Set list of job ad for costss */
  jobadforcostsSet?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  language: OrderLanguage;
  lastReviewed?: InputMaybe<Scalars['DateTime']>;
  /** Set list of metric values */
  metricvalueSet?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  minVsdfPayment?: InputMaybe<Scalars['String']>;
  nettoFrom?: InputMaybe<Scalars['Int']>;
  nettoTo?: InputMaybe<Scalars['Int']>;
  /** Offboarding roles/checklists to use when this order/contract is terminated */
  offboardingRoles?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Set list of operations tasks */
  operationstaskSet?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  opportunityToEmployDirectly?: InputMaybe<Scalars['Boolean']>;
  orderCanBeExtended?: InputMaybe<Scalars['Boolean']>;
  orderCanBeExtendedComment?: InputMaybe<Scalars['String']>;
  orderDate?: InputMaybe<Scalars['Date']>;
  orderNumber?: InputMaybe<Scalars['String']>;
  orderPeriodFromBackup?: InputMaybe<Scalars['Date']>;
  orderPeriodToBackup?: InputMaybe<Scalars['Date']>;
  orderType: OrderOrderType;
  otherInfo?: InputMaybe<Scalars['String']>;
  passCommentToOrder?: InputMaybe<Scalars['Boolean']>;
  periodMonths?: InputMaybe<Scalars['Int']>;
  plannedCandidateNumber?: InputMaybe<Scalars['Int']>;
  plannedTermForProvision?: InputMaybe<Scalars['String']>;
  priority?: InputMaybe<OrderPriority>;
  projectManager?: InputMaybe<Scalars['ID']>;
  provisionOfInformationOnConclusion?: InputMaybe<Scalars['String']>;
  qualification: OrderQualification;
  recruiter?: InputMaybe<Scalars['ID']>;
  /** Saved by user. Based on this data Metric value is calculated. Calculations will be done starting to count from order period from date */
  recruitmentProgressReportFrequency?: InputMaybe<OrderRecruitmentProgressReportFrequency>;
  region?: InputMaybe<Scalars['ID']>;
  rejectedDatetime?: InputMaybe<Scalars['DateTime']>;
  remunerationAmount?: InputMaybe<Scalars['String']>;
  /** The date from which the reporting frequency should take effect */
  reportingFrequencyStartDate?: InputMaybe<Scalars['Date']>;
  salaryInfo?: InputMaybe<Scalars['String']>;
  sent?: InputMaybe<Scalars['Boolean']>;
  sentDatetime?: InputMaybe<Scalars['DateTime']>;
  shortage: Scalars['Int'];
  specification?: InputMaybe<Scalars['ID']>;
  status?: InputMaybe<OrderStatus>;
  subtype: OrderSubtype;
  /** Set list of tasks */
  taskSet?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** By marketing division */
  toBeReviewed?: InputMaybe<Scalars['Boolean']>;
  token?: InputMaybe<Scalars['UUID']>;
  trafficGeneration: OrderTrafficGeneration;
  warrantyPeriod?: InputMaybe<Scalars['String']>;
  workTimeRegistrationSystem?: InputMaybe<Scalars['String']>;
  workisMarketing?: InputMaybe<Scalars['Boolean']>;
  workwearIssuedBy: OrderWorkwearIssuedBy;
};

export type CreateOrderModelMutationPayload = {
  __typename?: 'CreateOrderModelMutationPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  /** List of errors that occurred while executing the mutation. */
  errors?: Maybe<Array<MutationErrorType>>;
  /** The mutated object. */
  order?: Maybe<OrderType>;
};

export type CreateRequestsActivityInput = {
  channel: RequestsActivityChannel;
  clientContact?: InputMaybe<Scalars['ID']>;
  clientMutationId?: InputMaybe<Scalars['String']>;
  comment?: InputMaybe<Scalars['String']>;
  contact?: InputMaybe<Scalars['ID']>;
  country?: InputMaybe<Scalars['String']>;
  delegateTo?: InputMaybe<Scalars['ID']>;
  /** If true, task will be created as if selecting Do Nothing option during standup */
  doNothing: Scalars['Boolean'];
  email?: InputMaybe<Scalars['String']>;
  firstName?: InputMaybe<Scalars['String']>;
  lastName?: InputMaybe<Scalars['String']>;
  livasCandidateId?: InputMaybe<Scalars['Int']>;
  livasEmployeeId?: InputMaybe<Scalars['Int']>;
  phone?: InputMaybe<Scalars['String']>;
  reason: Scalars['ID'];
  /** If true, request is related to  Workis */
  workis?: InputMaybe<Scalars['Boolean']>;
};

export type CreateRequestsActivityPayload = {
  __typename?: 'CreateRequestsActivityPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  /** List of errors that occurred while executing the mutation. */
  errors?: Maybe<Array<MutationErrorType>>;
  /** The mutated object. */
  requestsActivity?: Maybe<RequestsActivityType>;
};

export type CreateRequirement = {
  __typename?: 'CreateRequirement';
  requirement?: Maybe<RequirementType>;
};

export type CreateScheduleInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** Day of the month for monthly tasks (1-31) */
  dayOfMonth?: InputMaybe<Scalars['Int']>;
  dayOfWeek?: InputMaybe<Scalars['Int']>;
  endDate?: InputMaybe<Scalars['Date']>;
  /** Set list of events */
  eventSet?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Task should be repeated every x days/weeks/months */
  intervalCount?: InputMaybe<Scalars['Int']>;
  monthInterval?: InputMaybe<Scalars['Int']>;
  /** Set list of operations tasks */
  operationstaskSet?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  parentTask: Scalars['ID'];
  recurrencePeriod: ScheduleRecurrencePeriod;
  repeatAfterXDays?: InputMaybe<Scalars['Int']>;
  /** Set list of tasks */
  taskSet?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  weekOfMonth?: InputMaybe<Scalars['Int']>;
};

export type CreateSchedulePayload = {
  __typename?: 'CreateSchedulePayload';
  clientMutationId?: Maybe<Scalars['String']>;
  /** List of errors that occurred while executing the mutation. */
  errors?: Maybe<Array<MutationErrorType>>;
  /** The mutated object. */
  schedule?: Maybe<ScheduleType>;
};

export type CreateSelectionActionInput = {
  /** Users assigned to this task. Migrate from completed_by */
  assignees?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  candidate?: InputMaybe<Scalars['ID']>;
  category?: InputMaybe<Scalars['ID']>;
  clientMutationId?: InputMaybe<Scalars['String']>;
  comment: Scalars['String'];
  company?: InputMaybe<Scalars['ID']>;
  completedAt?: InputMaybe<Scalars['DateTime']>;
  completedBy?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  country?: InputMaybe<Scalars['ID']>;
  createdBy?: InputMaybe<Scalars['ID']>;
  createdBySchedule?: InputMaybe<Scalars['ID']>;
  dashboard?: InputMaybe<Scalars['ID']>;
  dashboards?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  date: Scalars['Date'];
  deleted?: InputMaybe<Scalars['DateTime']>;
  durationMinutes?: InputMaybe<Scalars['Int']>;
  isImportant?: InputMaybe<Scalars['Boolean']>;
  key?: InputMaybe<Scalars['String']>;
  lastOverdueUpdate?: InputMaybe<Scalars['Date']>;
  /** Set list of metric values */
  metricvalueLevel2?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Set list of metric values */
  metricvalueSet?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  nextActionCategory?: InputMaybe<Scalars['ID']>;
  nextActionDate?: InputMaybe<Scalars['Date']>;
  nextTaskAssignee?: InputMaybe<Scalars['ID']>;
  numPreviousTasks?: InputMaybe<Scalars['Int']>;
  order: Scalars['ID'];
  overdueCount?: InputMaybe<Scalars['Int']>;
  parentTask?: InputMaybe<Scalars['ID']>;
  result?: InputMaybe<Scalars['String']>;
  searchResults?: InputMaybe<Scalars['ID']>;
  /** Set list of selection action completions */
  selectionactioncompletionSet?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  sendNotificationToAssignee?: InputMaybe<Scalars['Boolean']>;
  status?: InputMaybe<TaskStatus>;
  /** Set list of tasks */
  taskSet?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
};

export type CreateSelectionActionPayload = {
  __typename?: 'CreateSelectionActionPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  /** List of errors that occurred while executing the mutation. */
  errors?: Maybe<Array<MutationErrorType>>;
  /** The mutated object. */
  task?: Maybe<TaskType>;
};

export type CreateSpecification = {
  __typename?: 'CreateSpecification';
  specification?: Maybe<SpecificationType>;
};

export type CreateTaskCopyInput = {
  /** Users assigned to this task. Migrate from completed_by */
  assignees?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  candidate?: InputMaybe<Scalars['ID']>;
  category?: InputMaybe<Scalars['ID']>;
  clientMutationId?: InputMaybe<Scalars['String']>;
  comment?: InputMaybe<Scalars['String']>;
  company?: InputMaybe<Scalars['ID']>;
  completedAt?: InputMaybe<Scalars['DateTime']>;
  completedBy?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  country?: InputMaybe<Scalars['ID']>;
  createdBy?: InputMaybe<Scalars['ID']>;
  createdBySchedule?: InputMaybe<Scalars['ID']>;
  dashboard?: InputMaybe<Scalars['ID']>;
  dashboards?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  date?: InputMaybe<Scalars['Date']>;
  deleted?: InputMaybe<Scalars['DateTime']>;
  durationMinutes?: InputMaybe<Scalars['Int']>;
  /** The ID of the object. */
  id: Scalars['ID'];
  isImportant?: InputMaybe<Scalars['Boolean']>;
  key?: InputMaybe<Scalars['String']>;
  lastOverdueUpdate?: InputMaybe<Scalars['Date']>;
  /** Set list of metric values */
  metricvalueLevel2?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Set list of metric values */
  metricvalueSet?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  nextActionCategory?: InputMaybe<Scalars['ID']>;
  nextActionDate?: InputMaybe<Scalars['Date']>;
  nextTaskAssignee?: InputMaybe<Scalars['ID']>;
  numPreviousTasks?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Scalars['ID']>;
  overdueCount?: InputMaybe<Scalars['Int']>;
  parentTask?: InputMaybe<Scalars['ID']>;
  result?: InputMaybe<Scalars['String']>;
  searchResults?: InputMaybe<Scalars['ID']>;
  /** Set list of selection action completions */
  selectionactioncompletionSet?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  sendNotificationToAssignee?: InputMaybe<Scalars['Boolean']>;
  status?: InputMaybe<TaskStatus>;
  /** Set list of tasks */
  taskSet?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
};

export type CreateTaskCopyPayload = {
  __typename?: 'CreateTaskCopyPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  /** List of errors that occurred while executing the mutation. */
  errors?: Maybe<Array<MutationErrorType>>;
  /** The mutated object. */
  task?: Maybe<TaskType>;
};

export type CreateUpdateCustomFieldValuesMutation = {
  __typename?: 'CreateUpdateCustomFieldValuesMutation';
  customFieldValues?: Maybe<Array<Maybe<CustomFieldValueType>>>;
};

/** An enumeration. */
export enum CustomFieldDefinitionFieldType {
  /** Boolean */
  Boolean = 'BOOLEAN',
  /** Date */
  Date = 'DATE',
  /** Hyperlink */
  Heperlink = 'HEPERLINK',
  /** Numeric */
  Numeric = 'NUMERIC',
  /** Numeric and Text */
  NumericText = 'NUMERIC_TEXT',
  /** Rating with Comment */
  RatingWithComment = 'RATING_WITH_COMMENT',
  /** Single Select */
  SingleSelect = 'SINGLE_SELECT',
  /** Text */
  Text = 'TEXT'
}

export type CustomFieldDefinitionType = Node & {
  __typename?: 'CustomFieldDefinitionType';
  fieldType: CustomFieldDefinitionFieldType;
  /** The ID of the object. */
  id: Scalars['ID'];
  name: Scalars['String'];
};

export type CustomFieldType = Node & {
  __typename?: 'CustomFieldType';
  fieldType: CustomFieldDefinitionType;
  hintText?: Maybe<Scalars['String']>;
  /** The ID of the object. */
  id: Scalars['ID'];
  key?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  /** Used for Single Select fields only.  JSON array of options. Each option must have id and name fields.  Example: [{"id": 1, "name": "Option 1"}, {"id": 2, "name": "Option 2"}] */
  options?: Maybe<Scalars['JSONString']>;
};

export type CustomFieldTypeConnection = {
  __typename?: 'CustomFieldTypeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<CustomFieldTypeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** The total count of objects in this query. */
  totalCount?: Maybe<Scalars['Int']>;
};

/** A Relay edge containing a `CustomFieldType` and its cursor. */
export type CustomFieldTypeEdge = {
  __typename?: 'CustomFieldTypeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<CustomFieldType>;
};

export type CustomFieldValueInput = {
  boolValue?: InputMaybe<Scalars['Boolean']>;
  customFieldId: Scalars['ID'];
  dateValue?: InputMaybe<Scalars['Date']>;
  numericValue?: InputMaybe<Scalars['Float']>;
  textValue?: InputMaybe<Scalars['String']>;
  urlValue?: InputMaybe<Scalars['String']>;
};

export type CustomFieldValueType = Node & {
  __typename?: 'CustomFieldValueType';
  boolValue?: Maybe<Scalars['Boolean']>;
  createdAt: Scalars['DateTime'];
  createdBy?: Maybe<UserProfileMType>;
  customField: CustomFieldType;
  dateValue?: Maybe<Scalars['Date']>;
  /** The ID of the object. */
  id: Scalars['ID'];
  numericValue?: Maybe<Scalars['Float']>;
  task: TaskType;
  textValue?: Maybe<Scalars['String']>;
  /** Used for Hyperlink fields only.  This is the value that will be used to replace {{@value}} in the base URL. */
  urlValue?: Maybe<Scalars['String']>;
};

export type CustomFieldValueTypeConnection = {
  __typename?: 'CustomFieldValueTypeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<CustomFieldValueTypeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** The total count of objects in this query. */
  totalCount?: Maybe<Scalars['Int']>;
};

/** A Relay edge containing a `CustomFieldValueType` and its cursor. */
export type CustomFieldValueTypeEdge = {
  __typename?: 'CustomFieldValueTypeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<CustomFieldValueType>;
};

export type CustomLinkType = Node & {
  __typename?: 'CustomLinkType';
  createdAt: Scalars['DateTime'];
  createdBy?: Maybe<UserProfileMType>;
  dashboard: DashboardType;
  /** The ID of the object. */
  id: Scalars['ID'];
  title: Scalars['String'];
  updatedAt: Scalars['DateTime'];
  url: Scalars['String'];
};

export type CustomLinkTypeConnection = {
  __typename?: 'CustomLinkTypeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<CustomLinkTypeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** The total count of objects in this query. */
  totalCount?: Maybe<Scalars['Int']>;
};

/** A Relay edge containing a `CustomLinkType` and its cursor. */
export type CustomLinkTypeEdge = {
  __typename?: 'CustomLinkTypeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<CustomLinkType>;
};

export type DailyDashboardCardOrderedConnection = {
  __typename?: 'DailyDashboardCardOrderedConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<DailyDashboardCardOrderedEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `DailyDashboardCardOrdered` and its cursor. */
export type DailyDashboardCardOrderedEdge = {
  __typename?: 'DailyDashboardCardOrderedEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<DailyDashboardCardType>;
};

export type DailyDashboardCardType = Node & {
  __typename?: 'DailyDashboardCardType';
  /** Additional filters for the table. Used for dynamic tasks table. Eaxmple {"custom_fields": [{"meeting_goal":"1"}]} */
  additionalFilters?: Maybe<Scalars['JSONString']>;
  /** If true, this card should return data from all dashboards. */
  allDashboards: Scalars['Boolean'];
  createdAt: Scalars['DateTime'];
  dashboardcardSet: DashboardCardTypeConnection;
  dashboards: DashboardTypeConnection;
  description: Scalars['String'];
  /** Columns to display in the table. Used for dynamic tasks table. Full list ["orders", "next_action", "metric_value", "reasons_with_comments", "candidate"] */
  displayColumns?: Maybe<Scalars['JSONString']>;
  escalatedFromDashboard?: Maybe<DashboardType>;
  excludeTaskCategoriesKeys?: Maybe<Scalars['String']>;
  excludeTaskStatuses?: Maybe<Scalars['String']>;
  filterTaskCategoriesKeys?: Maybe<Scalars['String']>;
  /** The ID of the object. */
  id: Scalars['ID'];
  /** Include child tasks in the table from related Dashboards. Should be users for 2nd lvl dashboards. */
  includeFromChildDashboards: Scalars['Boolean'];
  /** Number of days to look forward for tasks: filters tasks that are due in no more than the next X days */
  lookForwardDays?: Maybe<Scalars['Int']>;
  metricGroups: MetricGroupTypeConnection;
  metricgroupassignmentSet: MetricGroupAssignmentTypeConnection;
  title: Scalars['String'];
  type: CardType;
  updatedAt: Scalars['DateTime'];
};


export type DailyDashboardCardTypeDashboardcardSetArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type DailyDashboardCardTypeDashboardsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type DailyDashboardCardTypeMetricGroupsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type DailyDashboardCardTypeMetricgroupassignmentSetArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};

export type DailyDashboardCardTypeConnection = {
  __typename?: 'DailyDashboardCardTypeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<DailyDashboardCardTypeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** The total count of objects in this query. */
  totalCount?: Maybe<Scalars['Int']>;
};

/** A Relay edge containing a `DailyDashboardCardType` and its cursor. */
export type DailyDashboardCardTypeEdge = {
  __typename?: 'DailyDashboardCardTypeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<DailyDashboardCardType>;
};

/** An enumeration. */
export enum DashboardCardScopeMode {
  /** Region scope */
  Region = 'REGION'
}

export type DashboardCardType = Node & {
  __typename?: 'DashboardCardType';
  barchartGoal?: Maybe<Scalars['Float']>;
  card: DailyDashboardCardType;
  cardOrderInDashboard: Scalars['Int'];
  dashboard: DashboardType;
  /** The ID of the object. */
  id: Scalars['ID'];
  /** Defines the metric group for which Metric Value will be created */
  metricGroupForOtherProblem?: Maybe<MetricGroupType>;
  /** If set, only show metrics for these region groups */
  regionGroups: RegionGroupTypeConnection;
  /** Optional override for how this card should be scoped on this dashboard. */
  scopeMode?: Maybe<DashboardCardScopeMode>;
};


export type DashboardCardTypeRegionGroupsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};

export type DashboardCardTypeConnection = {
  __typename?: 'DashboardCardTypeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<DashboardCardTypeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** The total count of objects in this query. */
  totalCount?: Maybe<Scalars['Int']>;
};

/** A Relay edge containing a `DashboardCardType` and its cursor. */
export type DashboardCardTypeEdge = {
  __typename?: 'DashboardCardTypeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<DashboardCardType>;
};

/** An enumeration. */
export enum DashboardMeetingLevel {
  /** Level I */
  I = 'I',
  /** Level II */
  Ii = 'II',
  /** Level III */
  Iii = 'III'
}

export type DashboardType = Node & {
  __typename?: 'DashboardType';
  cards?: Maybe<DailyDashboardCardOrderedConnection>;
  createdAt: Scalars['DateTime'];
  customLinks?: Maybe<Array<Maybe<CustomLinkType>>>;
  dashboardcardSet: DashboardCardTypeConnection;
  description: Scalars['String'];
  /** Dashboard to which metrics will be escalated */
  escalateTo?: Maybe<DashboardType>;
  escalateToDashboards?: Maybe<Array<Maybe<DashboardType>>>;
  escalatedFromDashboards?: Maybe<Array<Maybe<DashboardType>>>;
  /** Multiple dashboards to which metrics can be escalated */
  escalatedFromDashboardsMultiple: DashboardTypeConnection;
  escalatedFromMetrics: MetricValueTypeConnection;
  escalatedFromMetricsMultiple: MetricValueEscalationTypeConnection;
  escalatedFromTasksMultiple: TaskEscalationTypeConnection;
  escalatedMetrics: MetricValueTypeConnection;
  escalatedMetricsMultiple: MetricValueTypeConnection;
  escalatedToCards: DailyDashboardCardTypeConnection;
  escalatedToMetrics: MetricValueEscalationTypeConnection;
  escalatedToTasks: TaskEscalationTypeConnection;
  /** The ID of the object. */
  id: Scalars['ID'];
  meetingLevel?: Maybe<DashboardMeetingLevel>;
  metricsUserprofiles: UserProfileMTypeConnection;
  regionGroup?: Maybe<RegionGroupType>;
  taskSet: TaskTypeConnection;
  tasks: TaskTypeConnection;
  title: Scalars['String'];
  updatedAt: Scalars['DateTime'];
};


export type DashboardTypeCardsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type DashboardTypeDashboardcardSetArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type DashboardTypeEscalatedFromDashboardsMultipleArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type DashboardTypeEscalatedFromMetricsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  cardId?: InputMaybe<Scalars['ID']>;
  channel?: InputMaybe<Scalars['String']>;
  dashboardId?: InputMaybe<Scalars['ID']>;
  dashboardRegion?: InputMaybe<Scalars['ID']>;
  date?: InputMaybe<Scalars['Date']>;
  dateFrom?: InputMaybe<Scalars['Date']>;
  dateTo?: InputMaybe<Scalars['Date']>;
  escalatedFrom?: InputMaybe<Scalars['ID']>;
  escalatedTo?: InputMaybe<Scalars['ID']>;
  escalatedToDashboard?: InputMaybe<Scalars['ID']>;
  first?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['ID']>;
  includeEscalated?: InputMaybe<Scalars['Boolean']>;
  isImportant?: InputMaybe<Scalars['Boolean']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type DashboardTypeEscalatedFromMetricsMultipleArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type DashboardTypeEscalatedFromTasksMultipleArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  createdBy?: InputMaybe<Scalars['ID']>;
  escalatedFrom?: InputMaybe<Scalars['ID']>;
  escalatedTo?: InputMaybe<Scalars['ID']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  task?: InputMaybe<Scalars['ID']>;
};


export type DashboardTypeEscalatedMetricsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  cardId?: InputMaybe<Scalars['ID']>;
  channel?: InputMaybe<Scalars['String']>;
  dashboardId?: InputMaybe<Scalars['ID']>;
  dashboardRegion?: InputMaybe<Scalars['ID']>;
  date?: InputMaybe<Scalars['Date']>;
  dateFrom?: InputMaybe<Scalars['Date']>;
  dateTo?: InputMaybe<Scalars['Date']>;
  escalatedFrom?: InputMaybe<Scalars['ID']>;
  escalatedTo?: InputMaybe<Scalars['ID']>;
  escalatedToDashboard?: InputMaybe<Scalars['ID']>;
  first?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['ID']>;
  includeEscalated?: InputMaybe<Scalars['Boolean']>;
  isImportant?: InputMaybe<Scalars['Boolean']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type DashboardTypeEscalatedMetricsMultipleArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  cardId?: InputMaybe<Scalars['ID']>;
  channel?: InputMaybe<Scalars['String']>;
  dashboardId?: InputMaybe<Scalars['ID']>;
  dashboardRegion?: InputMaybe<Scalars['ID']>;
  date?: InputMaybe<Scalars['Date']>;
  dateFrom?: InputMaybe<Scalars['Date']>;
  dateTo?: InputMaybe<Scalars['Date']>;
  escalatedFrom?: InputMaybe<Scalars['ID']>;
  escalatedTo?: InputMaybe<Scalars['ID']>;
  escalatedToDashboard?: InputMaybe<Scalars['ID']>;
  first?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['ID']>;
  includeEscalated?: InputMaybe<Scalars['Boolean']>;
  isImportant?: InputMaybe<Scalars['Boolean']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type DashboardTypeEscalatedToCardsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type DashboardTypeEscalatedToMetricsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type DashboardTypeEscalatedToTasksArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  createdBy?: InputMaybe<Scalars['ID']>;
  escalatedFrom?: InputMaybe<Scalars['ID']>;
  escalatedTo?: InputMaybe<Scalars['ID']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  task?: InputMaybe<Scalars['ID']>;
};


export type DashboardTypeMetricsUserprofilesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type DashboardTypeTaskSetArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type DashboardTypeTasksArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};

export type DashboardTypeConnection = {
  __typename?: 'DashboardTypeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<DashboardTypeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** The total count of objects in this query. */
  totalCount?: Maybe<Scalars['Int']>;
};

/** A Relay edge containing a `DashboardType` and its cursor. */
export type DashboardTypeEdge = {
  __typename?: 'DashboardTypeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<DashboardType>;
};

export type DateStats = {
  __typename?: 'DateStats';
  name?: Maybe<Scalars['Date']>;
  value?: Maybe<Scalars['Int']>;
};

export type DeleteEventMutation = {
  __typename?: 'DeleteEventMutation';
  ok?: Maybe<Scalars['Boolean']>;
};

export type DeleteOffboardingRole = {
  __typename?: 'DeleteOffboardingRole';
  ok?: Maybe<Scalars['Boolean']>;
};

export type DeleteOrderPeriod = {
  __typename?: 'DeleteOrderPeriod';
  ok?: Maybe<Scalars['Boolean']>;
};

export type DeleteScheduleInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The ID of the object. */
  id: Scalars['ID'];
};

export type DeleteSchedulePayload = {
  __typename?: 'DeleteSchedulePayload';
  clientMutationId?: Maybe<Scalars['String']>;
  /** List of errors that occurred while executing the mutation. */
  errors?: Maybe<Array<MutationErrorType>>;
  /** The mutated object. */
  schedule?: Maybe<ScheduleType>;
};

export type DeleteSelectionActionInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The ID of the object. */
  id: Scalars['ID'];
};

export type DeleteSelectionActionPayload = {
  __typename?: 'DeleteSelectionActionPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  /** List of errors that occurred while executing the mutation. */
  errors?: Maybe<Array<MutationErrorType>>;
  /** The mutated object. */
  task?: Maybe<TaskType>;
};

export type DeleteTaskInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The ID of the object. */
  id: Scalars['ID'];
};

export type DeleteTaskPayload = {
  __typename?: 'DeleteTaskPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  /** List of errors that occurred while executing the mutation. */
  errors?: Maybe<Array<MutationErrorType>>;
  /** The mutated object. */
  task?: Maybe<TaskType>;
};

/** An enumeration. */
export enum DocumentConfirmationMethod {
  /** Dokobit */
  Dokobit = 'DOKOBIT',
  /** Not in system */
  OffSystem = 'OFF_SYSTEM',
  /** Web confirm */
  WebConfirm = 'WEB_CONFIRM'
}

/** An enumeration. */
export enum DocumentStatus {
  /** Cancelled */
  Cancelled = 'CANCELLED',
  /** Pending */
  Pending = 'PENDING',
  /** Signed */
  Signed = 'SIGNED'
}

export type DocumentType = Node & {
  __typename?: 'DocumentType';
  confirmationMethod: DocumentConfirmationMethod;
  createDate: Scalars['DateTime'];
  documentDate?: Maybe<Scalars['Date']>;
  generatedDocument?: Maybe<Scalars['String']>;
  /** The ID of the object. */
  id: Scalars['ID'];
  isSignedBiuro: Scalars['Boolean'];
  isSignedClient: Scalars['Boolean'];
  order: OrderType;
  orderPeriods: Array<OrderPeriodType>;
  signedDocument?: Maybe<Scalars['String']>;
  signingUrl?: Maybe<Scalars['String']>;
  status: DocumentStatus;
};

export type DocumentTypeConnection = {
  __typename?: 'DocumentTypeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<DocumentTypeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `DocumentType` and its cursor. */
export type DocumentTypeEdge = {
  __typename?: 'DocumentTypeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<DocumentType>;
};

export type EdlaAlert = {
  __typename?: 'EdlaAlert';
  employees?: Maybe<Array<Maybe<EdlaAlertEmployee>>>;
  name?: Maybe<Scalars['String']>;
};

export type EdlaAlertEmployee = {
  __typename?: 'EdlaAlertEmployee';
  name?: Maybe<Scalars['String']>;
};

export type ErrorType = {
  __typename?: 'ErrorType';
  field: Scalars['String'];
  messages: Array<Scalars['String']>;
};

export type EscalateMetricValueToDashboards = {
  __typename?: 'EscalateMetricValueToDashboards';
  errors?: Maybe<Array<Maybe<Scalars['String']>>>;
  metricValue?: Maybe<MetricValueType>;
};

export type EscalateTaskToDashboards = {
  __typename?: 'EscalateTaskToDashboards';
  errors?: Maybe<Array<Maybe<Scalars['String']>>>;
  task?: Maybe<TaskType>;
};

/** An enumeration. */
export enum EventClientStatus {
  /** CONFIRMED */
  Confirmed = 'CONFIRMED',
  /** PROPOSED */
  Proposed = 'PROPOSED',
  /** REJECTED */
  Rejected = 'REJECTED'
}

export type EventCreateMutationInput = {
  candidate?: InputMaybe<Scalars['ID']>;
  clientComment?: InputMaybe<Scalars['String']>;
  clientId?: InputMaybe<Scalars['Int']>;
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** Field for client to enter proposed new dates and time slots (hence text) */
  clientProposedNewDatetime?: InputMaybe<Scalars['String']>;
  clientProposedPosition?: InputMaybe<Scalars['String']>;
  clientStatus?: InputMaybe<EventClientStatus>;
  createdBy?: InputMaybe<Scalars['ID']>;
  deleted?: InputMaybe<Scalars['Boolean']>;
  description?: InputMaybe<Scalars['String']>;
  eventType: EventEventType;
  /** If true, the event is considered problematic and is used as flag to show in daily standups */
  isProblematicInterview?: InputMaybe<Scalars['Boolean']>;
  livasContactDate?: InputMaybe<Scalars['Date']>;
  livasStatusId?: InputMaybe<Scalars['Int']>;
  offerPropositions: Array<InputMaybe<Scalars['ID']>>;
  problematicInterviewBy?: InputMaybe<Scalars['ID']>;
  relatedOffer?: InputMaybe<Scalars['ID']>;
  resolutionStatus?: InputMaybe<EventResolutionStatus>;
  source?: InputMaybe<EventSource>;
  startDatetime?: InputMaybe<Scalars['DateTime']>;
  updateLivasClientInterviewDate?: InputMaybe<Scalars['Boolean']>;
  updateLivasEmploymentDate?: InputMaybe<Scalars['Boolean']>;
  updateLivasOfficeInterviewDate?: InputMaybe<Scalars['Boolean']>;
};

export type EventCreateMutationPayload = {
  __typename?: 'EventCreateMutationPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  /** List of errors that occurred while executing the mutation. */
  errors?: Maybe<Array<MutationErrorType>>;
  /** The mutated object. */
  event?: Maybe<CandidateEventType>;
};

/** An enumeration. */
export enum EventEventType {
  /** client_interview */
  ClientInterview = 'CLIENT_INTERVIEW',
  /** employment */
  Employment = 'EMPLOYMENT',
  /** health_check_pending */
  HealthCheckPending = 'HEALTH_CHECK_PENDING',
  /** interview */
  Interview = 'INTERVIEW',
  /** to_be_presented */
  ToBePresented = 'TO_BE_PRESENTED',
  /** trial_day */
  TrialDay = 'TRIAL_DAY'
}

/** An enumeration. */
export enum EventLanguage {
  /** EE */
  Ee = 'EE',
  /** EN */
  En = 'EN',
  /** LT */
  Lt = 'LT',
  /** LV */
  Lv = 'LV',
  /** RU */
  Ru = 'RU'
}

export type EventMutationInput = {
  adId?: InputMaybe<Scalars['Int']>;
  category?: InputMaybe<Scalars['ID']>;
  channels?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  clientMutationId?: InputMaybe<Scalars['String']>;
  comment?: InputMaybe<Scalars['String']>;
  completedBy?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  date: Scalars['Date'];
  durationMinutes?: InputMaybe<Scalars['Int']>;
  /** ID from FB and GOOGLE */
  externalPlatformId?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  key?: InputMaybe<Scalars['String']>;
  language?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Scalars['ID']>;
  price?: InputMaybe<Scalars['Int']>;
  regionId?: InputMaybe<Scalars['Int']>;
  workisJobId?: InputMaybe<Scalars['Int']>;
  workisMarketing?: InputMaybe<Scalars['Boolean']>;
};

export type EventMutationPayload = {
  __typename?: 'EventMutationPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  event?: Maybe<EventType>;
};

export type EventProblematicInterviewUpdateMutationInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  /** The ID of the object. */
  id: Scalars['ID'];
  /** If true, the event is considered problematic and is used as flag to show in daily standups */
  isProblematicInterview: Scalars['Boolean'];
  livasContactDate?: InputMaybe<Scalars['Date']>;
  livasStatusId?: InputMaybe<Scalars['Int']>;
  updateLivasClientInterviewDate?: InputMaybe<Scalars['Boolean']>;
  updateLivasEmploymentDate?: InputMaybe<Scalars['Boolean']>;
  updateLivasOfficeInterviewDate?: InputMaybe<Scalars['Boolean']>;
};

export type EventProblematicInterviewUpdateMutationPayload = {
  __typename?: 'EventProblematicInterviewUpdateMutationPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  /** List of errors that occurred while executing the mutation. */
  errors?: Maybe<Array<MutationErrorType>>;
  /** The mutated object. */
  event?: Maybe<CandidateEventType>;
};

/** An enumeration. */
export enum EventResolutionStatus {
  /** CANCELLED */
  Cancelled = 'CANCELLED',
  /** COMPLETE */
  Complete = 'COMPLETE',
  /** FAILED */
  Failed = 'FAILED',
  /** CLIENT_REJECTED */
  Rejected = 'REJECTED'
}

/** An enumeration. */
export enum EventSource {
  /** BORIS */
  Boris = 'BORIS',
  /** LIVAS */
  Livas = 'LIVAS'
}

export type EventStatusUpdateMutationInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The ID of the object. */
  id: Scalars['ID'];
  livasContactDate?: InputMaybe<Scalars['Date']>;
  livasStatusId?: InputMaybe<Scalars['Int']>;
  resolutionStatus?: InputMaybe<EventResolutionStatus>;
  updateLivasClientInterviewDate?: InputMaybe<Scalars['Boolean']>;
  updateLivasEmploymentDate?: InputMaybe<Scalars['Boolean']>;
  updateLivasOfficeInterviewDate?: InputMaybe<Scalars['Boolean']>;
};

export type EventStatusUpdateMutationPayload = {
  __typename?: 'EventStatusUpdateMutationPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  /** List of errors that occurred while executing the mutation. */
  errors?: Maybe<Array<MutationErrorType>>;
  /** The mutated object. */
  event?: Maybe<CandidateEventType>;
};

export type EventType = Node & {
  __typename?: 'EventType';
  adId?: Maybe<Scalars['Int']>;
  /** Users assigned to this task. Migrate from completed_by */
  assignees: UserProfileMTypeConnection;
  category?: Maybe<CategoryType>;
  channels: Array<ChannelType>;
  comment?: Maybe<Scalars['String']>;
  completedAt?: Maybe<Scalars['DateTime']>;
  completedBy?: Maybe<Array<Maybe<UserProfileMType>>>;
  country?: Maybe<CountryType>;
  createdAt: Scalars['DateTime'];
  createdBy?: Maybe<UserProfileMType>;
  createdBySchedule?: Maybe<ScheduleType>;
  date?: Maybe<Scalars['Date']>;
  durationMinutes?: Maybe<Scalars['Int']>;
  /** ID from FB and GOOGLE */
  externalPlatformId?: Maybe<Scalars['String']>;
  /** The ID of the object. */
  id: Scalars['ID'];
  key?: Maybe<Scalars['String']>;
  language?: Maybe<EventLanguage>;
  order?: Maybe<OrderType>;
  price?: Maybe<Scalars['Int']>;
  sendNotificationToAssignee: Scalars['Boolean'];
  status?: Maybe<TaskStatus>;
  workisJobId?: Maybe<Scalars['Int']>;
};


export type EventTypeAssigneesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};

export type EventTypeConnection = {
  __typename?: 'EventTypeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<EventTypeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** The total count of objects in this query. */
  totalCount?: Maybe<Scalars['Int']>;
};

/** A Relay edge containing a `EventType` and its cursor. */
export type EventTypeEdge = {
  __typename?: 'EventTypeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<EventType>;
};

export type EventUpdateMutationInput = {
  candidate?: InputMaybe<Scalars['ID']>;
  clientComment?: InputMaybe<Scalars['String']>;
  clientId?: InputMaybe<Scalars['Int']>;
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** Field for client to enter proposed new dates and time slots (hence text) */
  clientProposedNewDatetime?: InputMaybe<Scalars['String']>;
  clientProposedPosition?: InputMaybe<Scalars['String']>;
  clientStatus?: InputMaybe<EventClientStatus>;
  createdBy?: InputMaybe<Scalars['ID']>;
  deleted?: InputMaybe<Scalars['Boolean']>;
  description?: InputMaybe<Scalars['String']>;
  eventType?: InputMaybe<EventEventType>;
  /** The ID of the object. */
  id: Scalars['ID'];
  /** If true, the event is considered problematic and is used as flag to show in daily standups */
  isProblematicInterview?: InputMaybe<Scalars['Boolean']>;
  livasContactDate?: InputMaybe<Scalars['Date']>;
  livasStatusId?: InputMaybe<Scalars['Int']>;
  offerPropositions?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  problematicInterviewBy?: InputMaybe<Scalars['ID']>;
  relatedOffer?: InputMaybe<Scalars['ID']>;
  source?: InputMaybe<EventSource>;
  startDatetime?: InputMaybe<Scalars['DateTime']>;
  updateLivasClientInterviewDate?: InputMaybe<Scalars['Boolean']>;
  updateLivasEmploymentDate?: InputMaybe<Scalars['Boolean']>;
  updateLivasOfficeInterviewDate?: InputMaybe<Scalars['Boolean']>;
};

export type EventUpdateMutationPayload = {
  __typename?: 'EventUpdateMutationPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  /** List of errors that occurred while executing the mutation. */
  errors?: Maybe<Array<MutationErrorType>>;
  /** The mutated object. */
  event?: Maybe<CandidateEventType>;
};

export type FailureReason = {
  __typename?: 'FailureReason';
  count?: Maybe<Scalars['Int']>;
  reason?: Maybe<Scalars['String']>;
};

/** An enumeration. */
export enum HistoricalCompanyColor {
  /** BLUE */
  Blue = 'BLUE',
  /** GREEN */
  Green = 'GREEN',
  /** GREEN_A */
  GreenA = 'GREEN_A',
  /** GREEN_B */
  GreenB = 'GREEN_B',
  /** GREEN_C */
  GreenC = 'GREEN_C',
  /** RED */
  Red = 'RED',
  /** YELLOW */
  Yellow = 'YELLOW'
}

/** An enumeration. */
export enum ImageDocType {
  /** Healthcheck doc */
  Hygiene = 'HYGIENE',
  /** Healthcheck doc */
  Medical = 'MEDICAL',
  /** Other */
  Other = 'OTHER'
}

export type ImageType = {
  __typename?: 'ImageType';
  created: Scalars['DateTime'];
  createdBy?: Maybe<UserType>;
  docType: ImageDocType;
  id: Scalars['ID'];
  imageUrl?: Maybe<Scalars['String']>;
  medImage: Scalars['String'];
  nextHealthCheck?: Maybe<Scalars['Date']>;
  userId: Scalars['Int'];
  validTill?: Maybe<Scalars['Date']>;
};

export type InitOrderSigningMutation = {
  __typename?: 'InitOrderSigningMutation';
  ok?: Maybe<Scalars['Boolean']>;
  order?: Maybe<OrderType>;
};

export type InventaEmployee = {
  __typename?: 'InventaEmployee';
  confirmedInOtherCompany?: Maybe<Scalars['Boolean']>;
  firstName?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
};

/** An enumeration. */
export enum JobAdAiContentStatus {
  /** Completed */
  Completed = 'COMPLETED',
  /** New */
  New = 'NEW',
  /** Pending */
  Pending = 'PENDING'
}

export type JobAdAiContentType = Node & {
  __typename?: 'JobAdAIContentType';
  createdAt: Scalars['DateTime'];
  createdBy?: Maybe<UserProfileMType>;
  /** The ID of the object. */
  id: Scalars['ID'];
  order: OrderType;
  response?: Maybe<Scalars['JSONString']>;
  status: JobAdAiContentStatus;
  updatedAt: Scalars['DateTime'];
};

export type JobAdAiContentTypeConnection = {
  __typename?: 'JobAdAIContentTypeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<JobAdAiContentTypeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `JobAdAIContentType` and its cursor. */
export type JobAdAiContentTypeEdge = {
  __typename?: 'JobAdAIContentTypeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<JobAdAiContentType>;
};

export type JobCategoryType = Node & {
  __typename?: 'JobCategoryType';
  externalId?: Maybe<Scalars['Int']>;
  /** The ID of the object. */
  id: Scalars['ID'];
  title?: Maybe<Scalars['String']>;
};

export type JobCategoryTypeConnection = {
  __typename?: 'JobCategoryTypeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<JobCategoryTypeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `JobCategoryType` and its cursor. */
export type JobCategoryTypeEdge = {
  __typename?: 'JobCategoryTypeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<JobCategoryType>;
};

export type LduForm = {
  __typename?: 'LDUForm';
  isNew?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
};

export type LabelGroupType = Node & {
  __typename?: 'LabelGroupType';
  country?: Maybe<CountryType>;
  createdAt: Scalars['DateTime'];
  /** The ID of the object. */
  id: Scalars['ID'];
  key?: Maybe<Scalars['String']>;
  labelSet: LabelTypeConnection;
  priority?: Maybe<Scalars['Int']>;
  title: Scalars['String'];
};


export type LabelGroupTypeLabelSetArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['ID']>;
  first?: InputMaybe<Scalars['Int']>;
  group_Key?: InputMaybe<Scalars['String']>;
  key?: InputMaybe<Scalars['String']>;
  last?: InputMaybe<Scalars['Int']>;
};

export type LabelGroupTypeConnection = {
  __typename?: 'LabelGroupTypeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<LabelGroupTypeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `LabelGroupType` and its cursor. */
export type LabelGroupTypeEdge = {
  __typename?: 'LabelGroupTypeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<LabelGroupType>;
};

export type LabelType = Node & {
  __typename?: 'LabelType';
  companySet: CompanyTypeConnection;
  createdAt: Scalars['DateTime'];
  externalLivasId?: Maybe<Scalars['Int']>;
  externalWorkisId?: Maybe<Scalars['Int']>;
  group: LabelGroupType;
  /** The ID of the object. */
  id: Scalars['ID'];
  key?: Maybe<Scalars['String']>;
  priority?: Maybe<Scalars['Int']>;
  title: Scalars['String'];
};


export type LabelTypeCompanySetArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};

export type LabelTypeConnection = {
  __typename?: 'LabelTypeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<LabelTypeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `LabelType` and its cursor. */
export type LabelTypeEdge = {
  __typename?: 'LabelTypeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<LabelType>;
};

export type LanguagesType = {
  __typename?: 'LanguagesType';
  lt?: Maybe<Scalars['String']>;
};

export type LivasCompanyUpdate = {
  __typename?: 'LivasCompanyUpdate';
  ok?: Maybe<Scalars['Boolean']>;
};

export type LivasData = {
  __typename?: 'LivasData';
  biuro1sdCount?: Maybe<Scalars['Int']>;
  biuro1sdUrgentCount?: Maybe<Scalars['Int']>;
  biuro2sdCount?: Maybe<Scalars['Int']>;
  biurogo1sdCount?: Maybe<Scalars['Int']>;
  biurolatvia1sdCount?: Maybe<Scalars['Int']>;
  biurolv1sdCount?: Maybe<Scalars['Int']>;
  darbius1sdCount?: Maybe<Scalars['Int']>;
  darbius1sdUrgentCount?: Maybe<Scalars['Int']>;
  darbius2sdCount?: Maybe<Scalars['Int']>;
  edlaAlerts?: Maybe<Array<Maybe<EdlaAlert>>>;
  lduForms?: Maybe<Array<Maybe<LduForm>>>;
  lduUrgentForms?: Maybe<Scalars['Int']>;
  unreadSmsCount?: Maybe<Scalars['Int']>;
};

export type LivasJobAdContentType = {
  __typename?: 'LivasJobAdContentType';
  additionalCategory?: Maybe<Array<Maybe<Scalars['String']>>>;
  additionalLocation?: Maybe<Array<Maybe<Scalars['String']>>>;
  additionalTypes?: Maybe<Array<Maybe<Scalars['String']>>>;
  address?: Maybe<Scalars['String']>;
  advertTitle?: Maybe<Scalars['String']>;
  categoryId?: Maybe<Scalars['Int']>;
  companyDsc?: Maybe<Scalars['String']>;
  companyTitle?: Maybe<Scalars['String']>;
  contactsCount?: Maybe<Scalars['Int']>;
  date?: Maybe<Scalars['Date']>;
  department?: Maybe<Scalars['Int']>;
  description2?: Maybe<Scalars['String']>;
  descriptionDsc?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['Int']>;
  groupId?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isPublished?: Maybe<Scalars['Boolean']>;
  lang?: Maybe<Scalars['String']>;
  languages?: Maybe<LanguagesType>;
  locationId?: Maybe<Scalars['Int']>;
  logo?: Maybe<Scalars['String']>;
  logoOriginal?: Maybe<Scalars['String']>;
  managerId?: Maybe<Scalars['Int']>;
  offerDsc?: Maybe<Scalars['String']>;
  other?: Maybe<Scalars['String']>;
  personsCount?: Maybe<Scalars['Int']>;
  phone?: Maybe<Scalars['String']>;
  position?: Maybe<Scalars['String']>;
  positionId?: Maybe<Scalars['Int']>;
  regionId?: Maybe<Scalars['Int']>;
  requirementsDsc?: Maybe<Scalars['String']>;
  salaryFrom?: Maybe<Scalars['Float']>;
  salaryTo?: Maybe<Scalars['Float']>;
  salaryType?: Maybe<Scalars['String']>;
  seoTitle?: Maybe<Scalars['String']>;
  seoUrl?: Maybe<Scalars['String']>;
  source?: Maybe<Scalars['String']>;
  startOfWork?: Maybe<Scalars['Int']>;
  type?: Maybe<Scalars['Int']>;
  typeOfWork?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  urlSegment?: Maybe<UrlSegmentType>;
  validUntil?: Maybe<Scalars['Date']>;
  videoUrl?: Maybe<Scalars['String']>;
  workingHours?: Maybe<Scalars['String']>;
  www?: Maybe<WwwType>;
};

export type MetricGroupAssignmentType = Node & {
  __typename?: 'MetricGroupAssignmentType';
  card: DailyDashboardCardType;
  /** The ID of the object. */
  id: Scalars['ID'];
  metricGroup: MetricGroupType;
  order: Scalars['Int'];
};

export type MetricGroupAssignmentTypeConnection = {
  __typename?: 'MetricGroupAssignmentTypeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<MetricGroupAssignmentTypeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** The total count of objects in this query. */
  totalCount?: Maybe<Scalars['Int']>;
};

/** A Relay edge containing a `MetricGroupAssignmentType` and its cursor. */
export type MetricGroupAssignmentTypeEdge = {
  __typename?: 'MetricGroupAssignmentTypeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<MetricGroupAssignmentType>;
};

/** An enumeration. */
export enum MetricGroupGrouping {
  /** Client */
  Client = 'CLIENT',
  /** Metric Comment Reason */
  CommentReason = 'COMMENT_REASON',
  /** Manager */
  Manager = 'MANAGER',
  /** Not aggregated */
  NonAggregated = 'NON_AGGREGATED',
  /** Order */
  Order = 'ORDER',
  /** Region */
  Region = 'REGION'
}

/** An enumeration. */
export enum MetricGroupHighlightWhen {
  /** Greater than */
  GreaterThan = 'GREATER_THAN',
  /** Less than */
  LessThan = 'LESS_THAN'
}

export type MetricGroupType = Node & {
  __typename?: 'MetricGroupType';
  actioncategorySet: ActionCategoryTypeConnection;
  createdAt: Scalars['DateTime'];
  /** Defines the metric group for which Metric Value will be created */
  dashboardcardSet: DashboardCardTypeConnection;
  description: Scalars['String'];
  goal: Scalars['Float'];
  grouping: MetricGroupGrouping;
  /** Highlight the metric when the value is less than or greater than the goal */
  highlightWhen?: Maybe<MetricGroupHighlightWhen>;
  /** The ID of the object. */
  id: Scalars['ID'];
  lookbackDays: Scalars['Int'];
  metricGroups: DailyDashboardCardTypeConnection;
  metricclientreasonSet: MetricValueClientReasonTypeConnection;
  metricgroupassignmentSet: MetricGroupAssignmentTypeConnection;
  metricvalueSet: MetricValueTypeConnection;
  nextActions: ActionCategoryTypeConnection;
  showLastInPeriod: Scalars['Boolean'];
  showUntilNextTaskCreated: Scalars['Boolean'];
  /** Explanation of the subvalue. E.g. "Number of Fired due to Recruitment error" */
  subvalueExplanation?: Maybe<Scalars['String']>;
  taskCategory?: Maybe<SaCategoryType>;
  title: Scalars['String'];
  updatedAt: Scalars['DateTime'];
};


export type MetricGroupTypeActioncategorySetArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type MetricGroupTypeDashboardcardSetArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type MetricGroupTypeMetricGroupsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type MetricGroupTypeMetricclientreasonSetArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type MetricGroupTypeMetricgroupassignmentSetArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type MetricGroupTypeMetricvalueSetArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  cardId?: InputMaybe<Scalars['ID']>;
  channel?: InputMaybe<Scalars['String']>;
  dashboardId?: InputMaybe<Scalars['ID']>;
  dashboardRegion?: InputMaybe<Scalars['ID']>;
  date?: InputMaybe<Scalars['Date']>;
  dateFrom?: InputMaybe<Scalars['Date']>;
  dateTo?: InputMaybe<Scalars['Date']>;
  escalatedFrom?: InputMaybe<Scalars['ID']>;
  escalatedTo?: InputMaybe<Scalars['ID']>;
  escalatedToDashboard?: InputMaybe<Scalars['ID']>;
  first?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['ID']>;
  includeEscalated?: InputMaybe<Scalars['Boolean']>;
  isImportant?: InputMaybe<Scalars['Boolean']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type MetricGroupTypeNextActionsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};

export type MetricGroupTypeConnection = {
  __typename?: 'MetricGroupTypeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<MetricGroupTypeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** The total count of objects in this query. */
  totalCount?: Maybe<Scalars['Int']>;
};

/** A Relay edge containing a `MetricGroupType` and its cursor. */
export type MetricGroupTypeEdge = {
  __typename?: 'MetricGroupTypeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<MetricGroupType>;
};

/** An enumeration. */
export enum MetricValueChannel {
  /** Email */
  Email = 'EMAIL',
  /** Phone */
  Phone = 'PHONE'
}

export type MetricValueClientReasonType = Node & {
  __typename?: 'MetricValueClientReasonType';
  createdAt: Scalars['DateTime'];
  /** The ID of the object. */
  id: Scalars['ID'];
  metricGroup: MetricGroupType;
  metricvaluecommentSet: MetricValueCommentTypeConnection;
  objectId?: Maybe<Scalars['Int']>;
  title: Scalars['String'];
  updatedAt: Scalars['DateTime'];
};


export type MetricValueClientReasonTypeMetricvaluecommentSetArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};

export type MetricValueClientReasonTypeConnection = {
  __typename?: 'MetricValueClientReasonTypeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<MetricValueClientReasonTypeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** The total count of objects in this query. */
  totalCount?: Maybe<Scalars['Int']>;
};

/** A Relay edge containing a `MetricValueClientReasonType` and its cursor. */
export type MetricValueClientReasonTypeEdge = {
  __typename?: 'MetricValueClientReasonTypeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<MetricValueClientReasonType>;
};

export type MetricValueCommentType = Node & {
  __typename?: 'MetricValueCommentType';
  candidates: CandidateTypeConnection;
  clients: CompanyTypeConnection;
  comment: Scalars['String'];
  createdAt: Scalars['DateTime'];
  /** The ID of the object. */
  id: Scalars['ID'];
  metricClientReason?: Maybe<MetricValueClientReasonType>;
  metricValue: MetricValueType;
  updatedAt: Scalars['DateTime'];
};


export type MetricValueCommentTypeCandidatesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  livasId_In?: InputMaybe<Scalars['Int']>;
};


export type MetricValueCommentTypeClientsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};

export type MetricValueCommentTypeConnection = {
  __typename?: 'MetricValueCommentTypeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<MetricValueCommentTypeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** The total count of objects in this query. */
  totalCount?: Maybe<Scalars['Int']>;
};

/** A Relay edge containing a `MetricValueCommentType` and its cursor. */
export type MetricValueCommentTypeEdge = {
  __typename?: 'MetricValueCommentTypeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<MetricValueCommentType>;
};

export type MetricValueEscalationType = Node & {
  __typename?: 'MetricValueEscalationType';
  createdAt: Scalars['DateTime'];
  createdBy?: Maybe<UserProfileMType>;
  escalatedFrom?: Maybe<DashboardType>;
  escalatedTo: DashboardType;
  /** The ID of the object. */
  id: Scalars['ID'];
  metricValue: MetricValueType;
};

export type MetricValueEscalationTypeConnection = {
  __typename?: 'MetricValueEscalationTypeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<MetricValueEscalationTypeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** The total count of objects in this query. */
  totalCount?: Maybe<Scalars['Int']>;
};

/** A Relay edge containing a `MetricValueEscalationType` and its cursor. */
export type MetricValueEscalationTypeEdge = {
  __typename?: 'MetricValueEscalationTypeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<MetricValueEscalationType>;
};

export type MetricValueType = Node & {
  __typename?: 'MetricValueType';
  candidate?: Maybe<CandidateType>;
  /** Channel used for the activity (Email or Phone) */
  channel?: Maybe<MetricValueChannel>;
  client?: Maybe<CompanyType>;
  comments?: Maybe<Array<Maybe<Scalars['ID']>>>;
  createdAt: Scalars['DateTime'];
  createdBy?: Maybe<UserProfileMType>;
  date: Scalars['Date'];
  escalatedAt?: Maybe<Scalars['DateTime']>;
  escalatedBy?: Maybe<UserProfileMType>;
  escalatedFrom?: Maybe<DashboardType>;
  escalatedTo?: Maybe<DashboardType>;
  escalatedToDashboards?: Maybe<Array<Maybe<DashboardType>>>;
  escalations: MetricValueEscalationTypeConnection;
  goal?: Maybe<Scalars['Float']>;
  /** The ID of the object. */
  id: Scalars['ID'];
  isImportant: Scalars['Boolean'];
  /** Key to identify specific metric variant (e.g., conversion type) */
  key?: Maybe<Scalars['String']>;
  manager?: Maybe<UserProfileMType>;
  metricGroup?: Maybe<MetricGroupType>;
  metricvaluecommentSet: MetricValueCommentTypeConnection;
  nextTask?: Maybe<TaskType>;
  nextTaskId?: Maybe<Scalars['Int']>;
  nextTaskLevel2?: Maybe<TaskType>;
  nextTaskLevel2Id?: Maybe<Scalars['Int']>;
  order?: Maybe<OrderType>;
  orderId?: Maybe<Scalars['Int']>;
  regionGroup?: Maybe<RegionGroupType>;
  relatedActivity: RequestsActivityTypeConnection;
  subvalue?: Maybe<Scalars['Float']>;
  updatedAt: Scalars['DateTime'];
  value: Scalars['Float'];
  /** If true, metric is related to  Workis; LOGO will be shown on the standup board. */
  workis?: Maybe<Scalars['Boolean']>;
};


export type MetricValueTypeEscalationsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type MetricValueTypeMetricvaluecommentSetArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type MetricValueTypeRelatedActivityArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};

export type MetricValueTypeConnection = {
  __typename?: 'MetricValueTypeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<MetricValueTypeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** The total count of objects in this query. */
  totalCount?: Maybe<Scalars['Int']>;
};

/** A Relay edge containing a `MetricValueType` and its cursor. */
export type MetricValueTypeEdge = {
  __typename?: 'MetricValueTypeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<MetricValueType>;
};

export type Mutation = {
  __typename?: 'Mutation';
  changeEventStatus?: Maybe<ChangeEventStatus>;
  changeOrderStatus?: Maybe<ChangeOrderStatus>;
  clientInterviewCreate?: Maybe<ClientInterviewCreateMutationPayload>;
  clientInterviewUpdate?: Maybe<ClientInterviewUpdateMutationPayload>;
  clientInterviewUpdateByClient?: Maybe<ClientInterviewClientUpdateMutationPayload>;
  copySpecification?: Maybe<CopySpecification>;
  createCancellationReasonAssignment?: Maybe<CreateCancellationReasonAssignmentMutation>;
  createCompany?: Maybe<CreateCompany>;
  createContact?: Maybe<CreateContact>;
  createCustomLink?: Maybe<CreateCustomLinkPayload>;
  createJobAdLivas?: Maybe<CreateJobAdLivas>;
  createMetricValue?: Maybe<CreateMetricValuePayload>;
  createMetricValueComment?: Maybe<CreateMetricValueCommentPayload>;
  createOffboardingRole?: Maybe<CreateOffboardingRole>;
  createOfferPropositionComment?: Maybe<CreateOfferPropositionCommentPayload>;
  createOperationsTask?: Maybe<CreateOperationsTaskPayload>;
  createOrder?: Maybe<CreateOrder>;
  createOrderClientContacted?: Maybe<CreateOrderClientContactedMutationPayload>;
  createOrderComment?: Maybe<CreateOrderCommentPayload>;
  createOrderError?: Maybe<CreateOrderErrorPayload>;
  createOrderModel?: Maybe<CreateOrderModelMutationPayload>;
  createRequestsActivity?: Maybe<CreateRequestsActivityPayload>;
  createRequirement?: Maybe<CreateRequirement>;
  createSelectionAction?: Maybe<CreateSelectionActionPayload>;
  createSpecification?: Maybe<CreateSpecification>;
  createTaskCopy?: Maybe<CreateTaskCopyPayload>;
  createTaskSchedule?: Maybe<CreateSchedulePayload>;
  createUpdateCustomFieldValues?: Maybe<CreateUpdateCustomFieldValuesMutation>;
  deleteEvent?: Maybe<DeleteEventMutation>;
  deleteOffboardingRole?: Maybe<DeleteOffboardingRole>;
  deleteOrderPeriod?: Maybe<DeleteOrderPeriod>;
  deleteSelectionAction?: Maybe<DeleteSelectionActionPayload>;
  deleteTask?: Maybe<DeleteTaskPayload>;
  deleteTaskSchedule?: Maybe<DeleteSchedulePayload>;
  escalateMetricValueToDashboards?: Maybe<EscalateMetricValueToDashboards>;
  escalateTaskToDashboards?: Maybe<EscalateTaskToDashboards>;
  event?: Maybe<EventMutationPayload>;
  eventCreate?: Maybe<EventCreateMutationPayload>;
  eventProblematicInterviewUpdate?: Maybe<EventProblematicInterviewUpdateMutationPayload>;
  eventStatusUpdate?: Maybe<EventStatusUpdateMutationPayload>;
  eventUpdate?: Maybe<EventUpdateMutationPayload>;
  initOrderSigning?: Maybe<InitOrderSigningMutation>;
  livasCompanyUpdate?: Maybe<LivasCompanyUpdate>;
  offerPropositionCreate?: Maybe<OfferPropositionCreateMutationPayload>;
  offerPropositionUpdate?: Maybe<OfferPropositionUpdateMutationPayload>;
  partialUpdateOrderModel?: Maybe<PartialUpdateOrderModelMutationPayload>;
  prop2?: Maybe<PropositionMutationPayload>;
  proposition?: Maybe<OfferPropositionMutationPayload>;
  propositionDelete?: Maybe<OfferPropositionDeleteMutationPayload>;
  propositionUpdate?: Maybe<OfferPropositionUpdateMutationPayload>;
  resendOrderSigning?: Maybe<ResendOrderSigningMutation>;
  saveRequirements?: Maybe<SaveRequirementsMutation>;
  scheduleUpdate?: Maybe<ScheduleUpdatePeople>;
  sendOrderDocumentToClient?: Maybe<CreateDocumentMutationPayload>;
  sendOrderSummaries?: Maybe<SendOrderSummariesMutation>;
  sendSms?: Maybe<SendSmsMutation>;
  setProcessedOrderViewDatetime?: Maybe<SetProcessedOrderViewDatetimeMutation>;
  specificationCreate?: Maybe<SpecificationModelCreateMutationPayload>;
  specificationUpdate?: Maybe<SpecificationModelUpdateMutationPayload>;
  submitOrder?: Maybe<SubmitOrderMutation>;
  syncCompanyLabels?: Maybe<SyncCompanyLabelsMutation>;
  triggerCandidateUpdate?: Maybe<TriggerCandidateUpdateMutation>;
  unEscalateMetricValueFromDashboards?: Maybe<UnEscalateMetricValueFromDashboards>;
  unEscalateTaskFromDashboards?: Maybe<UnEscalateTaskFromDashboards>;
  updateCompany?: Maybe<UpdateCompany>;
  updateCompanyDescription?: Maybe<UpdateCompanyDescription>;
  updateCompanyManagers?: Maybe<UpdateCompanyManagers>;
  updateCompanyModel?: Maybe<UpdateCompanyModelPayload>;
  updateCompanyRelay?: Maybe<UpdateCompanyRelay>;
  updateContact?: Maybe<UpdateContact>;
  updateDashboardCard?: Maybe<UpdateDashboardCardPayload>;
  updateLivasCandidateStatus?: Maybe<UpdateLivasCandidateStatus>;
  updateMetricValue?: Maybe<UpdateMetricValuePayload>;
  updateMetricValueComment?: Maybe<UpdateMetricValueCommentPayload>;
  updateOffboardingRole?: Maybe<UpdateOffboardingRole>;
  updateOfferPropositionComment?: Maybe<UpdateOfferPropositionCommentPayload>;
  updateOperationsTask?: Maybe<UpdateOperationsTaskPayload>;
  updateOrder?: Maybe<UpdateOrder>;
  updateRequestsActivity?: Maybe<UpdateRequestsActivityPayload>;
  updateSelectionAction?: Maybe<UpdateSelectionActionPayload>;
  updateSpecification?: Maybe<UpdateSpecification>;
  updateTaskSchedule?: Maybe<UpdateSchedulePayload>;
};


export type MutationChangeEventStatusArgs = {
  id: Scalars['ID'];
  transition: Scalars['String'];
};


export type MutationChangeOrderStatusArgs = {
  id: Scalars['ID'];
  transition: Scalars['String'];
};


export type MutationClientInterviewCreateArgs = {
  input: ClientInterviewCreateMutationInput;
};


export type MutationClientInterviewUpdateArgs = {
  input: ClientInterviewUpdateMutationInput;
};


export type MutationClientInterviewUpdateByClientArgs = {
  input: ClientInterviewClientUpdateMutationInput;
};


export type MutationCopySpecificationArgs = {
  input?: InputMaybe<Scalars['Int']>;
};


export type MutationCreateCancellationReasonAssignmentArgs = {
  cancellationReasons?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  offerProposition?: InputMaybe<Scalars['ID']>;
};


export type MutationCreateCompanyArgs = {
  input: CompanyInput;
};


export type MutationCreateContactArgs = {
  input: ContactInput;
};


export type MutationCreateCustomLinkArgs = {
  input: CreateCustomLinkInput;
};


export type MutationCreateJobAdLivasArgs = {
  address?: InputMaybe<Scalars['String']>;
  advertTitle: Scalars['String'];
  categoryId?: InputMaybe<Scalars['Int']>;
  companyTitle?: InputMaybe<Scalars['String']>;
  descriptionDsc: Scalars['String'];
  locationId?: InputMaybe<Scalars['Int']>;
  offerDsc: Scalars['String'];
  orderId: Scalars['ID'];
  position?: InputMaybe<Scalars['String']>;
  requirementsDsc: Scalars['String'];
  salaryFrom?: InputMaybe<Scalars['Float']>;
  salaryTo?: InputMaybe<Scalars['Float']>;
  salaryType?: InputMaybe<Scalars['String']>;
  seoTitle: Scalars['String'];
  summary?: InputMaybe<Scalars['String']>;
  workingHours?: InputMaybe<Scalars['String']>;
};


export type MutationCreateMetricValueArgs = {
  input: CreateMetricValueInput;
};


export type MutationCreateMetricValueCommentArgs = {
  input: CreateMetricValueCommentInput;
};


export type MutationCreateOffboardingRoleArgs = {
  input: OffboardingRoleInput;
};


export type MutationCreateOfferPropositionCommentArgs = {
  input: CreateOfferPropositionCommentInput;
};


export type MutationCreateOperationsTaskArgs = {
  input: CreateOperationsTaskInput;
};


export type MutationCreateOrderArgs = {
  input: OrderInput;
  periods?: InputMaybe<Array<InputMaybe<OrderPeriodInput>>>;
};


export type MutationCreateOrderClientContactedArgs = {
  input: CreateOrderClientContactedMutationInput;
};


export type MutationCreateOrderCommentArgs = {
  input: CreateOrderCommentInput;
};


export type MutationCreateOrderErrorArgs = {
  input: CreateOrderErrorInput;
};


export type MutationCreateOrderModelArgs = {
  input: CreateOrderModelMutationInput;
};


export type MutationCreateRequestsActivityArgs = {
  input: CreateRequestsActivityInput;
};


export type MutationCreateRequirementArgs = {
  country?: InputMaybe<Scalars['ID']>;
  englishValue?: InputMaybe<Scalars['String']>;
  input?: InputMaybe<Scalars['String']>;
  localValue?: InputMaybe<Scalars['String']>;
};


export type MutationCreateSelectionActionArgs = {
  input: CreateSelectionActionInput;
};


export type MutationCreateSpecificationArgs = {
  companyId: Scalars['ID'];
  input: SpecificationInput;
};


export type MutationCreateTaskCopyArgs = {
  input: CreateTaskCopyInput;
};


export type MutationCreateTaskScheduleArgs = {
  input: CreateScheduleInput;
};


export type MutationCreateUpdateCustomFieldValuesArgs = {
  customFieldValues: Array<InputMaybe<CustomFieldValueInput>>;
  taskId: Scalars['ID'];
};


export type MutationDeleteEventArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteOffboardingRoleArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteOrderPeriodArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteSelectionActionArgs = {
  input: DeleteSelectionActionInput;
};


export type MutationDeleteTaskArgs = {
  input: DeleteTaskInput;
};


export type MutationDeleteTaskScheduleArgs = {
  input: DeleteScheduleInput;
};


export type MutationEscalateMetricValueToDashboardsArgs = {
  escalatedFromId?: InputMaybe<Scalars['ID']>;
  escalatedToIds: Array<InputMaybe<Scalars['ID']>>;
  metricValueId: Scalars['ID'];
};


export type MutationEscalateTaskToDashboardsArgs = {
  escalatedFromId?: InputMaybe<Scalars['ID']>;
  escalatedToIds: Array<InputMaybe<Scalars['ID']>>;
  taskId: Scalars['ID'];
};


export type MutationEventArgs = {
  input: EventMutationInput;
};


export type MutationEventCreateArgs = {
  input: EventCreateMutationInput;
};


export type MutationEventProblematicInterviewUpdateArgs = {
  input: EventProblematicInterviewUpdateMutationInput;
};


export type MutationEventStatusUpdateArgs = {
  input: EventStatusUpdateMutationInput;
};


export type MutationEventUpdateArgs = {
  input: EventUpdateMutationInput;
};


export type MutationInitOrderSigningArgs = {
  id?: InputMaybe<Scalars['ID']>;
};


export type MutationLivasCompanyUpdateArgs = {
  input?: InputMaybe<CompanyUpdateInput>;
};


export type MutationOfferPropositionCreateArgs = {
  input: OfferPropositionCreateMutationInput;
};


export type MutationOfferPropositionUpdateArgs = {
  input: OfferPropositionUpdateMutationInput;
};


export type MutationPartialUpdateOrderModelArgs = {
  input: PartialUpdateOrderModelMutationInput;
};


export type MutationProp2Args = {
  input: PropositionMutationInput;
};


export type MutationPropositionArgs = {
  input: OfferPropositionMutationInput;
};


export type MutationPropositionDeleteArgs = {
  input: OfferPropositionDeleteMutationInput;
};


export type MutationPropositionUpdateArgs = {
  input: OfferPropositionUpdateMutationInput;
};


export type MutationResendOrderSigningArgs = {
  id?: InputMaybe<Scalars['ID']>;
};


export type MutationSaveRequirementsArgs = {
  inputList: Array<InputMaybe<CandidateRequirementsEvaluationInput>>;
};


export type MutationScheduleUpdateArgs = {
  input: Array<InputMaybe<Scalars['Int']>>;
};


export type MutationSendOrderDocumentToClientArgs = {
  input: CreateDocumentMutationInput;
};


export type MutationSendOrderSummariesArgs = {
  companyId?: InputMaybe<Scalars['ID']>;
  dateFrom?: InputMaybe<Scalars['Date']>;
  dateTo?: InputMaybe<Scalars['Date']>;
  emails?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  orderIds?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
};


export type MutationSendSmsArgs = {
  candidateId?: InputMaybe<Scalars['ID']>;
  text?: InputMaybe<Scalars['String']>;
};


export type MutationSpecificationCreateArgs = {
  input: SpecificationModelCreateMutationInput;
};


export type MutationSpecificationUpdateArgs = {
  input: SpecificationModelUpdateMutationInput;
};


export type MutationSubmitOrderArgs = {
  input?: InputMaybe<Scalars['Int']>;
};


export type MutationSyncCompanyLabelsArgs = {
  companyId: Scalars['ID'];
  date?: InputMaybe<Scalars['Date']>;
  syncLivas?: InputMaybe<Scalars['Boolean']>;
  syncWorkis?: InputMaybe<Scalars['Boolean']>;
};


export type MutationTriggerCandidateUpdateArgs = {
  input?: InputMaybe<TriggerCandidateUpdateInput>;
};


export type MutationUnEscalateMetricValueFromDashboardsArgs = {
  escalationId: Scalars['ID'];
};


export type MutationUnEscalateTaskFromDashboardsArgs = {
  escalationId: Scalars['ID'];
};


export type MutationUpdateCompanyArgs = {
  contractorId: Scalars['ID'];
  id: Scalars['Int'];
  livasId?: InputMaybe<Scalars['Int']>;
};


export type MutationUpdateCompanyDescriptionArgs = {
  color?: InputMaybe<CompanyLights>;
  description?: InputMaybe<Scalars['String']>;
  id: Scalars['Int'];
  salesQuestionnaire?: InputMaybe<Scalars['String']>;
};


export type MutationUpdateCompanyManagersArgs = {
  companyIds: Array<InputMaybe<Scalars['ID']>>;
  projectManager1?: InputMaybe<Scalars['ID']>;
  projectManager2?: InputMaybe<Scalars['ID']>;
  recruiter1?: InputMaybe<Scalars['ID']>;
  recruiter2?: InputMaybe<Scalars['ID']>;
  substituteManager1?: InputMaybe<Scalars['ID']>;
  substituteManager2?: InputMaybe<Scalars['ID']>;
  substituteRecruiter1?: InputMaybe<Scalars['ID']>;
  substituteRecruiter2?: InputMaybe<Scalars['ID']>;
};


export type MutationUpdateCompanyModelArgs = {
  input: UpdateCompanyModelInput;
};


export type MutationUpdateCompanyRelayArgs = {
  color?: InputMaybe<CompanyLights>;
  description?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  salesQuestionnaire?: InputMaybe<Scalars['String']>;
};


export type MutationUpdateContactArgs = {
  id: Scalars['Int'];
  input?: InputMaybe<ContactInput>;
};


export type MutationUpdateDashboardCardArgs = {
  input: UpdateDashboardCardInput;
};


export type MutationUpdateLivasCandidateStatusArgs = {
  livasStatusId?: InputMaybe<Scalars['Int']>;
  offerProposition?: InputMaybe<Scalars['ID']>;
};


export type MutationUpdateMetricValueArgs = {
  input: UpdateMetricValueInput;
};


export type MutationUpdateMetricValueCommentArgs = {
  input: UpdateMetricValueCommentInput;
};


export type MutationUpdateOffboardingRoleArgs = {
  id: Scalars['ID'];
  input: OffboardingRoleInput;
};


export type MutationUpdateOfferPropositionCommentArgs = {
  input: UpdateOfferPropositionCommentInput;
};


export type MutationUpdateOperationsTaskArgs = {
  input: UpdateOperationsTaskInput;
};


export type MutationUpdateOrderArgs = {
  id: Scalars['ID'];
  input: OrderInput;
  periods?: InputMaybe<Array<InputMaybe<OrderPeriodInput>>>;
};


export type MutationUpdateRequestsActivityArgs = {
  input: UpdateRequestsActivityInput;
};


export type MutationUpdateSelectionActionArgs = {
  input: UpdateSelectionActionInput;
};


export type MutationUpdateSpecificationArgs = {
  id: Scalars['ID'];
  input: SpecificationInput;
};


export type MutationUpdateTaskScheduleArgs = {
  input: UpdateScheduleInput;
};

/** An error that happened in a mutation. */
export type MutationErrorType = {
  __typename?: 'MutationErrorType';
  /** The field that caused the error, or `null` if it isn't associated with any particular field. */
  field?: Maybe<Scalars['String']>;
  /** The error message. */
  message?: Maybe<Scalars['String']>;
};

export type NextTaskType = {
  __typename?: 'NextTaskType';
  date?: Maybe<Scalars['String']>;
  message?: Maybe<Scalars['String']>;
};

/** An object with an ID */
export type Node = {
  /** The ID of the object. */
  id: Scalars['ID'];
};

export type OffboardingActionInput = {
  description: Scalars['String'];
  order?: InputMaybe<Scalars['Int']>;
};

export type OffboardingActionType = Node & {
  __typename?: 'OffboardingActionType';
  createdAt: Scalars['DateTime'];
  /** Description of the offboarding action/requirement */
  description: Scalars['String'];
  /** The ID of the object. */
  id: Scalars['ID'];
  /** Order in which actions should be displayed */
  order: Scalars['Int'];
  role: OffboardingRoleType;
};

export type OffboardingRoleInput = {
  actions?: InputMaybe<Array<InputMaybe<OffboardingActionInput>>>;
  companyId: Scalars['ID'];
  id?: InputMaybe<Scalars['ID']>;
  name: Scalars['String'];
};

export type OffboardingRoleType = Node & {
  __typename?: 'OffboardingRoleType';
  actions?: Maybe<Array<Maybe<OffboardingActionType>>>;
  company: CompanyType;
  createdAt: Scalars['DateTime'];
  /** The ID of the object. */
  id: Scalars['ID'];
  /** Name of the role (e.g., 'Software Engineer', 'Manager') */
  name: Scalars['String'];
  /** Offboarding roles/checklists to use when this order/contract is terminated */
  orders: OrderTypeConnection;
  updatedAt?: Maybe<Scalars['DateTime']>;
};


export type OffboardingRoleTypeOrdersArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};

export type OffboardingRoleTypeConnection = {
  __typename?: 'OffboardingRoleTypeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<OffboardingRoleTypeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** The total count of objects in this query. */
  totalCount?: Maybe<Scalars['Int']>;
};

/** A Relay edge containing a `OffboardingRoleType` and its cursor. */
export type OffboardingRoleTypeEdge = {
  __typename?: 'OffboardingRoleTypeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<OffboardingRoleType>;
};

export type OfferPropositionCommentType = Node & {
  __typename?: 'OfferPropositionCommentType';
  createdAt: Scalars['DateTime'];
  createdBy: UserProfileMType;
  /** The ID of the object. */
  id: Scalars['ID'];
  livasId?: Maybe<Scalars['Int']>;
  offerProposition: OfferPropositionType;
  text?: Maybe<Scalars['String']>;
};

export type OfferPropositionCommentTypeConnection = {
  __typename?: 'OfferPropositionCommentTypeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<OfferPropositionCommentTypeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** The total count of objects in this query. */
  totalCount?: Maybe<Scalars['Int']>;
};

/** A Relay edge containing a `OfferPropositionCommentType` and its cursor. */
export type OfferPropositionCommentTypeEdge = {
  __typename?: 'OfferPropositionCommentTypeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<OfferPropositionCommentType>;
};

export type OfferPropositionCreateMutationInput = {
  cancellationReasons?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  candidate?: InputMaybe<Scalars['ID']>;
  /** Set list of events */
  candidateEvents?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  clientMutationId?: InputMaybe<Scalars['String']>;
  comment?: InputMaybe<Scalars['String']>;
  createdBy?: InputMaybe<Scalars['ID']>;
  deleted?: InputMaybe<Scalars['DateTime']>;
  /** Set list of events */
  eventSet?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  firstInterestedAt?: InputMaybe<Scalars['DateTime']>;
  firstInterestedCreatedBy?: InputMaybe<Scalars['ID']>;
  firstInterestedOnCallBy?: InputMaybe<Scalars['ID']>;
  firstOfferedOnCallBy?: InputMaybe<Scalars['ID']>;
  interested?: InputMaybe<OfferPropositionInterested>;
  interestedOnCall?: InputMaybe<OfferPropositionInterestedOnCall>;
  lastUpdatedAt?: InputMaybe<Scalars['DateTime']>;
  longListed?: InputMaybe<OfferPropositionLongListed>;
  longListedAt?: InputMaybe<Scalars['DateTime']>;
  offeredOnCallAt?: InputMaybe<Scalars['DateTime']>;
  order?: InputMaybe<Scalars['ID']>;
  personId?: InputMaybe<Scalars['Int']>;
  rejectedWithoutCallReasons?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** This field is used for contract making in LIVAS */
  signed?: InputMaybe<Scalars['Boolean']>;
  signedAt?: InputMaybe<Scalars['DateTime']>;
};

export type OfferPropositionCreateMutationPayload = {
  __typename?: 'OfferPropositionCreateMutationPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  /** List of errors that occurred while executing the mutation. */
  errors?: Maybe<Array<MutationErrorType>>;
  /** The mutated object. */
  offerProposition?: Maybe<OfferPropositionType>;
};

export type OfferPropositionDeleteMutationInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The ID of the object. */
  id: Scalars['ID'];
};

export type OfferPropositionDeleteMutationPayload = {
  __typename?: 'OfferPropositionDeleteMutationPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  /** List of errors that occurred while executing the mutation. */
  errors?: Maybe<Array<MutationErrorType>>;
  /** The mutated object. */
  offerProposition?: Maybe<OfferPropositionType>;
};

/** An enumeration. */
export enum OfferPropositionInterested {
  /** Interested */
  Interested = 'INTERESTED',
  /** Not Interested */
  NotInterested = 'NOT_INTERESTED',
  /** Undecided */
  Undecided = 'UNDECIDED'
}

/** An enumeration. */
export enum OfferPropositionInterestedOnCall {
  /** Interested */
  Interested = 'INTERESTED',
  /** Not Interested */
  NotInterested = 'NOT_INTERESTED',
  /** Undecided */
  Undecided = 'UNDECIDED'
}

/** An enumeration. */
export enum OfferPropositionLongListed {
  /** Included */
  Included = 'INCLUDED',
  /** Rejected without call */
  RejectedWithoutCall = 'REJECTED_WITHOUT_CALL'
}

export type OfferPropositionMutationInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  comment?: InputMaybe<Scalars['String']>;
  createdBy?: InputMaybe<Scalars['ID']>;
  id?: InputMaybe<Scalars['ID']>;
  interested?: InputMaybe<Scalars['String']>;
  interestedOnCall?: InputMaybe<Scalars['String']>;
  lastUpdatedAt?: InputMaybe<Scalars['DateTime']>;
  longListed?: InputMaybe<Scalars['String']>;
  order: Scalars['ID'];
  personId: Scalars['Int'];
  /** This field is used for contract making in LIVAS */
  signed?: InputMaybe<Scalars['Boolean']>;
};

export type OfferPropositionMutationPayload = {
  __typename?: 'OfferPropositionMutationPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  offerProposition?: Maybe<OfferPropositionType>;
  proposition?: Maybe<OfferPropositionType>;
};

export type OfferPropositionStats = {
  __typename?: 'OfferPropositionStats';
  employmentEvent?: Maybe<StageStats>;
  healthCheckEvent?: Maybe<StageStats>;
  interestedOnPhone?: Maybe<StageStats>;
  longListed?: Maybe<StageStats>;
};

export type OfferPropositionStatsType = {
  __typename?: 'OfferPropositionStatsType';
  interestedCallCount?: Maybe<Scalars['Int']>;
  interestedCount?: Maybe<Scalars['Int']>;
  notInterestedCallCount?: Maybe<Scalars['Int']>;
  notInterestedCount?: Maybe<Scalars['Int']>;
  signed?: Maybe<Scalars['Int']>;
  totalInterested?: Maybe<Scalars['Int']>;
  totalNotInterested?: Maybe<Scalars['Int']>;
  totalOffered?: Maybe<Scalars['Int']>;
};

export type OfferPropositionType = Node & {
  __typename?: 'OfferPropositionType';
  cancellationReasons: CancellationReasonTypeConnection;
  cancellationreasonassignmentSet: CancellationReasonAssignmentTypeConnection;
  candidate?: Maybe<CandidateType>;
  candidateEvents: CandidateEventTypeConnection;
  candidaterequirementsevaluationSet: CandidateRequirementsEvaluationTypeConnection;
  comment?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  createdBy?: Maybe<UserProfileMType>;
  deleted?: Maybe<Scalars['DateTime']>;
  eventSet: CandidateEventTypeConnection;
  firstInterestedAt?: Maybe<Scalars['DateTime']>;
  firstInterestedCreatedBy?: Maybe<UserProfileMType>;
  firstInterestedOnCallBy?: Maybe<UserProfileMType>;
  firstOfferedOnCallBy?: Maybe<UserProfileMType>;
  /** The ID of the object. */
  id: Scalars['ID'];
  interested?: Maybe<OfferPropositionInterested>;
  interestedOnCall?: Maybe<OfferPropositionInterestedOnCall>;
  lastUpdatedAt?: Maybe<Scalars['DateTime']>;
  longListed?: Maybe<OfferPropositionLongListed>;
  longListedAt?: Maybe<Scalars['DateTime']>;
  offeredOnCallAt?: Maybe<Scalars['DateTime']>;
  offerpropositioncommentSet: OfferPropositionCommentTypeConnection;
  order: OrderType;
  personId: Scalars['Int'];
  rejectedWithoutCallReasons: CancellationReasonTypeConnection;
  /** This field is used for contract making in LIVAS */
  signed: Scalars['Boolean'];
  signedAt?: Maybe<Scalars['DateTime']>;
};


export type OfferPropositionTypeCancellationReasonsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Scalars['String']>;
};


export type OfferPropositionTypeCancellationreasonassignmentSetArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offerProposition?: InputMaybe<Scalars['ID']>;
};


export type OfferPropositionTypeCandidateEventsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  deleted?: InputMaybe<Scalars['Boolean']>;
  eventType?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  startDatetime_Gte?: InputMaybe<Scalars['DateTime']>;
  startDatetime_Lte?: InputMaybe<Scalars['DateTime']>;
};


export type OfferPropositionTypeCandidaterequirementsevaluationSetArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type OfferPropositionTypeEventSetArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  deleted?: InputMaybe<Scalars['Boolean']>;
  eventType?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  startDatetime_Gte?: InputMaybe<Scalars['DateTime']>;
  startDatetime_Lte?: InputMaybe<Scalars['DateTime']>;
};


export type OfferPropositionTypeOfferpropositioncommentSetArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  createdBy?: InputMaybe<Scalars['ID']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offerProposition?: InputMaybe<Scalars['ID']>;
  orderBy?: InputMaybe<Scalars['String']>;
};


export type OfferPropositionTypeRejectedWithoutCallReasonsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Scalars['String']>;
};

export type OfferPropositionTypeConnection = {
  __typename?: 'OfferPropositionTypeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<OfferPropositionTypeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** The total count of objects in this query. */
  totalCount?: Maybe<Scalars['Int']>;
};

/** A Relay edge containing a `OfferPropositionType` and its cursor. */
export type OfferPropositionTypeEdge = {
  __typename?: 'OfferPropositionTypeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<OfferPropositionType>;
};

export type OfferPropositionUpdateMutationInput = {
  cancellationReasons?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  candidate?: InputMaybe<Scalars['ID']>;
  /** Set list of events */
  candidateEvents?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  clientMutationId?: InputMaybe<Scalars['String']>;
  comment?: InputMaybe<Scalars['String']>;
  createdBy?: InputMaybe<Scalars['ID']>;
  deleted?: InputMaybe<Scalars['DateTime']>;
  /** Set list of events */
  eventSet?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  firstInterestedAt?: InputMaybe<Scalars['DateTime']>;
  firstInterestedCreatedBy?: InputMaybe<Scalars['ID']>;
  firstInterestedOnCallBy?: InputMaybe<Scalars['ID']>;
  firstOfferedOnCallBy?: InputMaybe<Scalars['ID']>;
  /** The ID of the object. */
  id: Scalars['ID'];
  interested?: InputMaybe<OfferPropositionInterested>;
  interestedOnCall?: InputMaybe<OfferPropositionInterestedOnCall>;
  lastUpdatedAt?: InputMaybe<Scalars['DateTime']>;
  longListed?: InputMaybe<OfferPropositionLongListed>;
  longListedAt?: InputMaybe<Scalars['DateTime']>;
  offeredOnCallAt?: InputMaybe<Scalars['DateTime']>;
  order?: InputMaybe<Scalars['ID']>;
  personId?: InputMaybe<Scalars['Int']>;
  rejectedWithoutCallReasons?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** This field is used for contract making in LIVAS */
  signed?: InputMaybe<Scalars['Boolean']>;
  signedAt?: InputMaybe<Scalars['DateTime']>;
};

export type OfferPropositionUpdateMutationPayload = {
  __typename?: 'OfferPropositionUpdateMutationPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  /** List of errors that occurred while executing the mutation. */
  errors?: Maybe<Array<MutationErrorType>>;
  /** The mutated object. */
  offerProposition?: Maybe<OfferPropositionType>;
};

export type OrderClientContactedType = Node & {
  __typename?: 'OrderClientContactedType';
  createdAt: Scalars['DateTime'];
  createdBy: UserProfileMType;
  date: Scalars['Date'];
  /** The ID of the object. */
  id: Scalars['ID'];
  order: OrderType;
};

export type OrderClientContactedTypeConnection = {
  __typename?: 'OrderClientContactedTypeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<OrderClientContactedTypeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** The total count of objects in this query. */
  totalCount?: Maybe<Scalars['Int']>;
};

/** A Relay edge containing a `OrderClientContactedType` and its cursor. */
export type OrderClientContactedTypeEdge = {
  __typename?: 'OrderClientContactedTypeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<OrderClientContactedType>;
};

export type OrderCommentType = Node & {
  __typename?: 'OrderCommentType';
  comment?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  createdBy: UserProfileMType;
  /** The ID of the object. */
  id: Scalars['ID'];
  order: OrderType;
};

export type OrderCommentTypeConnection = {
  __typename?: 'OrderCommentTypeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<OrderCommentTypeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** A Relay edge containing a `OrderCommentType` and its cursor. */
export type OrderCommentTypeEdge = {
  __typename?: 'OrderCommentTypeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<OrderCommentType>;
};

export type OrderErrorCategoryType = Node & {
  __typename?: 'OrderErrorCategoryType';
  createdAt: Scalars['DateTime'];
  createdBy: UserProfileMType;
  /** The ID of the object. */
  id: Scalars['ID'];
  isActive: Scalars['Boolean'];
  ordererrorSet: OrderErrorTypeConnection;
  title?: Maybe<Scalars['String']>;
};


export type OrderErrorCategoryTypeOrdererrorSetArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};

export type OrderErrorCategoryTypeConnection = {
  __typename?: 'OrderErrorCategoryTypeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<OrderErrorCategoryTypeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** The total count of objects in this query. */
  totalCount?: Maybe<Scalars['Int']>;
};

/** A Relay edge containing a `OrderErrorCategoryType` and its cursor. */
export type OrderErrorCategoryTypeEdge = {
  __typename?: 'OrderErrorCategoryTypeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<OrderErrorCategoryType>;
};

export type OrderErrorType = Node & {
  __typename?: 'OrderErrorType';
  assignedTo?: Maybe<UserProfileMType>;
  category: OrderErrorCategoryType;
  comment: Scalars['String'];
  createdAt: Scalars['DateTime'];
  createdBy: UserProfileMType;
  /** The ID of the object. */
  id: Scalars['ID'];
  order: OrderType;
};

export type OrderErrorTypeConnection = {
  __typename?: 'OrderErrorTypeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<OrderErrorTypeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `OrderErrorType` and its cursor. */
export type OrderErrorTypeEdge = {
  __typename?: 'OrderErrorTypeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<OrderErrorType>;
};

export type OrderInput = {
  additionalClientContacts?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  additionalRegions?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  adsIds?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  biuroSignee?: InputMaybe<Scalars['ID']>;
  canGetBonuses?: InputMaybe<Scalars['Boolean']>;
  canIncreaseSalary?: InputMaybe<Scalars['Boolean']>;
  cancellationPeriod?: InputMaybe<Scalars['Int']>;
  candidatesToBeProvided?: InputMaybe<Scalars['String']>;
  clientContact?: InputMaybe<Scalars['ID']>;
  company?: InputMaybe<Scalars['ID']>;
  compensationForRecruitment?: InputMaybe<Scalars['String']>;
  contract?: InputMaybe<Scalars['ID']>;
  contractIdLivas?: InputMaybe<Scalars['ID']>;
  createdBy?: InputMaybe<Scalars['ID']>;
  createdFromBlank?: InputMaybe<Scalars['Boolean']>;
  demand?: InputMaybe<Scalars['Int']>;
  displayPlannedTermForProvision?: InputMaybe<Scalars['Boolean']>;
  exportFreetextRequirements?: InputMaybe<Scalars['Boolean']>;
  hourRateBruttoPermanent?: InputMaybe<Scalars['Float']>;
  indefiniteOrderInfo?: InputMaybe<Scalars['String']>;
  isCompanyInternational?: InputMaybe<Scalars['Boolean']>;
  isCompanyModern?: InputMaybe<Scalars['Boolean']>;
  isLogoPublicAllowed?: InputMaybe<Scalars['Boolean']>;
  isProposal?: InputMaybe<Scalars['Boolean']>;
  language?: InputMaybe<OrderLanguageEnum>;
  longTerm?: InputMaybe<Scalars['Boolean']>;
  minVsdfPayment?: InputMaybe<Scalars['String']>;
  nettoFrom?: InputMaybe<Scalars['Int']>;
  nettoTo?: InputMaybe<Scalars['Int']>;
  offboardingRoles?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  opportunityToEmployDirectly?: InputMaybe<Scalars['Boolean']>;
  orderCanBeExtended?: InputMaybe<Scalars['Boolean']>;
  orderCanBeExtendedComment?: InputMaybe<Scalars['String']>;
  orderNumber?: InputMaybe<Scalars['String']>;
  orderPeriodFrom?: InputMaybe<Scalars['Date']>;
  orderPeriodTo?: InputMaybe<Scalars['Date']>;
  orderType?: InputMaybe<Scalars['String']>;
  otherInfo?: InputMaybe<Scalars['String']>;
  passCommentToOrder?: InputMaybe<Scalars['Boolean']>;
  plannedTermForProvision?: InputMaybe<Scalars['String']>;
  priority?: InputMaybe<Scalars['String']>;
  projectManager?: InputMaybe<Scalars['ID']>;
  projectManagerEmail?: InputMaybe<Scalars['String']>;
  provisionOfInformationOnConclusion?: InputMaybe<Scalars['String']>;
  qualification?: InputMaybe<QualificationEnum>;
  recruiter?: InputMaybe<Scalars['ID']>;
  recruitmentProgressReportFrequency?: InputMaybe<Scalars['String']>;
  region?: InputMaybe<Scalars['ID']>;
  remunerationAmount?: InputMaybe<Scalars['String']>;
  reportingFrequencyStartDate?: InputMaybe<Scalars['Date']>;
  salaryInfo?: InputMaybe<Scalars['String']>;
  shortage?: InputMaybe<Scalars['Int']>;
  specification?: InputMaybe<Scalars['ID']>;
  subtype?: InputMaybe<OrderSubtypesEnum>;
  toBeReviewed?: InputMaybe<Scalars['Boolean']>;
  trafficGeneration?: InputMaybe<Scalars['String']>;
  warrantyPeriod?: InputMaybe<Scalars['String']>;
  workTimeRegistrationSystem?: InputMaybe<Scalars['String']>;
  workwearIssuedBy?: InputMaybe<Scalars['String']>;
};

/** An enumeration. */
export enum OrderLanguage {
  /** English */
  LanguageEn = 'LANGUAGE_EN',
  /** Estonian */
  LanguageEt = 'LANGUAGE_ET',
  /** Lithuanian */
  LanguageLt = 'LANGUAGE_LT',
  /** Latvian */
  LanguageLv = 'LANGUAGE_LV'
}

/** An enumeration. */
export enum OrderLanguageEnum {
  LanguageEn = 'LANGUAGE_EN',
  LanguageEt = 'LANGUAGE_ET',
  LanguageLt = 'LANGUAGE_LT',
  LanguageLv = 'LANGUAGE_LV'
}

export type OrderMType = Node & {
  __typename?: 'OrderMType';
  additionalClientContacts: ContactTypeConnection;
  additionalRegions: Array<RegionType>;
  adsIds?: Maybe<Array<Scalars['Int']>>;
  biuroSignee?: Maybe<UserProfileMType>;
  canGetBonuses?: Maybe<Scalars['Boolean']>;
  canIncreaseSalary?: Maybe<Scalars['Boolean']>;
  cancellationPeriod?: Maybe<Scalars['Int']>;
  candidatesToBeProvided?: Maybe<Scalars['String']>;
  clientContact?: Maybe<ContactType>;
  clientInterview?: Maybe<ClientInterviewType>;
  company?: Maybe<CompanyType>;
  compensationForRecruitment: Scalars['String'];
  confirmed: Scalars['Boolean'];
  confirmedDatetime?: Maybe<Scalars['DateTime']>;
  contract?: Maybe<ContractType>;
  createdBy?: Maybe<UserProfileMType>;
  createdDate: Scalars['DateTime'];
  createdFromBlank: Scalars['Boolean'];
  demand?: Maybe<Scalars['Int']>;
  displayPlannedTermForProvision?: Maybe<Scalars['Boolean']>;
  documentSet: DocumentTypeConnection;
  eventSet: EventTypeConnection;
  /** Field for freetext requirements to be included in document instead of selecting from the list */
  exportFreetextRequirements?: Maybe<Scalars['Boolean']>;
  generatedDocument?: Maybe<Scalars['String']>;
  hourRateBruttoPermanent?: Maybe<Scalars['Float']>;
  hourRateBruttoTrial?: Maybe<Scalars['Float']>;
  hourRateNettoPermanent?: Maybe<Scalars['Float']>;
  hourRateNettoTrial?: Maybe<Scalars['Float']>;
  /** The ID of the object. */
  id: Scalars['ID'];
  /** Information about indefinite/long-term orders */
  indefiniteOrderInfo?: Maybe<Scalars['String']>;
  insightlyId?: Maybe<Scalars['Int']>;
  isCompanyInternational?: Maybe<Scalars['Boolean']>;
  isCompanyModern?: Maybe<Scalars['Boolean']>;
  isLogoPublicAllowed?: Maybe<Scalars['Boolean']>;
  jobAds: JobAdAiContentTypeConnection;
  language: OrderLanguage;
  lastReviewed?: Maybe<Scalars['DateTime']>;
  metricvalueSet: MetricValueTypeConnection;
  minVsdfPayment?: Maybe<Scalars['String']>;
  nettoFrom?: Maybe<Scalars['Int']>;
  nettoTo?: Maybe<Scalars['Int']>;
  /** Offboarding roles/checklists to use when this order/contract is terminated */
  offboardingRoles: OffboardingRoleTypeConnection;
  offerpropositionSet: OfferPropositionTypeConnection;
  opportunityToEmployDirectly?: Maybe<Scalars['Boolean']>;
  orderCanBeExtended?: Maybe<Scalars['Boolean']>;
  orderCanBeExtendedComment?: Maybe<Scalars['String']>;
  orderDate?: Maybe<Scalars['Date']>;
  orderNumber?: Maybe<Scalars['String']>;
  orderPeriodFromBackup?: Maybe<Scalars['Date']>;
  orderPeriodToBackup?: Maybe<Scalars['Date']>;
  orderType: OrderOrderType;
  orderclientcontactedSet: OrderClientContactedTypeConnection;
  ordercommentSet: OrderCommentTypeConnection;
  ordererrorSet: OrderErrorTypeConnection;
  ordermetrics?: Maybe<OrderMetricType>;
  orderperiodSet: Array<OrderPeriodType>;
  otherInfo?: Maybe<Scalars['String']>;
  passCommentToOrder?: Maybe<Scalars['Boolean']>;
  periodMonths?: Maybe<Scalars['Int']>;
  plannedCandidateNumber?: Maybe<Scalars['Int']>;
  plannedTermForProvision?: Maybe<Scalars['String']>;
  priority?: Maybe<OrderPriority>;
  projectManager?: Maybe<UserProfileMType>;
  provisionOfInformationOnConclusion?: Maybe<Scalars['String']>;
  qualification: OrderQualification;
  recruiter?: Maybe<UserProfileMType>;
  /** Saved by user. Based on this data Metric value is calculated. Calculations will be done starting to count from order period from date */
  recruitmentProgressReportFrequency?: Maybe<OrderRecruitmentProgressReportFrequency>;
  region?: Maybe<RegionType>;
  rejectedDatetime?: Maybe<Scalars['DateTime']>;
  remunerationAmount?: Maybe<Scalars['String']>;
  /** The date from which the reporting frequency should take effect */
  reportingFrequencyStartDate?: Maybe<Scalars['Date']>;
  salaryInfo?: Maybe<Scalars['String']>;
  sent: Scalars['Boolean'];
  sentDatetime?: Maybe<Scalars['DateTime']>;
  shortage: Scalars['Int'];
  specification?: Maybe<SpecificationType>;
  status?: Maybe<OrderStatus>;
  subtype: OrderSubtype;
  taskSet: TaskTypeConnection;
  /** By marketing division */
  toBeReviewed: Scalars['Boolean'];
  token?: Maybe<Scalars['UUID']>;
  trafficGeneration: OrderTrafficGeneration;
  warrantyPeriod?: Maybe<Scalars['String']>;
  workTimeRegistrationSystem?: Maybe<Scalars['String']>;
  workisMarketing: Scalars['Boolean'];
  workwearIssuedBy: OrderWorkwearIssuedBy;
};


export type OrderMTypeAdditionalClientContactsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type OrderMTypeDocumentSetArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type OrderMTypeEventSetArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  date_Gte?: InputMaybe<Scalars['Date']>;
  date_Lte?: InputMaybe<Scalars['Date']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Scalars['ID']>;
};


export type OrderMTypeJobAdsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type OrderMTypeMetricvalueSetArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  cardId?: InputMaybe<Scalars['ID']>;
  channel?: InputMaybe<Scalars['String']>;
  dashboardId?: InputMaybe<Scalars['ID']>;
  dashboardRegion?: InputMaybe<Scalars['ID']>;
  date?: InputMaybe<Scalars['Date']>;
  dateFrom?: InputMaybe<Scalars['Date']>;
  dateTo?: InputMaybe<Scalars['Date']>;
  escalatedFrom?: InputMaybe<Scalars['ID']>;
  escalatedTo?: InputMaybe<Scalars['ID']>;
  escalatedToDashboard?: InputMaybe<Scalars['ID']>;
  first?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['ID']>;
  includeEscalated?: InputMaybe<Scalars['Boolean']>;
  isImportant?: InputMaybe<Scalars['Boolean']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type OrderMTypeOffboardingRolesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  company?: InputMaybe<Scalars['ID']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type OrderMTypeOfferpropositionSetArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type OrderMTypeOrderclientcontactedSetArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderId?: InputMaybe<Scalars['ID']>;
};


export type OrderMTypeOrdercommentSetArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderId?: InputMaybe<Scalars['ID']>;
};


export type OrderMTypeOrdererrorSetArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type OrderMTypeTaskSetArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};

export type OrderMTypeConnection = {
  __typename?: 'OrderMTypeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<OrderMTypeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `OrderMType` and its cursor. */
export type OrderMTypeEdge = {
  __typename?: 'OrderMTypeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<OrderMType>;
};

export type OrderMetricType = Node & {
  __typename?: 'OrderMetricType';
  /** Ratio of successful interview to total call */
  effortConversion?: Maybe<Scalars['Float']>;
  /** The ID of the object. */
  id: Scalars['ID'];
  /** Ratio successful interview to total interviews */
  interviewEffortConversion?: Maybe<Scalars['Float']>;
  lifetime?: Maybe<Scalars['Int']>;
  order: OrderType;
  successfulCalls?: Maybe<Scalars['Int']>;
  successfulInterviews?: Maybe<Scalars['Int']>;
  totalCalls?: Maybe<Scalars['Int']>;
  totalInterviews?: Maybe<Scalars['Int']>;
  updatedAt: Scalars['DateTime'];
};

export type OrderMetricTypeConnection = {
  __typename?: 'OrderMetricTypeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<OrderMetricTypeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `OrderMetricType` and its cursor. */
export type OrderMetricTypeEdge = {
  __typename?: 'OrderMetricTypeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<OrderMetricType>;
};

/** An enumeration. */
export enum OrderOrderType {
  /** Partial Selections */
  PartialSelections = 'PARTIAL_SELECTIONS',
  /** Selection only */
  Selection = 'SELECTION',
  /** Temp. Staffing */
  Staffing = 'STAFFING'
}

export type OrderPeriodInput = {
  dateFrom?: InputMaybe<Scalars['Date']>;
  dateTo?: InputMaybe<Scalars['Date']>;
  demand?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['ID']>;
  longTerm?: InputMaybe<Scalars['Boolean']>;
};

export type OrderPeriodType = {
  __typename?: 'OrderPeriodType';
  createdAt: Scalars['DateTime'];
  dateFrom: Scalars['Date'];
  dateTo?: Maybe<Scalars['Date']>;
  demand: Scalars['Int'];
  documentSet: DocumentTypeConnection;
  id: Scalars['ID'];
  longTerm: Scalars['Boolean'];
  order: OrderType;
};


export type OrderPeriodTypeDocumentSetArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};

/** An enumeration. */
export enum OrderPriority {
  /** High */
  High = 'HIGH',
  /** Low */
  Low = 'LOW',
  /** Normal */
  Normal = 'NORMAL'
}

/** An enumeration. */
export enum OrderQualification {
  /** Non-specialist */
  NonSpecialist = 'NON_SPECIALIST',
  /** Specialist */
  Specialist = 'SPECIALIST'
}

/** An enumeration. */
export enum OrderRecruitmentProgressReportFrequency {
  /** Every week */
  Every_1Week = 'EVERY_1_WEEK',
  /** Every 2 weeks */
  Every_2Weeks = 'EVERY_2_WEEKS',
  /** Every 3 weeks */
  Every_3Weeks = 'EVERY_3_WEEKS',
  /** Every 4 weeks */
  Every_4Weeks = 'EVERY_4_WEEKS'
}

/** An enumeration. */
export enum OrderStatus {
  /** Cancelled */
  Cancelled = 'CANCELLED',
  /** Completed */
  Completed = 'COMPLETED',
  /** Confirmed */
  Confirmed = 'CONFIRMED',
  /** Filled */
  Filled = 'FILLED',
  /** Generate applicant flow */
  GenerateFlow = 'GENERATE_FLOW',
  /** In progress */
  InProgress = 'IN_PROGRESS',
  /** Lost */
  Lost = 'LOST',
  /** New */
  New = 'NEW',
  /** Pending signature */
  PendingSignature = 'PENDING_SIGNATURE',
  /** Proposal */
  Proposal = 'PROPOSAL',
  /** Rejected */
  Rejected = 'REJECTED',
  /** Sent */
  Sent = 'SENT',
  /** Uploading */
  Uploading = 'UPLOADING'
}

/** An enumeration. */
export enum OrderSubtype {
  /** Order amendment */
  Amendment = 'AMENDMENT',
  /** New order */
  New = 'NEW',
  /** Order prolongation */
  Prolongation = 'PROLONGATION',
  /** Try and hire */
  TryNHire = 'TRY_N_HIRE'
}

/** An enumeration. */
export enum OrderSubtypesEnum {
  Amendment = 'AMENDMENT',
  New = 'NEW',
  Prolongation = 'PROLONGATION',
  TryNHire = 'TRY_N_HIRE'
}

/** An enumeration. */
export enum OrderTrafficGeneration {
  /** Offer in office, no marketing */
  ActiveNoMarketing = 'ACTIVE_NO_MARKETING',
  /** Offer in office and use marketing */
  ActiveWithMarketing = 'ACTIVE_WITH_MARKETING',
  /** Do not offer job for applicants */
  Inactive = 'INACTIVE',
  /** Marketing only */
  MarketingOnly = 'MARKETING_ONLY'
}

export type OrderType = Node & {
  __typename?: 'OrderType';
  additionalClientContacts: ContactTypeConnection;
  additionalRegions: Array<RegionType>;
  adsIds?: Maybe<Array<Scalars['Int']>>;
  biuroSignee?: Maybe<UserProfileMType>;
  canGetBonuses?: Maybe<Scalars['Boolean']>;
  canIncreaseSalary?: Maybe<Scalars['Boolean']>;
  cancellationPeriod?: Maybe<Scalars['Int']>;
  candidatesToBeProvided?: Maybe<Scalars['String']>;
  clientContact?: Maybe<ContactType>;
  clientInterview?: Maybe<ClientInterviewType>;
  company?: Maybe<CompanyType>;
  compensationForRecruitment: Scalars['String'];
  confirmed: Scalars['Boolean'];
  confirmedDatetime?: Maybe<Scalars['DateTime']>;
  contract?: Maybe<ContractType>;
  createdBy?: Maybe<UserProfileMType>;
  createdDate: Scalars['DateTime'];
  createdFromBlank: Scalars['Boolean'];
  dateFrom?: Maybe<Scalars['Date']>;
  dateTo?: Maybe<Scalars['Date']>;
  demand?: Maybe<Scalars['Int']>;
  displayPlannedTermForProvision?: Maybe<Scalars['Boolean']>;
  documentSet: DocumentTypeConnection;
  eventSet: EventTypeConnection;
  /** Field for freetext requirements to be included in document instead of selecting from the list */
  exportFreetextRequirements?: Maybe<Scalars['Boolean']>;
  generatedDocument?: Maybe<Scalars['String']>;
  hourRateBruttoPermanent?: Maybe<Scalars['Float']>;
  hourRateBruttoTrial?: Maybe<Scalars['Float']>;
  hourRateNettoPermanent?: Maybe<Scalars['Float']>;
  hourRateNettoTrial?: Maybe<Scalars['Float']>;
  /** The ID of the object. */
  id: Scalars['ID'];
  /** Information about indefinite/long-term orders */
  indefiniteOrderInfo?: Maybe<Scalars['String']>;
  insightlyId?: Maybe<Scalars['Int']>;
  isCompanyInternational?: Maybe<Scalars['Boolean']>;
  isCompanyModern?: Maybe<Scalars['Boolean']>;
  isLogoPublicAllowed?: Maybe<Scalars['Boolean']>;
  isLongTerm?: Maybe<Scalars['Boolean']>;
  jobAds: JobAdAiContentTypeConnection;
  language: OrderLanguage;
  lastDocument?: Maybe<DocumentType>;
  lastReviewed?: Maybe<Scalars['DateTime']>;
  metricvalueSet: MetricValueTypeConnection;
  minVsdfPayment?: Maybe<Scalars['String']>;
  nettoFrom?: Maybe<Scalars['Int']>;
  nettoTo?: Maybe<Scalars['Int']>;
  offboardingRoles?: Maybe<Array<Maybe<OffboardingRoleType>>>;
  offerPropositionStats?: Maybe<OfferPropositionStats>;
  offerpropositionSet: OfferPropositionTypeConnection;
  opportunityToEmployDirectly?: Maybe<Scalars['Boolean']>;
  orderCanBeExtended?: Maybe<Scalars['Boolean']>;
  orderCanBeExtendedComment?: Maybe<Scalars['String']>;
  orderDate?: Maybe<Scalars['Date']>;
  orderNumber?: Maybe<Scalars['String']>;
  orderPeriodFrom?: Maybe<Scalars['String']>;
  orderPeriodFromBackup?: Maybe<Scalars['Date']>;
  orderPeriodTo?: Maybe<Scalars['String']>;
  orderPeriodToBackup?: Maybe<Scalars['Date']>;
  orderType: OrderOrderType;
  orderclientcontactedSet: OrderClientContactedTypeConnection;
  ordercommentSet: OrderCommentTypeConnection;
  ordererrorSet: OrderErrorTypeConnection;
  ordermetrics?: Maybe<OrderMetricType>;
  orderperiodSet: Array<OrderPeriodType>;
  otherInfo?: Maybe<Scalars['String']>;
  passCommentToOrder?: Maybe<Scalars['Boolean']>;
  periodMonths?: Maybe<Scalars['Int']>;
  plannedCandidateNumber?: Maybe<Scalars['Int']>;
  plannedTermForProvision?: Maybe<Scalars['String']>;
  priority?: Maybe<OrderPriority>;
  projectManager?: Maybe<UserProfileMType>;
  provisionOfInformationOnConclusion?: Maybe<Scalars['String']>;
  qualification: OrderQualification;
  recruiter?: Maybe<UserProfileMType>;
  /** Saved by user. Based on this data Metric value is calculated. Calculations will be done starting to count from order period from date */
  recruitmentProgressReportFrequency?: Maybe<OrderRecruitmentProgressReportFrequency>;
  region?: Maybe<RegionType>;
  rejectedDatetime?: Maybe<Scalars['DateTime']>;
  remunerationAmount?: Maybe<Scalars['String']>;
  /** The date from which the reporting frequency should take effect */
  reportingFrequencyStartDate?: Maybe<Scalars['Date']>;
  salaryInfo?: Maybe<Scalars['String']>;
  sent: Scalars['Boolean'];
  sentDatetime?: Maybe<Scalars['DateTime']>;
  shortage: Scalars['Int'];
  specification?: Maybe<SpecificationType>;
  statsClientInterviews?: Maybe<Scalars['Int']>;
  statsEmployments?: Maybe<Scalars['Int']>;
  statsFutureInterview?: Maybe<Scalars['Int']>;
  statsInterested?: Maybe<Scalars['Int']>;
  statsOffered?: Maybe<Scalars['Int']>;
  status?: Maybe<OrderStatus>;
  subtype: OrderSubtype;
  taskSet: TaskTypeConnection;
  /** By marketing division */
  toBeReviewed: Scalars['Boolean'];
  token?: Maybe<Scalars['UUID']>;
  trafficGeneration: OrderTrafficGeneration;
  warrantyPeriod?: Maybe<Scalars['String']>;
  workTimeRegistrationSystem?: Maybe<Scalars['String']>;
  workisMarketing: Scalars['Boolean'];
  workwearIssuedBy: OrderWorkwearIssuedBy;
};


export type OrderTypeAdditionalClientContactsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type OrderTypeDocumentSetArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type OrderTypeEventSetArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  date_Gte?: InputMaybe<Scalars['Date']>;
  date_Lte?: InputMaybe<Scalars['Date']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Scalars['ID']>;
};


export type OrderTypeJobAdsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type OrderTypeMetricvalueSetArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  cardId?: InputMaybe<Scalars['ID']>;
  channel?: InputMaybe<Scalars['String']>;
  dashboardId?: InputMaybe<Scalars['ID']>;
  dashboardRegion?: InputMaybe<Scalars['ID']>;
  date?: InputMaybe<Scalars['Date']>;
  dateFrom?: InputMaybe<Scalars['Date']>;
  dateTo?: InputMaybe<Scalars['Date']>;
  escalatedFrom?: InputMaybe<Scalars['ID']>;
  escalatedTo?: InputMaybe<Scalars['ID']>;
  escalatedToDashboard?: InputMaybe<Scalars['ID']>;
  first?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['ID']>;
  includeEscalated?: InputMaybe<Scalars['Boolean']>;
  isImportant?: InputMaybe<Scalars['Boolean']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type OrderTypeOfferpropositionSetArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type OrderTypeOrderclientcontactedSetArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderId?: InputMaybe<Scalars['ID']>;
};


export type OrderTypeOrdercommentSetArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderId?: InputMaybe<Scalars['ID']>;
};


export type OrderTypeOrdererrorSetArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type OrderTypeTaskSetArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};

export type OrderTypeConnection = {
  __typename?: 'OrderTypeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<OrderTypeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** A Relay edge containing a `OrderType` and its cursor. */
export type OrderTypeEdge = {
  __typename?: 'OrderTypeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<OrderType>;
};

/** An enumeration. */
export enum OrderWorkwearIssuedBy {
  /** Įdarbinimo įmonė */
  Agency = 'AGENCY',
  /** Klientas */
  Client = 'CLIENT'
}

export type OrdersStats = {
  __typename?: 'OrdersStats';
  cancelled?: Maybe<Scalars['Int']>;
  confirmed?: Maybe<Scalars['Int']>;
  created?: Maybe<Scalars['Int']>;
  sent?: Maybe<Scalars['Int']>;
};

/** The Relay compliant `PageInfo` type, containing data necessary to paginate this connection. */
export type PageInfo = {
  __typename?: 'PageInfo';
  /** When paginating forwards, the cursor to continue. */
  endCursor?: Maybe<Scalars['String']>;
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean'];
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean'];
  /** When paginating backwards, the cursor to continue. */
  startCursor?: Maybe<Scalars['String']>;
};

export type PartialUpdateOrderModelMutationInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The ID of the object. */
  id: Scalars['ID'];
  priority?: InputMaybe<OrderPriority>;
  shortage?: InputMaybe<Scalars['Int']>;
  trafficGeneration?: InputMaybe<OrderTrafficGeneration>;
};

export type PartialUpdateOrderModelMutationPayload = {
  __typename?: 'PartialUpdateOrderModelMutationPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  /** List of errors that occurred while executing the mutation. */
  errors?: Maybe<Array<MutationErrorType>>;
  /** The mutated object. */
  order?: Maybe<OrderType>;
};

export type PersonalProtectiveEquipmentType = {
  __typename?: 'PersonalProtectiveEquipmentType';
  country?: Maybe<CountryType>;
  id: Scalars['ID'];
  specificationppeSet: Array<SpecificationPpeType>;
  specificationsBiuro: Array<SpecificationType>;
  specificationsClient: Array<SpecificationType>;
  title: Scalars['String'];
  titleEn?: Maybe<Scalars['String']>;
};

export type PropositionMutationInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  text: Scalars['String'];
};

export type PropositionMutationPayload = {
  __typename?: 'PropositionMutationPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  proposition?: Maybe<OfferPropositionType>;
};

/** An enumeration. */
export enum QualificationEnum {
  NonSpecialist = 'NON_SPECIALIST',
  Specialist = 'SPECIALIST'
}

export type Query = {
  __typename?: 'Query';
  aggregatedMetrics?: Maybe<Array<Maybe<AggregatedMetricValueType>>>;
  allDashboards?: Maybe<DashboardTypeConnection>;
  allReasons?: Maybe<ReasonTypeConnection>;
  allRequestsActivities?: Maybe<RequestsActivityTypeConnection>;
  cancellationReasonAssignments?: Maybe<CancellationReasonAssignmentTypeConnection>;
  cancellationReasonGroups?: Maybe<CancellationReasonGroupTypeConnection>;
  candidate?: Maybe<CandidateType>;
  candidateEvaluations?: Maybe<CandidateRequirementsEvaluationTypeConnection>;
  candidateEvents?: Maybe<CandidateEventTypeConnection>;
  candidateOrderStats?: Maybe<Array<Maybe<CandidateOrderStatsType>>>;
  candidateStatuses?: Maybe<CandidateStatusTypeConnection>;
  candidates?: Maybe<CandidateTypeConnection>;
  certificates?: Maybe<Array<Maybe<CertificateType>>>;
  cities?: Maybe<CityTypeConnection>;
  companies?: Maybe<CompanyTypeConnection>;
  company?: Maybe<CompanyModelType>;
  companyInstances?: Maybe<CompanyModelTypeConnection>;
  competences?: Maybe<CompetenceTypeConnection>;
  contact?: Maybe<ContactType>;
  contacts?: Maybe<ContactTypeConnection>;
  contract?: Maybe<ContractType>;
  contractToSignCount?: Maybe<Scalars['Int']>;
  contractToSignCountEe?: Maybe<Scalars['Int']>;
  contractToSignCountLv?: Maybe<Scalars['Int']>;
  contractors?: Maybe<ContractorTypeConnection>;
  contracts?: Maybe<Array<Maybe<ContractType>>>;
  conversionRatesTransregional?: Maybe<Array<Maybe<ConversionRatesTransregionalType>>>;
  countries?: Maybe<CountryTypeConnection>;
  customFieldValues?: Maybe<CustomFieldValueTypeConnection>;
  customFields?: Maybe<CustomFieldTypeConnection>;
  documents?: Maybe<DocumentTypeConnection>;
  hasPermission?: Maybe<Scalars['Boolean']>;
  images?: Maybe<Array<Maybe<ImageType>>>;
  inactiveApplications?: Maybe<Array<Maybe<WaitingApplication>>>;
  inventaPrivateEmployees?: Maybe<Array<Maybe<InventaEmployee>>>;
  jobAdsContentAi?: Maybe<JobAdAiContentType>;
  jobCategories?: Maybe<JobCategoryTypeConnection>;
  label?: Maybe<LabelType>;
  labels?: Maybe<LabelTypeConnection>;
  livasData?: Maybe<LivasData>;
  livasJobAds?: Maybe<Array<Maybe<LivasJobAdContentType>>>;
  me?: Maybe<UserProfileMType>;
  medicalCertificateReviewCount?: Maybe<Scalars['Int']>;
  metricGroups?: Maybe<MetricGroupTypeConnection>;
  metricGroupsAssignment?: Maybe<MetricGroupAssignmentTypeConnection>;
  metricValueComments?: Maybe<MetricValueCommentTypeConnection>;
  metricValues?: Maybe<MetricValueTypeConnection>;
  nextTaskDate?: Maybe<NextTaskType>;
  offboardingRoles?: Maybe<OffboardingRoleTypeConnection>;
  offerPropositionComments?: Maybe<OfferPropositionCommentTypeConnection>;
  offerPropositionStats?: Maybe<OfferPropositionStatsType>;
  offers?: Maybe<OfferPropositionTypeConnection>;
  openZohoTicketCount?: Maybe<Scalars['Int']>;
  operationTasks?: Maybe<TaskTypeConnection>;
  operationsDateOffsetForEmployeesTask?: Maybe<Scalars['Int']>;
  order?: Maybe<OrderType>;
  orderChangeLog?: Maybe<Array<Maybe<SpecficationChangeLogType>>>;
  orderComments?: Maybe<OrderCommentTypeConnection>;
  orderContacts?: Maybe<OrderClientContactedTypeConnection>;
  orderErrorCategories?: Maybe<OrderErrorCategoryTypeConnection>;
  orderErrors?: Maybe<OrderErrorTypeConnection>;
  orderMetrics?: Maybe<OrderMetricTypeConnection>;
  orderModel?: Maybe<OrderMType>;
  orders?: Maybe<OrderMTypeConnection>;
  ordersPaginated?: Maybe<OrderTypeConnection>;
  personalProtectiveEquipment?: Maybe<Array<Maybe<PersonalProtectiveEquipmentType>>>;
  plannerCategories?: Maybe<Array<Maybe<CategoryType>>>;
  plannerChannels?: Maybe<Array<Maybe<ChannelType>>>;
  plannerEvents?: Maybe<EventTypeConnection>;
  ppeItems?: Maybe<Array<Maybe<SpecificationPpeType>>>;
  regions?: Maybe<Array<Maybe<RegionType>>>;
  regionsGroups?: Maybe<RegionGroupTypeConnection>;
  regionsRelay?: Maybe<RegionMTypeConnection>;
  requestsActivities?: Maybe<RequestsActivityTypeConnection>;
  requirements?: Maybe<Array<Maybe<RequirementType>>>;
  reservedTimes?: Maybe<ReservedTimeTypeConnection>;
  riskFactors?: Maybe<Array<Maybe<RiskFactorType>>>;
  scheduleTypes?: Maybe<Array<Maybe<ScheduleTypeType>>>;
  searchResults?: Maybe<SearchResultsTypeConnection>;
  selectedByClientTodayApplications?: Maybe<Array<Maybe<SelectedByClientApplication>>>;
  selectedByClientTodayApplicationsLv?: Maybe<Array<Maybe<SelectedByClientApplication>>>;
  selectedByClientTomorrowApplications?: Maybe<Array<Maybe<SelectedByClientApplication>>>;
  selectedByClientTwoWeeksUpfrontApplicationsLv?: Maybe<Array<Maybe<SelectedByClientApplication>>>;
  selectionActionCategories?: Maybe<SaCategoryTypeConnection>;
  selectionActionCategoryGroups?: Maybe<SaCategoryGroupTypeConnection>;
  selectionActions?: Maybe<SelectionActionTypeConnection>;
  specification?: Maybe<SpecificationType>;
  specifications?: Maybe<Array<Maybe<SpecificationType>>>;
  statsGetAggregatedDemandSelection?: Maybe<Array<Maybe<DateStats>>>;
  statsGetAggregatedDemandStaffing?: Maybe<Array<Maybe<DateStats>>>;
  statsOrderCandidateStatsForPeriod?: Maybe<CandidateStats>;
  statsOrderStatsForPeriod?: Maybe<OrdersStats>;
  statsUnseenProcessedOrdersAccepted?: Maybe<Scalars['Int']>;
  statsUnseenProcessedOrdersRejected?: Maybe<Scalars['Int']>;
  tags?: Maybe<Array<Maybe<TagType>>>;
  tagsGroups?: Maybe<Array<Maybe<TagGroupType>>>;
  task?: Maybe<TaskType>;
  taskSchedules?: Maybe<ScheduleTypeConnection>;
  tasks?: Maybe<TaskTypeConnection>;
  unsignedByEmployeeContractCount?: Maybe<Scalars['Int']>;
  unsignedGigroupContractCount?: Maybe<Scalars['Int']>;
  updatedCandidates?: Maybe<UpdatedCandidateListType>;
  userprofile?: Maybe<UserProfileMType>;
  userprofiles?: Maybe<Array<Maybe<UserProfileMType>>>;
  virtualNumbers?: Maybe<Array<Maybe<VirtualNumberType>>>;
  waitingTomorrowApplications?: Maybe<Array<Maybe<WaitingApplication>>>;
  waitingTomorrowApplicationsLv?: Maybe<Array<Maybe<WaitingApplication>>>;
};


export type QueryAggregatedMetricsArgs = {
  dateFrom: Scalars['Date'];
  dateTo: Scalars['Date'];
  metricGroupIds: Array<InputMaybe<Scalars['ID']>>;
  regionGroupId: Scalars['ID'];
};


export type QueryAllDashboardsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['ID']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type QueryAllReasonsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['String']>;
  department?: InputMaybe<Scalars['ID']>;
  departmentKey?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['ID']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
};


export type QueryAllRequestsActivitiesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  createdAt_Gte?: InputMaybe<Scalars['Date']>;
  createdAt_Lte?: InputMaybe<Scalars['Date']>;
  createdBy?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['ID']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
};


export type QueryCancellationReasonAssignmentsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offerProposition?: InputMaybe<Scalars['ID']>;
};


export type QueryCancellationReasonGroupsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['ID']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Scalars['String']>;
};


export type QueryCandidateArgs = {
  id?: InputMaybe<Scalars['Int']>;
  livasId?: InputMaybe<Scalars['Int']>;
};


export type QueryCandidateEvaluationsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  candidate?: InputMaybe<Scalars['ID']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offerProposition?: InputMaybe<Scalars['ID']>;
  order?: InputMaybe<Scalars['ID']>;
  orderBy?: InputMaybe<Scalars['String']>;
};


export type QueryCandidateEventsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  candidate?: InputMaybe<Scalars['ID']>;
  candidateLivasId?: InputMaybe<Scalars['Float']>;
  eventType?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['ID']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Scalars['String']>;
  orderId?: InputMaybe<Scalars['ID']>;
  startDate_Gte?: InputMaybe<Scalars['Date']>;
};


export type QueryCandidateOrderStatsArgs = {
  companyIds?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  dateFrom?: InputMaybe<Scalars['Date']>;
  dateTo?: InputMaybe<Scalars['Date']>;
  orderIds?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
};


export type QueryCandidateStatusesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['ID']>;
  last?: InputMaybe<Scalars['Int']>;
  titleEe?: InputMaybe<Scalars['String']>;
  titleLt?: InputMaybe<Scalars['String']>;
  titleLv?: InputMaybe<Scalars['String']>;
};


export type QueryCandidatesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['ID']>;
  countryIso?: InputMaybe<Scalars['String']>;
  employeeLivasId?: InputMaybe<Scalars['Float']>;
  eventFrom?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  livasId?: InputMaybe<Scalars['Float']>;
  metricValueCommentId?: InputMaybe<Scalars['ID']>;
};


export type QueryCertificatesArgs = {
  country?: InputMaybe<Scalars['ID']>;
  language?: InputMaybe<Scalars['String']>;
};


export type QueryCitiesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  region?: InputMaybe<Scalars['ID']>;
  title?: InputMaybe<Scalars['String']>;
};


export type QueryCompaniesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['ID']>;
  first?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['ID']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  last?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  nameExact?: InputMaybe<Scalars['String']>;
  orderBy?: InputMaybe<Scalars['String']>;
  projectManager?: InputMaybe<Scalars['ID']>;
  recruiter?: InputMaybe<Scalars['ID']>;
  substituteManager?: InputMaybe<Scalars['ID']>;
  substituteRecruiter?: InputMaybe<Scalars['ID']>;
};


export type QueryCompanyArgs = {
  id: Scalars['ID'];
};


export type QueryCompanyInstancesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['ID']>;
  first?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['ID']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  last?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  nameExact?: InputMaybe<Scalars['String']>;
  orderBy?: InputMaybe<Scalars['String']>;
  projectManager?: InputMaybe<Scalars['ID']>;
  recruiter?: InputMaybe<Scalars['ID']>;
  substituteManager?: InputMaybe<Scalars['ID']>;
  substituteRecruiter?: InputMaybe<Scalars['ID']>;
};


export type QueryCompetencesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['ID']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type QueryContactArgs = {
  id?: InputMaybe<Scalars['Int']>;
};


export type QueryContactsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  canUseInOrder?: InputMaybe<Scalars['Boolean']>;
  company?: InputMaybe<Scalars['ID']>;
  country?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['ID']>;
  last?: InputMaybe<Scalars['Int']>;
  phone?: InputMaybe<Scalars['String']>;
  search?: InputMaybe<Scalars['String']>;
};


export type QueryContractArgs = {
  id?: InputMaybe<Scalars['Int']>;
};


export type QueryContractorsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['ID']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type QueryConversionRatesTransregionalArgs = {
  cardId: Scalars['ID'];
  conversionType?: InputMaybe<Scalars['String']>;
  dashboardId: Scalars['ID'];
  date: Scalars['Date'];
};


export type QueryCountriesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['ID']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type QueryCustomFieldValuesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  customField?: InputMaybe<Scalars['ID']>;
  first?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['ID']>;
  keys?: InputMaybe<Scalars['String']>;
  last?: InputMaybe<Scalars['Int']>;
  task?: InputMaybe<Scalars['ID']>;
  taskIds?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
};


export type QueryCustomFieldsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  fieldType?: InputMaybe<Scalars['ID']>;
  first?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['ID']>;
  last?: InputMaybe<Scalars['Int']>;
  saCategory?: InputMaybe<Scalars['ID']>;
};


export type QueryDocumentsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['ID']>;
  last?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Scalars['ID']>;
  orderBy?: InputMaybe<Scalars['String']>;
};


export type QueryHasPermissionArgs = {
  title?: InputMaybe<Scalars['String']>;
};


export type QueryImagesArgs = {
  userId?: InputMaybe<Scalars['Int']>;
};


export type QueryJobAdsContentAiArgs = {
  orderId: Scalars['Int'];
};


export type QueryJobCategoriesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['ID']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Scalars['String']>;
};


export type QueryLabelArgs = {
  id: Scalars['ID'];
};


export type QueryLabelsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['ID']>;
  first?: InputMaybe<Scalars['Int']>;
  group_Key?: InputMaybe<Scalars['String']>;
  key?: InputMaybe<Scalars['String']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type QueryLivasJobAdsArgs = {
  orderId: Scalars['ID'];
};


export type QueryMetricGroupsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['ID']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type QueryMetricGroupsAssignmentArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  card?: InputMaybe<Scalars['ID']>;
  first?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['ID']>;
  last?: InputMaybe<Scalars['Int']>;
  metricGroup?: InputMaybe<Scalars['ID']>;
};


export type QueryMetricValueCommentsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['ID']>;
  last?: InputMaybe<Scalars['Int']>;
  metricValue?: InputMaybe<Scalars['ID']>;
  metricValueIds?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
};


export type QueryMetricValuesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  cardId?: InputMaybe<Scalars['ID']>;
  channel?: InputMaybe<Scalars['String']>;
  dashboardId?: InputMaybe<Scalars['ID']>;
  dashboardRegion?: InputMaybe<Scalars['ID']>;
  date?: InputMaybe<Scalars['Date']>;
  dateFrom?: InputMaybe<Scalars['Date']>;
  dateTo?: InputMaybe<Scalars['Date']>;
  escalatedFrom?: InputMaybe<Scalars['ID']>;
  escalatedTo?: InputMaybe<Scalars['ID']>;
  escalatedToDashboard?: InputMaybe<Scalars['ID']>;
  first?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['ID']>;
  includeEscalated?: InputMaybe<Scalars['Boolean']>;
  isImportant?: InputMaybe<Scalars['Boolean']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type QueryNextTaskDateArgs = {
  taskGlobalId: Scalars['ID'];
};


export type QueryOffboardingRolesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  company?: InputMaybe<Scalars['ID']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type QueryOfferPropositionCommentsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  createdBy?: InputMaybe<Scalars['ID']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offerProposition?: InputMaybe<Scalars['ID']>;
  orderBy?: InputMaybe<Scalars['String']>;
};


export type QueryOfferPropositionStatsArgs = {
  dateFrom?: InputMaybe<Scalars['Date']>;
  dateTo?: InputMaybe<Scalars['Date']>;
  orderId?: InputMaybe<Scalars['Int']>;
};


export type QueryOffersArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  clientinterviewHealthcheckPlanned?: InputMaybe<Scalars['Date']>;
  company?: InputMaybe<Scalars['ID']>;
  country?: InputMaybe<Scalars['String']>;
  countryId?: InputMaybe<Scalars['ID']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  createdAt_Gte?: InputMaybe<Scalars['Date']>;
  createdAt_Lte?: InputMaybe<Scalars['Date']>;
  employmentEventPlanned?: InputMaybe<Scalars['Boolean']>;
  first?: InputMaybe<Scalars['Int']>;
  hasCandidate?: InputMaybe<Scalars['Boolean']>;
  hasPlannedEvents?: InputMaybe<Scalars['Boolean']>;
  last?: InputMaybe<Scalars['Int']>;
  manager?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  managerIds?: InputMaybe<Scalars['String']>;
  orderBy?: InputMaybe<Scalars['String']>;
  orderId?: InputMaybe<Scalars['ID']>;
  personId?: InputMaybe<Scalars['Int']>;
  personIds?: InputMaybe<Scalars['String']>;
  search?: InputMaybe<Scalars['String']>;
  signed?: InputMaybe<Scalars['Boolean']>;
};


export type QueryOperationTasksArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  company?: InputMaybe<Scalars['ID']>;
  country?: InputMaybe<Scalars['ID']>;
  date?: InputMaybe<Scalars['Date']>;
  date_Gte?: InputMaybe<Scalars['Date']>;
  date_Lte?: InputMaybe<Scalars['Date']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Scalars['ID']>;
  orderBy?: InputMaybe<Scalars['String']>;
  order_Company?: InputMaybe<Scalars['ID']>;
  status?: InputMaybe<Scalars['String']>;
};


export type QueryOperationsDateOffsetForEmployeesTaskArgs = {
  country: Scalars['String'];
  personLivasId: Scalars['ID'];
};


export type QueryOrderArgs = {
  id?: InputMaybe<Scalars['Int']>;
};


export type QueryOrderChangeLogArgs = {
  orderId?: InputMaybe<Scalars['ID']>;
};


export type QueryOrderCommentsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderId?: InputMaybe<Scalars['ID']>;
};


export type QueryOrderContactsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderId?: InputMaybe<Scalars['ID']>;
};


export type QueryOrderErrorCategoriesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  isActive?: InputMaybe<Scalars['Boolean']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type QueryOrderErrorsArgs = {
  after?: InputMaybe<Scalars['String']>;
  assignedTo?: InputMaybe<Scalars['ID']>;
  before?: InputMaybe<Scalars['String']>;
  category?: InputMaybe<Scalars['ID']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Scalars['ID']>;
};


export type QueryOrderMetricsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type QueryOrderModelArgs = {
  id: Scalars['ID'];
};


export type QueryOrdersArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  canEmployUa?: InputMaybe<Scalars['Boolean']>;
  companies?: InputMaybe<Scalars['String']>;
  company?: InputMaybe<Scalars['ID']>;
  country?: InputMaybe<Scalars['ID']>;
  covidPolicy?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  first?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['ID']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  isLongTerm?: InputMaybe<Scalars['Boolean']>;
  keyAccountManager?: InputMaybe<Scalars['ID']>;
  last?: InputMaybe<Scalars['Int']>;
  nettoFrom?: InputMaybe<Scalars['Float']>;
  nettoTo?: InputMaybe<Scalars['Float']>;
  orderBy?: InputMaybe<Scalars['String']>;
  orderType?: InputMaybe<Scalars['String']>;
  periodDateFrom?: InputMaybe<Scalars['Date']>;
  periodDateTo?: InputMaybe<Scalars['Date']>;
  region?: InputMaybe<Scalars['String']>;
  regionId?: InputMaybe<Scalars['ID']>;
  region_Country?: InputMaybe<Scalars['String']>;
  region_ExternalId?: InputMaybe<Scalars['Int']>;
  region_ExternalIds?: InputMaybe<Scalars['String']>;
  scheduleTypes?: InputMaybe<Scalars['String']>;
  scheduleTypesAll?: InputMaybe<Scalars['String']>;
  search?: InputMaybe<Scalars['String']>;
  sex?: InputMaybe<Scalars['String']>;
  specification?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
  tags?: InputMaybe<Scalars['String']>;
  trafficGeneration?: InputMaybe<Scalars['String']>;
  unseenProcessedOrders?: InputMaybe<Scalars['Boolean']>;
};


export type QueryOrdersPaginatedArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  canEmployUa?: InputMaybe<Scalars['Boolean']>;
  companies?: InputMaybe<Scalars['String']>;
  company?: InputMaybe<Scalars['ID']>;
  country?: InputMaybe<Scalars['ID']>;
  covidPolicy?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  first?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['ID']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  isLongTerm?: InputMaybe<Scalars['Boolean']>;
  keyAccountManager?: InputMaybe<Scalars['ID']>;
  last?: InputMaybe<Scalars['Int']>;
  nettoFrom?: InputMaybe<Scalars['Float']>;
  nettoTo?: InputMaybe<Scalars['Float']>;
  orderBy?: InputMaybe<Scalars['String']>;
  orderType?: InputMaybe<Scalars['String']>;
  periodDateFrom?: InputMaybe<Scalars['Date']>;
  periodDateTo?: InputMaybe<Scalars['Date']>;
  region?: InputMaybe<Scalars['String']>;
  regionId?: InputMaybe<Scalars['ID']>;
  region_Country?: InputMaybe<Scalars['String']>;
  region_ExternalId?: InputMaybe<Scalars['Int']>;
  region_ExternalIds?: InputMaybe<Scalars['String']>;
  scheduleTypes?: InputMaybe<Scalars['String']>;
  scheduleTypesAll?: InputMaybe<Scalars['String']>;
  search?: InputMaybe<Scalars['String']>;
  sex?: InputMaybe<Scalars['String']>;
  specification?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
  tags?: InputMaybe<Scalars['String']>;
  trafficGeneration?: InputMaybe<Scalars['String']>;
  unseenProcessedOrders?: InputMaybe<Scalars['Boolean']>;
};


export type QueryPersonalProtectiveEquipmentArgs = {
  country?: InputMaybe<Scalars['ID']>;
  specification?: InputMaybe<Scalars['ID']>;
  title?: InputMaybe<Scalars['String']>;
};


export type QueryPlannerEventsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['ID']>;
  date?: InputMaybe<Scalars['Date']>;
  date_Gte?: InputMaybe<Scalars['Date']>;
  date_Lte?: InputMaybe<Scalars['Date']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Scalars['ID']>;
  order_Company?: InputMaybe<Scalars['ID']>;
  ordering?: InputMaybe<Scalars['String']>;
};


export type QueryPpeItemsArgs = {
  specification?: InputMaybe<Scalars['ID']>;
};


export type QueryRegionsArgs = {
  isActive?: InputMaybe<Scalars['Boolean']>;
  title?: InputMaybe<Scalars['String']>;
};


export type QueryRegionsGroupsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  title?: InputMaybe<Scalars['String']>;
};


export type QueryRegionsRelayArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['ID']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  title?: InputMaybe<Scalars['String']>;
};


export type QueryRequestsActivitiesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  createdAt_Gte?: InputMaybe<Scalars['Date']>;
  createdAt_Lte?: InputMaybe<Scalars['Date']>;
  createdBy?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['ID']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
};


export type QueryRequirementsArgs = {
  country?: InputMaybe<Scalars['ID']>;
  language?: InputMaybe<Scalars['String']>;
  requirement?: InputMaybe<Scalars['String']>;
};


export type QueryReservedTimesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  dayOfTheWeek?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  region?: InputMaybe<Scalars['ID']>;
  timeFrom?: InputMaybe<Scalars['Time']>;
  timeTo?: InputMaybe<Scalars['Time']>;
};


export type QueryRiskFactorsArgs = {
  country?: InputMaybe<Scalars['ID']>;
  title?: InputMaybe<Scalars['String']>;
};


export type QuerySearchResultsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  createdBy?: InputMaybe<Scalars['ID']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type QuerySelectionActionCategoriesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['ID']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type QuerySelectionActionCategoryGroupsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['ID']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type QuerySelectionActionsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['ID']>;
  date?: InputMaybe<Scalars['Date']>;
  date_Gte?: InputMaybe<Scalars['Date']>;
  date_Lte?: InputMaybe<Scalars['Date']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Scalars['ID']>;
  orderBy?: InputMaybe<Scalars['String']>;
  order_Company?: InputMaybe<Scalars['ID']>;
};


export type QuerySpecificationArgs = {
  id?: InputMaybe<Scalars['Int']>;
};


export type QuerySpecificationsArgs = {
  companyId?: InputMaybe<Scalars['Int']>;
};


export type QueryStatsGetAggregatedDemandSelectionArgs = {
  dateFrom: Scalars['Date'];
  dateTo: Scalars['Date'];
  statuses?: InputMaybe<Scalars['String']>;
};


export type QueryStatsGetAggregatedDemandStaffingArgs = {
  dateFrom: Scalars['Date'];
  dateTo: Scalars['Date'];
  statuses?: InputMaybe<Scalars['String']>;
};


export type QueryStatsOrderCandidateStatsForPeriodArgs = {
  dateFrom: Scalars['Date'];
  dateTo: Scalars['Date'];
};


export type QueryStatsOrderStatsForPeriodArgs = {
  dateFrom: Scalars['Date'];
  dateTo: Scalars['Date'];
  projectManagerIds?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
};


export type QueryTagsArgs = {
  country?: InputMaybe<Scalars['ID']>;
  groupKey?: InputMaybe<Scalars['String']>;
};


export type QueryTagsGroupsArgs = {
  country?: InputMaybe<Scalars['ID']>;
};


export type QueryTaskArgs = {
  id: Scalars['ID'];
};


export type QueryTaskSchedulesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  endDateMax?: InputMaybe<Scalars['Date']>;
  endDateMin?: InputMaybe<Scalars['Date']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  parentTask?: InputMaybe<Scalars['String']>;
  recurrencePeriod?: InputMaybe<Scalars['String']>;
};


export type QueryTasksArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  candidate?: InputMaybe<Scalars['ID']>;
  candidateLivasEmployeeId?: InputMaybe<Scalars['Float']>;
  cardId?: InputMaybe<Scalars['ID']>;
  categories?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  categoriesKeys?: InputMaybe<Scalars['String']>;
  category?: InputMaybe<Scalars['ID']>;
  company?: InputMaybe<Scalars['ID']>;
  completedBy?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  country?: InputMaybe<Scalars['ID']>;
  customFields?: InputMaybe<Scalars['String']>;
  dashboard?: InputMaybe<Scalars['ID']>;
  dashboards?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  date?: InputMaybe<Scalars['Date']>;
  date_Gte?: InputMaybe<Scalars['Date']>;
  date_Lte?: InputMaybe<Scalars['Date']>;
  directDashboard?: InputMaybe<Scalars['ID']>;
  escalatedTo?: InputMaybe<Scalars['ID']>;
  excludeCategoriesKeys?: InputMaybe<Scalars['String']>;
  excludeStatuses?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  firstTimeSameCategoryPerCandidate?: InputMaybe<Scalars['Boolean']>;
  hasNoCalls?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['ID']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  includeChildDashboards?: InputMaybe<Scalars['Boolean']>;
  isFromMetric?: InputMaybe<Scalars['Boolean']>;
  isImportant?: InputMaybe<Scalars['Boolean']>;
  isNewEmployee?: InputMaybe<Scalars['Boolean']>;
  last?: InputMaybe<Scalars['Int']>;
  noOwners?: InputMaybe<Scalars['Boolean']>;
  order?: InputMaybe<Scalars['ID']>;
  orderBy?: InputMaybe<Scalars['String']>;
  order_Company?: InputMaybe<Scalars['ID']>;
  ownerDashboardMode?: InputMaybe<Scalars['String']>;
  search?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
  statuses?: InputMaybe<Scalars['String']>;
};


export type QueryUpdatedCandidatesArgs = {
  ids?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  taskId?: InputMaybe<Scalars['String']>;
};


export type QueryUserprofileArgs = {
  id?: InputMaybe<Scalars['Int']>;
};


export type QueryUserprofilesArgs = {
  country?: InputMaybe<Scalars['ID']>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  email?: InputMaybe<Scalars['String']>;
  parentDashboardId?: InputMaybe<Scalars['ID']>;
  showInactive?: InputMaybe<Scalars['Boolean']>;
};

export type ReasonType = Node & {
  __typename?: 'ReasonType';
  createdAt: Scalars['DateTime'];
  group?: Maybe<ReasonsGroupType>;
  /** The ID of the object. */
  id: Scalars['ID'];
  isActive: Scalars['Boolean'];
  /** Key for the reason, used for mergin the same reason accross different countries and environments */
  key?: Maybe<Scalars['String']>;
  requestsactivitySet: RequestsActivityTypeConnection;
  title: Scalars['String'];
};


export type ReasonTypeRequestsactivitySetArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};

export type ReasonTypeConnection = {
  __typename?: 'ReasonTypeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<ReasonTypeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** The total count of objects in this query. */
  totalCount?: Maybe<Scalars['Int']>;
};

/** A Relay edge containing a `ReasonType` and its cursor. */
export type ReasonTypeEdge = {
  __typename?: 'ReasonTypeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<ReasonType>;
};

export type ReasonsGroupType = Node & {
  __typename?: 'ReasonsGroupType';
  country?: Maybe<CountryType>;
  createdAt: Scalars['DateTime'];
  /** The ID of the object. */
  id: Scalars['ID'];
  key?: Maybe<Scalars['String']>;
  order: Scalars['Int'];
  reasonSet: ReasonTypeConnection;
  title: Scalars['String'];
};


export type ReasonsGroupTypeReasonSetArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};

export type ReasonsGroupTypeConnection = {
  __typename?: 'ReasonsGroupTypeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<ReasonsGroupTypeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** The total count of objects in this query. */
  totalCount?: Maybe<Scalars['Int']>;
};

/** A Relay edge containing a `ReasonsGroupType` and its cursor. */
export type ReasonsGroupTypeEdge = {
  __typename?: 'ReasonsGroupTypeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<ReasonsGroupType>;
};

export type RegionGroupType = Node & {
  __typename?: 'RegionGroupType';
  /** If set, only show metrics for these region groups */
  dashboardCards: DashboardCardTypeConnection;
  dashboardSet: DashboardTypeConnection;
  externalId?: Maybe<Scalars['Int']>;
  /** The ID of the object. */
  id: Scalars['ID'];
  isActive: Scalars['Boolean'];
  metricvalueSet: MetricValueTypeConnection;
  priority: Scalars['Int'];
  regionSet: Array<RegionType>;
  title: Scalars['String'];
};


export type RegionGroupTypeDashboardCardsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type RegionGroupTypeDashboardSetArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type RegionGroupTypeMetricvalueSetArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  cardId?: InputMaybe<Scalars['ID']>;
  channel?: InputMaybe<Scalars['String']>;
  dashboardId?: InputMaybe<Scalars['ID']>;
  dashboardRegion?: InputMaybe<Scalars['ID']>;
  date?: InputMaybe<Scalars['Date']>;
  dateFrom?: InputMaybe<Scalars['Date']>;
  dateTo?: InputMaybe<Scalars['Date']>;
  escalatedFrom?: InputMaybe<Scalars['ID']>;
  escalatedTo?: InputMaybe<Scalars['ID']>;
  escalatedToDashboard?: InputMaybe<Scalars['ID']>;
  first?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['ID']>;
  includeEscalated?: InputMaybe<Scalars['Boolean']>;
  isImportant?: InputMaybe<Scalars['Boolean']>;
  last?: InputMaybe<Scalars['Int']>;
};

export type RegionGroupTypeConnection = {
  __typename?: 'RegionGroupTypeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<RegionGroupTypeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** The total count of objects in this query. */
  totalCount?: Maybe<Scalars['Int']>;
};

/** A Relay edge containing a `RegionGroupType` and its cursor. */
export type RegionGroupTypeEdge = {
  __typename?: 'RegionGroupTypeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<RegionGroupType>;
};

export type RegionMType = Node & {
  __typename?: 'RegionMType';
  additionalOrders: OrderTypeConnection;
  citySet: CityTypeConnection;
  country?: Maybe<CountryType>;
  externalId?: Maybe<Scalars['Int']>;
  /** The ID of the object. */
  id: Scalars['ID'];
  isActive: Scalars['Boolean'];
  orderSet: OrderTypeConnection;
  regionGroup?: Maybe<RegionGroupType>;
  regionmetrics?: Maybe<RegionMetricType>;
  regionthresholdsettings?: Maybe<RegionThresholdSettingsType>;
  reservedtimeSet: ReservedTimeTypeConnection;
  title: Scalars['String'];
  userprofileSet: UserProfileMTypeConnection;
  virtualnumberSet: Array<VirtualNumberType>;
};


export type RegionMTypeAdditionalOrdersArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type RegionMTypeCitySetArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  region?: InputMaybe<Scalars['ID']>;
};


export type RegionMTypeOrderSetArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type RegionMTypeReservedtimeSetArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type RegionMTypeUserprofileSetArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};

export type RegionMTypeConnection = {
  __typename?: 'RegionMTypeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<RegionMTypeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** The total count of objects in this query. */
  totalCount?: Maybe<Scalars['Int']>;
};

/** A Relay edge containing a `RegionMType` and its cursor. */
export type RegionMTypeEdge = {
  __typename?: 'RegionMTypeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<RegionMType>;
};

export type RegionMetricType = Node & {
  __typename?: 'RegionMetricType';
  effortConversion?: Maybe<Scalars['Float']>;
  /** The ID of the object. */
  id: Scalars['ID'];
  interviewSuccessRatio?: Maybe<Scalars['Float']>;
  lifetime?: Maybe<Scalars['Int']>;
  region: RegionType;
  successfulCalls?: Maybe<Scalars['Int']>;
  successfulInterviews?: Maybe<Scalars['Int']>;
  totalCalls?: Maybe<Scalars['Int']>;
  totalInverviews?: Maybe<Scalars['Int']>;
};

export type RegionThresholdSettingsType = Node & {
  __typename?: 'RegionThresholdSettingsType';
  /** The ID of the object. */
  id: Scalars['ID'];
  minDaysForOffers?: Maybe<Scalars['Int']>;
  /** Minimum number of offers expected for order in region, made within min_days_for_offers */
  minOffersExpected?: Maybe<Scalars['Int']>;
  region: RegionType;
  updatedAt: Scalars['DateTime'];
};

export type RegionType = {
  __typename?: 'RegionType';
  additionalOrders: OrderTypeConnection;
  citySet: CityTypeConnection;
  country?: Maybe<CountryType>;
  externalId?: Maybe<Scalars['Int']>;
  id: Scalars['ID'];
  isActive: Scalars['Boolean'];
  orderSet: OrderTypeConnection;
  regionGroup?: Maybe<RegionGroupType>;
  regionmetrics?: Maybe<RegionMetricType>;
  regionthresholdsettings?: Maybe<RegionThresholdSettingsType>;
  reservedtimeSet: ReservedTimeTypeConnection;
  title: Scalars['String'];
  userprofileSet: UserProfileMTypeConnection;
  virtualnumberSet: Array<VirtualNumberType>;
};


export type RegionTypeAdditionalOrdersArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type RegionTypeCitySetArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  region?: InputMaybe<Scalars['ID']>;
};


export type RegionTypeOrderSetArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type RegionTypeReservedtimeSetArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type RegionTypeUserprofileSetArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};

/** An enumeration. */
export enum RequestsActivityChannel {
  /** Email */
  Email = 'EMAIL',
  /** Phone */
  Phone = 'PHONE'
}

export type RequestsActivityType = Node & {
  __typename?: 'RequestsActivityType';
  channel: RequestsActivityChannel;
  clientContact?: Maybe<ContactType>;
  comment?: Maybe<Scalars['String']>;
  contact?: Maybe<CandidateType>;
  country?: Maybe<CountryType>;
  createdAt: Scalars['DateTime'];
  createdBy?: Maybe<UserProfileMType>;
  delegateTo?: Maybe<UserProfileMType>;
  /** If true, task will be created as if selecting Do Nothing option during standup */
  doNothing: Scalars['Boolean'];
  email?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  /** The ID of the object. */
  id: Scalars['ID'];
  lastName?: Maybe<Scalars['String']>;
  livasCandidateId?: Maybe<Scalars['Int']>;
  livasEmployeeId?: Maybe<Scalars['Int']>;
  metricvalueSet: MetricValueTypeConnection;
  phone?: Maybe<Scalars['String']>;
  reason: ReasonType;
  updatedAt: Scalars['DateTime'];
  /** If true, request is related to  Workis */
  workis?: Maybe<Scalars['Boolean']>;
};


export type RequestsActivityTypeMetricvalueSetArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  cardId?: InputMaybe<Scalars['ID']>;
  channel?: InputMaybe<Scalars['String']>;
  dashboardId?: InputMaybe<Scalars['ID']>;
  dashboardRegion?: InputMaybe<Scalars['ID']>;
  date?: InputMaybe<Scalars['Date']>;
  dateFrom?: InputMaybe<Scalars['Date']>;
  dateTo?: InputMaybe<Scalars['Date']>;
  escalatedFrom?: InputMaybe<Scalars['ID']>;
  escalatedTo?: InputMaybe<Scalars['ID']>;
  escalatedToDashboard?: InputMaybe<Scalars['ID']>;
  first?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['ID']>;
  includeEscalated?: InputMaybe<Scalars['Boolean']>;
  isImportant?: InputMaybe<Scalars['Boolean']>;
  last?: InputMaybe<Scalars['Int']>;
};

export type RequestsActivityTypeConnection = {
  __typename?: 'RequestsActivityTypeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<RequestsActivityTypeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** The total count of objects in this query. */
  totalCount?: Maybe<Scalars['Int']>;
};

/** A Relay edge containing a `RequestsActivityType` and its cursor. */
export type RequestsActivityTypeEdge = {
  __typename?: 'RequestsActivityTypeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<RequestsActivityType>;
};

export type RequirementType = {
  __typename?: 'RequirementType';
  candidaterequirementsevaluationSet: CandidateRequirementsEvaluationTypeConnection;
  country?: Maybe<CountryType>;
  id: Scalars['ID'];
  mandatorySpec: Array<SpecificationType>;
  optionalSpec: Array<SpecificationType>;
  /** Deprecated */
  requirement?: Maybe<Scalars['String']>;
};


export type RequirementTypeCandidaterequirementsevaluationSetArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};

export type ResendOrderSigningMutation = {
  __typename?: 'ResendOrderSigningMutation';
  ok?: Maybe<Scalars['Boolean']>;
};

/** An enumeration. */
export enum ReservedTimeDayOfTheWeek {
  /** Friday */
  Fri = 'FRI',
  /** Monday */
  Mon = 'MON',
  /** Saturday */
  Sat = 'SAT',
  /** Sunday */
  Sun = 'SUN',
  /** Thursday */
  Thu = 'THU',
  /** Tuesday */
  Tue = 'TUE',
  /** Wednesday */
  Wed = 'WED'
}

export type ReservedTimeType = Node & {
  __typename?: 'ReservedTimeType';
  dayOfTheWeek: ReservedTimeDayOfTheWeek;
  /** The ID of the object. */
  id: Scalars['ID'];
  region?: Maybe<RegionType>;
  timeFrom: Scalars['Time'];
  timeTo: Scalars['Time'];
  title: Scalars['String'];
};

export type ReservedTimeTypeConnection = {
  __typename?: 'ReservedTimeTypeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<ReservedTimeTypeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `ReservedTimeType` and its cursor. */
export type ReservedTimeTypeEdge = {
  __typename?: 'ReservedTimeTypeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<ReservedTimeType>;
};

export type RiskFactorType = {
  __typename?: 'RiskFactorType';
  country?: Maybe<CountryType>;
  id: Scalars['ID'];
  isDefault: Scalars['Boolean'];
  spec: Array<SpecificationType>;
  title: Scalars['String'];
};

/** An enumeration. */
export enum SaCategoryGroupDepartment {
  /** Administration */
  Administration = 'ADMINISTRATION',
  /** IT */
  It = 'IT',
  /** Key account managers */
  KeyAccountManagers = 'KEY_ACCOUNT_MANAGERS',
  /** Marketing */
  Marketing = 'MARKETING',
  /** Operations */
  Operations = 'OPERATIONS',
  /** Sales */
  Sales = 'SALES',
  /** Selections */
  Selections = 'SELECTIONS',
  /** Workis */
  Workis = 'WORKIS'
}

export type SaCategoryGroupType = Node & {
  __typename?: 'SACategoryGroupType';
  country?: Maybe<CountryType>;
  createdAt: Scalars['DateTime'];
  createdBy: UserProfileMType;
  department?: Maybe<SaCategoryGroupDepartment>;
  /** The ID of the object. */
  id: Scalars['ID'];
  isActive: Scalars['Boolean'];
  sacategorySet: SaCategoryTypeConnection;
  title: Scalars['String'];
};


export type SaCategoryGroupTypeSacategorySetArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  createdBy?: InputMaybe<Scalars['ID']>;
  first?: InputMaybe<Scalars['Int']>;
  group?: InputMaybe<Scalars['ID']>;
  last?: InputMaybe<Scalars['Int']>;
  title?: InputMaybe<Scalars['String']>;
};

export type SaCategoryGroupTypeConnection = {
  __typename?: 'SACategoryGroupTypeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<SaCategoryGroupTypeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** The total count of objects in this query. */
  totalCount?: Maybe<Scalars['Int']>;
};

/** A Relay edge containing a `SACategoryGroupType` and its cursor. */
export type SaCategoryGroupTypeEdge = {
  __typename?: 'SACategoryGroupTypeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<SaCategoryGroupType>;
};

export type SaCategoryType = Node & {
  __typename?: 'SACategoryType';
  actioncategorySet: ActionCategoryTypeConnection;
  createdAt: Scalars['DateTime'];
  createdBy: UserProfileMType;
  customFields: CustomFieldTypeConnection;
  durationMinutes?: Maybe<Scalars['Int']>;
  group: SaCategoryGroupType;
  hint?: Maybe<Scalars['String']>;
  /** The ID of the object. */
  id: Scalars['ID'];
  isActive: Scalars['Boolean'];
  key?: Maybe<Scalars['String']>;
  metricgroupSet: MetricGroupTypeConnection;
  /** Requires dashboard on task creation */
  requiresDashboard: Scalars['Boolean'];
  showCandidate: Scalars['Boolean'];
  showCompany: Scalars['Boolean'];
  showDescription: Scalars['Boolean'];
  showDuration: Scalars['Boolean'];
  showNextTaskAssignee: Scalars['Boolean'];
  showOrder: Scalars['Boolean'];
  taskSet: TaskTypeConnection;
  title: Scalars['String'];
};


export type SaCategoryTypeActioncategorySetArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type SaCategoryTypeCustomFieldsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type SaCategoryTypeMetricgroupSetArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type SaCategoryTypeTaskSetArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};

export type SaCategoryTypeConnection = {
  __typename?: 'SACategoryTypeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<SaCategoryTypeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** The total count of objects in this query. */
  totalCount?: Maybe<Scalars['Int']>;
};

/** A Relay edge containing a `SACategoryType` and its cursor. */
export type SaCategoryTypeEdge = {
  __typename?: 'SACategoryTypeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<SaCategoryType>;
};

export type SaveRequirementsMutation = {
  __typename?: 'SaveRequirementsMutation';
  candidateRequirementsEvaluations?: Maybe<Array<Maybe<CandidateRequirementsEvaluationType>>>;
  ok?: Maybe<Scalars['Boolean']>;
};

/** An enumeration. */
export enum ScheduleRecurrencePeriod {
  /** Bi-annually */
  Biannually = 'BIANNUALLY',
  /** Daily */
  Daily = 'DAILY',
  /** Monthly */
  Monthly = 'MONTHLY',
  /** Weekly */
  Weekly = 'WEEKLY'
}

export type ScheduleType = Node & {
  __typename?: 'ScheduleType';
  /** Day of the month for monthly tasks (1-31) */
  dayOfMonth?: Maybe<Scalars['Int']>;
  dayOfWeek?: Maybe<Scalars['Int']>;
  endDate?: Maybe<Scalars['Date']>;
  /** The ID of the object. */
  id: Scalars['ID'];
  /** Task should be repeated every x days/weeks/months */
  intervalCount: Scalars['Int'];
  monthInterval?: Maybe<Scalars['Int']>;
  parentTask: TaskType;
  recurrencePeriod: ScheduleRecurrencePeriod;
  repeatAfterXDays?: Maybe<Scalars['Int']>;
  weekOfMonth?: Maybe<Scalars['Int']>;
};

export type ScheduleTypeConnection = {
  __typename?: 'ScheduleTypeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<ScheduleTypeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** The total count of objects in this query. */
  totalCount?: Maybe<Scalars['Int']>;
};

/** A Relay edge containing a `ScheduleType` and its cursor. */
export type ScheduleTypeEdge = {
  __typename?: 'ScheduleTypeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<ScheduleType>;
};

export type ScheduleTypeType = {
  __typename?: 'ScheduleTypeType';
  country?: Maybe<CountryType>;
  id: Scalars['ID'];
  isDeleted: Scalars['Boolean'];
  isPreselected: Scalars['Boolean'];
  specificationSet: Array<SpecificationType>;
  title: Scalars['String'];
};

export type ScheduleUpdatePeople = {
  __typename?: 'ScheduleUpdatePeople';
  ok?: Maybe<Scalars['Boolean']>;
  taskId?: Maybe<Scalars['String']>;
};

export type SearchResultsType = Node & {
  __typename?: 'SearchResultsType';
  callCount: Scalars['Int'];
  candidates: CandidateTypeConnection;
  createdAt: Scalars['DateTime'];
  createdBy?: Maybe<UserProfileMType>;
  /** The ID of the object. */
  id: Scalars['ID'];
  successCount: Scalars['Int'];
  task?: Maybe<TaskType>;
  /** Total count of candidates found */
  totalCount: Scalars['Int'];
  /** How many times this search result was long listed or offered */
  touchedCount: Scalars['Int'];
  updatedAt: Scalars['DateTime'];
  url: Scalars['String'];
};


export type SearchResultsTypeCandidatesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  livasId_In?: InputMaybe<Scalars['Int']>;
};

export type SearchResultsTypeConnection = {
  __typename?: 'SearchResultsTypeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<SearchResultsTypeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** The total count of objects in this query. */
  totalCount?: Maybe<Scalars['Int']>;
};

/** A Relay edge containing a `SearchResultsType` and its cursor. */
export type SearchResultsTypeEdge = {
  __typename?: 'SearchResultsTypeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<SearchResultsType>;
};

export type SelectedByClientApplication = {
  __typename?: 'SelectedByClientApplication';
  company?: Maybe<Scalars['String']>;
  fullName?: Maybe<Scalars['String']>;
  job?: Maybe<Scalars['String']>;
  shiftDate?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
};

export type SelectionActionType = Node & {
  __typename?: 'SelectionActionType';
  /** Users assigned to this task. Migrate from completed_by */
  assignees: UserProfileMTypeConnection;
  candidate?: Maybe<CandidateType>;
  category?: Maybe<SaCategoryType>;
  comment?: Maybe<Scalars['String']>;
  company?: Maybe<CompanyType>;
  completedAt?: Maybe<Scalars['DateTime']>;
  completedBy: UserProfileMTypeConnection;
  country?: Maybe<CountryType>;
  createdAt: Scalars['DateTime'];
  createdBy?: Maybe<UserProfileMType>;
  createdBySchedule?: Maybe<ScheduleType>;
  customFieldValues: CustomFieldValueTypeConnection;
  dashboard?: Maybe<DashboardType>;
  dashboards: DashboardTypeConnection;
  date: Scalars['Date'];
  deleted?: Maybe<Scalars['DateTime']>;
  durationMinutes?: Maybe<Scalars['Int']>;
  /** The ID of the object. */
  id: Scalars['ID'];
  isImportant: Scalars['Boolean'];
  key?: Maybe<Scalars['String']>;
  lastOverdueUpdate?: Maybe<Scalars['Date']>;
  metricvalueLevel2: MetricValueTypeConnection;
  metricvalueSet: MetricValueTypeConnection;
  nextActionCategory?: Maybe<ActionCategoryType>;
  nextActionDate?: Maybe<Scalars['Date']>;
  nextTaskAssignee?: Maybe<UserProfileMType>;
  numPreviousTasks?: Maybe<Scalars['Int']>;
  order?: Maybe<OrderType>;
  overdueCount: Scalars['Int'];
  parentTask?: Maybe<TaskType>;
  result?: Maybe<Scalars['String']>;
  schedules: ScheduleTypeConnection;
  searchResults?: Maybe<SearchResultsType>;
  sendNotificationToAssignee: Scalars['Boolean'];
  status: TaskStatus;
  taskEscalations: TaskEscalationTypeConnection;
  taskSet: TaskTypeConnection;
};


export type SelectionActionTypeAssigneesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type SelectionActionTypeCompletedByArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type SelectionActionTypeCustomFieldValuesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type SelectionActionTypeDashboardsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type SelectionActionTypeMetricvalueLevel2Args = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  cardId?: InputMaybe<Scalars['ID']>;
  channel?: InputMaybe<Scalars['String']>;
  dashboardId?: InputMaybe<Scalars['ID']>;
  dashboardRegion?: InputMaybe<Scalars['ID']>;
  date?: InputMaybe<Scalars['Date']>;
  dateFrom?: InputMaybe<Scalars['Date']>;
  dateTo?: InputMaybe<Scalars['Date']>;
  escalatedFrom?: InputMaybe<Scalars['ID']>;
  escalatedTo?: InputMaybe<Scalars['ID']>;
  escalatedToDashboard?: InputMaybe<Scalars['ID']>;
  first?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['ID']>;
  includeEscalated?: InputMaybe<Scalars['Boolean']>;
  isImportant?: InputMaybe<Scalars['Boolean']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type SelectionActionTypeMetricvalueSetArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  cardId?: InputMaybe<Scalars['ID']>;
  channel?: InputMaybe<Scalars['String']>;
  dashboardId?: InputMaybe<Scalars['ID']>;
  dashboardRegion?: InputMaybe<Scalars['ID']>;
  date?: InputMaybe<Scalars['Date']>;
  dateFrom?: InputMaybe<Scalars['Date']>;
  dateTo?: InputMaybe<Scalars['Date']>;
  escalatedFrom?: InputMaybe<Scalars['ID']>;
  escalatedTo?: InputMaybe<Scalars['ID']>;
  escalatedToDashboard?: InputMaybe<Scalars['ID']>;
  first?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['ID']>;
  includeEscalated?: InputMaybe<Scalars['Boolean']>;
  isImportant?: InputMaybe<Scalars['Boolean']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type SelectionActionTypeSchedulesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type SelectionActionTypeTaskEscalationsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  createdBy?: InputMaybe<Scalars['ID']>;
  escalatedFrom?: InputMaybe<Scalars['ID']>;
  escalatedTo?: InputMaybe<Scalars['ID']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  task?: InputMaybe<Scalars['ID']>;
};


export type SelectionActionTypeTaskSetArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};

export type SelectionActionTypeConnection = {
  __typename?: 'SelectionActionTypeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<SelectionActionTypeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** The total count of objects in this query. */
  totalCount?: Maybe<Scalars['Int']>;
};

/** A Relay edge containing a `SelectionActionType` and its cursor. */
export type SelectionActionTypeEdge = {
  __typename?: 'SelectionActionTypeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<SelectionActionType>;
};

export type SendOrderSummariesMutation = {
  __typename?: 'SendOrderSummariesMutation';
  ok?: Maybe<Scalars['Boolean']>;
};

export type SendSmsMutation = {
  __typename?: 'SendSMSMutation';
  ok?: Maybe<Scalars['Boolean']>;
};

export type SetProcessedOrderViewDatetimeMutation = {
  __typename?: 'SetProcessedOrderViewDatetimeMutation';
  ok?: Maybe<Scalars['Boolean']>;
};

export type SpecficationChangeLogType = {
  __typename?: 'SpecficationChangeLogType';
  fieldName?: Maybe<Scalars['String']>;
  newValue?: Maybe<Scalars['String']>;
  oldValue?: Maybe<Scalars['String']>;
};

/** An enumeration. */
export enum SpecificationAapCoat {
  /** Biuro */
  Biuro = 'BIURO',
  /** Klientas */
  Client = 'CLIENT',
  /** Nėra */
  None = 'NONE'
}

/** An enumeration. */
export enum SpecificationAapJacket {
  /** Biuro */
  Biuro = 'BIURO',
  /** Klientas */
  Client = 'CLIENT',
  /** Nėra */
  None = 'NONE'
}

/** An enumeration. */
export enum SpecificationAppApron {
  /** Biuro */
  Biuro = 'BIURO',
  /** Klientas */
  Client = 'CLIENT',
  /** Nėra */
  None = 'NONE'
}

/** An enumeration. */
export enum SpecificationAppEarPlugs {
  /** Biuro */
  Biuro = 'BIURO',
  /** Klientas */
  Client = 'CLIENT',
  /** Nėra */
  None = 'NONE'
}

/** An enumeration. */
export enum SpecificationAppGlasses {
  /** Biuro */
  Biuro = 'BIURO',
  /** Klientas */
  Client = 'CLIENT',
  /** Nėra */
  None = 'NONE'
}

/** An enumeration. */
export enum SpecificationAppGloves {
  /** Biuro */
  Biuro = 'BIURO',
  /** Klientas */
  Client = 'CLIENT',
  /** Nėra */
  None = 'NONE'
}

/** An enumeration. */
export enum SpecificationAppOverall {
  /** Biuro */
  Biuro = 'BIURO',
  /** Klientas */
  Client = 'CLIENT',
  /** Nėra */
  None = 'NONE'
}

/** An enumeration. */
export enum SpecificationAppRespirator {
  /** Biuro */
  Biuro = 'BIURO',
  /** Klientas */
  Client = 'CLIENT',
  /** Nėra */
  None = 'NONE'
}

/** An enumeration. */
export enum SpecificationAppShoes {
  /** Biuro */
  Biuro = 'BIURO',
  /** Klientas */
  Client = 'CLIENT',
  /** Nėra */
  None = 'NONE'
}

/** An enumeration. */
export enum SpecificationAppTrousers {
  /** Biuro */
  Biuro = 'BIURO',
  /** Klientas */
  Client = 'CLIENT',
  /** Nėra */
  None = 'NONE'
}

/** An enumeration. */
export enum SpecificationAppVest {
  /** Biuro */
  Biuro = 'BIURO',
  /** Klientas */
  Client = 'CLIENT',
  /** Nėra */
  None = 'NONE'
}

/** An enumeration. */
export enum SpecificationExperienceType {
  /** Nesvarbu */
  Irrelevant = 'IRRELEVANT',
  /** Analogiška */
  Same = 'SAME',
  /** Panaši */
  Similar = 'SIMILAR'
}

/** An enumeration. */
export enum SpecificationHealthcheckType {
  /** Non-standard healthcheck */
  NonStandard = 'NON_STANDARD',
  /** Standard healthcheck */
  Standard = 'STANDARD',
  /** Standard healthcheck with food factors */
  StandardWithFood = 'STANDARD_WITH_FOOD'
}

/** An enumeration. */
export enum SpecificationHotBeverages {
  /** Su nuolaida */
  Discount = 'DISCOUNT',
  /** Nemokamai */
  Free = 'FREE',
  /** Įprasta kaina */
  Regular = 'REGULAR'
}

export type SpecificationInput = {
  additionalRecruitmentInformation?: InputMaybe<Scalars['String']>;
  address?: InputMaybe<Scalars['String']>;
  ageFrom?: InputMaybe<Scalars['Int']>;
  ageTo?: InputMaybe<Scalars['Int']>;
  allFunctionsFromFirstDay?: InputMaybe<Scalars['Boolean']>;
  assignmentTags?: InputMaybe<Array<InputMaybe<AssignmentTagInput>>>;
  breakDuration?: InputMaybe<Scalars['Int']>;
  certificates?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  experienceType?: InputMaybe<Scalars['String']>;
  female?: InputMaybe<Scalars['Boolean']>;
  healthcheckType?: InputMaybe<Scalars['String']>;
  intensity?: InputMaybe<Scalars['String']>;
  isCompanyInternational?: InputMaybe<Scalars['Boolean']>;
  isCompanyModern?: InputMaybe<Scalars['Boolean']>;
  isLogoPublicAllowed?: InputMaybe<Scalars['Boolean']>;
  isMagneticKeyIssued?: InputMaybe<Scalars['Boolean']>;
  isSalaryPublicAllowed?: InputMaybe<Scalars['Boolean']>;
  isSecurityPostPresent?: InputMaybe<Scalars['Boolean']>;
  isWorkplaceVideoAllowed?: InputMaybe<Scalars['Boolean']>;
  isWorkplaceVisitAllowed?: InputMaybe<Scalars['Boolean']>;
  male?: InputMaybe<Scalars['Boolean']>;
  mandatoryRequirements?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  minExperienceMonths?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  onboardingDuration?: InputMaybe<Scalars['String']>;
  optionalRequirements?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  personalProtectiveEquipmentBiuro?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  personalProtectiveEquipmentClient?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  positionTitle?: InputMaybe<Scalars['String']>;
  ppeItems?: InputMaybe<Array<InputMaybe<SpecificationPpeInput>>>;
  riskFactors?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  scheduleText?: InputMaybe<Scalars['String']>;
  scheduleType?: InputMaybe<Scalars['Int']>;
  scheduleTypes?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  shiftDuration?: InputMaybe<Scalars['Int']>;
  shiftPattern?: InputMaybe<Scalars['JSONString']>;
  whoIssuesMagneticKey?: InputMaybe<Scalars['String']>;
  workFunctions?: InputMaybe<Scalars['String']>;
  workIntensity?: InputMaybe<Scalars['String']>;
};

/** An enumeration. */
export enum SpecificationIntensity {
  /** Sėdimas */
  Sedentary = 'SEDENTARY',
  /** Sėdimas, greitu tempu */
  SedentaryFast = 'SEDENTARY_FAST',
  /** Sėdimas ir stovimas */
  SedentaryStationary = 'SEDENTARY_STATIONARY',
  /** Stovimas */
  Stationary = 'STATIONARY',
  /** Stovimas, greitu tempu */
  StationaryFast = 'STATIONARY_FAST'
}

/** An enumeration. */
export enum SpecificationLunch {
  /** Su nuolaida */
  Discount = 'DISCOUNT',
  /** Nemokamai */
  Free = 'FREE',
  /** Įprasta kaina */
  Regular = 'REGULAR'
}

/** An enumeration. */
export enum SpecificationMaxWeight {
  /** iki 10kg */
  M = 'M',
  /** iki 30kg */
  V = 'V'
}

export type SpecificationModelCreateMutationInput = {
  additionalRecruitementInformation?: InputMaybe<Scalars['String']>;
  address?: InputMaybe<Scalars['String']>;
  ageFrom?: InputMaybe<Scalars['Int']>;
  ageTo?: InputMaybe<Scalars['Int']>;
  allFunctionsFromFirstDay?: InputMaybe<Scalars['Boolean']>;
  assignmentTags?: InputMaybe<Array<InputMaybe<AssignmentTagInput>>>;
  breakDuration?: InputMaybe<Scalars['Int']>;
  canEmployUa?: InputMaybe<Scalars['Boolean']>;
  careerPossibilities?: InputMaybe<Scalars['String']>;
  certificates?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  clientMutationId?: InputMaybe<Scalars['String']>;
  clientWashesClothes?: InputMaybe<Scalars['Boolean']>;
  company: Scalars['ID'];
  competences?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  displayRequirementsOther?: InputMaybe<Scalars['Boolean']>;
  experienceType?: InputMaybe<SpecificationExperienceType>;
  female?: InputMaybe<Scalars['Boolean']>;
  healthcheckType?: InputMaybe<SpecificationHealthcheckType>;
  intensity?: InputMaybe<SpecificationIntensity>;
  isCompanyInternational?: InputMaybe<Scalars['Boolean']>;
  /** Įmonė tvarkinga, inovatyvi */
  isCompanyModern?: InputMaybe<Scalars['Boolean']>;
  isLogoPublicAllowed?: InputMaybe<Scalars['Boolean']>;
  isMagneticKeyIssued?: InputMaybe<Scalars['Boolean']>;
  isQualificationImprovementPossible?: InputMaybe<Scalars['Boolean']>;
  isSalaryPublicAllowed?: InputMaybe<Scalars['Boolean']>;
  isSecurityPostPresent?: InputMaybe<Scalars['Boolean']>;
  isWorkplaceVideoAllowed?: InputMaybe<Scalars['Boolean']>;
  isWorkplaceVisitAllowed?: InputMaybe<Scalars['Boolean']>;
  male?: InputMaybe<Scalars['Boolean']>;
  mandatoryRequirements?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  minExperienceMonths?: InputMaybe<Scalars['Int']>;
  name: Scalars['String'];
  noMandatoryRequirements?: InputMaybe<Scalars['Boolean']>;
  onboardingDuration?: InputMaybe<Scalars['String']>;
  optionalRequirements?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  personalProtectiveEquipmentBiuro?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  personalProtectiveEquipmentClient?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  positionTitle: Scalars['String'];
  ppeItems?: InputMaybe<Array<InputMaybe<SpecificationPpeInput>>>;
  requirementsOther?: InputMaybe<Scalars['String']>;
  riskFactors?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  riskFactorsByTitle?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  salary?: InputMaybe<SpecificationSalaryInput>;
  scheduleText?: InputMaybe<Scalars['String']>;
  scheduleType?: InputMaybe<Scalars['Int']>;
  scheduleTypes?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  shiftDuration?: InputMaybe<Scalars['Int']>;
  shiftPattern?: InputMaybe<Scalars['JSONString']>;
  whoIssuesMagneticKey?: InputMaybe<Scalars['String']>;
  workFunctions?: InputMaybe<Scalars['String']>;
  workIntensity?: InputMaybe<Scalars['String']>;
};

export type SpecificationModelCreateMutationPayload = {
  __typename?: 'SpecificationModelCreateMutationPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  /** List of errors that occurred while executing the mutation. */
  errors?: Maybe<Array<MutationErrorType>>;
  /** The mutated object. */
  specification?: Maybe<SpecificationType>;
};

export type SpecificationModelUpdateMutationInput = {
  aapCoat?: InputMaybe<SpecificationAapCoat>;
  aapJacket?: InputMaybe<SpecificationAapJacket>;
  /** Ar nėra perteklinių, nepagrįstų reikalavimų? */
  additionalClientTrainings?: InputMaybe<Scalars['String']>;
  additionalRecruitementInformation?: InputMaybe<Scalars['String']>;
  address?: InputMaybe<Scalars['String']>;
  ageFrom?: InputMaybe<Scalars['Int']>;
  ageTo?: InputMaybe<Scalars['Int']>;
  allFunctionsFromFirstDay?: InputMaybe<Scalars['Boolean']>;
  appApron?: InputMaybe<SpecificationAppApron>;
  appEarPlugs?: InputMaybe<SpecificationAppEarPlugs>;
  appGlasses?: InputMaybe<SpecificationAppGlasses>;
  appGloves?: InputMaybe<SpecificationAppGloves>;
  appOverall?: InputMaybe<SpecificationAppOverall>;
  appRespirator?: InputMaybe<SpecificationAppRespirator>;
  appShoes?: InputMaybe<SpecificationAppShoes>;
  appTrousers?: InputMaybe<SpecificationAppTrousers>;
  appVest?: InputMaybe<SpecificationAppVest>;
  assignmentTags?: InputMaybe<Array<InputMaybe<AssignmentTagInput>>>;
  autoForkliftLicence?: InputMaybe<Scalars['Boolean']>;
  availableInterviewTimes?: InputMaybe<Scalars['String']>;
  biuroEmployeesCanParticipate?: InputMaybe<Scalars['Boolean']>;
  breakDuration?: InputMaybe<Scalars['Int']>;
  canCandidatesSwitch?: InputMaybe<Scalars['Boolean']>;
  canEmployUa?: InputMaybe<Scalars['Boolean']>;
  candidateCount?: InputMaybe<Scalars['Int']>;
  canteen?: InputMaybe<Scalars['Boolean']>;
  carLeasingContract?: InputMaybe<Scalars['Boolean']>;
  careerPossibilities?: InputMaybe<Scalars['String']>;
  certificates?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  clientCoverageConditionsFree?: InputMaybe<Scalars['String']>;
  clientCoverageConditionsNonFree?: InputMaybe<Scalars['String']>;
  clientCoverageConditionsOther?: InputMaybe<Scalars['String']>;
  clientCoversTrainings?: InputMaybe<Scalars['Boolean']>;
  clientMutationId?: InputMaybe<Scalars['String']>;
  clientWashesClothes?: InputMaybe<Scalars['Boolean']>;
  company?: InputMaybe<Scalars['ID']>;
  competences?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  cooperationWithOthers?: InputMaybe<Scalars['Boolean']>;
  displayRequirementsOther?: InputMaybe<Scalars['Boolean']>;
  dressingRoom?: InputMaybe<Scalars['Boolean']>;
  dressingRoomLocation?: InputMaybe<Scalars['String']>;
  drinksCoffee?: InputMaybe<Scalars['Boolean']>;
  drinksMilk?: InputMaybe<Scalars['Boolean']>;
  drinksTea?: InputMaybe<Scalars['Boolean']>;
  driversLicence95?: InputMaybe<Scalars['Boolean']>;
  driversLicenceB?: InputMaybe<Scalars['Boolean']>;
  driversLicenceC?: InputMaybe<Scalars['Boolean']>;
  driversLicenceCe?: InputMaybe<Scalars['Boolean']>;
  driversLicenceD?: InputMaybe<Scalars['Boolean']>;
  electricForkliftLicence?: InputMaybe<Scalars['Boolean']>;
  employeeOfTheMonthElection?: InputMaybe<Scalars['Boolean']>;
  employeeOnboarding?: InputMaybe<Scalars['String']>;
  events?: InputMaybe<Scalars['String']>;
  expectedOvertimes?: InputMaybe<Scalars['String']>;
  experienceType?: InputMaybe<SpecificationExperienceType>;
  female?: InputMaybe<Scalars['Boolean']>;
  firstAidLicence?: InputMaybe<Scalars['Boolean']>;
  forkliftLicence?: InputMaybe<Scalars['Boolean']>;
  freeBus?: InputMaybe<Scalars['Boolean']>;
  freeDays?: InputMaybe<Scalars['String']>;
  gasCompensation?: InputMaybe<Scalars['Boolean']>;
  gifts?: InputMaybe<Scalars['Boolean']>;
  healthcheckType?: InputMaybe<SpecificationHealthcheckType>;
  /** (karštų gėrimų) */
  hotBeveragePrice?: InputMaybe<Scalars['String']>;
  hotBeverages?: InputMaybe<SpecificationHotBeverages>;
  howBonusSystemWork?: InputMaybe<Scalars['String']>;
  howDirectEmploymentWorks?: InputMaybe<Scalars['String']>;
  howQualificationImprovementWorks?: InputMaybe<Scalars['String']>;
  howSalaryIsRaised?: InputMaybe<Scalars['String']>;
  hygieneLicence?: InputMaybe<Scalars['Boolean']>;
  /** The ID of the object. */
  id: Scalars['ID'];
  insightlyId?: InputMaybe<Scalars['Int']>;
  instruction?: InputMaybe<Scalars['String']>;
  intensity?: InputMaybe<SpecificationIntensity>;
  isBonusSystemPresent?: InputMaybe<Scalars['Boolean']>;
  isCompanyInternational?: InputMaybe<Scalars['Boolean']>;
  /** Įmonė tvarkinga, inovatyvi */
  isCompanyModern?: InputMaybe<Scalars['Boolean']>;
  isDirectEmploymentPossible?: InputMaybe<Scalars['Boolean']>;
  isInterviewPlanned?: InputMaybe<Scalars['Boolean']>;
  isLockerKeyIssued?: InputMaybe<Scalars['Boolean']>;
  isLogoPublicAllowed?: InputMaybe<Scalars['Boolean']>;
  isMagneticKeyIssued?: InputMaybe<Scalars['Boolean']>;
  isQualificationImprovementPossible?: InputMaybe<Scalars['Boolean']>;
  isSalaryPublicAllowed?: InputMaybe<Scalars['Boolean']>;
  isSalaryRaisePossible?: InputMaybe<Scalars['Boolean']>;
  isSecurityPostPresent?: InputMaybe<Scalars['Boolean']>;
  isWorkplaceVideoAllowed?: InputMaybe<Scalars['Boolean']>;
  isWorkplaceVisitAllowed?: InputMaybe<Scalars['Boolean']>;
  kitchenFreezer?: InputMaybe<Scalars['Boolean']>;
  kitchenMicrowave?: InputMaybe<Scalars['Boolean']>;
  lockerKey?: InputMaybe<Scalars['String']>;
  lunch?: InputMaybe<SpecificationLunch>;
  /** (pietų) */
  lunchPrice?: InputMaybe<Scalars['String']>;
  lunchTimes?: InputMaybe<Scalars['String']>;
  magneticKey?: InputMaybe<Scalars['String']>;
  male?: InputMaybe<Scalars['Boolean']>;
  mandatoryRequirements?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  maxWeight?: InputMaybe<SpecificationMaxWeight>;
  minExperienceMonths?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  noMandatoryRequirements?: InputMaybe<Scalars['Boolean']>;
  nonFreeBus?: InputMaybe<Scalars['String']>;
  onboardingDuration?: InputMaybe<Scalars['String']>;
  optionalRequirements?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Set list of orders */
  orderSet?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  personalProtectiveEquipmentBiuro?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  personalProtectiveEquipmentClient?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  positionTitle?: InputMaybe<Scalars['String']>;
  ppeItems?: InputMaybe<Array<InputMaybe<SpecificationPpeInput>>>;
  publicTransportNr?: InputMaybe<Scalars['String']>;
  requirementsOther?: InputMaybe<Scalars['String']>;
  restZoneEntertainment?: InputMaybe<Scalars['Boolean']>;
  restZoneGames?: InputMaybe<Scalars['Boolean']>;
  riskFactors?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  salary?: InputMaybe<SpecificationSalaryInput>;
  scheduleText?: InputMaybe<Scalars['String']>;
  scheduleType?: InputMaybe<Scalars['Int']>;
  scheduleTypes?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  securityPost?: InputMaybe<Scalars['String']>;
  shiftDuration?: InputMaybe<Scalars['Int']>;
  shiftPattern?: InputMaybe<Scalars['JSONString']>;
  showers?: InputMaybe<Scalars['Boolean']>;
  smokingAreaInside?: InputMaybe<Scalars['Boolean']>;
  smokingAreaOutside?: InputMaybe<Scalars['Boolean']>;
  snacks?: InputMaybe<SpecificationSnacks>;
  snacksOptions?: InputMaybe<Scalars['String']>;
  /** (užkandžių) */
  snacksPrice?: InputMaybe<Scalars['String']>;
  specificWorkConditions?: InputMaybe<Scalars['String']>;
  sportCompetitions?: InputMaybe<Scalars['Boolean']>;
  /** Autobusas */
  transportDirection?: InputMaybe<Scalars['String']>;
  /** Autobusas */
  transportStops?: InputMaybe<Scalars['String']>;
  water?: InputMaybe<SpecificationWater>;
  /** (vandens) */
  waterPrice?: InputMaybe<Scalars['String']>;
  whoIssuesLockerKey?: InputMaybe<Scalars['String']>;
  whoIssuesMagneticKey?: InputMaybe<Scalars['String']>;
  whomToContact?: InputMaybe<Scalars['String']>;
  workDays?: InputMaybe<Scalars['String']>;
  workFunctions?: InputMaybe<Scalars['String']>;
  workHours?: InputMaybe<Scalars['String']>;
  workIntensity?: InputMaybe<Scalars['String']>;
};

export type SpecificationModelUpdateMutationPayload = {
  __typename?: 'SpecificationModelUpdateMutationPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  /** List of errors that occurred while executing the mutation. */
  errors?: Maybe<Array<MutationErrorType>>;
  /** The mutated object. */
  specification?: Maybe<SpecificationType>;
};

export type SpecificationPpeInput = {
  customEquipment?: InputMaybe<Scalars['String']>;
  equipment?: InputMaybe<Scalars['ID']>;
  provider?: InputMaybe<Scalars['String']>;
};

/** An enumeration. */
export enum SpecificationPpeProvider {
  /** Biuro */
  Biuro = 'BIURO',
  /** Client */
  Client = 'CLIENT'
}

export type SpecificationPpeType = {
  __typename?: 'SpecificationPPEType';
  customEquipment?: Maybe<Scalars['String']>;
  displayTitle?: Maybe<Scalars['String']>;
  equipment?: Maybe<PersonalProtectiveEquipmentType>;
  id: Scalars['ID'];
  isCustom?: Maybe<Scalars['Boolean']>;
  provider: SpecificationPpeProvider;
  specification: SpecificationType;
};

export type SpecificationSalaryInput = {
  description?: InputMaybe<Scalars['String']>;
  hourlyBruttoFrom?: InputMaybe<Scalars['Float']>;
  hourlyBruttoFromFilled?: InputMaybe<Scalars['Boolean']>;
  hourlyBruttoTo?: InputMaybe<Scalars['Float']>;
  hourlyBruttoToFilled?: InputMaybe<Scalars['Boolean']>;
  hourlyNettoFrom?: InputMaybe<Scalars['Float']>;
  hourlyNettoFromFilled?: InputMaybe<Scalars['Boolean']>;
  hourlyNettoTo?: InputMaybe<Scalars['Float']>;
  hourlyNettoToFilled?: InputMaybe<Scalars['Boolean']>;
  monthlyBruttoFrom?: InputMaybe<Scalars['Float']>;
  monthlyBruttoFromFilled?: InputMaybe<Scalars['Boolean']>;
  monthlyBruttoTo?: InputMaybe<Scalars['Float']>;
  monthlyBruttoToFilled?: InputMaybe<Scalars['Boolean']>;
  monthlyNettoFrom?: InputMaybe<Scalars['Float']>;
  monthlyNettoFromFilled?: InputMaybe<Scalars['Boolean']>;
  monthlyNettoTo?: InputMaybe<Scalars['Float']>;
  monthlyNettoToFilled?: InputMaybe<Scalars['Boolean']>;
  passDescriptionToTemplate?: InputMaybe<Scalars['Boolean']>;
  useInTemplate?: InputMaybe<SpecificationSalaryPeriodEnum>;
};

/** An enumeration. */
export enum SpecificationSalaryPeriodEnum {
  Hourly = 'HOURLY',
  Monthly = 'MONTHLY'
}

export type SpecificationSalaryType = {
  __typename?: 'SpecificationSalaryType';
  description?: Maybe<Scalars['String']>;
  hourlyBruttoFrom?: Maybe<Scalars['Float']>;
  hourlyBruttoFromFilled: Scalars['Boolean'];
  hourlyBruttoTo?: Maybe<Scalars['Float']>;
  hourlyBruttoToFilled: Scalars['Boolean'];
  hourlyNettoFrom?: Maybe<Scalars['Float']>;
  hourlyNettoFromFilled: Scalars['Boolean'];
  hourlyNettoTo?: Maybe<Scalars['Float']>;
  hourlyNettoToFilled: Scalars['Boolean'];
  id: Scalars['ID'];
  monthlyBruttoFrom?: Maybe<Scalars['Float']>;
  monthlyBruttoFromFilled: Scalars['Boolean'];
  monthlyBruttoTo?: Maybe<Scalars['Float']>;
  monthlyBruttoToFilled: Scalars['Boolean'];
  monthlyNettoFrom?: Maybe<Scalars['Float']>;
  monthlyNettoFromFilled: Scalars['Boolean'];
  monthlyNettoTo?: Maybe<Scalars['Float']>;
  monthlyNettoToFilled: Scalars['Boolean'];
  passDescriptionToTemplate?: Maybe<Scalars['Boolean']>;
  specification: SpecificationType;
  useInTemplate: SpecificationSalaryUseInTemplate;
};

/** An enumeration. */
export enum SpecificationSalaryUseInTemplate {
  /** Hourly */
  Hourly = 'HOURLY',
  /** Monthly */
  Monthly = 'MONTHLY'
}

/** An enumeration. */
export enum SpecificationSnacks {
  /** Su nuolaida */
  Discount = 'DISCOUNT',
  /** Nemokamai */
  Free = 'FREE',
  /** Įprasta kaina */
  Regular = 'REGULAR'
}

export type SpecificationType = {
  __typename?: 'SpecificationType';
  aapCoat: SpecificationAapCoat;
  aapJacket: SpecificationAapJacket;
  /** Ar nėra perteklinių, nepagrįstų reikalavimų? */
  additionalClientTrainings?: Maybe<Scalars['String']>;
  additionalRecruitementInformation?: Maybe<Scalars['String']>;
  address?: Maybe<Scalars['String']>;
  ageFrom?: Maybe<Scalars['Int']>;
  ageTo?: Maybe<Scalars['Int']>;
  allFunctionsFromFirstDay: Scalars['Boolean'];
  appApron: SpecificationAppApron;
  appEarPlugs: SpecificationAppEarPlugs;
  appGlasses: SpecificationAppGlasses;
  appGloves: SpecificationAppGloves;
  appOverall: SpecificationAppOverall;
  appRespirator: SpecificationAppRespirator;
  appShoes: SpecificationAppShoes;
  appTrousers: SpecificationAppTrousers;
  appVest: SpecificationAppVest;
  autoForkliftLicence: Scalars['Boolean'];
  availableInterviewTimes: Scalars['String'];
  biuroEmployeesCanParticipate: Scalars['Boolean'];
  breakDuration?: Maybe<Scalars['Int']>;
  canCandidatesSwitch: Scalars['Boolean'];
  canEmployUa: Scalars['Boolean'];
  candidateCount: Scalars['Int'];
  canteen: Scalars['Boolean'];
  carLeasingContract: Scalars['Boolean'];
  careerPossibilities?: Maybe<Scalars['String']>;
  certificates: Array<CertificateType>;
  clientCoverageConditionsFree?: Maybe<Scalars['String']>;
  clientCoverageConditionsNonFree?: Maybe<Scalars['String']>;
  clientCoverageConditionsOther?: Maybe<Scalars['String']>;
  clientCoversTrainings: Scalars['Boolean'];
  clientWashesClothes?: Maybe<Scalars['Boolean']>;
  company?: Maybe<CompanyType>;
  competences: CompetenceTypeConnection;
  cooperationWithOthers: Scalars['Boolean'];
  displayRequirementsOther?: Maybe<Scalars['Boolean']>;
  dressingRoom: Scalars['Boolean'];
  dressingRoomLocation?: Maybe<Scalars['String']>;
  drinksCoffee: Scalars['Boolean'];
  drinksMilk: Scalars['Boolean'];
  drinksTea: Scalars['Boolean'];
  driversLicence95: Scalars['Boolean'];
  driversLicenceB: Scalars['Boolean'];
  driversLicenceC: Scalars['Boolean'];
  driversLicenceCe: Scalars['Boolean'];
  driversLicenceD: Scalars['Boolean'];
  electricForkliftLicence: Scalars['Boolean'];
  employeeOfTheMonthElection: Scalars['Boolean'];
  employeeOnboarding?: Maybe<Scalars['String']>;
  events?: Maybe<Scalars['String']>;
  expectedOvertimes?: Maybe<Scalars['String']>;
  experienceType: SpecificationExperienceType;
  female: Scalars['Boolean'];
  firstAidLicence: Scalars['Boolean'];
  forkliftLicence: Scalars['Boolean'];
  freeBus: Scalars['Boolean'];
  freeDays?: Maybe<Scalars['String']>;
  gasCompensation: Scalars['Boolean'];
  gifts: Scalars['Boolean'];
  healthcheckType?: Maybe<SpecificationHealthcheckType>;
  /** (karštų gėrimų) */
  hotBeveragePrice?: Maybe<Scalars['String']>;
  hotBeverages?: Maybe<SpecificationHotBeverages>;
  howBonusSystemWork?: Maybe<Scalars['String']>;
  howDirectEmploymentWorks?: Maybe<Scalars['String']>;
  howQualificationImprovementWorks?: Maybe<Scalars['String']>;
  howSalaryIsRaised?: Maybe<Scalars['String']>;
  hygieneLicence: Scalars['Boolean'];
  id: Scalars['ID'];
  insightlyId?: Maybe<Scalars['Int']>;
  instruction?: Maybe<Scalars['String']>;
  intensity?: Maybe<SpecificationIntensity>;
  isBonusSystemPresent: Scalars['Boolean'];
  isCompanyInternational: Scalars['Boolean'];
  /** Įmonė tvarkinga, inovatyvi */
  isCompanyModern: Scalars['Boolean'];
  isConfirmed?: Maybe<Scalars['Boolean']>;
  isDirectEmploymentPossible: Scalars['Boolean'];
  isInterviewPlanned: Scalars['Boolean'];
  isLockerKeyIssued?: Maybe<Scalars['Boolean']>;
  isLogoPublicAllowed: Scalars['Boolean'];
  isMagneticKeyIssued?: Maybe<Scalars['Boolean']>;
  isQualificationImprovementPossible: Scalars['Boolean'];
  isSalaryPublicAllowed: Scalars['Boolean'];
  isSalaryRaisePossible: Scalars['Boolean'];
  isSecurityPostPresent?: Maybe<Scalars['Boolean']>;
  isWorkplaceVideoAllowed: Scalars['Boolean'];
  isWorkplaceVisitAllowed: Scalars['Boolean'];
  kitchenFreezer: Scalars['Boolean'];
  kitchenMicrowave: Scalars['Boolean'];
  lockerKey?: Maybe<Scalars['String']>;
  lunch?: Maybe<SpecificationLunch>;
  /** (pietų) */
  lunchPrice?: Maybe<Scalars['String']>;
  lunchTimes?: Maybe<Scalars['String']>;
  magneticKey?: Maybe<Scalars['String']>;
  male: Scalars['Boolean'];
  mandatoryRequirements: Array<RequirementType>;
  maxWeight?: Maybe<SpecificationMaxWeight>;
  minExperienceMonths?: Maybe<Scalars['Int']>;
  name: Scalars['String'];
  noMandatoryRequirements: Scalars['Boolean'];
  nonFreeBus?: Maybe<Scalars['String']>;
  onboardingDuration?: Maybe<Scalars['String']>;
  optionalRequirements: Array<RequirementType>;
  orderSet: OrderTypeConnection;
  personalProtectiveEquipmentBiuro: Array<PersonalProtectiveEquipmentType>;
  personalProtectiveEquipmentClient: Array<PersonalProtectiveEquipmentType>;
  positionTitle: Scalars['String'];
  ppeItems?: Maybe<Array<Maybe<SpecificationPpeType>>>;
  publicTransportNr?: Maybe<Scalars['String']>;
  requirementsOther?: Maybe<Scalars['String']>;
  restZoneEntertainment: Scalars['Boolean'];
  restZoneGames: Scalars['Boolean'];
  riskFactors: Array<RiskFactorType>;
  salary?: Maybe<SpecificationSalaryType>;
  scheduleText?: Maybe<Scalars['String']>;
  scheduleType?: Maybe<Scalars['Int']>;
  scheduleTypes: Array<ScheduleTypeType>;
  securityPost?: Maybe<Scalars['String']>;
  shiftDuration?: Maybe<Scalars['Int']>;
  shiftPattern?: Maybe<Scalars['JSONString']>;
  showers: Scalars['Boolean'];
  smokingAreaInside: Scalars['Boolean'];
  smokingAreaOutside: Scalars['Boolean'];
  snacks?: Maybe<SpecificationSnacks>;
  snacksOptions?: Maybe<Scalars['String']>;
  /** (užkandžių) */
  snacksPrice?: Maybe<Scalars['String']>;
  specificWorkConditions?: Maybe<Scalars['String']>;
  sportCompetitions: Scalars['Boolean'];
  tagassignmentSet: Array<TagAssignmentType>;
  /** Autobusas */
  transportDirection: Scalars['String'];
  /** Autobusas */
  transportStops: Scalars['String'];
  water?: Maybe<SpecificationWater>;
  /** (vandens) */
  waterPrice?: Maybe<Scalars['String']>;
  whoIssuesLockerKey?: Maybe<Scalars['String']>;
  whoIssuesMagneticKey?: Maybe<Scalars['String']>;
  whomToContact?: Maybe<Scalars['String']>;
  workDays?: Maybe<Scalars['String']>;
  workFunctions?: Maybe<Scalars['String']>;
  workHours?: Maybe<Scalars['String']>;
  workIntensity?: Maybe<Scalars['String']>;
};


export type SpecificationTypeCompetencesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['ID']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type SpecificationTypeOrderSetArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};

/** An enumeration. */
export enum SpecificationWater {
  /** Su nuolaida */
  Discount = 'DISCOUNT',
  /** Nemokamai */
  Free = 'FREE',
  /** Įprasta kaina */
  Regular = 'REGULAR'
}

export type StageStats = {
  __typename?: 'StageStats';
  fail?: Maybe<Scalars['Int']>;
  failureReasons?: Maybe<Array<Maybe<FailureReason>>>;
  success?: Maybe<Scalars['Int']>;
};

export type SubmitOrderMutation = {
  __typename?: 'SubmitOrderMutation';
  ok?: Maybe<Scalars['Boolean']>;
};

export type SyncCompanyLabelsMutation = {
  __typename?: 'SyncCompanyLabelsMutation';
  ok?: Maybe<Scalars['Boolean']>;
};

export type TagAssignmentType = {
  __typename?: 'TagAssignmentType';
  comment: Scalars['String'];
  createdAt: Scalars['DateTime'];
  id: Scalars['ID'];
  specification: SpecificationType;
  tag: TagType;
};

export type TagGroupType = {
  __typename?: 'TagGroupType';
  country?: Maybe<CountryType>;
  id: Scalars['ID'];
  key: Scalars['String'];
  tagSet: Array<TagType>;
  title: Scalars['String'];
};

export type TagType = {
  __typename?: 'TagType';
  deleted: Scalars['Boolean'];
  group?: Maybe<TagGroupType>;
  hint?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  key?: Maybe<Scalars['String']>;
  order: Scalars['Int'];
  tagassignmentSet: Array<TagAssignmentType>;
  title: Scalars['String'];
};

export type TaskEscalationType = Node & {
  __typename?: 'TaskEscalationType';
  createdAt: Scalars['DateTime'];
  createdBy?: Maybe<UserProfileMType>;
  escalatedFrom?: Maybe<DashboardType>;
  escalatedTo: DashboardType;
  /** The ID of the object. */
  id: Scalars['ID'];
  task: TaskType;
};

export type TaskEscalationTypeConnection = {
  __typename?: 'TaskEscalationTypeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<TaskEscalationTypeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** The total count of objects in this query. */
  totalCount?: Maybe<Scalars['Int']>;
};

/** A Relay edge containing a `TaskEscalationType` and its cursor. */
export type TaskEscalationTypeEdge = {
  __typename?: 'TaskEscalationTypeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<TaskEscalationType>;
};

/** An enumeration. */
export enum TaskStatus {
  /** Announce */
  Announce = 'ANNOUNCE',
  /** Automatic cancellation */
  AutomaticCancellation = 'AUTOMATIC_CANCELLATION',
  /** Cancelled */
  Cancelled = 'CANCELLED',
  /** Done */
  Done = 'DONE',
  /** In progress */
  InProgress = 'IN_PROGRESS',
  /** Planned */
  Planned = 'PLANNED'
}

export type TaskType = Node & {
  __typename?: 'TaskType';
  /** Users assigned to this task. Migrate from completed_by */
  assignees: UserProfileMTypeConnection;
  candidate?: Maybe<CandidateType>;
  category?: Maybe<SaCategoryType>;
  comment?: Maybe<Scalars['String']>;
  company?: Maybe<CompanyType>;
  completedAt?: Maybe<Scalars['DateTime']>;
  completedBy?: Maybe<Array<Maybe<UserProfileMType>>>;
  country?: Maybe<CountryType>;
  /** Country ISO code from task, company or order relationship */
  countryIsoCode?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  createdBy?: Maybe<UserProfileMType>;
  createdBySchedule?: Maybe<ScheduleType>;
  customFieldValues: CustomFieldValueTypeConnection;
  dashboard?: Maybe<DashboardType>;
  dashboards: DashboardTypeConnection;
  date: Scalars['Date'];
  deleted?: Maybe<Scalars['DateTime']>;
  durationMinutes?: Maybe<Scalars['Int']>;
  /** The ID of the object. */
  id: Scalars['ID'];
  isImportant: Scalars['Boolean'];
  key?: Maybe<Scalars['String']>;
  lastOverdueUpdate?: Maybe<Scalars['Date']>;
  metricvalueLevel2: MetricValueTypeConnection;
  metricvalueSet: MetricValueTypeConnection;
  nextActionCategory?: Maybe<ActionCategoryType>;
  nextActionDate?: Maybe<Scalars['Date']>;
  nextTaskAssignee?: Maybe<UserProfileMType>;
  numPreviousTasks?: Maybe<Scalars['Int']>;
  order?: Maybe<OrderType>;
  overdueCount: Scalars['Int'];
  parentTask?: Maybe<TaskType>;
  result?: Maybe<Scalars['String']>;
  schedules: ScheduleTypeConnection;
  searchResults?: Maybe<SearchResultsType>;
  sendNotificationToAssignee: Scalars['Boolean'];
  status: TaskStatus;
  taskEscalations: TaskEscalationTypeConnection;
  taskSet: TaskTypeConnection;
};


export type TaskTypeAssigneesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type TaskTypeCustomFieldValuesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type TaskTypeDashboardsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type TaskTypeMetricvalueLevel2Args = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  cardId?: InputMaybe<Scalars['ID']>;
  channel?: InputMaybe<Scalars['String']>;
  dashboardId?: InputMaybe<Scalars['ID']>;
  dashboardRegion?: InputMaybe<Scalars['ID']>;
  date?: InputMaybe<Scalars['Date']>;
  dateFrom?: InputMaybe<Scalars['Date']>;
  dateTo?: InputMaybe<Scalars['Date']>;
  escalatedFrom?: InputMaybe<Scalars['ID']>;
  escalatedTo?: InputMaybe<Scalars['ID']>;
  escalatedToDashboard?: InputMaybe<Scalars['ID']>;
  first?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['ID']>;
  includeEscalated?: InputMaybe<Scalars['Boolean']>;
  isImportant?: InputMaybe<Scalars['Boolean']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type TaskTypeMetricvalueSetArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  cardId?: InputMaybe<Scalars['ID']>;
  channel?: InputMaybe<Scalars['String']>;
  dashboardId?: InputMaybe<Scalars['ID']>;
  dashboardRegion?: InputMaybe<Scalars['ID']>;
  date?: InputMaybe<Scalars['Date']>;
  dateFrom?: InputMaybe<Scalars['Date']>;
  dateTo?: InputMaybe<Scalars['Date']>;
  escalatedFrom?: InputMaybe<Scalars['ID']>;
  escalatedTo?: InputMaybe<Scalars['ID']>;
  escalatedToDashboard?: InputMaybe<Scalars['ID']>;
  first?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['ID']>;
  includeEscalated?: InputMaybe<Scalars['Boolean']>;
  isImportant?: InputMaybe<Scalars['Boolean']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type TaskTypeSchedulesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type TaskTypeTaskEscalationsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  createdBy?: InputMaybe<Scalars['ID']>;
  escalatedFrom?: InputMaybe<Scalars['ID']>;
  escalatedTo?: InputMaybe<Scalars['ID']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  task?: InputMaybe<Scalars['ID']>;
};


export type TaskTypeTaskSetArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};

export type TaskTypeConnection = {
  __typename?: 'TaskTypeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<TaskTypeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** The total count of objects in this query. */
  totalCount?: Maybe<Scalars['Int']>;
};

/** A Relay edge containing a `TaskType` and its cursor. */
export type TaskTypeEdge = {
  __typename?: 'TaskTypeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<TaskType>;
};

export type TriggerCandidateUpdateInput = {
  country?: InputMaybe<CountryEnum>;
  externalId: Scalars['Int'];
};

export type TriggerCandidateUpdateMutation = {
  __typename?: 'TriggerCandidateUpdateMutation';
  ok?: Maybe<Scalars['Boolean']>;
};

export type UrlSegmentType = {
  __typename?: 'URLSegmentType';
  biuro?: Maybe<Scalars['String']>;
};

export type UnEscalateMetricValueFromDashboards = {
  __typename?: 'UnEscalateMetricValueFromDashboards';
  errors?: Maybe<Array<Maybe<Scalars['String']>>>;
  metricValue?: Maybe<MetricValueType>;
  ok?: Maybe<Scalars['Boolean']>;
};

export type UnEscalateTaskFromDashboards = {
  __typename?: 'UnEscalateTaskFromDashboards';
  errors?: Maybe<Array<Maybe<Scalars['String']>>>;
  ok?: Maybe<Scalars['Boolean']>;
  task?: Maybe<TaskType>;
};

export type UpdateCompany = {
  __typename?: 'UpdateCompany';
  company?: Maybe<CompanyType>;
  ok?: Maybe<Scalars['Boolean']>;
};

export type UpdateCompanyDescription = {
  __typename?: 'UpdateCompanyDescription';
  company?: Maybe<CompanyType>;
  ok?: Maybe<Scalars['Boolean']>;
};

export type UpdateCompanyManagers = {
  __typename?: 'UpdateCompanyManagers';
  companies?: Maybe<Array<Maybe<CompanyType>>>;
  ok?: Maybe<Scalars['Boolean']>;
};

export type UpdateCompanyModelInput = {
  address?: InputMaybe<Scalars['String']>;
  clientMutationId?: InputMaybe<Scalars['String']>;
  color?: InputMaybe<HistoricalCompanyColor>;
  country?: InputMaybe<Scalars['ID']>;
  description?: InputMaybe<Scalars['String']>;
  /** The ID of the object. */
  id: Scalars['ID'];
  insightlyId?: InputMaybe<Scalars['Int']>;
  invoiceContact?: InputMaybe<Scalars['ID']>;
  keyAccountManager?: InputMaybe<Scalars['ID']>;
  labels?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  legalEntityCode?: InputMaybe<Scalars['String']>;
  livasId?: InputMaybe<Scalars['Int']>;
  /** Set list of metric values */
  metricvalueSet?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Set list of metric value comments */
  metricvaluecommentSet?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  name?: InputMaybe<Scalars['String']>;
  /** Set list of operations tasks */
  operationstaskSet?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Set list of orders */
  orderSet?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  projectManager1?: InputMaybe<Scalars['ID']>;
  projectManager2?: InputMaybe<Scalars['ID']>;
  recruiter1?: InputMaybe<Scalars['ID']>;
  recruiter2?: InputMaybe<Scalars['ID']>;
  registrationId?: InputMaybe<Scalars['String']>;
  salesQuestionnaire?: InputMaybe<Scalars['String']>;
  /** Set list of specifications */
  specificationSet?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  status?: InputMaybe<Scalars['String']>;
  substituteManager1?: InputMaybe<Scalars['ID']>;
  substituteManager2?: InputMaybe<Scalars['ID']>;
  substituteRecruiter1?: InputMaybe<Scalars['ID']>;
  substituteRecruiter2?: InputMaybe<Scalars['ID']>;
  /** Set list of tasks */
  taskSet?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  vatNumber?: InputMaybe<Scalars['String']>;
  /** Set list of work time violations */
  worktimeviolationSet?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
};

export type UpdateCompanyModelPayload = {
  __typename?: 'UpdateCompanyModelPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  /** The mutated object. */
  company?: Maybe<CompanyType>;
  /** List of errors that occurred while executing the mutation. */
  errors?: Maybe<Array<MutationErrorType>>;
};

export type UpdateCompanyRelay = {
  __typename?: 'UpdateCompanyRelay';
  company?: Maybe<CompanyType>;
  ok?: Maybe<Scalars['Boolean']>;
};

export type UpdateContact = {
  __typename?: 'UpdateContact';
  contact?: Maybe<ContactType>;
  ok?: Maybe<Scalars['Boolean']>;
};

export type UpdateDashboardCardInput = {
  barchartGoal?: InputMaybe<Scalars['Float']>;
  card?: InputMaybe<Scalars['ID']>;
  cardOrderInDashboard?: InputMaybe<Scalars['Int']>;
  clientMutationId?: InputMaybe<Scalars['String']>;
  dashboard?: InputMaybe<Scalars['ID']>;
  /** The ID of the object. */
  id: Scalars['ID'];
  /** Defines the metric group for which Metric Value will be created */
  metricGroupForOtherProblem?: InputMaybe<Scalars['ID']>;
  /** If set, only show metrics for these region groups */
  regionGroups?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Optional override for how this card should be scoped on this dashboard. */
  scopeMode?: InputMaybe<DashboardCardScopeMode>;
};

export type UpdateDashboardCardPayload = {
  __typename?: 'UpdateDashboardCardPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  /** The mutated object. */
  dashboardCard?: Maybe<DashboardCardType>;
  /** List of errors that occurred while executing the mutation. */
  errors?: Maybe<Array<MutationErrorType>>;
};

export type UpdateLivasCandidateStatus = {
  __typename?: 'UpdateLivasCandidateStatus';
  ok?: Maybe<Scalars['Boolean']>;
};

export type UpdateMetricValueCommentInput = {
  candidates?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  clientMutationId?: InputMaybe<Scalars['String']>;
  clients?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  comment?: InputMaybe<Scalars['String']>;
  /** The ID of the object. */
  id: Scalars['ID'];
  metricClientReason?: InputMaybe<Scalars['ID']>;
  metricValue?: InputMaybe<Scalars['ID']>;
};

export type UpdateMetricValueCommentPayload = {
  __typename?: 'UpdateMetricValueCommentPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  /** List of errors that occurred while executing the mutation. */
  errors?: Maybe<Array<MutationErrorType>>;
  /** The mutated object. */
  metricValueComment?: Maybe<MetricValueCommentType>;
};

export type UpdateMetricValueInput = {
  candidate?: InputMaybe<Scalars['ID']>;
  /** Channel used for the activity (Email or Phone) */
  channel?: InputMaybe<MetricValueChannel>;
  client?: InputMaybe<Scalars['ID']>;
  clientMutationId?: InputMaybe<Scalars['String']>;
  createdBy?: InputMaybe<Scalars['ID']>;
  date?: InputMaybe<Scalars['Date']>;
  escalatedAt?: InputMaybe<Scalars['DateTime']>;
  escalatedBy?: InputMaybe<Scalars['ID']>;
  escalatedFrom?: InputMaybe<Scalars['ID']>;
  escalatedTo?: InputMaybe<Scalars['ID']>;
  escalatedToDashboards?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  goal?: InputMaybe<Scalars['Float']>;
  /** The ID of the object. */
  id: Scalars['ID'];
  isImportant?: InputMaybe<Scalars['Boolean']>;
  /** Key to identify specific metric variant (e.g., conversion type) */
  key?: InputMaybe<Scalars['String']>;
  manager?: InputMaybe<Scalars['ID']>;
  metricGroup?: InputMaybe<Scalars['ID']>;
  nextTask?: InputMaybe<Scalars['ID']>;
  nextTaskLevel2?: InputMaybe<Scalars['ID']>;
  order?: InputMaybe<Scalars['ID']>;
  regionGroup?: InputMaybe<Scalars['ID']>;
  relatedActivity?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  relatedObjects?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  subvalue?: InputMaybe<Scalars['Float']>;
  value?: InputMaybe<Scalars['Float']>;
  /** If true, metric is related to  Workis; LOGO will be shown on the standup board. */
  workis?: InputMaybe<Scalars['Boolean']>;
};

export type UpdateMetricValuePayload = {
  __typename?: 'UpdateMetricValuePayload';
  clientMutationId?: Maybe<Scalars['String']>;
  /** List of errors that occurred while executing the mutation. */
  errors?: Maybe<Array<MutationErrorType>>;
  /** The mutated object. */
  metricValue?: Maybe<MetricValueType>;
};

export type UpdateOffboardingRole = {
  __typename?: 'UpdateOffboardingRole';
  offboardingRole?: Maybe<OffboardingRoleType>;
  ok?: Maybe<Scalars['Boolean']>;
};

export type UpdateOfferPropositionCommentInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  createdBy?: InputMaybe<Scalars['ID']>;
  /** The ID of the object. */
  id: Scalars['ID'];
  livasId?: InputMaybe<Scalars['Int']>;
  offerProposition?: InputMaybe<Scalars['ID']>;
  text?: InputMaybe<Scalars['String']>;
};

export type UpdateOfferPropositionCommentPayload = {
  __typename?: 'UpdateOfferPropositionCommentPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  /** List of errors that occurred while executing the mutation. */
  errors?: Maybe<Array<MutationErrorType>>;
  /** The mutated object. */
  offerPropositionComment?: Maybe<OfferPropositionCommentType>;
};

export type UpdateOperationsTaskInput = {
  /** Users assigned to this task. Migrate from completed_by */
  assignees?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  candidate?: InputMaybe<Scalars['ID']>;
  category?: InputMaybe<Scalars['ID']>;
  clientMutationId?: InputMaybe<Scalars['String']>;
  comment?: InputMaybe<Scalars['String']>;
  company?: InputMaybe<Scalars['ID']>;
  completedAt?: InputMaybe<Scalars['DateTime']>;
  completedBy?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  country?: InputMaybe<Scalars['ID']>;
  createdBy?: InputMaybe<Scalars['ID']>;
  createdBySchedule?: InputMaybe<Scalars['ID']>;
  dashboard?: InputMaybe<Scalars['ID']>;
  dashboards?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  date?: InputMaybe<Scalars['Date']>;
  deleted?: InputMaybe<Scalars['DateTime']>;
  durationMinutes?: InputMaybe<Scalars['Int']>;
  /** The ID of the object. */
  id: Scalars['ID'];
  isImportant?: InputMaybe<Scalars['Boolean']>;
  key?: InputMaybe<Scalars['String']>;
  lastOverdueUpdate?: InputMaybe<Scalars['Date']>;
  /** Set list of metric values */
  metricvalueLevel2?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Set list of metric values */
  metricvalueSet?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  nextActionCategory?: InputMaybe<Scalars['ID']>;
  nextActionDate?: InputMaybe<Scalars['Date']>;
  nextTaskAssignee?: InputMaybe<Scalars['ID']>;
  numPreviousTasks?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Scalars['ID']>;
  overdueCount?: InputMaybe<Scalars['Int']>;
  parentTask?: InputMaybe<Scalars['ID']>;
  result?: InputMaybe<Scalars['String']>;
  searchResults?: InputMaybe<Scalars['ID']>;
  /** Set list of selection action completions */
  selectionactioncompletionSet?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  sendNotificationToAssignee?: InputMaybe<Scalars['Boolean']>;
  status?: InputMaybe<TaskStatus>;
  /** Set list of tasks */
  taskSet?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
};

export type UpdateOperationsTaskPayload = {
  __typename?: 'UpdateOperationsTaskPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  /** List of errors that occurred while executing the mutation. */
  errors?: Maybe<Array<MutationErrorType>>;
  /** The mutated object. */
  task?: Maybe<TaskType>;
};

export type UpdateOrder = {
  __typename?: 'UpdateOrder';
  order?: Maybe<OrderType>;
};

export type UpdateRequestsActivityInput = {
  channel?: InputMaybe<RequestsActivityChannel>;
  clientContact?: InputMaybe<Scalars['ID']>;
  clientMutationId?: InputMaybe<Scalars['String']>;
  comment?: InputMaybe<Scalars['String']>;
  contact?: InputMaybe<Scalars['ID']>;
  createdBy?: InputMaybe<Scalars['ID']>;
  email?: InputMaybe<Scalars['String']>;
  /** The ID of the object. */
  id: Scalars['ID'];
  phone?: InputMaybe<Scalars['String']>;
  reason?: InputMaybe<Scalars['ID']>;
};

export type UpdateRequestsActivityPayload = {
  __typename?: 'UpdateRequestsActivityPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  /** List of errors that occurred while executing the mutation. */
  errors?: Maybe<Array<MutationErrorType>>;
  /** The mutated object. */
  requestsActivity?: Maybe<RequestsActivityType>;
};

export type UpdateScheduleInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** Day of the month for monthly tasks (1-31) */
  dayOfMonth?: InputMaybe<Scalars['Int']>;
  dayOfWeek?: InputMaybe<Scalars['Int']>;
  endDate?: InputMaybe<Scalars['Date']>;
  /** Set list of events */
  eventSet?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** The ID of the object. */
  id: Scalars['ID'];
  /** Task should be repeated every x days/weeks/months */
  intervalCount?: InputMaybe<Scalars['Int']>;
  monthInterval?: InputMaybe<Scalars['Int']>;
  /** Set list of operations tasks */
  operationstaskSet?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  parentTask?: InputMaybe<Scalars['ID']>;
  recurrencePeriod?: InputMaybe<ScheduleRecurrencePeriod>;
  repeatAfterXDays?: InputMaybe<Scalars['Int']>;
  /** Set list of tasks */
  taskSet?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  weekOfMonth?: InputMaybe<Scalars['Int']>;
};

export type UpdateSchedulePayload = {
  __typename?: 'UpdateSchedulePayload';
  clientMutationId?: Maybe<Scalars['String']>;
  /** List of errors that occurred while executing the mutation. */
  errors?: Maybe<Array<MutationErrorType>>;
  /** The mutated object. */
  schedule?: Maybe<ScheduleType>;
};

export type UpdateSelectionActionInput = {
  /** Users assigned to this task. Migrate from completed_by */
  assignees?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  candidate?: InputMaybe<Scalars['ID']>;
  category?: InputMaybe<Scalars['ID']>;
  clientMutationId?: InputMaybe<Scalars['String']>;
  comment?: InputMaybe<Scalars['String']>;
  company?: InputMaybe<Scalars['ID']>;
  completedAt?: InputMaybe<Scalars['DateTime']>;
  completedBy?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  country?: InputMaybe<Scalars['ID']>;
  createdBy?: InputMaybe<Scalars['ID']>;
  createdBySchedule?: InputMaybe<Scalars['ID']>;
  dashboard?: InputMaybe<Scalars['ID']>;
  dashboards?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  date?: InputMaybe<Scalars['Date']>;
  deleted?: InputMaybe<Scalars['DateTime']>;
  durationMinutes?: InputMaybe<Scalars['Int']>;
  /** The ID of the object. */
  id: Scalars['ID'];
  isImportant?: InputMaybe<Scalars['Boolean']>;
  key?: InputMaybe<Scalars['String']>;
  lastOverdueUpdate?: InputMaybe<Scalars['Date']>;
  /** Set list of metric values */
  metricvalueLevel2?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Set list of metric values */
  metricvalueSet?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  nextActionCategory?: InputMaybe<Scalars['ID']>;
  nextActionDate?: InputMaybe<Scalars['Date']>;
  nextTaskAssignee?: InputMaybe<Scalars['ID']>;
  numPreviousTasks?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Scalars['ID']>;
  overdueCount?: InputMaybe<Scalars['Int']>;
  parentTask?: InputMaybe<Scalars['ID']>;
  result?: InputMaybe<Scalars['String']>;
  searchResults?: InputMaybe<Scalars['ID']>;
  /** Set list of selection action completions */
  selectionactioncompletionSet?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  sendNotificationToAssignee?: InputMaybe<Scalars['Boolean']>;
  status?: InputMaybe<TaskStatus>;
  /** Set list of tasks */
  taskSet?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
};

export type UpdateSelectionActionPayload = {
  __typename?: 'UpdateSelectionActionPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  /** List of errors that occurred while executing the mutation. */
  errors?: Maybe<Array<MutationErrorType>>;
  /** The mutated object. */
  task?: Maybe<TaskType>;
};

export type UpdateSpecification = {
  __typename?: 'UpdateSpecification';
  specification?: Maybe<SpecificationType>;
};

export type UpdatedCandidateListType = {
  __typename?: 'UpdatedCandidateListType';
  candidates?: Maybe<Array<Maybe<CandidateType>>>;
  taskStatus?: Maybe<Scalars['String']>;
};

/** An enumeration. */
export enum UserProfileDepartment {
  /** Administration */
  Administration = 'ADMINISTRATION',
  /** IT */
  It = 'IT',
  /** Key account managers */
  KeyAccountManagers = 'KEY_ACCOUNT_MANAGERS',
  /** Marketing */
  Marketing = 'MARKETING',
  /** Operations */
  Operations = 'OPERATIONS',
  /** Sales */
  Sales = 'SALES',
  /** Selections */
  Selections = 'SELECTIONS',
  /** Workis */
  Workis = 'WORKIS'
}

export type UserProfileMType = Node & {
  __typename?: 'UserProfileMType';
  actioncategorySet: ActionCategoryTypeConnection;
  assignedErrors: OrderErrorTypeConnection;
  cancellationReasonAssignments: CancellationReasonAssignmentTypeConnection;
  color?: Maybe<Scalars['String']>;
  companyProjectManager1: CompanyTypeConnection;
  companyProjectManager2: CompanyTypeConnection;
  companyRecruiter1: CompanyTypeConnection;
  companyRecruiter2: CompanyTypeConnection;
  companySet: CompanyTypeConnection;
  companySubstituteManager1: CompanyTypeConnection;
  companySubstituteManager2: CompanyTypeConnection;
  companySubstituteRecruiter1: CompanyTypeConnection;
  companySubstituteRecruiter2: CompanyTypeConnection;
  contactSet: ContactTypeConnection;
  createdCandidateEvents: CandidateEventTypeConnection;
  createdEscalations: MetricValueEscalationTypeConnection;
  createdLinks: CustomLinkTypeConnection;
  createdMetricValues: MetricValueTypeConnection;
  createdTaskEscalations: TaskEscalationTypeConnection;
  creator: OrderTypeConnection;
  customfieldvalueSet: CustomFieldValueTypeConnection;
  dashboards: DashboardTypeConnection;
  delegateRequests: RequestsActivityTypeConnection;
  department?: Maybe<UserProfileDepartment>;
  escalatedMetrics: MetricValueTypeConnection;
  /** Users assigned to this task. Migrate from completed_by */
  eventAssigned: EventTypeConnection;
  eventComplete: EventTypeConnection;
  eventSet: EventTypeConnection;
  firstInterestedOnCall: OfferPropositionTypeConnection;
  firstOffered: OfferPropositionTypeConnection;
  firstOfferedOnCall: OfferPropositionTypeConnection;
  fullName: Scalars['String'];
  /** The ID of the object. */
  id: Scalars['ID'];
  insightlyId?: Maybe<Scalars['Int']>;
  jobadaicontentSet: JobAdAiContentTypeConnection;
  livasId?: Maybe<Scalars['Int']>;
  metricvalueSet: MetricValueTypeConnection;
  nextTaskAssignee: TaskTypeConnection;
  offerpropositionSet: OfferPropositionTypeConnection;
  offerpropositioncommentSet: OfferPropositionCommentTypeConnection;
  orderSet: OrderTypeConnection;
  orderclientcontactedSet: OrderClientContactedTypeConnection;
  ordercommentSet: OrderCommentTypeConnection;
  ordererrorSet: OrderErrorTypeConnection;
  ordererrorcategorySet: OrderErrorCategoryTypeConnection;
  phone?: Maybe<Scalars['String']>;
  problematicInterviews: CandidateEventTypeConnection;
  profileImage?: Maybe<Scalars['String']>;
  profileImageUrl?: Maybe<Scalars['String']>;
  recruiting: OrderTypeConnection;
  region?: Maybe<RegionType>;
  requestsactivitySet: RequestsActivityTypeConnection;
  sacategorySet: SaCategoryTypeConnection;
  sacategorygroupSet: SaCategoryGroupTypeConnection;
  searchresultsSet: SearchResultsTypeConnection;
  selectionsComplete: TaskTypeConnection;
  signing: OrderTypeConnection;
  /** Users assigned to this task. Migrate from completed_by */
  taskAssigned: TaskTypeConnection;
  taskSet: TaskTypeConnection;
  user: UserType;
};


export type UserProfileMTypeActioncategorySetArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type UserProfileMTypeAssignedErrorsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type UserProfileMTypeCancellationReasonAssignmentsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offerProposition?: InputMaybe<Scalars['ID']>;
};


export type UserProfileMTypeCompanyProjectManager1Args = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type UserProfileMTypeCompanyProjectManager2Args = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type UserProfileMTypeCompanyRecruiter1Args = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type UserProfileMTypeCompanyRecruiter2Args = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type UserProfileMTypeCompanySetArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type UserProfileMTypeCompanySubstituteManager1Args = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type UserProfileMTypeCompanySubstituteManager2Args = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type UserProfileMTypeCompanySubstituteRecruiter1Args = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type UserProfileMTypeCompanySubstituteRecruiter2Args = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type UserProfileMTypeContactSetArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type UserProfileMTypeCreatedCandidateEventsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  deleted?: InputMaybe<Scalars['Boolean']>;
  eventType?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  startDatetime_Gte?: InputMaybe<Scalars['DateTime']>;
  startDatetime_Lte?: InputMaybe<Scalars['DateTime']>;
};


export type UserProfileMTypeCreatedEscalationsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type UserProfileMTypeCreatedLinksArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type UserProfileMTypeCreatedMetricValuesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  cardId?: InputMaybe<Scalars['ID']>;
  channel?: InputMaybe<Scalars['String']>;
  dashboardId?: InputMaybe<Scalars['ID']>;
  dashboardRegion?: InputMaybe<Scalars['ID']>;
  date?: InputMaybe<Scalars['Date']>;
  dateFrom?: InputMaybe<Scalars['Date']>;
  dateTo?: InputMaybe<Scalars['Date']>;
  escalatedFrom?: InputMaybe<Scalars['ID']>;
  escalatedTo?: InputMaybe<Scalars['ID']>;
  escalatedToDashboard?: InputMaybe<Scalars['ID']>;
  first?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['ID']>;
  includeEscalated?: InputMaybe<Scalars['Boolean']>;
  isImportant?: InputMaybe<Scalars['Boolean']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type UserProfileMTypeCreatedTaskEscalationsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  createdBy?: InputMaybe<Scalars['ID']>;
  escalatedFrom?: InputMaybe<Scalars['ID']>;
  escalatedTo?: InputMaybe<Scalars['ID']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  task?: InputMaybe<Scalars['ID']>;
};


export type UserProfileMTypeCreatorArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type UserProfileMTypeCustomfieldvalueSetArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type UserProfileMTypeDashboardsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type UserProfileMTypeDelegateRequestsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type UserProfileMTypeEscalatedMetricsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  cardId?: InputMaybe<Scalars['ID']>;
  channel?: InputMaybe<Scalars['String']>;
  dashboardId?: InputMaybe<Scalars['ID']>;
  dashboardRegion?: InputMaybe<Scalars['ID']>;
  date?: InputMaybe<Scalars['Date']>;
  dateFrom?: InputMaybe<Scalars['Date']>;
  dateTo?: InputMaybe<Scalars['Date']>;
  escalatedFrom?: InputMaybe<Scalars['ID']>;
  escalatedTo?: InputMaybe<Scalars['ID']>;
  escalatedToDashboard?: InputMaybe<Scalars['ID']>;
  first?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['ID']>;
  includeEscalated?: InputMaybe<Scalars['Boolean']>;
  isImportant?: InputMaybe<Scalars['Boolean']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type UserProfileMTypeEventAssignedArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  date_Gte?: InputMaybe<Scalars['Date']>;
  date_Lte?: InputMaybe<Scalars['Date']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Scalars['ID']>;
};


export type UserProfileMTypeEventCompleteArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  date_Gte?: InputMaybe<Scalars['Date']>;
  date_Lte?: InputMaybe<Scalars['Date']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Scalars['ID']>;
};


export type UserProfileMTypeEventSetArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  date_Gte?: InputMaybe<Scalars['Date']>;
  date_Lte?: InputMaybe<Scalars['Date']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Scalars['ID']>;
};


export type UserProfileMTypeFirstInterestedOnCallArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type UserProfileMTypeFirstOfferedArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type UserProfileMTypeFirstOfferedOnCallArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type UserProfileMTypeJobadaicontentSetArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type UserProfileMTypeMetricvalueSetArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  cardId?: InputMaybe<Scalars['ID']>;
  channel?: InputMaybe<Scalars['String']>;
  dashboardId?: InputMaybe<Scalars['ID']>;
  dashboardRegion?: InputMaybe<Scalars['ID']>;
  date?: InputMaybe<Scalars['Date']>;
  dateFrom?: InputMaybe<Scalars['Date']>;
  dateTo?: InputMaybe<Scalars['Date']>;
  escalatedFrom?: InputMaybe<Scalars['ID']>;
  escalatedTo?: InputMaybe<Scalars['ID']>;
  escalatedToDashboard?: InputMaybe<Scalars['ID']>;
  first?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['ID']>;
  includeEscalated?: InputMaybe<Scalars['Boolean']>;
  isImportant?: InputMaybe<Scalars['Boolean']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type UserProfileMTypeNextTaskAssigneeArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type UserProfileMTypeOfferpropositionSetArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type UserProfileMTypeOfferpropositioncommentSetArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  createdBy?: InputMaybe<Scalars['ID']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offerProposition?: InputMaybe<Scalars['ID']>;
  orderBy?: InputMaybe<Scalars['String']>;
};


export type UserProfileMTypeOrderSetArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type UserProfileMTypeOrderclientcontactedSetArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderId?: InputMaybe<Scalars['ID']>;
};


export type UserProfileMTypeOrdercommentSetArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderId?: InputMaybe<Scalars['ID']>;
};


export type UserProfileMTypeOrdererrorSetArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type UserProfileMTypeOrdererrorcategorySetArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type UserProfileMTypeProblematicInterviewsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  deleted?: InputMaybe<Scalars['Boolean']>;
  eventType?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  startDatetime_Gte?: InputMaybe<Scalars['DateTime']>;
  startDatetime_Lte?: InputMaybe<Scalars['DateTime']>;
};


export type UserProfileMTypeRecruitingArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type UserProfileMTypeRequestsactivitySetArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type UserProfileMTypeSacategorySetArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  createdBy?: InputMaybe<Scalars['ID']>;
  first?: InputMaybe<Scalars['Int']>;
  group?: InputMaybe<Scalars['ID']>;
  last?: InputMaybe<Scalars['Int']>;
  title?: InputMaybe<Scalars['String']>;
};


export type UserProfileMTypeSacategorygroupSetArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['ID']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  createdBy?: InputMaybe<Scalars['ID']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  title?: InputMaybe<Scalars['String']>;
};


export type UserProfileMTypeSearchresultsSetArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  createdAt_Gte?: InputMaybe<Scalars['DateTime']>;
  createdAt_Lte?: InputMaybe<Scalars['DateTime']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  task?: InputMaybe<Scalars['ID']>;
};


export type UserProfileMTypeSelectionsCompleteArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type UserProfileMTypeSigningArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type UserProfileMTypeTaskAssignedArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type UserProfileMTypeTaskSetArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};

export type UserProfileMTypeConnection = {
  __typename?: 'UserProfileMTypeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<UserProfileMTypeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `UserProfileMType` and its cursor. */
export type UserProfileMTypeEdge = {
  __typename?: 'UserProfileMTypeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<UserProfileMType>;
};

export type UserType = {
  __typename?: 'UserType';
  candidaterequirementsevaluationSet: CandidateRequirementsEvaluationTypeConnection;
  dateJoined: Scalars['DateTime'];
  email: Scalars['String'];
  firstName: Scalars['String'];
  id: Scalars['ID'];
  imageSet: Array<ImageType>;
  /** Designates whether this user should be treated as active. Unselect this instead of deleting accounts. */
  isActive: Scalars['Boolean'];
  /** Designates whether the user can log into this admin site. */
  isStaff: Scalars['Boolean'];
  /** Designates that this user has all permissions without explicitly assigning them. */
  isSuperuser: Scalars['Boolean'];
  lastLogin?: Maybe<Scalars['DateTime']>;
  lastName: Scalars['String'];
  password: Scalars['String'];
  /** Required. 150 characters or fewer. Letters, digits and @/./+/-/_ only. */
  username: Scalars['String'];
  userprofile?: Maybe<UserProfileMType>;
};


export type UserTypeCandidaterequirementsevaluationSetArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};

/** An enumeration. */
export enum VirtualNumberDepartment {
  /** Administration */
  Administration = 'ADMINISTRATION',
  /** IT */
  It = 'IT',
  /** Key account managers */
  KeyAccountManagers = 'KEY_ACCOUNT_MANAGERS',
  /** Marketing */
  Marketing = 'MARKETING',
  /** Operations */
  Operations = 'OPERATIONS',
  /** Sales */
  Sales = 'SALES',
  /** Selections */
  Selections = 'SELECTIONS',
  /** Workis */
  Workis = 'WORKIS'
}

export type VirtualNumberType = {
  __typename?: 'VirtualNumberType';
  department?: Maybe<VirtualNumberDepartment>;
  id: Scalars['ID'];
  name?: Maybe<Scalars['String']>;
  phone: Scalars['String'];
  region?: Maybe<RegionType>;
  usageArea?: Maybe<VirtualNumberUsageArea>;
};

/** An enumeration. */
export enum VirtualNumberUsageArea {
  /** CV portal */
  CvPortal = 'CV_PORTAL',
  /** Facebook groups */
  FacebookGroups = 'FACEBOOK_GROUPS',
  /** Flyers */
  Flyers = 'FLYERS',
  /** Landing page */
  LandingPage = 'LANDING_PAGE',
  /** Newspaper */
  Newspaper = 'NEWSPAPER',
  /** Outdoor */
  Outdoor = 'OUTDOOR',
  /** Poster */
  Poster = 'POSTER',
  /** SMS */
  Sms = 'SMS'
}

export type WwwType = {
  __typename?: 'WWWType';
  alio?: Maybe<Scalars['String']>;
  biuro?: Maybe<Scalars['String']>;
  cvbankas?: Maybe<Scalars['String']>;
  cvlt?: Maybe<Scalars['String']>;
  cvmarket?: Maybe<Scalars['String']>;
  cvonline?: Maybe<Scalars['String']>;
  cvzona?: Maybe<Scalars['String']>;
  dirbaLt?: Maybe<Scalars['String']>;
};

export type WaitingApplication = {
  __typename?: 'WaitingApplication';
  company?: Maybe<Scalars['String']>;
  fullName?: Maybe<Scalars['String']>;
  job?: Maybe<Scalars['String']>;
  shiftDate?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
};

export type CancellationReasonsGroupFieldsFragment = { __typename?: 'CancellationReasonGroupType', id: string, title: string, order: number, cancellationReasons: { __typename?: 'CancellationReasonTypeConnection', edges: Array<{ __typename?: 'CancellationReasonTypeEdge', node?: { __typename?: 'CancellationReasonType', id: string, title: string, order: number } | null } | null> } };

export type GetCancellationReasonsQueryVariables = Exact<{
  country?: InputMaybe<Scalars['ID']>;
}>;


export type GetCancellationReasonsQuery = { __typename?: 'Query', cancellationReasonGroups?: { __typename?: 'CancellationReasonGroupTypeConnection', edges: Array<{ __typename?: 'CancellationReasonGroupTypeEdge', node?: { __typename?: 'CancellationReasonGroupType', id: string, title: string, order: number, cancellationReasons: { __typename?: 'CancellationReasonTypeConnection', edges: Array<{ __typename?: 'CancellationReasonTypeEdge', node?: { __typename?: 'CancellationReasonType', id: string, title: string, order: number } | null } | null> } } | null } | null> } | null };

export type GetCancellationReasonsForOfferQueryVariables = Exact<{
  offerPropositionId: Scalars['ID'];
}>;


export type GetCancellationReasonsForOfferQuery = { __typename?: 'Query', cancellationReasonAssignments?: { __typename?: 'CancellationReasonAssignmentTypeConnection', edges: Array<{ __typename?: 'CancellationReasonAssignmentTypeEdge', node?: { __typename?: 'CancellationReasonAssignmentType', id: string, cancellationReason: { __typename?: 'CancellationReasonType', id: string } } | null } | null> } | null };

export type CreateCancellationReasonAssignmentsMutationVariables = Exact<{
  offerProposition: Scalars['ID'];
  cancellationReasons: Array<InputMaybe<Scalars['ID']>> | InputMaybe<Scalars['ID']>;
}>;


export type CreateCancellationReasonAssignmentsMutation = { __typename?: 'Mutation', createCancellationReasonAssignment?: { __typename?: 'CreateCancellationReasonAssignmentMutation', ok?: boolean | null } | null };

export type CandidatesTableDataQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']>;
  after?: InputMaybe<Scalars['String']>;
  manager?: InputMaybe<Array<InputMaybe<Scalars['ID']>> | InputMaybe<Scalars['ID']>>;
  country?: InputMaybe<Scalars['ID']>;
  company?: InputMaybe<Scalars['ID']>;
  search?: InputMaybe<Scalars['String']>;
}>;


export type CandidatesTableDataQuery = { __typename?: 'Query', offers?: { __typename?: 'OfferPropositionTypeConnection', totalCount?: number | null, edges: Array<{ __typename?: 'OfferPropositionTypeEdge', node?: { __typename?: 'OfferPropositionType', id: string, order: { __typename?: 'OrderType', projectManager?: { __typename?: 'UserProfileMType', fullName: string } | null, company?: { __typename?: 'CompanyType', name: string, address?: string | null } | null }, candidate?: { __typename?: 'CandidateType', firstName: string, lastName: string } | null, candidateEvents: { __typename?: 'CandidateEventTypeConnection', edges: Array<{ __typename?: 'CandidateEventTypeEdge', node?: { __typename?: 'CandidateEventType', id: string, startDatetime?: any | null, resolutionStatus?: EventResolutionStatus | null, eventType: EventEventType, deleted: boolean, description?: string | null, isProblematicInterview: boolean, relatedOffer?: { __typename?: 'OfferPropositionType', order: { __typename?: 'OrderType', company?: { __typename?: 'CompanyType', name: string } | null } } | null } | null } | null> }, offerpropositioncommentSet: { __typename?: 'OfferPropositionCommentTypeConnection', totalCount?: number | null, edges: Array<{ __typename?: 'OfferPropositionCommentTypeEdge', node?: { __typename?: 'OfferPropositionCommentType', text?: string | null } | null } | null> } } | null } | null> } | null };

export type GetCandidatesQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']>;
  after?: InputMaybe<Scalars['String']>;
  metricValueCommentId?: InputMaybe<Scalars['ID']>;
}>;


export type GetCandidatesQuery = { __typename?: 'Query', candidates?: { __typename?: 'CandidateTypeConnection', totalCount?: number | null, edges: Array<{ __typename?: 'CandidateTypeEdge', node?: { __typename?: 'CandidateType', firstName: string, lastName: string, employeeLivasId?: number | null, livasId: number, livasStatus?: { __typename?: 'CandidateStatusType', key?: string | null } | null } | null } | null> } | null };

export type CovidLabelsFieldsFragment = { __typename?: 'LabelType', id: string, title: string };

export type FilterMetadataQueryVariables = Exact<{ [key: string]: never; }>;


export type FilterMetadataQuery = { __typename?: 'Query', scheduleTypes?: Array<{ __typename?: 'ScheduleTypeType', id: string, title: string, isPreselected: boolean } | null> | null, labels?: { __typename?: 'LabelTypeConnection', edges: Array<{ __typename?: 'LabelTypeEdge', node?: { __typename?: 'LabelType', id: string, title: string } | null } | null> } | null };

export type ContractorSelectFieldsFragment = { __typename?: 'ContractorType', id: string, title: string, externalId: number, country?: { __typename?: 'CountryType', id: string, isoCode?: string | null } | null };

export type GetContractorsForSelectQueryVariables = Exact<{ [key: string]: never; }>;


export type GetContractorsForSelectQuery = { __typename?: 'Query', contractors?: { __typename?: 'ContractorTypeConnection', edges: Array<{ __typename?: 'ContractorTypeEdge', node?: { __typename?: 'ContractorType', id: string, title: string, externalId: number, country?: { __typename?: 'CountryType', id: string, isoCode?: string | null } | null } | null } | null> } | null };

export type OffboardingRoleFragment = { __typename?: 'OffboardingRoleType', id: string, name: string, createdAt: any, updatedAt?: any | null, company: { __typename?: 'CompanyType', id: string, name: string }, orders: { __typename?: 'OrderTypeConnection', edges: Array<{ __typename?: 'OrderTypeEdge', node?: { __typename?: 'OrderType', id: string } | null } | null> }, actions?: Array<{ __typename?: 'OffboardingActionType', id: string, description: string, order: number, createdAt: any, role: { __typename?: 'OffboardingRoleType', id: string } } | null> | null };

export type GetOffboardingRolesQueryVariables = Exact<{
  company?: InputMaybe<Scalars['ID']>;
}>;


export type GetOffboardingRolesQuery = { __typename?: 'Query', offboardingRoles?: { __typename?: 'OffboardingRoleTypeConnection', edges: Array<{ __typename?: 'OffboardingRoleTypeEdge', node?: { __typename?: 'OffboardingRoleType', id: string, name: string, createdAt: any, updatedAt?: any | null, company: { __typename?: 'CompanyType', id: string, name: string }, orders: { __typename?: 'OrderTypeConnection', edges: Array<{ __typename?: 'OrderTypeEdge', node?: { __typename?: 'OrderType', id: string } | null } | null> }, actions?: Array<{ __typename?: 'OffboardingActionType', id: string, description: string, order: number, createdAt: any, role: { __typename?: 'OffboardingRoleType', id: string } } | null> | null } | null } | null> } | null };

export type CreateOffboardingRoleMutationVariables = Exact<{
  input: OffboardingRoleInput;
}>;


export type CreateOffboardingRoleMutation = { __typename?: 'Mutation', createOffboardingRole?: { __typename?: 'CreateOffboardingRole', ok?: boolean | null, offboardingRole?: { __typename?: 'OffboardingRoleType', id: string, name: string, createdAt: any, updatedAt?: any | null, company: { __typename?: 'CompanyType', id: string, name: string }, orders: { __typename?: 'OrderTypeConnection', edges: Array<{ __typename?: 'OrderTypeEdge', node?: { __typename?: 'OrderType', id: string } | null } | null> }, actions?: Array<{ __typename?: 'OffboardingActionType', id: string, description: string, order: number, createdAt: any, role: { __typename?: 'OffboardingRoleType', id: string } } | null> | null } | null } | null };

export type UpdateOffboardingRoleMutationVariables = Exact<{
  id: Scalars['ID'];
  input: OffboardingRoleInput;
}>;


export type UpdateOffboardingRoleMutation = { __typename?: 'Mutation', updateOffboardingRole?: { __typename?: 'UpdateOffboardingRole', ok?: boolean | null, offboardingRole?: { __typename?: 'OffboardingRoleType', id: string, name: string, createdAt: any, updatedAt?: any | null, company: { __typename?: 'CompanyType', id: string, name: string }, orders: { __typename?: 'OrderTypeConnection', edges: Array<{ __typename?: 'OrderTypeEdge', node?: { __typename?: 'OrderType', id: string } | null } | null> }, actions?: Array<{ __typename?: 'OffboardingActionType', id: string, description: string, order: number, createdAt: any, role: { __typename?: 'OffboardingRoleType', id: string } } | null> | null } | null } | null };

export type DeleteOffboardingRoleMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DeleteOffboardingRoleMutation = { __typename?: 'Mutation', deleteOffboardingRole?: { __typename?: 'DeleteOffboardingRole', ok?: boolean | null } | null };

export type GetChangeColorPermissionQueryVariables = Exact<{ [key: string]: never; }>;


export type GetChangeColorPermissionQuery = { __typename?: 'Query', hasPermission?: boolean | null };

export type CompanySelectFieldsFragment = { __typename?: 'CompanyModelType', id: string, livasId?: number | null, status?: string | null, name: string, insightlyId?: number | null, description?: string | null, salesQuestionnaire?: string | null, contractSet: Array<{ __typename?: 'ContractType', id: string, validFromDate?: any | null }>, country?: { __typename?: 'CountryType', id: string, isoCode?: string | null, languageIsoCode?: string | null } | null };

export type CompanyTypeFieldsFragment = { __typename?: 'CompanyType', id: string, status?: string | null, name: string, insightlyId?: number | null, description?: string | null, salesQuestionnaire?: string | null, contactSet: { __typename?: 'ContactTypeConnection', edges: Array<{ __typename?: 'ContactTypeEdge', node?: { __typename?: 'ContactType', id: string, firstName: string, lastName?: string | null, phone?: string | null, email?: string | null, insightlyId?: number | null } | null } | null> }, contractSet: Array<{ __typename?: 'ContractType', id: string, validFromDate?: any | null, validTillDate?: any | null }>, country?: { __typename?: 'CountryType', id: string, isoCode?: string | null, languageIsoCode?: string | null } | null };

export type SearchCompaniesQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['ID']>;
}>;


export type SearchCompaniesQuery = { __typename?: 'Query', companyInstances?: { __typename?: 'CompanyModelTypeConnection', edges: Array<{ __typename?: 'CompanyModelTypeEdge', node?: { __typename?: 'CompanyModelType', id: string, livasId?: number | null, status?: string | null, name: string, insightlyId?: number | null, description?: string | null, salesQuestionnaire?: string | null, contractSet: Array<{ __typename?: 'ContractType', id: string, validFromDate?: any | null }>, country?: { __typename?: 'CountryType', id: string, isoCode?: string | null, languageIsoCode?: string | null } | null } | null } | null> } | null };

export type SearchCompaniesTypeQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']>;
}>;


export type SearchCompaniesTypeQuery = { __typename?: 'Query', companyInstances?: { __typename?: 'CompanyModelTypeConnection', edges: Array<{ __typename?: 'CompanyModelTypeEdge', node?: { __typename?: 'CompanyModelType', id: string, livasId?: number | null, status?: string | null, name: string, insightlyId?: number | null, description?: string | null, salesQuestionnaire?: string | null, contractSet: Array<{ __typename?: 'ContractType', id: string, validFromDate?: any | null }>, country?: { __typename?: 'CountryType', id: string, isoCode?: string | null, languageIsoCode?: string | null } | null } | null } | null> } | null };

export type GetCompaniesNamesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCompaniesNamesQuery = { __typename?: 'Query', companies?: { __typename?: 'CompanyTypeConnection', edges: Array<{ __typename?: 'CompanyTypeEdge', node?: { __typename?: 'CompanyType', id: string, name: string } | null } | null> } | null };

export type GetCompanyQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GetCompanyQuery = { __typename?: 'Query', company?: { __typename?: 'CompanyModelType', name: string, status?: string | null, country?: { __typename?: 'CountryType', id: string, isoCode?: string | null } | null } | null };

export type UpdateCompanyManagersDataMutationVariables = Exact<{
  companyIds: Array<InputMaybe<Scalars['ID']>> | InputMaybe<Scalars['ID']>;
  projectManager1?: InputMaybe<Scalars['ID']>;
  projectManager2?: InputMaybe<Scalars['ID']>;
  substituteManager1?: InputMaybe<Scalars['ID']>;
  substituteManager2?: InputMaybe<Scalars['ID']>;
  recruiter1?: InputMaybe<Scalars['ID']>;
  recruiter2?: InputMaybe<Scalars['ID']>;
  substituteRecruiter1?: InputMaybe<Scalars['ID']>;
  substituteRecruiter2?: InputMaybe<Scalars['ID']>;
}>;


export type UpdateCompanyManagersDataMutation = { __typename?: 'Mutation', updateCompanyManagers?: { __typename?: 'UpdateCompanyManagers', ok?: boolean | null } | null };

export type CovidLabelsQueryVariables = Exact<{ [key: string]: never; }>;


export type CovidLabelsQuery = { __typename?: 'Query', labels?: { __typename?: 'LabelTypeConnection', edges: Array<{ __typename?: 'LabelTypeEdge', node?: { __typename?: 'LabelType', id: string, title: string } | null } | null> } | null };

export type SaveCompanyLabelsMutationVariables = Exact<{
  companyId: Scalars['ID'];
  labels: Array<InputMaybe<Scalars['ID']>> | InputMaybe<Scalars['ID']>;
}>;


export type SaveCompanyLabelsMutation = { __typename?: 'Mutation', updateCompanyModel?: { __typename?: 'UpdateCompanyModelPayload', company?: { __typename?: 'CompanyType', id: string } | null } | null };

export type UpdateCompanyTagsInExternalSysMutationVariables = Exact<{
  companyId: Scalars['ID'];
  dateFrom?: InputMaybe<Scalars['Date']>;
  updateLivas?: InputMaybe<Scalars['Boolean']>;
  updateWorkis?: InputMaybe<Scalars['Boolean']>;
}>;


export type UpdateCompanyTagsInExternalSysMutation = { __typename?: 'Mutation', syncCompanyLabels?: { __typename?: 'SyncCompanyLabelsMutation', ok?: boolean | null } | null };

export type AllContactsQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']>;
  after?: InputMaybe<Scalars['String']>;
  search?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
  company?: InputMaybe<Scalars['ID']>;
  canUseInOrder?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['ID']>;
}>;


export type AllContactsQuery = { __typename?: 'Query', contacts?: { __typename?: 'ContactTypeConnection', totalCount?: number | null, pageInfo: { __typename?: 'PageInfo', startCursor?: string | null, endCursor?: string | null, hasNextPage: boolean }, edges: Array<{ __typename?: 'ContactTypeEdge', node?: { __typename?: 'ContactType', id: string, firstName: string, lastName?: string | null, phone?: string | null, email?: string | null, insightlyId?: number | null, comment?: string | null, canUseInOrder: boolean, company: { __typename?: 'CompanyType', id: string, name: string } } | null } | null> } | null };

export type CountryFieldsFragment = { __typename?: 'CountryType', id: string, isoCode?: string | null, languageIsoCode?: string | null };

export type GetCountriesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCountriesQuery = { __typename?: 'Query', countries?: { __typename?: 'CountryTypeConnection', totalCount?: number | null, edges: Array<{ __typename?: 'CountryTypeEdge', node?: { __typename?: 'CountryType', id: string, isoCode?: string | null, languageIsoCode?: string | null } | null } | null> } | null };

export type CreateCustomLinkMutationVariables = Exact<{
  input: CreateCustomLinkInput;
}>;


export type CreateCustomLinkMutation = { __typename?: 'Mutation', createCustomLink?: { __typename?: 'CreateCustomLinkPayload', customLink?: { __typename?: 'CustomLinkType', id: string, title: string, url: string, createdAt: any, dashboard: { __typename?: 'DashboardType', id: string, title: string }, createdBy?: { __typename?: 'UserProfileMType', id: string, fullName: string } | null } | null } | null };

export type EscalateMetricValueToDashboardsMutationMutationVariables = Exact<{
  metricValueId: Scalars['ID'];
  escalatedToIds: Array<Scalars['ID']> | Scalars['ID'];
  escalatedFromId?: InputMaybe<Scalars['ID']>;
}>;


export type EscalateMetricValueToDashboardsMutationMutation = { __typename?: 'Mutation', escalateMetricValueToDashboards?: { __typename?: 'EscalateMetricValueToDashboards', errors?: Array<string | null> | null, metricValue?: { __typename?: 'MetricValueType', id: string, value: number, escalatedAt?: any | null, escalatedTo?: { __typename?: 'DashboardType', id: string, title: string, meetingLevel?: DashboardMeetingLevel | null } | null, escalatedFrom?: { __typename?: 'DashboardType', id: string, title: string } | null, escalatedBy?: { __typename?: 'UserProfileMType', id: string, fullName: string } | null, escalations: { __typename?: 'MetricValueEscalationTypeConnection', edges: Array<{ __typename?: 'MetricValueEscalationTypeEdge', node?: { __typename?: 'MetricValueEscalationType', id: string, createdAt: any, escalatedTo: { __typename?: 'DashboardType', id: string, title: string, meetingLevel?: DashboardMeetingLevel | null }, escalatedFrom?: { __typename?: 'DashboardType', id: string, title: string } | null, createdBy?: { __typename?: 'UserProfileMType', id: string, fullName: string } | null, metricValue: { __typename?: 'MetricValueType', id: string } } | null } | null> } } | null } | null };

export type UnEscalateMetricValueFromDashboardsMutationVariables = Exact<{
  escalationId: Scalars['ID'];
}>;


export type UnEscalateMetricValueFromDashboardsMutation = { __typename?: 'Mutation', unEscalateMetricValueFromDashboards?: { __typename?: 'UnEscalateMetricValueFromDashboards', ok?: boolean | null, errors?: Array<string | null> | null, metricValue?: { __typename?: 'MetricValueType', id: string } | null } | null };

export type UpdateMetricValueCommentMutationMutationVariables = Exact<{
  id: Scalars['ID'];
  comment?: InputMaybe<Scalars['String']>;
  reasonId?: InputMaybe<Scalars['ID']>;
}>;


export type UpdateMetricValueCommentMutationMutation = { __typename?: 'Mutation', updateMetricValueComment?: { __typename?: 'UpdateMetricValueCommentPayload', metricValueComment?: { __typename?: 'MetricValueCommentType', id: string, comment: string, metricClientReason?: { __typename?: 'MetricValueClientReasonType', id: string, title: string } | null } | null } | null };

export type SetMetricValueNextTaskMutationMutationVariables = Exact<{
  id: Scalars['ID'];
  taskId: Scalars['ID'];
}>;


export type SetMetricValueNextTaskMutationMutation = { __typename?: 'Mutation', updateMetricValue?: { __typename?: 'UpdateMetricValuePayload', metricValue?: { __typename?: 'MetricValueType', id: string, value: number, nextTask?: { __typename?: 'TaskType', id: string, date: any, status: TaskStatus, comment?: string | null, durationMinutes?: number | null, customFieldValues: { __typename?: 'CustomFieldValueTypeConnection', edges: Array<{ __typename?: 'CustomFieldValueTypeEdge', node?: { __typename?: 'CustomFieldValueType', id: string, boolValue?: boolean | null, numericValue?: number | null, textValue?: string | null, dateValue?: any | null, urlValue?: string | null, customField: { __typename?: 'CustomFieldType', id: string, name: string, fieldType: { __typename?: 'CustomFieldDefinitionType', id: string, name: string, fieldType: CustomFieldDefinitionFieldType } } } | null } | null> }, completedBy?: Array<{ __typename?: 'UserProfileMType', id: string, fullName: string, color?: string | null, user: { __typename?: 'UserType', id: string, firstName: string, lastName: string } } | null> | null, nextActionCategory?: { __typename?: 'ActionCategoryType', id: string, title?: string | null } | null } | null } | null } | null };

export type SetMetricValueNextTaskL2MutationMutationVariables = Exact<{
  id: Scalars['ID'];
  taskId: Scalars['ID'];
}>;


export type SetMetricValueNextTaskL2MutationMutation = { __typename?: 'Mutation', updateMetricValue?: { __typename?: 'UpdateMetricValuePayload', metricValue?: { __typename?: 'MetricValueType', id: string, value: number, nextTaskLevel2?: { __typename?: 'TaskType', id: string, date: any, status: TaskStatus, comment?: string | null, durationMinutes?: number | null, completedBy?: Array<{ __typename?: 'UserProfileMType', id: string, fullName: string, color?: string | null, user: { __typename?: 'UserType', id: string, firstName: string, lastName: string } } | null> | null, nextActionCategory?: { __typename?: 'ActionCategoryType', id: string, title?: string | null } | null } | null } | null } | null };

export type UpdateMetricValueImportanceMutationMutationVariables = Exact<{
  id: Scalars['ID'];
  isImportant: Scalars['Boolean'];
}>;


export type UpdateMetricValueImportanceMutationMutation = { __typename?: 'Mutation', updateMetricValue?: { __typename?: 'UpdateMetricValuePayload', metricValue?: { __typename?: 'MetricValueType', id: string, isImportant: boolean } | null } | null };

export type EscalateMetricValueMutationMutationVariables = Exact<{
  input: UpdateMetricValueInput;
}>;


export type EscalateMetricValueMutationMutation = { __typename?: 'Mutation', updateMetricValue?: { __typename?: 'UpdateMetricValuePayload', metricValue?: { __typename?: 'MetricValueType', id: string, escalatedAt?: any | null, escalatedTo?: { __typename?: 'DashboardType', id: string, title: string } | null, escalatedBy?: { __typename?: 'UserProfileMType', id: string, fullName: string } | null, escalatedFrom?: { __typename?: 'DashboardType', id: string, title: string } | null, escalations: { __typename?: 'MetricValueEscalationTypeConnection', edges: Array<{ __typename?: 'MetricValueEscalationTypeEdge', node?: { __typename?: 'MetricValueEscalationType', id: string, createdAt: any, escalatedTo: { __typename?: 'DashboardType', id: string, title: string, meetingLevel?: DashboardMeetingLevel | null }, escalatedFrom?: { __typename?: 'DashboardType', id: string, title: string } | null, createdBy?: { __typename?: 'UserProfileMType', id: string, fullName: string } | null, metricValue: { __typename?: 'MetricValueType', id: string } } | null } | null> } } | null, errors?: Array<{ __typename?: 'MutationErrorType', field?: string | null, message?: string | null }> | null } | null };

export type UpdateDashboardCardMutationVariables = Exact<{
  input: UpdateDashboardCardInput;
}>;


export type UpdateDashboardCardMutation = { __typename?: 'Mutation', updateDashboardCard?: { __typename?: 'UpdateDashboardCardPayload', dashboardCard?: { __typename?: 'DashboardCardType', id: string, barchartGoal?: number | null } | null } | null };

export type AggregatedMetricsQueryVariables = Exact<{
  regionGroupId: Scalars['ID'];
  dateFrom: Scalars['Date'];
  dateTo: Scalars['Date'];
  metricGroupIds: Array<Scalars['ID']> | Scalars['ID'];
}>;


export type AggregatedMetricsQuery = { __typename?: 'Query', aggregatedMetrics?: Array<{ __typename?: 'AggregatedMetricValueType', id: string, date: any, isImportant: boolean, escalatedAt?: any | null, value: number, subvalue?: number | null, goal?: number | null, workis?: boolean | null, nextTaskId?: number | null, nextTaskLevel2Id?: number | null, manager?: { __typename?: 'UserProfileMType', id: string, fullName: string } | null, client?: { __typename?: 'CompanyType', id: string, name: string, livasId?: number | null, country?: { __typename?: 'CountryType', id: string, isoCode?: string | null } | null } | null, candidate?: { __typename?: 'CandidateType', id: string, livasId: number, employeeLivasId?: number | null, firstName: string, lastName: string, country: { __typename?: 'CountryType', id: string, isoCode?: string | null } } | null, order?: { __typename?: 'OrderType', id: string, priority?: OrderPriority | null, company?: { __typename?: 'CompanyType', id: string, name: string } | null, specification?: { __typename?: 'SpecificationType', id: string, positionTitle: string } | null } | null, escalatedTo?: { __typename?: 'DashboardType', id: string, title: string } | null, escalatedBy?: { __typename?: 'UserProfileMType', id: string, fullName: string } | null, escalatedFrom?: { __typename?: 'DashboardType', id: string, title: string } | null, metricvaluecommentSet?: Array<{ __typename?: 'MetricValueCommentType', id: string, comment: string, metricClientReason?: { __typename?: 'MetricValueClientReasonType', id: string, title: string } | null, clients: { __typename?: 'CompanyTypeConnection', edges: Array<{ __typename?: 'CompanyTypeEdge', node?: { __typename?: 'CompanyType', id: string, name: string, livasId?: number | null, country?: { __typename?: 'CountryType', id: string, isoCode?: string | null } | null } | null } | null> }, candidates: { __typename?: 'CandidateTypeConnection', edges: Array<{ __typename?: 'CandidateTypeEdge', node?: { __typename?: 'CandidateType', id: string, livasId: number, employeeLivasId?: number | null, firstName: string, lastName: string, country: { __typename?: 'CountryType', id: string, isoCode?: string | null } } | null } | null> } } | null> | null, metricGroup?: { __typename?: 'MetricGroupType', id: string, subvalueExplanation?: string | null, taskCategory?: { __typename?: 'SACategoryType', id: string, title: string, hint?: string | null, durationMinutes?: number | null, showDuration: boolean, showOrder: boolean, showCompany: boolean, showDescription: boolean, showCandidate: boolean, customFields: { __typename?: 'CustomFieldTypeConnection', edges: Array<{ __typename?: 'CustomFieldTypeEdge', node?: { __typename?: 'CustomFieldType', id: string, name: string, hintText?: string | null, options?: any | null, fieldType: { __typename?: 'CustomFieldDefinitionType', id: string, name: string, fieldType: CustomFieldDefinitionFieldType } } | null } | null> } } | null, nextActions: { __typename?: 'ActionCategoryTypeConnection', edges: Array<{ __typename?: 'ActionCategoryTypeEdge', node?: { __typename?: 'ActionCategoryType', id: string, title?: string | null, createCompletedTask: boolean, taskCategory?: { __typename?: 'SACategoryType', id: string, title: string, hint?: string | null, durationMinutes?: number | null, showDuration: boolean, showOrder: boolean, showCompany: boolean, showDescription: boolean, showCandidate: boolean, customFields: { __typename?: 'CustomFieldTypeConnection', edges: Array<{ __typename?: 'CustomFieldTypeEdge', node?: { __typename?: 'CustomFieldType', id: string, name: string, hintText?: string | null, options?: any | null, fieldType: { __typename?: 'CustomFieldDefinitionType', id: string, name: string, fieldType: CustomFieldDefinitionFieldType } } | null } | null> } } | null } | null } | null> } } | null } | null> | null };

export type GetDashboardsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetDashboardsQuery = { __typename?: 'Query', allDashboards?: { __typename?: 'DashboardTypeConnection', edges: Array<{ __typename?: 'DashboardTypeEdge', node?: { __typename?: 'DashboardType', id: string, title: string, meetingLevel?: DashboardMeetingLevel | null, regionGroup?: { __typename?: 'RegionGroupType', id: string } | null, escalateTo?: { __typename?: 'DashboardType', id: string, title: string } | null, escalateToDashboards?: Array<{ __typename?: 'DashboardType', id: string, title: string, meetingLevel?: DashboardMeetingLevel | null } | null> | null, dashboardcardSet: { __typename?: 'DashboardCardTypeConnection', edges: Array<{ __typename?: 'DashboardCardTypeEdge', node?: { __typename?: 'DashboardCardType', id: string, barchartGoal?: number | null, card: { __typename?: 'DailyDashboardCardType', id: string, title: string, description: string, type: CardType, filterTaskCategoriesKeys?: string | null, excludeTaskCategoriesKeys?: string | null, excludeTaskStatuses?: string | null, displayColumns?: any | null, lookForwardDays?: number | null, includeFromChildDashboards: boolean, allDashboards: boolean, additionalFilters?: any | null }, metricGroupForOtherProblem?: { __typename?: 'MetricGroupType', id: string } | null } | null } | null> }, metricsUserprofiles: { __typename?: 'UserProfileMTypeConnection', edges: Array<{ __typename?: 'UserProfileMTypeEdge', node?: { __typename?: 'UserProfileMType', id: string, fullName: string, color?: string | null } | null } | null> }, customLinks?: Array<{ __typename?: 'CustomLinkType', title: string, url: string } | null> | null } | null } | null> } | null };

export type GetDashboardsListQueryVariables = Exact<{ [key: string]: never; }>;


export type GetDashboardsListQuery = { __typename?: 'Query', allDashboards?: { __typename?: 'DashboardTypeConnection', edges: Array<{ __typename?: 'DashboardTypeEdge', node?: { __typename?: 'DashboardType', id: string, title: string } | null } | null> } | null };

export type MetricGroupReasonsQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type MetricGroupReasonsQuery = { __typename?: 'Query', metricGroups?: { __typename?: 'MetricGroupTypeConnection', edges: Array<{ __typename?: 'MetricGroupTypeEdge', node?: { __typename?: 'MetricGroupType', metricclientreasonSet: { __typename?: 'MetricValueClientReasonTypeConnection', edges: Array<{ __typename?: 'MetricValueClientReasonTypeEdge', node?: { __typename?: 'MetricValueClientReasonType', id: string, title: string } | null } | null> } } | null } | null> } | null };

export type GetMetricTableCardContentQueryVariables = Exact<{
  id: Scalars['ID'];
  dashboardId?: InputMaybe<Scalars['ID']>;
  dateFrom?: InputMaybe<Scalars['Date']>;
  dateTo?: InputMaybe<Scalars['Date']>;
}>;


export type GetMetricTableCardContentQuery = { __typename?: 'Query', metricGroupsAssignment?: { __typename?: 'MetricGroupAssignmentTypeConnection', edges: Array<{ __typename?: 'MetricGroupAssignmentTypeEdge', node?: { __typename?: 'MetricGroupAssignmentType', id: string, metricGroup: { __typename?: 'MetricGroupType', id: string, title: string, description: string, highlightWhen?: MetricGroupHighlightWhen | null, metricvalueSet: { __typename?: 'MetricValueTypeConnection', edges: Array<{ __typename?: 'MetricValueTypeEdge', node?: { __typename?: 'MetricValueType', id: string, key?: string | null, date: any, isImportant: boolean, channel?: MetricValueChannel | null, escalatedAt?: any | null, value: number, goal?: number | null, workis?: boolean | null, nextTaskId?: number | null, nextTaskLevel2Id?: number | null, regionGroup?: { __typename?: 'RegionGroupType', title: string } | null, manager?: { __typename?: 'UserProfileMType', id: string, fullName: string } | null, client?: { __typename?: 'CompanyType', id: string, name: string, livasId?: number | null, country?: { __typename?: 'CountryType', id: string, isoCode?: string | null } | null } | null, candidate?: { __typename?: 'CandidateType', id: string, livasId: number, employeeLivasId?: number | null, firstName: string, lastName: string, country: { __typename?: 'CountryType', id: string, isoCode?: string | null } } | null, order?: { __typename?: 'OrderType', id: string, company?: { __typename?: 'CompanyType', id: string, name: string } | null, specification?: { __typename?: 'SpecificationType', id: string, positionTitle: string } | null } | null, escalatedTo?: { __typename?: 'DashboardType', id: string, title: string, meetingLevel?: DashboardMeetingLevel | null } | null, escalatedBy?: { __typename?: 'UserProfileMType', id: string, fullName: string } | null, escalatedFrom?: { __typename?: 'DashboardType', id: string, title: string } | null, escalations: { __typename?: 'MetricValueEscalationTypeConnection', edges: Array<{ __typename?: 'MetricValueEscalationTypeEdge', node?: { __typename?: 'MetricValueEscalationType', id: string, createdAt: any, escalatedTo: { __typename?: 'DashboardType', id: string, title: string, meetingLevel?: DashboardMeetingLevel | null }, escalatedFrom?: { __typename?: 'DashboardType', id: string, title: string } | null, createdBy?: { __typename?: 'UserProfileMType', id: string, fullName: string } | null } | null } | null> }, metricvaluecommentSet: { __typename?: 'MetricValueCommentTypeConnection', edges: Array<{ __typename?: 'MetricValueCommentTypeEdge', node?: { __typename?: 'MetricValueCommentType', id: string, comment: string } | null } | null> } } | null } | null> }, taskCategory?: { __typename?: 'SACategoryType', id: string, title: string, hint?: string | null, durationMinutes?: number | null, showDuration: boolean, showOrder: boolean, showCompany: boolean, showDescription: boolean, showCandidate: boolean, customFields: { __typename?: 'CustomFieldTypeConnection', edges: Array<{ __typename?: 'CustomFieldTypeEdge', node?: { __typename?: 'CustomFieldType', id: string, name: string, hintText?: string | null, options?: any | null, fieldType: { __typename?: 'CustomFieldDefinitionType', id: string, name: string, fieldType: CustomFieldDefinitionFieldType } } | null } | null> } } | null, nextActions: { __typename?: 'ActionCategoryTypeConnection', edges: Array<{ __typename?: 'ActionCategoryTypeEdge', node?: { __typename?: 'ActionCategoryType', id: string, title?: string | null, createCompletedTask: boolean, taskCategory?: { __typename?: 'SACategoryType', id: string, title: string, hint?: string | null, durationMinutes?: number | null, showDuration: boolean, showOrder: boolean, showCompany: boolean, showDescription: boolean, showCandidate: boolean, customFields: { __typename?: 'CustomFieldTypeConnection', edges: Array<{ __typename?: 'CustomFieldTypeEdge', node?: { __typename?: 'CustomFieldType', id: string, name: string, hintText?: string | null, options?: any | null, fieldType: { __typename?: 'CustomFieldDefinitionType', id: string, name: string, fieldType: CustomFieldDefinitionFieldType } } | null } | null> } } | null } | null } | null> } } } | null } | null> } | null };

export type GetResourcesLvl2QueryVariables = Exact<{
  id: Scalars['ID'];
  dashboardId: Scalars['ID'];
  dateFrom?: InputMaybe<Scalars['Date']>;
  dateTo?: InputMaybe<Scalars['Date']>;
}>;


export type GetResourcesLvl2Query = { __typename?: 'Query', metricGroupsAssignment?: { __typename?: 'MetricGroupAssignmentTypeConnection', edges: Array<{ __typename?: 'MetricGroupAssignmentTypeEdge', node?: { __typename?: 'MetricGroupAssignmentType', id: string, metricGroup: { __typename?: 'MetricGroupType', id: string, title: string, description: string, highlightWhen?: MetricGroupHighlightWhen | null, metricvalueSet: { __typename?: 'MetricValueTypeConnection', edges: Array<{ __typename?: 'MetricValueTypeEdge', node?: { __typename?: 'MetricValueType', value: number, date: any, regionGroup?: { __typename?: 'RegionGroupType', id: string, title: string } | null } | null } | null> } } } | null } | null> } | null };

export type GetConversionsQueryVariables = Exact<{
  id: Scalars['ID'];
  dateFrom?: InputMaybe<Scalars['Date']>;
  dateTo?: InputMaybe<Scalars['Date']>;
  dashboardRegion?: InputMaybe<Scalars['ID']>;
}>;


export type GetConversionsQuery = { __typename?: 'Query', metricGroupsAssignment?: { __typename?: 'MetricGroupAssignmentTypeConnection', edges: Array<{ __typename?: 'MetricGroupAssignmentTypeEdge', node?: { __typename?: 'MetricGroupAssignmentType', id: string, metricGroup: { __typename?: 'MetricGroupType', id: string, title: string, metricvalueSet: { __typename?: 'MetricValueTypeConnection', edges: Array<{ __typename?: 'MetricValueTypeEdge', node?: { __typename?: 'MetricValueType', id: string, value: number, key?: string | null, regionGroup?: { __typename?: 'RegionGroupType', id: string, title: string } | null, order?: { __typename?: 'OrderType', id: string, specification?: { __typename?: 'SpecificationType', positionTitle: string, id: string } | null } | null } | null } | null> } } } | null } | null> } | null };

export type GetMetricValuesEscalatedQueryVariables = Exact<{
  escalatedTo?: InputMaybe<Scalars['ID']>;
  dateFrom?: InputMaybe<Scalars['Date']>;
  dateTo?: InputMaybe<Scalars['Date']>;
}>;


export type GetMetricValuesEscalatedQuery = { __typename?: 'Query', metricValues?: { __typename?: 'MetricValueTypeConnection', edges: Array<{ __typename?: 'MetricValueTypeEdge', node?: { __typename?: 'MetricValueType', id: string, date: any, isImportant: boolean, channel?: MetricValueChannel | null, escalatedAt?: any | null, value: number, goal?: number | null, workis?: boolean | null, nextTaskId?: number | null, nextTaskLevel2Id?: number | null, escalatedTo?: { __typename?: 'DashboardType', id: string, title: string, meetingLevel?: DashboardMeetingLevel | null } | null, escalatedBy?: { __typename?: 'UserProfileMType', id: string, fullName: string } | null, escalatedFrom?: { __typename?: 'DashboardType', id: string, title: string } | null, escalations: { __typename?: 'MetricValueEscalationTypeConnection', edges: Array<{ __typename?: 'MetricValueEscalationTypeEdge', node?: { __typename?: 'MetricValueEscalationType', id: string, createdAt: any, escalatedTo: { __typename?: 'DashboardType', id: string, title: string, meetingLevel?: DashboardMeetingLevel | null }, escalatedFrom?: { __typename?: 'DashboardType', id: string, title: string } | null, createdBy?: { __typename?: 'UserProfileMType', id: string, fullName: string } | null } | null } | null> }, manager?: { __typename?: 'UserProfileMType', id: string, fullName: string } | null, client?: { __typename?: 'CompanyType', id: string, name: string, livasId?: number | null } | null, candidate?: { __typename?: 'CandidateType', id: string, livasId: number, employeeLivasId?: number | null, firstName: string, lastName: string } | null, order?: { __typename?: 'OrderType', id: string, company?: { __typename?: 'CompanyType', id: string, name: string } | null, specification?: { __typename?: 'SpecificationType', id: string, positionTitle: string } | null } | null, metricvaluecommentSet: { __typename?: 'MetricValueCommentTypeConnection', edges: Array<{ __typename?: 'MetricValueCommentTypeEdge', node?: { __typename?: 'MetricValueCommentType', id: string } | null } | null> }, metricGroup?: { __typename?: 'MetricGroupType', id: string, title: string, description: string, highlightWhen?: MetricGroupHighlightWhen | null, taskCategory?: { __typename?: 'SACategoryType', id: string, title: string, hint?: string | null, durationMinutes?: number | null, showDuration: boolean, showOrder: boolean, showCompany: boolean, showDescription: boolean, showCandidate: boolean, customFields: { __typename?: 'CustomFieldTypeConnection', edges: Array<{ __typename?: 'CustomFieldTypeEdge', node?: { __typename?: 'CustomFieldType', id: string, name: string, hintText?: string | null, options?: any | null, fieldType: { __typename?: 'CustomFieldDefinitionType', id: string, name: string, fieldType: CustomFieldDefinitionFieldType } } | null } | null> } } | null, nextActions: { __typename?: 'ActionCategoryTypeConnection', edges: Array<{ __typename?: 'ActionCategoryTypeEdge', node?: { __typename?: 'ActionCategoryType', id: string, title?: string | null, createCompletedTask: boolean, taskCategory?: { __typename?: 'SACategoryType', id: string, title: string, hint?: string | null, durationMinutes?: number | null, showDuration: boolean, showOrder: boolean, showCompany: boolean, showDescription: boolean, showCandidate: boolean, customFields: { __typename?: 'CustomFieldTypeConnection', edges: Array<{ __typename?: 'CustomFieldTypeEdge', node?: { __typename?: 'CustomFieldType', id: string, name: string, hintText?: string | null, options?: any | null, fieldType: { __typename?: 'CustomFieldDefinitionType', id: string, name: string, fieldType: CustomFieldDefinitionFieldType } } | null } | null> } } | null } | null } | null> } } | null } | null } | null> } | null };

export type GetMetricNextTaskQueryVariables = Exact<{
  ids?: InputMaybe<Array<InputMaybe<Scalars['ID']>> | InputMaybe<Scalars['ID']>>;
}>;


export type GetMetricNextTaskQuery = { __typename?: 'Query', tasks?: { __typename?: 'TaskTypeConnection', edges: Array<{ __typename?: 'TaskTypeEdge', node?: { __typename?: 'TaskType', id: string, date: any, status: TaskStatus, comment?: string | null, durationMinutes?: number | null, customFieldValues: { __typename?: 'CustomFieldValueTypeConnection', edges: Array<{ __typename?: 'CustomFieldValueTypeEdge', node?: { __typename?: 'CustomFieldValueType', id: string, boolValue?: boolean | null, numericValue?: number | null, textValue?: string | null, dateValue?: any | null, urlValue?: string | null, customField: { __typename?: 'CustomFieldType', id: string, name: string, fieldType: { __typename?: 'CustomFieldDefinitionType', id: string, name: string, fieldType: CustomFieldDefinitionFieldType } } } | null } | null> }, completedBy?: Array<{ __typename?: 'UserProfileMType', id: string, fullName: string, color?: string | null, user: { __typename?: 'UserType', id: string, firstName: string, lastName: string } } | null> | null, nextActionCategory?: { __typename?: 'ActionCategoryType', id: string, title?: string | null } | null } | null } | null> } | null };

export type GetMetricCommentsQueryVariables = Exact<{
  ids?: InputMaybe<Array<InputMaybe<Scalars['ID']>> | InputMaybe<Scalars['ID']>>;
}>;


export type GetMetricCommentsQuery = { __typename?: 'Query', metricValueComments?: { __typename?: 'MetricValueCommentTypeConnection', edges: Array<{ __typename?: 'MetricValueCommentTypeEdge', node?: { __typename?: 'MetricValueCommentType', id: string, comment: string, metricClientReason?: { __typename?: 'MetricValueClientReasonType', id: string, title: string } | null, clients: { __typename?: 'CompanyTypeConnection', edges: Array<{ __typename?: 'CompanyTypeEdge', node?: { __typename?: 'CompanyType', id: string, name: string, livasId?: number | null, country?: { __typename?: 'CountryType', id: string, isoCode?: string | null } | null } | null } | null> }, candidates: { __typename?: 'CandidateTypeConnection', edges: Array<{ __typename?: 'CandidateTypeEdge', node?: { __typename?: 'CandidateType', id: string, livasId: number, employeeLivasId?: number | null, firstName: string, lastName: string, country: { __typename?: 'CountryType', id: string, isoCode?: string | null } } | null } | null> } } | null } | null> } | null };

export type GetMetricTableCardNextTaskUpdateQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GetMetricTableCardNextTaskUpdateQuery = { __typename?: 'Query', tasks?: { __typename?: 'TaskTypeConnection', edges: Array<{ __typename?: 'TaskTypeEdge', node?: { __typename?: 'TaskType', id: string, date: any, status: TaskStatus, comment?: string | null, durationMinutes?: number | null, nextActionCategory?: { __typename?: 'ActionCategoryType', id: string, title?: string | null } | null, completedBy?: Array<{ __typename?: 'UserProfileMType', id: string, fullName: string, color?: string | null, user: { __typename?: 'UserType', id: string, firstName: string, lastName: string } } | null> | null } | null } | null> } | null };

export type StandUpDashboardTaskFieldsFragment = { __typename?: 'TaskType', id: string, date: any, status: TaskStatus, comment?: string | null, durationMinutes?: number | null, completedBy?: Array<{ __typename?: 'UserProfileMType', id: string, fullName: string, color?: string | null, user: { __typename?: 'UserType', id: string, firstName: string, lastName: string } } | null> | null, nextActionCategory?: { __typename?: 'ActionCategoryType', id: string, title?: string | null } | null };

export type GetWeeklyBarchartCardContentQueryVariables = Exact<{
  id: Scalars['ID'];
  dashboardId: Scalars['ID'];
  dateFrom?: InputMaybe<Scalars['Date']>;
  dateTo?: InputMaybe<Scalars['Date']>;
}>;


export type GetWeeklyBarchartCardContentQuery = { __typename?: 'Query', metricGroupsAssignment?: { __typename?: 'MetricGroupAssignmentTypeConnection', edges: Array<{ __typename?: 'MetricGroupAssignmentTypeEdge', node?: { __typename?: 'MetricGroupAssignmentType', id: string, metricGroup: { __typename?: 'MetricGroupType', id: string, title: string, description: string, metricvalueSet: { __typename?: 'MetricValueTypeConnection', edges: Array<{ __typename?: 'MetricValueTypeEdge', node?: { __typename?: 'MetricValueType', id: string, date: any, value: number } | null } | null> } } } | null } | null> } | null };

export type GetMetricGroupsByDashboardCardQueryVariables = Exact<{
  cardId: Scalars['ID'];
}>;


export type GetMetricGroupsByDashboardCardQuery = { __typename?: 'Query', metricGroupsAssignment?: { __typename?: 'MetricGroupAssignmentTypeConnection', edges: Array<{ __typename?: 'MetricGroupAssignmentTypeEdge', node?: { __typename?: 'MetricGroupAssignmentType', id: string, metricGroup: { __typename?: 'MetricGroupType', id: string } } | null } | null> } | null };

export type GetConversionRatesQueryVariables = Exact<{
  cardId: Scalars['ID'];
  dashboardId: Scalars['ID'];
  date: Scalars['Date'];
}>;


export type GetConversionRatesQuery = { __typename?: 'Query', conversionRatesTransregional?: Array<{ __typename?: 'ConversionRatesTransregionalType', regionGroupId?: string | null, conversionType?: string | null, regionAverage?: number | null, ordersBelowAverageCount?: number | null, regionGroup?: { __typename?: 'RegionGroupType', id: string, title: string } | null } | null> | null };

export type GetPromisesTasksQueryVariables = Exact<{
  categoriesKeys?: InputMaybe<Scalars['String']>;
  owners?: InputMaybe<Array<InputMaybe<Scalars['ID']>> | InputMaybe<Scalars['ID']>>;
  date_Gte?: InputMaybe<Scalars['Date']>;
  excludeStatuses?: InputMaybe<Scalars['String']>;
}>;


export type GetPromisesTasksQuery = { __typename?: 'Query', tasks?: { __typename?: 'TaskTypeConnection', edges: Array<{ __typename?: 'TaskTypeEdge', node?: { __typename?: 'TaskType', id: string, isImportant: boolean, status: TaskStatus, comment?: string | null, date: any, taskEscalations: { __typename?: 'TaskEscalationTypeConnection', edges: Array<{ __typename?: 'TaskEscalationTypeEdge', node?: { __typename?: 'TaskEscalationType', id: string, escalatedTo: { __typename?: 'DashboardType', id: string, meetingLevel?: DashboardMeetingLevel | null }, escalatedFrom?: { __typename?: 'DashboardType', id: string, meetingLevel?: DashboardMeetingLevel | null } | null, task: { __typename?: 'TaskType', id: string } } | null } | null> }, category?: { __typename?: 'SACategoryType', id: string, key?: string | null } | null, order?: { __typename?: 'OrderType', id: string, company?: { __typename?: 'CompanyType', id: string, name: string } | null, specification?: { __typename?: 'SpecificationType', id: string, positionTitle: string } | null } | null, company?: { __typename?: 'CompanyType', id: string, name: string } | null } | null } | null> } | null };

export type GetOrderCandidateStatsQueryVariables = Exact<{
  orderIds?: InputMaybe<Array<InputMaybe<Scalars['ID']>> | InputMaybe<Scalars['ID']>>;
  dateFrom?: InputMaybe<Scalars['Date']>;
  companyIds?: InputMaybe<Array<InputMaybe<Scalars['ID']>> | InputMaybe<Scalars['ID']>>;
}>;


export type GetOrderCandidateStatsQuery = { __typename?: 'Query', candidateOrderStats?: Array<{ __typename?: 'CandidateOrderStatsType', orderId?: string | null, companyId?: string | null, toBeInterviewed?: number | null, toBeInterviewedClient?: number | null, healthCheckPending?: number | null, toBeEmployed?: number | null, offeredLast7Days?: number | null, offeredFromDate?: number | null, presentedClient?: number | null, presentedClientSuccess?: number | null, presentedClientFailed?: number | null, longListedLast7Days?: number | null, offeredLast1Day?: number | null, longListedLast1Day?: number | null } | null> | null };

export type GetUsersForCurrentAndChildDashboardsQueryVariables = Exact<{
  parentDashboardId?: InputMaybe<Scalars['ID']>;
}>;


export type GetUsersForCurrentAndChildDashboardsQuery = { __typename?: 'Query', userprofiles?: Array<{ __typename?: 'UserProfileMType', id: string } | null> | null };

export type EscalateTaskToDashboardsMutationVariables = Exact<{
  escalatedFrom?: InputMaybe<Scalars['ID']>;
  escalatedTo: Array<InputMaybe<Scalars['ID']>> | InputMaybe<Scalars['ID']>;
  taskId: Scalars['ID'];
}>;


export type EscalateTaskToDashboardsMutation = { __typename?: 'Mutation', escalateTaskToDashboards?: { __typename?: 'EscalateTaskToDashboards', task?: { __typename?: 'TaskType', id: string, taskEscalations: { __typename?: 'TaskEscalationTypeConnection', edges: Array<{ __typename?: 'TaskEscalationTypeEdge', node?: { __typename?: 'TaskEscalationType', id: string, escalatedTo: { __typename?: 'DashboardType', id: string, meetingLevel?: DashboardMeetingLevel | null }, escalatedFrom?: { __typename?: 'DashboardType', id: string, meetingLevel?: DashboardMeetingLevel | null } | null, task: { __typename?: 'TaskType', id: string } } | null } | null> } } | null } | null };

export type UnEscalateTaskToDashboardsMutationVariables = Exact<{
  escalation: Scalars['ID'];
}>;


export type UnEscalateTaskToDashboardsMutation = { __typename?: 'Mutation', unEscalateTaskFromDashboards?: { __typename?: 'UnEscalateTaskFromDashboards', ok?: boolean | null, task?: { __typename?: 'TaskType', id: string, taskEscalations: { __typename?: 'TaskEscalationTypeConnection', edges: Array<{ __typename?: 'TaskEscalationTypeEdge', node?: { __typename?: 'TaskEscalationType', id: string, escalatedTo: { __typename?: 'DashboardType', id: string, meetingLevel?: DashboardMeetingLevel | null }, escalatedFrom?: { __typename?: 'DashboardType', id: string, meetingLevel?: DashboardMeetingLevel | null } | null, task: { __typename?: 'TaskType', id: string } } | null } | null> } } | null } | null };

export type FreeVacanciesCalendarEventFieldsFragment = { __typename?: 'EventType', id: string, date?: any | null, status?: TaskStatus | null, adId?: number | null, channels: Array<{ __typename?: 'ChannelType', id: string, title: string, icon?: string | null }>, category?: { __typename?: 'CategoryType', id: string, title: string, icon?: string | null } | null };

export type FreeVacanciesCalendarEventsQueryVariables = Exact<{
  dateFrom?: InputMaybe<Scalars['Date']>;
}>;


export type FreeVacanciesCalendarEventsQuery = { __typename?: 'Query', plannerEvents?: { __typename?: 'EventTypeConnection', edges: Array<{ __typename?: 'EventTypeEdge', node?: { __typename?: 'EventType', externalPlatformId?: string | null, id: string, date?: any | null, status?: TaskStatus | null, adId?: number | null, order?: { __typename?: 'OrderType', id: string, specification?: { __typename?: 'SpecificationType', id: string, positionTitle: string } | null } | null, channels: Array<{ __typename?: 'ChannelType', id: string, title: string, icon?: string | null }>, category?: { __typename?: 'CategoryType', id: string, title: string, icon?: string | null } | null } | null } | null> } | null };

export type UserMainFieldsFragment = { __typename?: 'UserType', id: string, email: string, firstName: string, lastName: string };

export type CompanyMainFieldsFragment = { __typename?: 'CompanyType', id: string, name: string, color: HistoricalCompanyColor, description?: string | null, country?: { __typename?: 'CountryType', id: string, isoCode?: string | null } | null, labels: { __typename?: 'LabelTypeConnection', edges: Array<{ __typename?: 'LabelTypeEdge', node?: { __typename?: 'LabelType', id: string, title: string } | null } | null> } };

export type OrderPeriodFieldsFragment = { __typename?: 'OrderPeriodType', id: string, demand: number, dateTo?: any | null, dateFrom: any, longTerm: boolean };

export type MarketingEventsFieldsFragment = { __typename?: 'EventType', id: string, date?: any | null, status?: TaskStatus | null, adId?: number | null, comment?: string | null, workisJobId?: number | null, externalPlatformId?: string | null, language?: EventLanguage | null, channels: Array<{ __typename?: 'ChannelType', id: string, title: string, icon?: string | null }>, category?: { __typename?: 'CategoryType', id: string, title: string, icon?: string | null } | null };

export type FreeVacanciesSpecificationFieldsFragment = { __typename?: 'SpecificationType', id: string, male: boolean, female: boolean, positionTitle: string, address?: string | null, ageFrom?: number | null, ageTo?: number | null, additionalRecruitementInformation?: string | null, workFunctions?: string | null, isWorkplaceVideoAllowed: boolean, isWorkplaceVisitAllowed: boolean, shiftDuration?: number | null, breakDuration?: number | null, scheduleType?: number | null, scheduleText?: string | null, shiftPattern?: any | null, intensity?: SpecificationIntensity | null, allFunctionsFromFirstDay: boolean, onboardingDuration?: string | null, minExperienceMonths?: number | null, experienceType: SpecificationExperienceType, canEmployUa: boolean, healthcheckType?: SpecificationHealthcheckType | null, tagassignmentSet: Array<{ __typename?: 'TagAssignmentType', id: string, comment: string, tag: { __typename?: 'TagType', id: string, title: string, order: number, key?: string | null, group?: { __typename?: 'TagGroupType', id: string, key: string } | null } }>, mandatoryRequirements: Array<{ __typename?: 'RequirementType', id: string, requirement?: string | null }>, optionalRequirements: Array<{ __typename?: 'RequirementType', id: string, requirement?: string | null }>, scheduleTypes: Array<{ __typename?: 'ScheduleTypeType', id: string, title: string }>, certificates: Array<{ __typename?: 'CertificateType', id: string, title?: string | null }>, riskFactors: Array<{ __typename?: 'RiskFactorType', id: string, title: string }>, salary?: { __typename?: 'SpecificationSalaryType', id: string, hourlyBruttoFrom?: number | null, hourlyBruttoTo?: number | null, hourlyNettoFrom?: number | null, hourlyNettoTo?: number | null, monthlyBruttoFrom?: number | null, monthlyBruttoTo?: number | null, monthlyNettoFrom?: number | null, monthlyNettoTo?: number | null, hourlyBruttoFromFilled: boolean, hourlyBruttoToFilled: boolean, hourlyNettoFromFilled: boolean, hourlyNettoToFilled: boolean, monthlyBruttoFromFilled: boolean, monthlyBruttoToFilled: boolean, monthlyNettoFromFilled: boolean, monthlyNettoToFilled: boolean, useInTemplate: SpecificationSalaryUseInTemplate } | null };

export type FreeVacanciesListFieldsFragment = { __typename?: 'OrderType', id: string, canGetBonuses?: boolean | null, canIncreaseSalary?: boolean | null, orderType: OrderOrderType, toBeReviewed: boolean, hourRateBruttoPermanent?: number | null, salaryInfo?: string | null, orderNumber?: string | null, orderPeriodFrom?: string | null, orderPeriodTo?: string | null, orderCanBeExtended?: boolean | null, isLongTerm?: boolean | null, demand?: number | null, status?: OrderStatus | null, trafficGeneration: OrderTrafficGeneration, nettoFrom?: number | null, nettoTo?: number | null, shortage: number, isCompanyInternational?: boolean | null, isCompanyModern?: boolean | null, isLogoPublicAllowed?: boolean | null, statsFutureInterview?: number | null, clientContact?: { __typename?: 'ContactType', id: string, firstName: string, lastName?: string | null, email?: string | null, phone?: string | null } | null, additionalClientContacts: { __typename?: 'ContactTypeConnection', edges: Array<{ __typename?: 'ContactTypeEdge', node?: { __typename?: 'ContactType', id: string, firstName: string, lastName?: string | null, email?: string | null, phone?: string | null } | null } | null> }, createdBy?: { __typename?: 'UserProfileMType', id: string, user: { __typename?: 'UserType', id: string, email: string, firstName: string, lastName: string } } | null, region?: { __typename?: 'RegionType', id: string, title: string } | null, company?: { __typename?: 'CompanyType', id: string, name: string, color: HistoricalCompanyColor, description?: string | null, country?: { __typename?: 'CountryType', id: string, isoCode?: string | null } | null, labels: { __typename?: 'LabelTypeConnection', edges: Array<{ __typename?: 'LabelTypeEdge', node?: { __typename?: 'LabelType', id: string, title: string } | null } | null> } } | null, orderperiodSet: Array<{ __typename?: 'OrderPeriodType', id: string, demand: number, dateTo?: any | null, dateFrom: any, longTerm: boolean }>, specification?: { __typename?: 'SpecificationType', id: string, male: boolean, female: boolean, positionTitle: string, address?: string | null, ageFrom?: number | null, ageTo?: number | null, additionalRecruitementInformation?: string | null, workFunctions?: string | null, isWorkplaceVideoAllowed: boolean, isWorkplaceVisitAllowed: boolean, shiftDuration?: number | null, breakDuration?: number | null, scheduleType?: number | null, scheduleText?: string | null, shiftPattern?: any | null, intensity?: SpecificationIntensity | null, allFunctionsFromFirstDay: boolean, onboardingDuration?: string | null, minExperienceMonths?: number | null, experienceType: SpecificationExperienceType, canEmployUa: boolean, healthcheckType?: SpecificationHealthcheckType | null, tagassignmentSet: Array<{ __typename?: 'TagAssignmentType', id: string, comment: string, tag: { __typename?: 'TagType', id: string, title: string, order: number, key?: string | null, group?: { __typename?: 'TagGroupType', id: string, key: string } | null } }>, mandatoryRequirements: Array<{ __typename?: 'RequirementType', id: string, requirement?: string | null }>, optionalRequirements: Array<{ __typename?: 'RequirementType', id: string, requirement?: string | null }>, scheduleTypes: Array<{ __typename?: 'ScheduleTypeType', id: string, title: string }>, certificates: Array<{ __typename?: 'CertificateType', id: string, title?: string | null }>, riskFactors: Array<{ __typename?: 'RiskFactorType', id: string, title: string }>, salary?: { __typename?: 'SpecificationSalaryType', id: string, hourlyBruttoFrom?: number | null, hourlyBruttoTo?: number | null, hourlyNettoFrom?: number | null, hourlyNettoTo?: number | null, monthlyBruttoFrom?: number | null, monthlyBruttoTo?: number | null, monthlyNettoFrom?: number | null, monthlyNettoTo?: number | null, hourlyBruttoFromFilled: boolean, hourlyBruttoToFilled: boolean, hourlyNettoFromFilled: boolean, hourlyNettoToFilled: boolean, monthlyBruttoFromFilled: boolean, monthlyBruttoToFilled: boolean, monthlyNettoFromFilled: boolean, monthlyNettoToFilled: boolean, useInTemplate: SpecificationSalaryUseInTemplate } | null } | null, eventSet: { __typename?: 'EventTypeConnection', edges: Array<{ __typename?: 'EventTypeEdge', node?: { __typename?: 'EventType', id: string, date?: any | null, status?: TaskStatus | null, adId?: number | null, comment?: string | null, workisJobId?: number | null, externalPlatformId?: string | null, language?: EventLanguage | null, channels: Array<{ __typename?: 'ChannelType', id: string, title: string, icon?: string | null }>, category?: { __typename?: 'CategoryType', id: string, title: string, icon?: string | null } | null } | null } | null> } };

export type GetFreeVacanciesOrderQueryVariables = Exact<{
  status?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  after?: InputMaybe<Scalars['String']>;
  search?: InputMaybe<Scalars['String']>;
  region?: InputMaybe<Scalars['String']>;
  sex?: InputMaybe<Scalars['String']>;
  trafficGeneration?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  isLongTerm?: InputMaybe<Scalars['Boolean']>;
  nettoFrom?: InputMaybe<Scalars['Float']>;
  nettoTo?: InputMaybe<Scalars['Float']>;
  orderType?: InputMaybe<Scalars['String']>;
  covidPolicy?: InputMaybe<Array<InputMaybe<Scalars['ID']>> | InputMaybe<Scalars['ID']>>;
  scheduleTypes?: InputMaybe<Scalars['String']>;
  canEmployUa?: InputMaybe<Scalars['Boolean']>;
  country?: InputMaybe<Scalars['ID']>;
  date_Lte?: InputMaybe<Scalars['Date']>;
  date_Gte?: InputMaybe<Scalars['Date']>;
}>;


export type GetFreeVacanciesOrderQuery = { __typename?: 'Query', ordersPaginated?: { __typename?: 'OrderTypeConnection', totalCount?: number | null, pageInfo: { __typename?: 'PageInfo', startCursor?: string | null, endCursor?: string | null, hasNextPage: boolean }, edges: Array<{ __typename?: 'OrderTypeEdge', node?: { __typename?: 'OrderType', id: string, canGetBonuses?: boolean | null, canIncreaseSalary?: boolean | null, orderType: OrderOrderType, toBeReviewed: boolean, hourRateBruttoPermanent?: number | null, salaryInfo?: string | null, orderNumber?: string | null, orderPeriodFrom?: string | null, orderPeriodTo?: string | null, orderCanBeExtended?: boolean | null, orderCanBeExtendedComment?: string | null, isLongTerm?: boolean | null, demand?: number | null, status?: OrderStatus | null, trafficGeneration: OrderTrafficGeneration, nettoFrom?: number | null, nettoTo?: number | null, shortage: number, isCompanyInternational?: boolean | null, isCompanyModern?: boolean | null, isLogoPublicAllowed?: boolean | null, statsFutureInterview?: number | null, clientContact?: { __typename?: 'ContactType', id: string, firstName: string, lastName?: string | null, email?: string | null, phone?: string | null } | null, additionalClientContacts: { __typename?: 'ContactTypeConnection', edges: Array<{ __typename?: 'ContactTypeEdge', node?: { __typename?: 'ContactType', id: string, firstName: string, lastName?: string | null, email?: string | null, phone?: string | null } | null } | null> }, createdBy?: { __typename?: 'UserProfileMType', id: string, user: { __typename?: 'UserType', id: string, email: string, firstName: string, lastName: string } } | null, region?: { __typename?: 'RegionType', id: string, title: string } | null, company?: { __typename?: 'CompanyType', id: string, name: string, color: HistoricalCompanyColor, description?: string | null, country?: { __typename?: 'CountryType', id: string, isoCode?: string | null } | null, labels: { __typename?: 'LabelTypeConnection', edges: Array<{ __typename?: 'LabelTypeEdge', node?: { __typename?: 'LabelType', id: string, title: string } | null } | null> } } | null, orderperiodSet: Array<{ __typename?: 'OrderPeriodType', id: string, demand: number, dateTo?: any | null, dateFrom: any, longTerm: boolean }>, specification?: { __typename?: 'SpecificationType', id: string, male: boolean, female: boolean, positionTitle: string, address?: string | null, ageFrom?: number | null, ageTo?: number | null, additionalRecruitementInformation?: string | null, workFunctions?: string | null, isWorkplaceVideoAllowed: boolean, isWorkplaceVisitAllowed: boolean, shiftDuration?: number | null, breakDuration?: number | null, scheduleType?: number | null, scheduleText?: string | null, shiftPattern?: any | null, intensity?: SpecificationIntensity | null, allFunctionsFromFirstDay: boolean, onboardingDuration?: string | null, minExperienceMonths?: number | null, experienceType: SpecificationExperienceType, canEmployUa: boolean, healthcheckType?: SpecificationHealthcheckType | null, tagassignmentSet: Array<{ __typename?: 'TagAssignmentType', id: string, comment: string, tag: { __typename?: 'TagType', id: string, title: string, order: number, key?: string | null, group?: { __typename?: 'TagGroupType', id: string, key: string } | null } }>, mandatoryRequirements: Array<{ __typename?: 'RequirementType', id: string, requirement?: string | null }>, optionalRequirements: Array<{ __typename?: 'RequirementType', id: string, requirement?: string | null }>, scheduleTypes: Array<{ __typename?: 'ScheduleTypeType', id: string, title: string }>, certificates: Array<{ __typename?: 'CertificateType', id: string, title?: string | null }>, riskFactors: Array<{ __typename?: 'RiskFactorType', id: string, title: string }>, salary?: { __typename?: 'SpecificationSalaryType', id: string, hourlyBruttoFrom?: number | null, hourlyBruttoTo?: number | null, hourlyNettoFrom?: number | null, hourlyNettoTo?: number | null, monthlyBruttoFrom?: number | null, monthlyBruttoTo?: number | null, monthlyNettoFrom?: number | null, monthlyNettoTo?: number | null, hourlyBruttoFromFilled: boolean, hourlyBruttoToFilled: boolean, hourlyNettoFromFilled: boolean, hourlyNettoToFilled: boolean, monthlyBruttoFromFilled: boolean, monthlyBruttoToFilled: boolean, monthlyNettoFromFilled: boolean, monthlyNettoToFilled: boolean, useInTemplate: SpecificationSalaryUseInTemplate } | null } | null, eventSet: { __typename?: 'EventTypeConnection', edges: Array<{ __typename?: 'EventTypeEdge', node?: { __typename?: 'EventType', id: string, date?: any | null, status?: TaskStatus | null, adId?: number | null, comment?: string | null, workisJobId?: number | null, externalPlatformId?: string | null, language?: EventLanguage | null, channels: Array<{ __typename?: 'ChannelType', id: string, title: string, icon?: string | null }>, category?: { __typename?: 'CategoryType', id: string, title: string, icon?: string | null } | null } | null } | null> } } | null } | null> } | null };

export type GetPlannerEventsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetPlannerEventsQuery = { __typename?: 'Query', plannerEvents?: { __typename?: 'EventTypeConnection', edges: Array<{ __typename?: 'EventTypeEdge', node?: { __typename?: 'EventType', externalPlatformId?: string | null, id: string, date?: any | null, status?: TaskStatus | null, adId?: number | null, comment?: string | null, workisJobId?: number | null, language?: EventLanguage | null, order?: { __typename?: 'OrderType', id: string, specification?: { __typename?: 'SpecificationType', id: string, positionTitle: string } | null } | null, channels: Array<{ __typename?: 'ChannelType', id: string, title: string, icon?: string | null }>, category?: { __typename?: 'CategoryType', id: string, title: string, icon?: string | null } | null } | null } | null> } | null };

export type GetPlannerEventsByOrderQueryVariables = Exact<{
  orderId: Scalars['ID'];
  first?: InputMaybe<Scalars['Int']>;
  after?: InputMaybe<Scalars['String']>;
  date_Lte?: InputMaybe<Scalars['Date']>;
  date_Gte?: InputMaybe<Scalars['Date']>;
  ordering?: InputMaybe<Scalars['String']>;
}>;


export type GetPlannerEventsByOrderQuery = { __typename?: 'Query', plannerEvents?: { __typename?: 'EventTypeConnection', totalCount?: number | null, pageInfo: { __typename?: 'PageInfo', startCursor?: string | null, endCursor?: string | null, hasNextPage: boolean }, edges: Array<{ __typename?: 'EventTypeEdge', node?: { __typename?: 'EventType', externalPlatformId?: string | null, durationMinutes?: number | null, price?: number | null, id: string, date?: any | null, status?: TaskStatus | null, adId?: number | null, comment?: string | null, workisJobId?: number | null, language?: EventLanguage | null, order?: { __typename?: 'OrderType', id: string, specification?: { __typename?: 'SpecificationType', id: string, positionTitle: string } | null } | null, completedBy?: Array<{ __typename?: 'UserProfileMType', id: string, fullName: string, user: { __typename?: 'UserType', id: string, firstName: string, lastName: string } } | null> | null, channels: Array<{ __typename?: 'ChannelType', id: string, title: string, icon?: string | null }>, category?: { __typename?: 'CategoryType', id: string, title: string, icon?: string | null } | null } | null } | null> } | null };

export type GetPlannerEventsByCompanyQueryVariables = Exact<{
  order_Company: Scalars['ID'];
  first?: InputMaybe<Scalars['Int']>;
  after?: InputMaybe<Scalars['String']>;
  date_Lte?: InputMaybe<Scalars['Date']>;
  date_Gte?: InputMaybe<Scalars['Date']>;
}>;


export type GetPlannerEventsByCompanyQuery = { __typename?: 'Query', plannerEvents?: { __typename?: 'EventTypeConnection', totalCount?: number | null, pageInfo: { __typename?: 'PageInfo', startCursor?: string | null, endCursor?: string | null, hasNextPage: boolean }, edges: Array<{ __typename?: 'EventTypeEdge', node?: { __typename?: 'EventType', durationMinutes?: number | null, price?: number | null, externalPlatformId?: string | null, id: string, date?: any | null, status?: TaskStatus | null, adId?: number | null, comment?: string | null, workisJobId?: number | null, language?: EventLanguage | null, order?: { __typename?: 'OrderType', id: string, specification?: { __typename?: 'SpecificationType', id: string, positionTitle: string } | null } | null, channels: Array<{ __typename?: 'ChannelType', id: string, title: string, icon?: string | null }>, category?: { __typename?: 'CategoryType', id: string, title: string, icon?: string | null } | null } | null } | null> } | null };

export type InterviewWidgetOfferFieldsFragment = { __typename?: 'OfferPropositionType', id: string, comment?: string | null, personId: number, interested?: OfferPropositionInterested | null, interestedOnCall?: OfferPropositionInterestedOnCall | null, signed: boolean, longListed?: OfferPropositionLongListed | null, order: { __typename?: 'OrderType', orderType: OrderOrderType, id: string }, candidate?: { __typename?: 'CandidateType', id: string } | null, candidateEvents: { __typename?: 'CandidateEventTypeConnection', edges: Array<{ __typename?: 'CandidateEventTypeEdge', node?: { __typename?: 'CandidateEventType', id: string, startDatetime?: any | null, resolutionStatus?: EventResolutionStatus | null, eventType: EventEventType, deleted: boolean, description?: string | null, isProblematicInterview: boolean, relatedOffer?: { __typename?: 'OfferPropositionType', order: { __typename?: 'OrderType', company?: { __typename?: 'CompanyType', name: string } | null } } | null } | null } | null> } };

export type InterviewWidgetRegionFieldsFragment = { __typename?: 'RegionType', title: string, externalId?: number | null };

export type InterviewWidgetOrdersFieldsFragment = { __typename?: 'OrderType', id: string, orderType: OrderOrderType, trafficGeneration: OrderTrafficGeneration, specification?: { __typename?: 'SpecificationType', positionTitle: string, address?: string | null, company?: { __typename?: 'CompanyType', name: string, color: HistoricalCompanyColor, status?: string | null } | null } | null };

export type InterviewWidgetOffersQueryVariables = Exact<{
  sex?: InputMaybe<Scalars['String']>;
  personId?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  region?: InputMaybe<Scalars['String']>;
  region_ExternalId?: InputMaybe<Scalars['Int']>;
  trafficGeneration?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['String']>;
}>;


export type InterviewWidgetOffersQuery = { __typename?: 'Query', offers?: { __typename?: 'OfferPropositionTypeConnection', edges: Array<{ __typename?: 'OfferPropositionTypeEdge', node?: { __typename?: 'OfferPropositionType', createdAt: any, id: string, comment?: string | null, personId: number, interested?: OfferPropositionInterested | null, interestedOnCall?: OfferPropositionInterestedOnCall | null, signed: boolean, longListed?: OfferPropositionLongListed | null, cancellationreasonassignmentSet: { __typename?: 'CancellationReasonAssignmentTypeConnection', edges: Array<{ __typename?: 'CancellationReasonAssignmentTypeEdge', node?: { __typename?: 'CancellationReasonAssignmentType', id: string, cancellationReason: { __typename?: 'CancellationReasonType', id: string, title: string } } | null } | null> }, offerpropositioncommentSet: { __typename?: 'OfferPropositionCommentTypeConnection', totalCount?: number | null, edges: Array<{ __typename?: 'OfferPropositionCommentTypeEdge', node?: { __typename?: 'OfferPropositionCommentType', text?: string | null } | null } | null> }, order: { __typename?: 'OrderType', orderType: OrderOrderType, id: string }, candidate?: { __typename?: 'CandidateType', id: string } | null, candidateEvents: { __typename?: 'CandidateEventTypeConnection', edges: Array<{ __typename?: 'CandidateEventTypeEdge', node?: { __typename?: 'CandidateEventType', id: string, startDatetime?: any | null, resolutionStatus?: EventResolutionStatus | null, eventType: EventEventType, deleted: boolean, description?: string | null, isProblematicInterview: boolean, relatedOffer?: { __typename?: 'OfferPropositionType', order: { __typename?: 'OrderType', company?: { __typename?: 'CompanyType', name: string } | null } } | null } | null } | null> } } | null } | null> } | null, regions?: Array<{ __typename?: 'RegionType', title: string, externalId?: number | null } | null> | null, ordersPaginated?: { __typename?: 'OrderTypeConnection', edges: Array<{ __typename?: 'OrderTypeEdge', node?: { __typename?: 'OrderType', id: string, orderType: OrderOrderType, trafficGeneration: OrderTrafficGeneration, specification?: { __typename?: 'SpecificationType', positionTitle: string, address?: string | null, company?: { __typename?: 'CompanyType', name: string, color: HistoricalCompanyColor, status?: string | null } | null } | null } | null } | null> } | null };

export type CandidateEventByTimeAndPersonQueryVariables = Exact<{
  livasId: Scalars['Float'];
  orderId: Scalars['ID'];
  eventType?: InputMaybe<Scalars['String']>;
}>;


export type CandidateEventByTimeAndPersonQuery = { __typename?: 'Query', candidateEvents?: { __typename?: 'CandidateEventTypeConnection', edges: Array<{ __typename?: 'CandidateEventTypeEdge', node?: { __typename?: 'CandidateEventType', id: string, startDatetime?: any | null, resolutionStatus?: EventResolutionStatus | null, eventType: EventEventType, deleted: boolean, description?: string | null, isProblematicInterview: boolean, relatedOffer?: { __typename?: 'OfferPropositionType', order: { __typename?: 'OrderType', company?: { __typename?: 'CompanyType', name: string } | null } } | null } | null } | null> } | null };

export type UpdateMutationVariables = Exact<{
  id: Scalars['ID'];
  status?: InputMaybe<EventResolutionStatus>;
}>;


export type UpdateMutation = { __typename?: 'Mutation', eventStatusUpdate?: { __typename?: 'EventStatusUpdateMutationPayload', event?: { __typename?: 'CandidateEventType', id: string } | null } | null };

export type SmsMutationVariables = Exact<{
  id: Scalars['ID'];
  sms?: InputMaybe<Scalars['String']>;
}>;


export type SmsMutation = { __typename?: 'Mutation', sendSms?: { __typename?: 'SendSMSMutation', ok?: boolean | null } | null };

export type EventUpdateMutationVariables = Exact<{
  id: Scalars['ID'];
  startDatetime: Scalars['DateTime'];
}>;


export type EventUpdateMutation = { __typename?: 'Mutation', eventUpdate?: { __typename?: 'EventUpdateMutationPayload', event?: { __typename?: 'CandidateEventType', id: string } | null } | null };

export type InterviewWidgetCreateEventMutationVariables = Exact<{
  eventType: EventEventType;
  offerPropositions: Array<InputMaybe<Scalars['ID']>> | InputMaybe<Scalars['ID']>;
  startDatetime?: InputMaybe<Scalars['DateTime']>;
  livasStatusId?: InputMaybe<Scalars['Int']>;
  livasContactDate?: InputMaybe<Scalars['Date']>;
  updateLivasOfficeInterviewDate?: InputMaybe<Scalars['Boolean']>;
  updateLivasClientInterviewDate?: InputMaybe<Scalars['Boolean']>;
  updateLivasEmploymentDate?: InputMaybe<Scalars['Boolean']>;
}>;


export type InterviewWidgetCreateEventMutation = { __typename?: 'Mutation', eventCreate?: { __typename?: 'EventCreateMutationPayload', event?: { __typename?: 'CandidateEventType', deleted: boolean, id: string, startDatetime?: any | null, resolutionStatus?: EventResolutionStatus | null, candidate: { __typename?: 'CandidateType', eventSet: { __typename?: 'CandidateEventTypeConnection', edges: Array<{ __typename?: 'CandidateEventTypeEdge', node?: { __typename?: 'CandidateEventType', id: string, deleted: boolean } | null } | null> } } } | null } | null };

export type InterviewWidgetEventUpdateMutationVariables = Exact<{
  eventId: Scalars['ID'];
  eventType: EventEventType;
  offerPropositions: Array<InputMaybe<Scalars['ID']>> | InputMaybe<Scalars['ID']>;
  startDatetime?: InputMaybe<Scalars['DateTime']>;
  livasStatusId?: InputMaybe<Scalars['Int']>;
  livasContactDate?: InputMaybe<Scalars['Date']>;
  updateLivasOfficeInterviewDate?: InputMaybe<Scalars['Boolean']>;
  updateLivasClientInterviewDate?: InputMaybe<Scalars['Boolean']>;
  updateLivasEmploymentDate?: InputMaybe<Scalars['Boolean']>;
  description?: InputMaybe<Scalars['String']>;
  isProblematicInterview?: InputMaybe<Scalars['Boolean']>;
}>;


export type InterviewWidgetEventUpdateMutation = { __typename?: 'Mutation', eventUpdate?: { __typename?: 'EventUpdateMutationPayload', event?: { __typename?: 'CandidateEventType', deleted: boolean, id: string, startDatetime?: any | null, resolutionStatus?: EventResolutionStatus | null } | null } | null };

export type InterviewWidgetChangeEventStatusMutationMutationVariables = Exact<{
  eventId: Scalars['ID'];
  resolutionStatus?: InputMaybe<EventResolutionStatus>;
}>;


export type InterviewWidgetChangeEventStatusMutationMutation = { __typename?: 'Mutation', eventStatusUpdate?: { __typename?: 'EventStatusUpdateMutationPayload', event?: { __typename?: 'CandidateEventType', deleted: boolean, id: string, startDatetime?: any | null, resolutionStatus?: EventResolutionStatus | null } | null } | null };

export type UpdateLivasCandidateStatusByOfferPropositionMutationVariables = Exact<{
  offerPropositionId: Scalars['ID'];
  livasStatusId: Scalars['Int'];
}>;


export type UpdateLivasCandidateStatusByOfferPropositionMutation = { __typename?: 'Mutation', updateLivasCandidateStatus?: { __typename?: 'UpdateLivasCandidateStatus', ok?: boolean | null } | null };

export type UpdateLivasOfferPropositionSignedMutationVariables = Exact<{
  offerPropositionId: Scalars['ID'];
}>;


export type UpdateLivasOfferPropositionSignedMutation = { __typename?: 'Mutation', offerPropositionUpdate?: { __typename?: 'OfferPropositionUpdateMutationPayload', offerProposition?: { __typename?: 'OfferPropositionType', id: string, signed: boolean } | null } | null };

export type UpdateEventProblematicInterviewMutationVariables = Exact<{
  id: Scalars['ID'];
  isProblematicInterview: Scalars['Boolean'];
  description?: InputMaybe<Scalars['String']>;
}>;


export type UpdateEventProblematicInterviewMutation = { __typename?: 'Mutation', eventProblematicInterviewUpdate?: { __typename?: 'EventProblematicInterviewUpdateMutationPayload', event?: { __typename?: 'CandidateEventType', id: string, description?: string | null, isProblematicInterview: boolean } | null } | null };

export type GetJobAdAiVersionsQueryVariables = Exact<{
  orderId: Scalars['Int'];
}>;


export type GetJobAdAiVersionsQuery = { __typename?: 'Query', jobAdsContentAi?: { __typename?: 'JobAdAIContentType', id: string, status: JobAdAiContentStatus, response?: any | null } | null };

export type LivasJobAdsQueryVariables = Exact<{
  orderId: Scalars['ID'];
}>;


export type LivasJobAdsQuery = { __typename?: 'Query', livasJobAds?: Array<{ __typename?: 'LivasJobAdContentType', advertTitle?: string | null, description2?: string | null, descriptionDsc?: string | null, requirementsDsc?: string | null, offerDsc?: string | null, seoTitle?: string | null, contactsCount?: number | null, updatedAt?: any | null, categoryId?: number | null, workingHours?: string | null, locationId?: number | null } | null> | null };

export type CreateJobAdLivasMutationVariables = Exact<{
  orderId: Scalars['ID'];
  advertTitle: Scalars['String'];
  summary?: InputMaybe<Scalars['String']>;
  offerDsc: Scalars['String'];
  descriptionDsc: Scalars['String'];
  requirementsDsc: Scalars['String'];
  seoTitle: Scalars['String'];
  address?: InputMaybe<Scalars['String']>;
  companyTitle?: InputMaybe<Scalars['String']>;
  categoryId?: InputMaybe<Scalars['Int']>;
  locationId?: InputMaybe<Scalars['Int']>;
  position?: InputMaybe<Scalars['String']>;
  workingHours?: InputMaybe<Scalars['String']>;
  salaryFrom?: InputMaybe<Scalars['Float']>;
  salaryTo?: InputMaybe<Scalars['Float']>;
  salaryType?: InputMaybe<Scalars['String']>;
}>;


export type CreateJobAdLivasMutation = { __typename?: 'Mutation', createJobAdLivas?: { __typename?: 'CreateJobAdLivas', response?: any | null } | null };

export type JobAdDialogMetaQueryVariables = Exact<{ [key: string]: never; }>;


export type JobAdDialogMetaQuery = { __typename?: 'Query', jobCategories?: { __typename?: 'JobCategoryTypeConnection', edges: Array<{ __typename?: 'JobCategoryTypeEdge', node?: { __typename?: 'JobCategoryType', id: string, title?: string | null, externalId?: number | null } | null } | null> } | null, cities?: { __typename?: 'CityTypeConnection', edges: Array<{ __typename?: 'CityTypeEdge', node?: { __typename?: 'CityType', id: string, title: string, externalId?: number | null, region?: { __typename?: 'RegionType', id: string, externalId?: number | null, title: string } | null } | null } | null> } | null };

export type OfferEventFieldsFragment = { __typename?: 'CandidateEventType', id: string, startDatetime?: any | null, resolutionStatus?: EventResolutionStatus | null, eventType: EventEventType, deleted: boolean, description?: string | null, isProblematicInterview: boolean, relatedOffer?: { __typename?: 'OfferPropositionType', order: { __typename?: 'OrderType', company?: { __typename?: 'CompanyType', name: string } | null } } | null };

export type CandidateOfferFieldsFragment = { __typename?: 'CandidateType', id: string, firstName: string, lastName: string, livasId: number, livasStatus?: { __typename?: 'CandidateStatusType', id: string, titleLt?: string | null, titleLv?: string | null, titleEe?: string | null } | null };

export type OfferFieldsFragment = { __typename?: 'OfferPropositionType', id: string, personId: number, interestedOnCall?: OfferPropositionInterestedOnCall | null, interested?: OfferPropositionInterested | null, firstInterestedAt?: any | null, signed: boolean, signedAt?: any | null, comment?: string | null, candidate?: { __typename?: 'CandidateType', id: string, firstName: string, lastName: string, livasId: number, livasStatus?: { __typename?: 'CandidateStatusType', id: string, titleLt?: string | null, titleLv?: string | null, titleEe?: string | null } | null } | null, cancellationreasonassignmentSet: { __typename?: 'CancellationReasonAssignmentTypeConnection', edges: Array<{ __typename?: 'CancellationReasonAssignmentTypeEdge', node?: { __typename?: 'CancellationReasonAssignmentType', id: string, cancellationReason: { __typename?: 'CancellationReasonType', id: string, title: string } } | null } | null> }, offerpropositioncommentSet: { __typename?: 'OfferPropositionCommentTypeConnection', totalCount?: number | null, edges: Array<{ __typename?: 'OfferPropositionCommentTypeEdge', node?: { __typename?: 'OfferPropositionCommentType', id: string, text?: string | null, createdAt: any } | null } | null> }, candidateEvents: { __typename?: 'CandidateEventTypeConnection', edges: Array<{ __typename?: 'CandidateEventTypeEdge', node?: { __typename?: 'CandidateEventType', id: string, startDatetime?: any | null, resolutionStatus?: EventResolutionStatus | null, eventType: EventEventType, deleted: boolean, description?: string | null, isProblematicInterview: boolean, relatedOffer?: { __typename?: 'OfferPropositionType', order: { __typename?: 'OrderType', company?: { __typename?: 'CompanyType', name: string } | null } } | null } | null } | null> }, eventSet: { __typename?: 'CandidateEventTypeConnection', edges: Array<{ __typename?: 'CandidateEventTypeEdge', node?: { __typename?: 'CandidateEventType', id: string, startDatetime?: any | null, resolutionStatus?: EventResolutionStatus | null, eventType: EventEventType, deleted: boolean, description?: string | null, isProblematicInterview: boolean, relatedOffer?: { __typename?: 'OfferPropositionType', order: { __typename?: 'OrderType', company?: { __typename?: 'CompanyType', name: string } | null } } | null } | null } | null> } };

export type OffersQueryVariables = Exact<{
  orderId: Scalars['ID'];
  first?: InputMaybe<Scalars['Int']>;
  after?: InputMaybe<Scalars['String']>;
  orderBy?: InputMaybe<Scalars['String']>;
  createdAt_Gte?: InputMaybe<Scalars['Date']>;
  createdAt_Lte?: InputMaybe<Scalars['Date']>;
}>;


export type OffersQuery = { __typename?: 'Query', offers?: { __typename?: 'OfferPropositionTypeConnection', totalCount?: number | null, pageInfo: { __typename?: 'PageInfo', startCursor?: string | null, endCursor?: string | null, hasNextPage: boolean, hasPreviousPage: boolean }, edges: Array<{ __typename?: 'OfferPropositionTypeEdge', node?: { __typename?: 'OfferPropositionType', id: string, personId: number, interestedOnCall?: OfferPropositionInterestedOnCall | null, interested?: OfferPropositionInterested | null, firstInterestedAt?: any | null, signed: boolean, signedAt?: any | null, comment?: string | null, candidate?: { __typename?: 'CandidateType', id: string, firstName: string, lastName: string, livasId: number, livasStatus?: { __typename?: 'CandidateStatusType', id: string, titleLt?: string | null, titleLv?: string | null, titleEe?: string | null } | null } | null, cancellationreasonassignmentSet: { __typename?: 'CancellationReasonAssignmentTypeConnection', edges: Array<{ __typename?: 'CancellationReasonAssignmentTypeEdge', node?: { __typename?: 'CancellationReasonAssignmentType', id: string, cancellationReason: { __typename?: 'CancellationReasonType', id: string, title: string } } | null } | null> }, offerpropositioncommentSet: { __typename?: 'OfferPropositionCommentTypeConnection', totalCount?: number | null, edges: Array<{ __typename?: 'OfferPropositionCommentTypeEdge', node?: { __typename?: 'OfferPropositionCommentType', id: string, text?: string | null, createdAt: any } | null } | null> }, candidateEvents: { __typename?: 'CandidateEventTypeConnection', edges: Array<{ __typename?: 'CandidateEventTypeEdge', node?: { __typename?: 'CandidateEventType', id: string, startDatetime?: any | null, resolutionStatus?: EventResolutionStatus | null, eventType: EventEventType, deleted: boolean, description?: string | null, isProblematicInterview: boolean, relatedOffer?: { __typename?: 'OfferPropositionType', order: { __typename?: 'OrderType', company?: { __typename?: 'CompanyType', name: string } | null } } | null } | null } | null> }, eventSet: { __typename?: 'CandidateEventTypeConnection', edges: Array<{ __typename?: 'CandidateEventTypeEdge', node?: { __typename?: 'CandidateEventType', id: string, startDatetime?: any | null, resolutionStatus?: EventResolutionStatus | null, eventType: EventEventType, deleted: boolean, description?: string | null, isProblematicInterview: boolean, relatedOffer?: { __typename?: 'OfferPropositionType', order: { __typename?: 'OrderType', company?: { __typename?: 'CompanyType', name: string } | null } } | null } | null } | null> } } | null } | null> } | null, orderModel?: { __typename?: 'OrderMType', id: string, company?: { __typename?: 'CompanyType', id: string, country?: { __typename?: 'CountryType', id: string, isoCode?: string | null } | null } | null } | null };

export type OfferPropisitionOfferFieldsFragment = { __typename?: 'OfferPropositionType', id: string, comment?: string | null, personId: number, interested?: OfferPropositionInterested | null, firstInterestedAt?: any | null, interestedOnCall?: OfferPropositionInterestedOnCall | null, signed: boolean, longListed?: OfferPropositionLongListed | null, order: { __typename?: 'OrderType', id: string, orderType: OrderOrderType, trafficGeneration: OrderTrafficGeneration, specification?: { __typename?: 'SpecificationType', positionTitle: string, address?: string | null, company?: { __typename?: 'CompanyType', name: string, color: HistoricalCompanyColor, status?: string | null } | null } | null }, candidate?: { __typename?: 'CandidateType', id: string } | null, candidateEvents: { __typename?: 'CandidateEventTypeConnection', edges: Array<{ __typename?: 'CandidateEventTypeEdge', node?: { __typename?: 'CandidateEventType', id: string, startDatetime?: any | null, resolutionStatus?: EventResolutionStatus | null, eventType: EventEventType, deleted: boolean, description?: string | null, isProblematicInterview: boolean, relatedOffer?: { __typename?: 'OfferPropositionType', order: { __typename?: 'OrderType', company?: { __typename?: 'CompanyType', name: string } | null } } | null } | null } | null> }, eventSet: { __typename?: 'CandidateEventTypeConnection', edges: Array<{ __typename?: 'CandidateEventTypeEdge', node?: { __typename?: 'CandidateEventType', id: string, startDatetime?: any | null, resolutionStatus?: EventResolutionStatus | null, eventType: EventEventType, deleted: boolean, description?: string | null, isProblematicInterview: boolean, relatedOffer?: { __typename?: 'OfferPropositionType', order: { __typename?: 'OrderType', company?: { __typename?: 'CompanyType', name: string } | null } } | null } | null } | null> } };

export type OfferPropisitionRegionFieldsFragment = { __typename?: 'RegionType', title: string, externalId?: number | null };

export type OfferPropisitionOrdersFieldsFragment = { __typename?: 'OrderType', id: string, orderType: OrderOrderType, trafficGeneration: OrderTrafficGeneration, specification?: { __typename?: 'SpecificationType', positionTitle: string, address?: string | null, company?: { __typename?: 'CompanyType', name: string, color: HistoricalCompanyColor, status?: string | null } | null } | null };

export type CancellationReasonAssignmentFieldsFragment = { __typename?: 'CancellationReasonAssignmentType', id: string, cancellationReason: { __typename?: 'CancellationReasonType', id: string, title: string } };

export type OfferPospositionOffersQueryVariables = Exact<{
  sex?: InputMaybe<Scalars['String']>;
  personId?: InputMaybe<Scalars['Int']>;
  region?: InputMaybe<Scalars['String']>;
  region_ExternalId?: InputMaybe<Scalars['Int']>;
  trafficGeneration?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['String']>;
  orderBy?: InputMaybe<Scalars['String']>;
}>;


export type OfferPospositionOffersQuery = { __typename?: 'Query', offers?: { __typename?: 'OfferPropositionTypeConnection', edges: Array<{ __typename?: 'OfferPropositionTypeEdge', node?: { __typename?: 'OfferPropositionType', createdAt: any, id: string, comment?: string | null, personId: number, interested?: OfferPropositionInterested | null, firstInterestedAt?: any | null, interestedOnCall?: OfferPropositionInterestedOnCall | null, signed: boolean, longListed?: OfferPropositionLongListed | null, cancellationreasonassignmentSet: { __typename?: 'CancellationReasonAssignmentTypeConnection', edges: Array<{ __typename?: 'CancellationReasonAssignmentTypeEdge', node?: { __typename?: 'CancellationReasonAssignmentType', id: string, cancellationReason: { __typename?: 'CancellationReasonType', id: string, title: string } } | null } | null> }, offerpropositioncommentSet: { __typename?: 'OfferPropositionCommentTypeConnection', totalCount?: number | null, edges: Array<{ __typename?: 'OfferPropositionCommentTypeEdge', node?: { __typename?: 'OfferPropositionCommentType', text?: string | null } | null } | null> }, order: { __typename?: 'OrderType', id: string, orderType: OrderOrderType, trafficGeneration: OrderTrafficGeneration, specification?: { __typename?: 'SpecificationType', positionTitle: string, address?: string | null, company?: { __typename?: 'CompanyType', name: string, color: HistoricalCompanyColor, status?: string | null } | null } | null }, candidate?: { __typename?: 'CandidateType', id: string } | null, candidateEvents: { __typename?: 'CandidateEventTypeConnection', edges: Array<{ __typename?: 'CandidateEventTypeEdge', node?: { __typename?: 'CandidateEventType', id: string, startDatetime?: any | null, resolutionStatus?: EventResolutionStatus | null, eventType: EventEventType, deleted: boolean, description?: string | null, isProblematicInterview: boolean, relatedOffer?: { __typename?: 'OfferPropositionType', order: { __typename?: 'OrderType', company?: { __typename?: 'CompanyType', name: string } | null } } | null } | null } | null> }, eventSet: { __typename?: 'CandidateEventTypeConnection', edges: Array<{ __typename?: 'CandidateEventTypeEdge', node?: { __typename?: 'CandidateEventType', id: string, startDatetime?: any | null, resolutionStatus?: EventResolutionStatus | null, eventType: EventEventType, deleted: boolean, description?: string | null, isProblematicInterview: boolean, relatedOffer?: { __typename?: 'OfferPropositionType', order: { __typename?: 'OrderType', company?: { __typename?: 'CompanyType', name: string } | null } } | null } | null } | null> } } | null } | null> } | null, regions?: Array<{ __typename?: 'RegionType', title: string, externalId?: number | null } | null> | null, ordersPaginated?: { __typename?: 'OrderTypeConnection', edges: Array<{ __typename?: 'OrderTypeEdge', node?: { __typename?: 'OrderType', id: string, orderType: OrderOrderType, trafficGeneration: OrderTrafficGeneration, specification?: { __typename?: 'SpecificationType', positionTitle: string, address?: string | null, company?: { __typename?: 'CompanyType', name: string, color: HistoricalCompanyColor, status?: string | null } | null } | null } | null } | null> } | null };

export type CreateOfferPropositionCommentMutationVariables = Exact<{
  input: CreateOfferPropositionCommentInput;
}>;


export type CreateOfferPropositionCommentMutation = { __typename?: 'Mutation', createOfferPropositionComment?: { __typename?: 'CreateOfferPropositionCommentPayload', offerPropositionComment?: { __typename?: 'OfferPropositionCommentType', id: string, text?: string | null, createdAt: any, createdBy: { __typename?: 'UserProfileMType', id: string, user: { __typename?: 'UserType', id: string, email: string, firstName: string, lastName: string } } } | null } | null };

export type OfferPropositionCommentsQueryVariables = Exact<{
  offerId: Scalars['ID'];
}>;


export type OfferPropositionCommentsQuery = { __typename?: 'Query', offerPropositionComments?: { __typename?: 'OfferPropositionCommentTypeConnection', edges: Array<{ __typename?: 'OfferPropositionCommentTypeEdge', node?: { __typename?: 'OfferPropositionCommentType', id: string, text?: string | null, createdAt: any, createdBy: { __typename?: 'UserProfileMType', id: string, user: { __typename?: 'UserType', id: string, email: string, firstName: string, lastName: string } } } | null } | null> } | null };

export type UpdateOfferPropositionCommentMutationVariables = Exact<{
  input: UpdateOfferPropositionCommentInput;
}>;


export type UpdateOfferPropositionCommentMutation = { __typename?: 'Mutation', updateOfferPropositionComment?: { __typename?: 'UpdateOfferPropositionCommentPayload', offerPropositionComment?: { __typename?: 'OfferPropositionCommentType', id: string, text?: string | null } | null } | null };

export type CreateOrderDocumentFieldsFragment = { __typename?: 'DocumentType', id: string, documentDate?: any | null, confirmationMethod: DocumentConfirmationMethod, generatedDocument?: string | null, order: { __typename?: 'OrderType', id: string, specification?: { __typename?: 'SpecificationType', id: string, positionTitle: string } | null }, orderPeriods: Array<{ __typename?: 'OrderPeriodType', id: string }> };

export type ContactFieldsFragment = { __typename?: 'ContactType', id: string, firstName: string, lastName?: string | null, email?: string | null, phone?: string | null, insightlyId?: number | null, comment?: string | null, canUseInOrder: boolean };

export type ContactFieldsShortFragment = { __typename?: 'ContactType', id: string, firstName: string, lastName?: string | null, email?: string | null, phone?: string | null };

export type ContractsMetaFieldsFragment = { __typename?: 'ContractType', id: string, validFromDate?: any | null, validTillDate?: any | null, contractor?: { __typename?: 'ContractorType', id: string, logoUrl?: string | null } | null };

export type OrderDocumentFieldsFragment = { __typename?: 'DocumentType', id: string, isSignedBiuro: boolean, isSignedClient: boolean, signingUrl?: string | null, confirmationMethod: DocumentConfirmationMethod, status: DocumentStatus, createDate: any, signedDocument?: string | null };

export type CompanyMetaFieldsFragment = { __typename?: 'CompanyType', id: string, status?: string | null, name: string, description?: string | null, contractSet: Array<{ __typename?: 'ContractType', id: string, validFromDate?: any | null, validTillDate?: any | null, contractor?: { __typename?: 'ContractorType', id: string, logoUrl?: string | null } | null }>, contactSet: { __typename?: 'ContactTypeConnection', edges: Array<{ __typename?: 'ContactTypeEdge', node?: { __typename?: 'ContactType', id: string, firstName: string, lastName?: string | null } | null } | null> }, specificationSet: Array<{ __typename?: 'SpecificationType', id: string, positionTitle: string }> };

export type OrderCommentFieldsFragment = { __typename?: 'OrderCommentType', id: string, comment?: string | null, createdAt: any };

export type SalaryTableCellFieldsFragment = { __typename?: 'SpecificationSalaryType', id: string, hourlyBruttoFrom?: number | null, hourlyBruttoTo?: number | null, monthlyBruttoFrom?: number | null, monthlyBruttoTo?: number | null, hourlyBruttoFromFilled: boolean, hourlyBruttoToFilled: boolean, monthlyBruttoFromFilled: boolean, monthlyBruttoToFilled: boolean, useInTemplate: SpecificationSalaryUseInTemplate };

export type SpecFieldInOrderListFragment = { __typename?: 'SpecificationType', id: string, positionTitle: string, address?: string | null, salary?: { __typename?: 'SpecificationSalaryType', id: string, hourlyBruttoFrom?: number | null, hourlyBruttoTo?: number | null, monthlyBruttoFrom?: number | null, monthlyBruttoTo?: number | null, hourlyBruttoFromFilled: boolean, hourlyBruttoToFilled: boolean, monthlyBruttoFromFilled: boolean, monthlyBruttoToFilled: boolean, useInTemplate: SpecificationSalaryUseInTemplate } | null };

export type RegionsList2FieldsFragment = { __typename?: 'RegionType', id: string, title: string, regionmetrics?: { __typename?: 'RegionMetricType', id: string, lifetime?: number | null } | null };

export type OrderSelectListFieldsFragment = { __typename?: 'OrderMType', id: string, orderType: OrderOrderType, createdDate: any, specification?: { __typename?: 'SpecificationType', id: string, positionTitle: string } | null, region?: { __typename?: 'RegionType', id: string, title: string } | null };

export type OrdersList2FieldsFragment = { __typename?: 'OrderType', id: string, hourRateBruttoPermanent?: number | null, orderNumber?: string | null, subtype: OrderSubtype, dateFrom?: any | null, dateTo?: any | null, isLongTerm?: boolean | null, demand?: number | null, orderType: OrderOrderType, orderDate?: any | null, priority?: OrderPriority | null, trafficGeneration: OrderTrafficGeneration, status?: OrderStatus | null, nettoFrom?: number | null, nettoTo?: number | null, shortage: number, ordermetrics?: { __typename?: 'OrderMetricType', id: string, lifetime?: number | null, effortConversion?: number | null, totalCalls?: number | null, successfulCalls?: number | null, totalInterviews?: number | null, successfulInterviews?: number | null } | null, region?: { __typename?: 'RegionType', id: string, title: string, regionmetrics?: { __typename?: 'RegionMetricType', id: string, lifetime?: number | null, effortConversion?: number | null, totalCalls?: number | null, successfulCalls?: number | null, totalInverviews?: number | null, successfulInterviews?: number | null } | null, regionthresholdsettings?: { __typename?: 'RegionThresholdSettingsType', minOffersExpected?: number | null } | null } | null, ordercommentSet: { __typename?: 'OrderCommentTypeConnection', edges: Array<{ __typename?: 'OrderCommentTypeEdge', node?: { __typename?: 'OrderCommentType', id: string, comment?: string | null, createdAt: any } | null } | null> }, projectManager?: { __typename?: 'UserProfileMType', id: string, user: { __typename?: 'UserType', id: string, firstName: string, lastName: string } } | null, recruiter?: { __typename?: 'UserProfileMType', id: string, user: { __typename?: 'UserType', id: string, firstName: string, lastName: string } } | null, specification?: { __typename?: 'SpecificationType', id: string, positionTitle: string, address?: string | null, salary?: { __typename?: 'SpecificationSalaryType', id: string, hourlyBruttoFrom?: number | null, hourlyBruttoTo?: number | null, monthlyBruttoFrom?: number | null, monthlyBruttoTo?: number | null, hourlyBruttoFromFilled: boolean, hourlyBruttoToFilled: boolean, monthlyBruttoFromFilled: boolean, monthlyBruttoToFilled: boolean, useInTemplate: SpecificationSalaryUseInTemplate } | null } | null, createdBy?: { __typename?: 'UserProfileMType', id: string, user: { __typename?: 'UserType', id: string, email: string, firstName: string, lastName: string } } | null, clientContact?: { __typename?: 'ContactType', id: string, email?: string | null, firstName: string, lastName?: string | null } | null, company?: { __typename?: 'CompanyType', id: string, status?: string | null, name: string, color: HistoricalCompanyColor, labels: { __typename?: 'LabelTypeConnection', edges: Array<{ __typename?: 'LabelTypeEdge', node?: { __typename?: 'LabelType', id: string, title: string } | null } | null> }, country?: { __typename?: 'CountryType', id: string, isoCode?: string | null } | null } | null, contract?: { __typename?: 'ContractType', id: string } | null, lastDocument?: { __typename?: 'DocumentType', id: string, isSignedBiuro: boolean, isSignedClient: boolean, signingUrl?: string | null, confirmationMethod: DocumentConfirmationMethod, status: DocumentStatus, createDate: any, signedDocument?: string | null } | null, orderclientcontactedSet: { __typename?: 'OrderClientContactedTypeConnection', edges: Array<{ __typename?: 'OrderClientContactedTypeEdge', node?: { __typename?: 'OrderClientContactedType', id: string, date: any, createdBy: { __typename?: 'UserProfileMType', id: string, fullName: string, color?: string | null, profileImage?: string | null } } | null } | null> } };

export type UserProfileFieldsFragment = { __typename?: 'UserProfileMType', id: string, user: { __typename?: 'UserType', id: string, firstName: string, lastName: string, email: string } };

export type ClientInterviewFieldsFragment = { __typename?: 'ClientInterviewType', id: string, workFunctions?: string | null, requirements?: string | null, competences1?: string | null, competences2?: string | null, companyRepresentation?: string | null, workConditions?: string | null, selectionProcess?: string | null, agencyProcessStandart?: string | null };

export type BaseOrderFieldsFragment = { __typename?: 'OrderMType', id: string, orderNumber?: string | null, subtype: OrderSubtype, orderType: OrderOrderType, trafficGeneration: OrderTrafficGeneration, cancellationPeriod?: number | null, salaryInfo?: string | null, shortage: number, compensationForRecruitment: string, canIncreaseSalary?: boolean | null, passCommentToOrder?: boolean | null, canGetBonuses?: boolean | null, isLogoPublicAllowed?: boolean | null, isCompanyInternational?: boolean | null, isCompanyModern?: boolean | null, opportunityToEmployDirectly?: boolean | null, orderCanBeExtended?: boolean | null, orderCanBeExtendedComment?: string | null, plannedTermForProvision?: string | null, provisionOfInformationOnConclusion?: string | null, remunerationAmount?: string | null, warrantyPeriod?: string | null, candidatesToBeProvided?: string | null, minVsdfPayment?: string | null, otherInfo?: string | null, indefiniteOrderInfo?: string | null, workTimeRegistrationSystem?: string | null, language: OrderLanguage, qualification: OrderQualification, displayPlannedTermForProvision?: boolean | null, exportFreetextRequirements?: boolean | null, recruitmentProgressReportFrequency?: OrderRecruitmentProgressReportFrequency | null, reportingFrequencyStartDate?: any | null, company?: { __typename?: 'CompanyType', id: string, status?: string | null, name: string, insightlyId?: number | null, description?: string | null, salesQuestionnaire?: string | null, contactSet: { __typename?: 'ContactTypeConnection', edges: Array<{ __typename?: 'ContactTypeEdge', node?: { __typename?: 'ContactType', id: string, firstName: string, lastName?: string | null, phone?: string | null, email?: string | null, insightlyId?: number | null } | null } | null> }, contractSet: Array<{ __typename?: 'ContractType', id: string, validFromDate?: any | null, validTillDate?: any | null }>, country?: { __typename?: 'CountryType', id: string, isoCode?: string | null, languageIsoCode?: string | null } | null } | null, clientContact?: { __typename?: 'ContactType', id: string, firstName: string, lastName?: string | null, email?: string | null, phone?: string | null } | null, contract?: { __typename?: 'ContractType', id: string } | null, offboardingRoles: { __typename?: 'OffboardingRoleTypeConnection', edges: Array<{ __typename?: 'OffboardingRoleTypeEdge', node?: { __typename?: 'OffboardingRoleType', id: string, name: string, createdAt: any, updatedAt?: any | null, company: { __typename?: 'CompanyType', id: string, name: string }, orders: { __typename?: 'OrderTypeConnection', edges: Array<{ __typename?: 'OrderTypeEdge', node?: { __typename?: 'OrderType', id: string } | null } | null> }, actions?: Array<{ __typename?: 'OffboardingActionType', id: string, description: string, order: number, createdAt: any, role: { __typename?: 'OffboardingRoleType', id: string } } | null> | null } | null } | null> }, projectManager?: { __typename?: 'UserProfileMType', id: string, fullName: string, user: { __typename?: 'UserType', id: string, email: string, firstName: string, lastName: string } } | null, recruiter?: { __typename?: 'UserProfileMType', id: string } | null, biuroSignee?: { __typename?: 'UserProfileMType', id: string } | null, additionalClientContacts: { __typename?: 'ContactTypeConnection', edges: Array<{ __typename?: 'ContactTypeEdge', node?: { __typename?: 'ContactType', id: string, firstName: string, lastName?: string | null, email?: string | null, phone?: string | null } | null } | null> }, region?: { __typename?: 'RegionType', id: string, title: string } | null, additionalRegions: Array<{ __typename?: 'RegionType', id: string, title: string }>, orderperiodSet: Array<{ __typename?: 'OrderPeriodType', id: string, demand: number, dateTo?: any | null, dateFrom: any, longTerm: boolean }>, specification?: { __typename?: 'SpecificationType', id: string, name: string, positionTitle: string, workFunctions?: string | null, address?: string | null, intensity?: SpecificationIntensity | null, onboardingDuration?: string | null, male: boolean, female: boolean, ageFrom?: number | null, isQualificationImprovementPossible: boolean, clientWashesClothes?: boolean | null, ageTo?: number | null, allFunctionsFromFirstDay: boolean, isWorkplaceVideoAllowed: boolean, isWorkplaceVisitAllowed: boolean, isLogoPublicAllowed: boolean, isCompanyModern: boolean, isCompanyInternational: boolean, shiftDuration?: number | null, breakDuration?: number | null, scheduleType?: number | null, shiftPattern?: any | null, scheduleText?: string | null, minExperienceMonths?: number | null, experienceType: SpecificationExperienceType, isSecurityPostPresent?: boolean | null, isMagneticKeyIssued?: boolean | null, whoIssuesMagneticKey?: string | null, additionalRecruitementInformation?: string | null, careerPossibilities?: string | null, requirementsOther?: string | null, canEmployUa: boolean, healthcheckType?: SpecificationHealthcheckType | null, competences: { __typename?: 'CompetenceTypeConnection', edges: Array<{ __typename?: 'CompetenceTypeEdge', node?: { __typename?: 'CompetenceType', id: string, title: string, color?: string | null } | null } | null> }, certificates: Array<{ __typename?: 'CertificateType', id: string, title?: string | null }>, riskFactors: Array<{ __typename?: 'RiskFactorType', id: string, title: string, isDefault: boolean }>, scheduleTypes: Array<{ __typename?: 'ScheduleTypeType', id: string, title: string }>, mandatoryRequirements: Array<{ __typename?: 'RequirementType', id: string, requirement?: string | null }>, optionalRequirements: Array<{ __typename?: 'RequirementType', id: string, requirement?: string | null }>, tagassignmentSet: Array<{ __typename?: 'TagAssignmentType', id: string, comment: string, tag: { __typename?: 'TagType', id: string, key?: string | null, group?: { __typename?: 'TagGroupType', id: string, key: string } | null } }>, salary?: { __typename?: 'SpecificationSalaryType', id: string, hourlyNettoFrom?: number | null, hourlyNettoTo?: number | null, hourlyBruttoFrom?: number | null, hourlyBruttoTo?: number | null, monthlyNettoFrom?: number | null, monthlyNettoTo?: number | null, monthlyBruttoFrom?: number | null, monthlyBruttoTo?: number | null, hourlyNettoFromFilled: boolean, hourlyNettoToFilled: boolean, hourlyBruttoFromFilled: boolean, hourlyBruttoToFilled: boolean, monthlyNettoFromFilled: boolean, monthlyNettoToFilled: boolean, monthlyBruttoFromFilled: boolean, monthlyBruttoToFilled: boolean, useInTemplate: SpecificationSalaryUseInTemplate, description?: string | null, passDescriptionToTemplate?: boolean | null } | null, personalProtectiveEquipmentBiuro: Array<{ __typename?: 'PersonalProtectiveEquipmentType', id: string }>, personalProtectiveEquipmentClient: Array<{ __typename?: 'PersonalProtectiveEquipmentType', id: string }>, ppeItems?: Array<{ __typename?: 'SpecificationPPEType', customEquipment?: string | null, provider: SpecificationPpeProvider } | null> | null } | null, clientInterview?: { __typename?: 'ClientInterviewType', id: string, workFunctions?: string | null, requirements?: string | null, competences1?: string | null, competences2?: string | null, companyRepresentation?: string | null, workConditions?: string | null, selectionProcess?: string | null, agencyProcessStandart?: string | null } | null };

export type CompanyModelMetaFieldsFragment = { __typename?: 'CompanyModelType', id: string, status?: string | null, name: string, description?: string | null, salesQuestionnaire?: string | null, contractSet: Array<{ __typename?: 'ContractType', id: string, validFromDate?: any | null, validTillDate?: any | null, contractor?: { __typename?: 'ContractorType', id: string, logoUrl?: string | null } | null }>, contactSet: { __typename?: 'ContactTypeConnection', edges: Array<{ __typename?: 'ContactTypeEdge', node?: { __typename?: 'ContactType', id: string, firstName: string, lastName?: string | null, canUseInOrder: boolean } | null } | null> }, specificationSet: Array<{ __typename?: 'SpecificationType', id: string, positionTitle: string }> };

export type CandidateRequirementsEvaluationFieldsFragment = { __typename?: 'CandidateRequirementsEvaluationType', id: string, description?: string | null, recordType: CandidateRequirementsEvaluationRecordType, createdAt: any, offerProposition: { __typename?: 'OfferPropositionType', id: string }, requirement?: { __typename?: 'RequirementType', id: string } | null, createdBy: { __typename?: 'UserType', id: string } };

export type CreateContactMutationVariables = Exact<{
  input: ContactInput;
}>;


export type CreateContactMutation = { __typename?: 'Mutation', createContact?: { __typename?: 'CreateContact', contact?: { __typename?: 'ContactType', id: string, firstName: string, lastName?: string | null, email?: string | null, phone?: string | null, insightlyId?: number | null, comment?: string | null, canUseInOrder: boolean } | null } | null };

export type UpdateContactMutationVariables = Exact<{
  id: Scalars['Int'];
  input: ContactInput;
}>;


export type UpdateContactMutation = { __typename?: 'Mutation', updateContact?: { __typename?: 'UpdateContact', contact?: { __typename?: 'ContactType', id: string, firstName: string, lastName?: string | null, email?: string | null, phone?: string | null, insightlyId?: number | null, comment?: string | null, canUseInOrder: boolean } | null } | null };

export type CreateOrderMutationVariables = Exact<{
  order: OrderInput;
  periods?: InputMaybe<Array<InputMaybe<OrderPeriodInput>> | InputMaybe<OrderPeriodInput>>;
}>;


export type CreateOrderMutation = { __typename?: 'Mutation', createOrder?: { __typename?: 'CreateOrder', ok?: boolean | null, order?: { __typename?: 'OrderType', id: string } | null } | null };

export type SubmitOrder2MutationVariables = Exact<{
  input?: InputMaybe<Scalars['Int']>;
}>;


export type SubmitOrder2Mutation = { __typename?: 'Mutation', submitOrder?: { __typename?: 'SubmitOrderMutation', ok?: boolean | null } | null };

export type UploadOrderForSigningMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type UploadOrderForSigningMutation = { __typename?: 'Mutation', initOrderSigning?: { __typename?: 'InitOrderSigningMutation', ok?: boolean | null, order?: { __typename?: 'OrderType', id: string, status?: OrderStatus | null } | null } | null };

export type ResendOrderForSigningMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type ResendOrderForSigningMutation = { __typename?: 'Mutation', resendOrderSigning?: { __typename?: 'ResendOrderSigningMutation', ok?: boolean | null } | null };

export type OfferPropositionCreateMutationVariables = Exact<{
  input: OfferPropositionCreateMutationInput;
}>;


export type OfferPropositionCreateMutation = { __typename?: 'Mutation', offerPropositionCreate?: { __typename?: 'OfferPropositionCreateMutationPayload', offerProposition?: { __typename?: 'OfferPropositionType', id: string, comment?: string | null, personId: number, interested?: OfferPropositionInterested | null, interestedOnCall?: OfferPropositionInterestedOnCall | null, signed: boolean, longListed?: OfferPropositionLongListed | null, order: { __typename?: 'OrderType', id: string }, candidate?: { __typename?: 'CandidateType', id: string } | null } | null } | null };

export type OfferPropositionUpdateMutationVariables = Exact<{
  input: OfferPropositionUpdateMutationInput;
}>;


export type OfferPropositionUpdateMutation = { __typename?: 'Mutation', offerPropositionUpdate?: { __typename?: 'OfferPropositionUpdateMutationPayload', offerProposition?: { __typename?: 'OfferPropositionType', id: string, comment?: string | null, personId: number, interested?: OfferPropositionInterested | null, interestedOnCall?: OfferPropositionInterestedOnCall | null, signed: boolean, longListed?: OfferPropositionLongListed | null, order: { __typename?: 'OrderType', id: string }, candidate?: { __typename?: 'CandidateType', id: string } | null } | null } | null };

export type CreateOrderCommentMutationVariables = Exact<{
  comment: Scalars['String'];
  orderId: Scalars['ID'];
}>;


export type CreateOrderCommentMutation = { __typename?: 'Mutation', createOrderComment?: { __typename?: 'CreateOrderCommentPayload', orderComment?: { __typename?: 'OrderCommentType', id: string, comment?: string | null, createdAt: any } | null } | null };

export type ClientInterviewCreateMutationVariables = Exact<{
  clientInterview: ClientInterviewCreateMutationInput;
}>;


export type ClientInterviewCreateMutation = { __typename?: 'Mutation', clientInterviewCreate?: { __typename?: 'ClientInterviewCreateMutationPayload', clientInterview?: { __typename?: 'ClientInterviewType', id: string } | null } | null };

export type ClientInterviewUpdateMutationVariables = Exact<{
  clientInterview: ClientInterviewUpdateMutationInput;
}>;


export type ClientInterviewUpdateMutation = { __typename?: 'Mutation', clientInterviewUpdate?: { __typename?: 'ClientInterviewUpdateMutationPayload', clientInterview?: { __typename?: 'ClientInterviewType', id: string } | null } | null };

export type OrderDocumentCreateMutationVariables = Exact<{
  orderId: Scalars['ID'];
  documentDate?: InputMaybe<Scalars['Date']>;
  confirmationMethod: DocumentConfirmationMethod;
  orderPeriodIds: Array<Scalars['ID']> | Scalars['ID'];
}>;


export type OrderDocumentCreateMutation = { __typename?: 'Mutation', sendOrderDocumentToClient?: { __typename?: 'CreateDocumentMutationPayload', document?: { __typename?: 'DocumentType', id: string, documentDate?: any | null, confirmationMethod: DocumentConfirmationMethod, generatedDocument?: string | null, order: { __typename?: 'OrderType', id: string, specification?: { __typename?: 'SpecificationType', id: string, positionTitle: string } | null }, orderPeriods: Array<{ __typename?: 'OrderPeriodType', id: string }> } | null } | null };

export type SaveRequirementsMutationMutationVariables = Exact<{
  input: Array<CandidateRequirementsEvaluationInput> | CandidateRequirementsEvaluationInput;
}>;


export type SaveRequirementsMutationMutation = { __typename?: 'Mutation', saveRequirements?: { __typename?: 'SaveRequirementsMutation', candidateRequirementsEvaluations?: Array<{ __typename?: 'CandidateRequirementsEvaluationType', id: string, description?: string | null, recordType: CandidateRequirementsEvaluationRecordType, createdAt: any, offerProposition: { __typename?: 'OfferPropositionType', id: string }, requirement?: { __typename?: 'RequirementType', id: string } | null, createdBy: { __typename?: 'UserType', id: string } } | null> | null } | null };

export type SendOrderSummariesMutationMutationVariables = Exact<{
  companyId?: InputMaybe<Scalars['ID']>;
  dateFrom?: InputMaybe<Scalars['Date']>;
  dateTo?: InputMaybe<Scalars['Date']>;
  orderIds?: InputMaybe<Array<InputMaybe<Scalars['ID']>> | InputMaybe<Scalars['ID']>>;
  emails?: InputMaybe<Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>>;
}>;


export type SendOrderSummariesMutationMutation = { __typename?: 'Mutation', sendOrderSummaries?: { __typename?: 'SendOrderSummariesMutation', ok?: boolean | null } | null };

export type CreateOrderClientContactedMutationVariables = Exact<{
  order: Scalars['ID'];
  date: Scalars['Date'];
}>;


export type CreateOrderClientContactedMutation = { __typename?: 'Mutation', createOrderClientContacted?: { __typename?: 'CreateOrderClientContactedMutationPayload', orderClientContacted?: { __typename?: 'OrderClientContactedType', id: string, date: any, createdBy: { __typename?: 'UserProfileMType', id: string, fullName: string, color?: string | null, profileImage?: string | null } } | null } | null };

export type CreateOrderErrorMutationVariables = Exact<{
  order: Scalars['ID'];
  category: Scalars['ID'];
  comment: Scalars['String'];
}>;


export type CreateOrderErrorMutation = { __typename?: 'Mutation', createOrderError?: { __typename?: 'CreateOrderErrorPayload', orderError?: { __typename?: 'OrderErrorType', id: string, comment: string } | null } | null };

export type GetOrderForTaskCreateQueryVariables = Exact<{
  id?: InputMaybe<Scalars['Int']>;
}>;


export type GetOrderForTaskCreateQuery = { __typename?: 'Query', order?: { __typename?: 'OrderType', id: string, company?: { __typename?: 'CompanyType', id: string, status?: string | null, name: string, insightlyId?: number | null, description?: string | null, salesQuestionnaire?: string | null, contactSet: { __typename?: 'ContactTypeConnection', edges: Array<{ __typename?: 'ContactTypeEdge', node?: { __typename?: 'ContactType', id: string, firstName: string, lastName?: string | null, phone?: string | null, email?: string | null, insightlyId?: number | null } | null } | null> }, contractSet: Array<{ __typename?: 'ContractType', id: string, validFromDate?: any | null, validTillDate?: any | null }>, country?: { __typename?: 'CountryType', id: string, isoCode?: string | null, languageIsoCode?: string | null } | null } | null, specification?: { __typename?: 'SpecificationType', positionTitle: string } | null } | null };

export type GetSpecificationsQueryVariables = Exact<{
  id?: InputMaybe<Scalars['Int']>;
}>;


export type GetSpecificationsQuery = { __typename?: 'Query', specification?: { __typename?: 'SpecificationType', id: string, name: string, positionTitle: string, workFunctions?: string | null, address?: string | null, intensity?: SpecificationIntensity | null, onboardingDuration?: string | null, male: boolean, female: boolean, ageFrom?: number | null, isQualificationImprovementPossible: boolean, clientWashesClothes?: boolean | null, ageTo?: number | null, allFunctionsFromFirstDay: boolean, isWorkplaceVideoAllowed: boolean, isWorkplaceVisitAllowed: boolean, isLogoPublicAllowed: boolean, isCompanyModern: boolean, isCompanyInternational: boolean, shiftDuration?: number | null, breakDuration?: number | null, scheduleType?: number | null, shiftPattern?: any | null, scheduleText?: string | null, minExperienceMonths?: number | null, experienceType: SpecificationExperienceType, isSecurityPostPresent?: boolean | null, isMagneticKeyIssued?: boolean | null, whoIssuesMagneticKey?: string | null, additionalRecruitementInformation?: string | null, careerPossibilities?: string | null, requirementsOther?: string | null, canEmployUa: boolean, healthcheckType?: SpecificationHealthcheckType | null, certificates: Array<{ __typename?: 'CertificateType', id: string, title?: string | null }>, optionalRequirements: Array<{ __typename?: 'RequirementType', id: string, requirement?: string | null }>, personalProtectiveEquipmentBiuro: Array<{ __typename?: 'PersonalProtectiveEquipmentType', id: string }>, personalProtectiveEquipmentClient: Array<{ __typename?: 'PersonalProtectiveEquipmentType', id: string }>, riskFactors: Array<{ __typename?: 'RiskFactorType', id: string, title: string, isDefault: boolean }>, competences: { __typename?: 'CompetenceTypeConnection', edges: Array<{ __typename?: 'CompetenceTypeEdge', node?: { __typename?: 'CompetenceType', id: string, title: string, color?: string | null } | null } | null> }, scheduleTypes: Array<{ __typename?: 'ScheduleTypeType', id: string, title: string }>, mandatoryRequirements: Array<{ __typename?: 'RequirementType', id: string, requirement?: string | null }>, tagassignmentSet: Array<{ __typename?: 'TagAssignmentType', id: string, comment: string, tag: { __typename?: 'TagType', id: string, key?: string | null, group?: { __typename?: 'TagGroupType', id: string, key: string } | null } }>, salary?: { __typename?: 'SpecificationSalaryType', id: string, hourlyNettoFrom?: number | null, hourlyNettoTo?: number | null, hourlyBruttoFrom?: number | null, hourlyBruttoTo?: number | null, monthlyNettoFrom?: number | null, monthlyNettoTo?: number | null, monthlyBruttoFrom?: number | null, monthlyBruttoTo?: number | null, hourlyNettoFromFilled: boolean, hourlyNettoToFilled: boolean, hourlyBruttoFromFilled: boolean, hourlyBruttoToFilled: boolean, monthlyNettoFromFilled: boolean, monthlyNettoToFilled: boolean, monthlyBruttoFromFilled: boolean, monthlyBruttoToFilled: boolean, useInTemplate: SpecificationSalaryUseInTemplate, description?: string | null, passDescriptionToTemplate?: boolean | null } | null, ppeItems?: Array<{ __typename?: 'SpecificationPPEType', customEquipment?: string | null, provider: SpecificationPpeProvider } | null> | null } | null };

export type GetPaginatedOrderForTableQueryVariables = Exact<{
  status?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  after?: InputMaybe<Scalars['String']>;
  search?: InputMaybe<Scalars['String']>;
  region?: InputMaybe<Scalars['String']>;
  specification?: InputMaybe<Scalars['String']>;
  unseenProcessedOrders?: InputMaybe<Scalars['Boolean']>;
  companies?: InputMaybe<Scalars['String']>;
  orderBy?: InputMaybe<Scalars['String']>;
  orderType?: InputMaybe<Scalars['String']>;
  keyAccountManager?: InputMaybe<Scalars['ID']>;
  trafficGeneration?: InputMaybe<Scalars['String']>;
  covidPolicy?: InputMaybe<Array<InputMaybe<Scalars['ID']>> | InputMaybe<Scalars['ID']>>;
  country?: InputMaybe<Scalars['ID']>;
  periodDateFrom?: InputMaybe<Scalars['Date']>;
  periodDateTo?: InputMaybe<Scalars['Date']>;
}>;


export type GetPaginatedOrderForTableQuery = { __typename?: 'Query', regions?: Array<{ __typename?: 'RegionType', id: string, title: string, regionmetrics?: { __typename?: 'RegionMetricType', id: string, lifetime?: number | null } | null } | null> | null, ordersPaginated?: { __typename?: 'OrderTypeConnection', totalCount?: number | null, pageInfo: { __typename?: 'PageInfo', startCursor?: string | null, endCursor?: string | null, hasNextPage: boolean }, edges: Array<{ __typename?: 'OrderTypeEdge', node?: { __typename?: 'OrderType', id: string, hourRateBruttoPermanent?: number | null, orderNumber?: string | null, subtype: OrderSubtype, dateFrom?: any | null, dateTo?: any | null, isLongTerm?: boolean | null, demand?: number | null, orderType: OrderOrderType, orderDate?: any | null, priority?: OrderPriority | null, trafficGeneration: OrderTrafficGeneration, status?: OrderStatus | null, nettoFrom?: number | null, nettoTo?: number | null, shortage: number, ordermetrics?: { __typename?: 'OrderMetricType', id: string, lifetime?: number | null, effortConversion?: number | null, totalCalls?: number | null, successfulCalls?: number | null, totalInterviews?: number | null, successfulInterviews?: number | null } | null, region?: { __typename?: 'RegionType', id: string, title: string, regionmetrics?: { __typename?: 'RegionMetricType', id: string, lifetime?: number | null, effortConversion?: number | null, totalCalls?: number | null, successfulCalls?: number | null, totalInverviews?: number | null, successfulInterviews?: number | null } | null, regionthresholdsettings?: { __typename?: 'RegionThresholdSettingsType', minOffersExpected?: number | null } | null } | null, ordercommentSet: { __typename?: 'OrderCommentTypeConnection', edges: Array<{ __typename?: 'OrderCommentTypeEdge', node?: { __typename?: 'OrderCommentType', id: string, comment?: string | null, createdAt: any } | null } | null> }, projectManager?: { __typename?: 'UserProfileMType', id: string, user: { __typename?: 'UserType', id: string, firstName: string, lastName: string } } | null, recruiter?: { __typename?: 'UserProfileMType', id: string, user: { __typename?: 'UserType', id: string, firstName: string, lastName: string } } | null, specification?: { __typename?: 'SpecificationType', id: string, positionTitle: string, address?: string | null, salary?: { __typename?: 'SpecificationSalaryType', id: string, hourlyBruttoFrom?: number | null, hourlyBruttoTo?: number | null, monthlyBruttoFrom?: number | null, monthlyBruttoTo?: number | null, hourlyBruttoFromFilled: boolean, hourlyBruttoToFilled: boolean, monthlyBruttoFromFilled: boolean, monthlyBruttoToFilled: boolean, useInTemplate: SpecificationSalaryUseInTemplate } | null } | null, createdBy?: { __typename?: 'UserProfileMType', id: string, user: { __typename?: 'UserType', id: string, email: string, firstName: string, lastName: string } } | null, clientContact?: { __typename?: 'ContactType', id: string, email?: string | null, firstName: string, lastName?: string | null } | null, company?: { __typename?: 'CompanyType', id: string, status?: string | null, name: string, color: HistoricalCompanyColor, labels: { __typename?: 'LabelTypeConnection', edges: Array<{ __typename?: 'LabelTypeEdge', node?: { __typename?: 'LabelType', id: string, title: string } | null } | null> }, country?: { __typename?: 'CountryType', id: string, isoCode?: string | null } | null } | null, contract?: { __typename?: 'ContractType', id: string } | null, lastDocument?: { __typename?: 'DocumentType', id: string, isSignedBiuro: boolean, isSignedClient: boolean, signingUrl?: string | null, confirmationMethod: DocumentConfirmationMethod, status: DocumentStatus, createDate: any, signedDocument?: string | null } | null, orderclientcontactedSet: { __typename?: 'OrderClientContactedTypeConnection', edges: Array<{ __typename?: 'OrderClientContactedTypeEdge', node?: { __typename?: 'OrderClientContactedType', id: string, date: any, createdBy: { __typename?: 'UserProfileMType', id: string, fullName: string, color?: string | null, profileImage?: string | null } } | null } | null> } } | null } | null> } | null };

export type GetOrderForTaskCreateSearchQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
}>;


export type GetOrderForTaskCreateSearchQuery = { __typename?: 'Query', ordersPaginated?: { __typename?: 'OrderTypeConnection', edges: Array<{ __typename?: 'OrderTypeEdge', node?: { __typename?: 'OrderType', id: string, company?: { __typename?: 'CompanyType', id: string, status?: string | null, name: string, insightlyId?: number | null, description?: string | null, salesQuestionnaire?: string | null, contactSet: { __typename?: 'ContactTypeConnection', edges: Array<{ __typename?: 'ContactTypeEdge', node?: { __typename?: 'ContactType', id: string, firstName: string, lastName?: string | null, phone?: string | null, email?: string | null, insightlyId?: number | null } | null } | null> }, contractSet: Array<{ __typename?: 'ContractType', id: string, validFromDate?: any | null, validTillDate?: any | null }>, country?: { __typename?: 'CountryType', id: string, isoCode?: string | null, languageIsoCode?: string | null } | null } | null, specification?: { __typename?: 'SpecificationType', positionTitle: string } | null } | null } | null> } | null };

export type GetOrderCommentsQueryVariables = Exact<{
  orderId?: InputMaybe<Scalars['ID']>;
}>;


export type GetOrderCommentsQuery = { __typename?: 'Query', orderComments?: { __typename?: 'OrderCommentTypeConnection', edges: Array<{ __typename?: 'OrderCommentTypeEdge', node?: { __typename?: 'OrderCommentType', id: string, comment?: string | null, createdAt: any } | null } | null> } | null };

export type GetOrderPeriodsQueryVariables = Exact<{
  orderId: Scalars['ID'];
}>;


export type GetOrderPeriodsQuery = { __typename?: 'Query', orderModel?: { __typename?: 'OrderMType', id: string, orderperiodSet: Array<{ __typename?: 'OrderPeriodType', id: string, demand: number, dateTo?: any | null, dateFrom: any, longTerm: boolean }> } | null };

export type GetUserProfilesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetUserProfilesQuery = { __typename?: 'Query', userprofiles?: Array<{ __typename?: 'UserProfileMType', id: string, user: { __typename?: 'UserType', id: string, firstName: string, lastName: string, email: string } } | null> | null };

export type GetUserProfileCountryQueryVariables = Exact<{ [key: string]: never; }>;


export type GetUserProfileCountryQuery = { __typename?: 'Query', userprofile?: { __typename?: 'UserProfileMType', region?: { __typename?: 'RegionType', country?: { __typename?: 'CountryType', id: string, isoCode?: string | null } | null } | null } | null };

export type GetLastOrdersCreatedQueryVariables = Exact<{
  companyId: Scalars['ID'];
  orderBy?: InputMaybe<Scalars['String']>;
}>;


export type GetLastOrdersCreatedQuery = { __typename?: 'Query', orders?: { __typename?: 'OrderMTypeConnection', edges: Array<{ __typename?: 'OrderMTypeEdge', node?: { __typename?: 'OrderMType', id: string, orderType: OrderOrderType, createdDate: any, specification?: { __typename?: 'SpecificationType', id: string, positionTitle: string } | null, region?: { __typename?: 'RegionType', id: string, title: string } | null } | null } | null> } | null };

export type OrderEditCompanyDataQueryVariables = Exact<{
  companyId: Scalars['ID'];
}>;


export type OrderEditCompanyDataQuery = { __typename?: 'Query', userprofiles?: Array<{ __typename?: 'UserProfileMType', id: string, user: { __typename?: 'UserType', id: string, firstName: string, lastName: string, email: string } } | null> | null, regions?: Array<{ __typename?: 'RegionType', id: string, title: string, regionmetrics?: { __typename?: 'RegionMetricType', id: string, lifetime?: number | null } | null } | null> | null, company?: { __typename?: 'CompanyModelType', id: string, status?: string | null, name: string, description?: string | null, salesQuestionnaire?: string | null, contractSet: Array<{ __typename?: 'ContractType', id: string, validFromDate?: any | null, validTillDate?: any | null, contractor?: { __typename?: 'ContractorType', id: string, logoUrl?: string | null } | null }>, contactSet: { __typename?: 'ContactTypeConnection', edges: Array<{ __typename?: 'ContactTypeEdge', node?: { __typename?: 'ContactType', id: string, firstName: string, lastName?: string | null, canUseInOrder: boolean } | null } | null> }, specificationSet: Array<{ __typename?: 'SpecificationType', id: string, positionTitle: string }> } | null };

export type OrderEditMetadataQueryVariables = Exact<{
  companyId: Scalars['ID'];
}>;


export type OrderEditMetadataQuery = { __typename?: 'Query', userprofiles?: Array<{ __typename?: 'UserProfileMType', id: string, user: { __typename?: 'UserType', id: string, firstName: string, lastName: string, email: string } } | null> | null, regions?: Array<{ __typename?: 'RegionType', id: string, title: string, regionmetrics?: { __typename?: 'RegionMetricType', id: string, lifetime?: number | null } | null } | null> | null, companies?: { __typename?: 'CompanyTypeConnection', totalCount?: number | null, pageInfo: { __typename?: 'PageInfo', startCursor?: string | null, endCursor?: string | null, hasNextPage: boolean }, edges: Array<{ __typename?: 'CompanyTypeEdge', node?: { __typename?: 'CompanyType', id: string, status?: string | null, name: string, description?: string | null, contractSet: Array<{ __typename?: 'ContractType', id: string, validFromDate?: any | null, validTillDate?: any | null, contractor?: { __typename?: 'ContractorType', id: string, logoUrl?: string | null } | null }>, contactSet: { __typename?: 'ContactTypeConnection', edges: Array<{ __typename?: 'ContactTypeEdge', node?: { __typename?: 'ContactType', id: string, firstName: string, lastName?: string | null } | null } | null> }, specificationSet: Array<{ __typename?: 'SpecificationType', id: string, positionTitle: string }> } | null } | null> } | null };

export type GetOrderForPrefillQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GetOrderForPrefillQuery = { __typename?: 'Query', orderModel?: { __typename?: 'OrderMType', id: string, orderNumber?: string | null, subtype: OrderSubtype, orderType: OrderOrderType, trafficGeneration: OrderTrafficGeneration, cancellationPeriod?: number | null, salaryInfo?: string | null, shortage: number, compensationForRecruitment: string, canIncreaseSalary?: boolean | null, passCommentToOrder?: boolean | null, canGetBonuses?: boolean | null, isLogoPublicAllowed?: boolean | null, isCompanyInternational?: boolean | null, isCompanyModern?: boolean | null, opportunityToEmployDirectly?: boolean | null, orderCanBeExtended?: boolean | null, orderCanBeExtendedComment?: string | null, plannedTermForProvision?: string | null, provisionOfInformationOnConclusion?: string | null, remunerationAmount?: string | null, warrantyPeriod?: string | null, candidatesToBeProvided?: string | null, minVsdfPayment?: string | null, otherInfo?: string | null, indefiniteOrderInfo?: string | null, workTimeRegistrationSystem?: string | null, language: OrderLanguage, qualification: OrderQualification, displayPlannedTermForProvision?: boolean | null, exportFreetextRequirements?: boolean | null, recruitmentProgressReportFrequency?: OrderRecruitmentProgressReportFrequency | null, reportingFrequencyStartDate?: any | null, ordererrorSet: { __typename?: 'OrderErrorTypeConnection', edges: Array<{ __typename?: 'OrderErrorTypeEdge', node?: { __typename?: 'OrderErrorType', id: string, comment: string, createdAt: any, category: { __typename?: 'OrderErrorCategoryType', title?: string | null } } | null } | null> }, company?: { __typename?: 'CompanyType', id: string, status?: string | null, name: string, insightlyId?: number | null, description?: string | null, salesQuestionnaire?: string | null, contactSet: { __typename?: 'ContactTypeConnection', edges: Array<{ __typename?: 'ContactTypeEdge', node?: { __typename?: 'ContactType', id: string, firstName: string, lastName?: string | null, phone?: string | null, email?: string | null, insightlyId?: number | null } | null } | null> }, contractSet: Array<{ __typename?: 'ContractType', id: string, validFromDate?: any | null, validTillDate?: any | null }>, country?: { __typename?: 'CountryType', id: string, isoCode?: string | null, languageIsoCode?: string | null } | null } | null, clientContact?: { __typename?: 'ContactType', id: string, firstName: string, lastName?: string | null, email?: string | null, phone?: string | null } | null, contract?: { __typename?: 'ContractType', id: string } | null, offboardingRoles: { __typename?: 'OffboardingRoleTypeConnection', edges: Array<{ __typename?: 'OffboardingRoleTypeEdge', node?: { __typename?: 'OffboardingRoleType', id: string, name: string, createdAt: any, updatedAt?: any | null, company: { __typename?: 'CompanyType', id: string, name: string }, orders: { __typename?: 'OrderTypeConnection', edges: Array<{ __typename?: 'OrderTypeEdge', node?: { __typename?: 'OrderType', id: string } | null } | null> }, actions?: Array<{ __typename?: 'OffboardingActionType', id: string, description: string, order: number, createdAt: any, role: { __typename?: 'OffboardingRoleType', id: string } } | null> | null } | null } | null> }, projectManager?: { __typename?: 'UserProfileMType', id: string, fullName: string, user: { __typename?: 'UserType', id: string, email: string, firstName: string, lastName: string } } | null, recruiter?: { __typename?: 'UserProfileMType', id: string } | null, biuroSignee?: { __typename?: 'UserProfileMType', id: string } | null, additionalClientContacts: { __typename?: 'ContactTypeConnection', edges: Array<{ __typename?: 'ContactTypeEdge', node?: { __typename?: 'ContactType', id: string, firstName: string, lastName?: string | null, email?: string | null, phone?: string | null } | null } | null> }, region?: { __typename?: 'RegionType', id: string, title: string } | null, additionalRegions: Array<{ __typename?: 'RegionType', id: string, title: string }>, orderperiodSet: Array<{ __typename?: 'OrderPeriodType', id: string, demand: number, dateTo?: any | null, dateFrom: any, longTerm: boolean }>, specification?: { __typename?: 'SpecificationType', id: string, name: string, positionTitle: string, workFunctions?: string | null, address?: string | null, intensity?: SpecificationIntensity | null, onboardingDuration?: string | null, male: boolean, female: boolean, ageFrom?: number | null, isQualificationImprovementPossible: boolean, clientWashesClothes?: boolean | null, ageTo?: number | null, allFunctionsFromFirstDay: boolean, isWorkplaceVideoAllowed: boolean, isWorkplaceVisitAllowed: boolean, isLogoPublicAllowed: boolean, isCompanyModern: boolean, isCompanyInternational: boolean, shiftDuration?: number | null, breakDuration?: number | null, scheduleType?: number | null, shiftPattern?: any | null, scheduleText?: string | null, minExperienceMonths?: number | null, experienceType: SpecificationExperienceType, isSecurityPostPresent?: boolean | null, isMagneticKeyIssued?: boolean | null, whoIssuesMagneticKey?: string | null, additionalRecruitementInformation?: string | null, careerPossibilities?: string | null, requirementsOther?: string | null, canEmployUa: boolean, healthcheckType?: SpecificationHealthcheckType | null, competences: { __typename?: 'CompetenceTypeConnection', edges: Array<{ __typename?: 'CompetenceTypeEdge', node?: { __typename?: 'CompetenceType', id: string, title: string, color?: string | null } | null } | null> }, certificates: Array<{ __typename?: 'CertificateType', id: string, title?: string | null }>, riskFactors: Array<{ __typename?: 'RiskFactorType', id: string, title: string, isDefault: boolean }>, scheduleTypes: Array<{ __typename?: 'ScheduleTypeType', id: string, title: string }>, mandatoryRequirements: Array<{ __typename?: 'RequirementType', id: string, requirement?: string | null }>, optionalRequirements: Array<{ __typename?: 'RequirementType', id: string, requirement?: string | null }>, tagassignmentSet: Array<{ __typename?: 'TagAssignmentType', id: string, comment: string, tag: { __typename?: 'TagType', id: string, key?: string | null, group?: { __typename?: 'TagGroupType', id: string, key: string } | null } }>, salary?: { __typename?: 'SpecificationSalaryType', id: string, hourlyNettoFrom?: number | null, hourlyNettoTo?: number | null, hourlyBruttoFrom?: number | null, hourlyBruttoTo?: number | null, monthlyNettoFrom?: number | null, monthlyNettoTo?: number | null, monthlyBruttoFrom?: number | null, monthlyBruttoTo?: number | null, hourlyNettoFromFilled: boolean, hourlyNettoToFilled: boolean, hourlyBruttoFromFilled: boolean, hourlyBruttoToFilled: boolean, monthlyNettoFromFilled: boolean, monthlyNettoToFilled: boolean, monthlyBruttoFromFilled: boolean, monthlyBruttoToFilled: boolean, useInTemplate: SpecificationSalaryUseInTemplate, description?: string | null, passDescriptionToTemplate?: boolean | null } | null, personalProtectiveEquipmentBiuro: Array<{ __typename?: 'PersonalProtectiveEquipmentType', id: string }>, personalProtectiveEquipmentClient: Array<{ __typename?: 'PersonalProtectiveEquipmentType', id: string }>, ppeItems?: Array<{ __typename?: 'SpecificationPPEType', customEquipment?: string | null, provider: SpecificationPpeProvider } | null> | null } | null, clientInterview?: { __typename?: 'ClientInterviewType', id: string, workFunctions?: string | null, requirements?: string | null, competences1?: string | null, competences2?: string | null, companyRepresentation?: string | null, workConditions?: string | null, selectionProcess?: string | null, agencyProcessStandart?: string | null } | null } | null };

export type GetRegionsRelayQueryVariables = Exact<{
  country: Scalars['ID'];
}>;


export type GetRegionsRelayQuery = { __typename?: 'Query', regionsRelay?: { __typename?: 'RegionMTypeConnection', totalCount?: number | null, edges: Array<{ __typename?: 'RegionMTypeEdge', node?: { __typename?: 'RegionMType', id: string, title: string, isActive: boolean, country?: { __typename?: 'CountryType', id: string, title: string, isoCode?: string | null } | null } | null } | null> } | null };

export type GetOrderDocumentsQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GetOrderDocumentsQuery = { __typename?: 'Query', documents?: { __typename?: 'DocumentTypeConnection', edges: Array<{ __typename?: 'DocumentTypeEdge', node?: { __typename?: 'DocumentType', id: string, isSignedBiuro: boolean, isSignedClient: boolean, signingUrl?: string | null, confirmationMethod: DocumentConfirmationMethod, status: DocumentStatus, createDate: any, signedDocument?: string | null } | null } | null> } | null };

export type GetOrderRequirementsAndCandidateEvaluationsQueryVariables = Exact<{
  orderId: Scalars['ID'];
  offerPropositionId: Scalars['ID'];
}>;


export type GetOrderRequirementsAndCandidateEvaluationsQuery = { __typename?: 'Query', orderModel?: { __typename?: 'OrderMType', id: string, language: OrderLanguage, specification?: { __typename?: 'SpecificationType', id: string, mandatoryRequirements: Array<{ __typename?: 'RequirementType', id: string, requirement?: string | null }> } | null } | null, candidateEvaluations?: { __typename?: 'CandidateRequirementsEvaluationTypeConnection', edges: Array<{ __typename?: 'CandidateRequirementsEvaluationTypeEdge', node?: { __typename?: 'CandidateRequirementsEvaluationType', id: string, recordType: CandidateRequirementsEvaluationRecordType, description?: string | null, requirement?: { __typename?: 'RequirementType', id: string, requirement?: string | null } | null } | null } | null> } | null };

export type GetCandidateNameQueryVariables = Exact<{
  livasId: Scalars['Int'];
}>;


export type GetCandidateNameQuery = { __typename?: 'Query', candidate?: { __typename?: 'CandidateType', id: string, livasId: number, firstName: string, lastName: string } | null };

export type GetCandidatesEvaluationsQueryVariables = Exact<{
  orderId: Scalars['ID'];
}>;


export type GetCandidatesEvaluationsQuery = { __typename?: 'Query', candidateEvaluations?: { __typename?: 'CandidateRequirementsEvaluationTypeConnection', edges: Array<{ __typename?: 'CandidateRequirementsEvaluationTypeEdge', node?: { __typename?: 'CandidateRequirementsEvaluationType', id: string, recordType: CandidateRequirementsEvaluationRecordType, description?: string | null, offerProposition: { __typename?: 'OfferPropositionType', id: string, candidate?: { __typename?: 'CandidateType', id: string, livasId: number, firstName: string, lastName: string, country: { __typename?: 'CountryType', id: string, isoCode?: string | null } } | null }, requirement?: { __typename?: 'RequirementType', id: string, requirement?: string | null } | null } | null } | null> } | null, orderModel?: { __typename?: 'OrderMType', id: string, language: OrderLanguage, specification?: { __typename?: 'SpecificationType', id: string, mandatoryRequirements: Array<{ __typename?: 'RequirementType', id: string, requirement?: string | null }> } | null } | null };

export type GetOrderErrorCategoriesQueryVariables = Exact<{
  isActive?: InputMaybe<Scalars['Boolean']>;
}>;


export type GetOrderErrorCategoriesQuery = { __typename?: 'Query', orderErrorCategories?: { __typename?: 'OrderErrorCategoryTypeConnection', edges: Array<{ __typename?: 'OrderErrorCategoryTypeEdge', node?: { __typename?: 'OrderErrorCategoryType', id: string, title?: string | null } | null } | null> } | null };

export type GetFilterRegionQueryVariables = Exact<{ [key: string]: never; }>;


export type GetFilterRegionQuery = { __typename?: 'Query', userprofile?: { __typename?: 'UserProfileMType', id: string, region?: { __typename?: 'RegionType', country?: { __typename?: 'CountryType', id: string, isoCode?: string | null } | null } | null } | null };

export type TaskScheduleFieldsFragment = { __typename?: 'ScheduleType', id: string, endDate?: any | null, recurrencePeriod: ScheduleRecurrencePeriod, intervalCount: number, dayOfWeek?: number | null, weekOfMonth?: number | null, dayOfMonth?: number | null, parentTask: { __typename?: 'TaskType', id: string } };

export type CreateOperationsTaskMutationVariables = Exact<{
  company?: InputMaybe<Scalars['ID']>;
  country?: InputMaybe<Scalars['ID']>;
  category?: InputMaybe<Scalars['ID']>;
  nextActionCategory?: InputMaybe<Scalars['ID']>;
  order?: InputMaybe<Scalars['ID']>;
  date: Scalars['Date'];
  comment: Scalars['String'];
  completedBy?: InputMaybe<Array<InputMaybe<Scalars['ID']>> | InputMaybe<Scalars['ID']>>;
  durationMinutes?: InputMaybe<Scalars['Int']>;
  status?: InputMaybe<TaskStatus>;
  sendNotificationToAssignee?: InputMaybe<Scalars['Boolean']>;
  dashboard?: InputMaybe<Scalars['ID']>;
  nextTaskAssignee?: InputMaybe<Scalars['ID']>;
  candidateLivasEmployeeId?: InputMaybe<Scalars['ID']>;
  dashboards?: InputMaybe<Array<InputMaybe<Scalars['ID']>> | InputMaybe<Scalars['ID']>>;
}>;


export type CreateOperationsTaskMutation = { __typename?: 'Mutation', createOperationsTask?: { __typename?: 'CreateOperationsTaskPayload', task?: { __typename?: 'TaskType', id: string, status: TaskStatus, durationMinutes?: number | null, countryIsoCode?: string | null, numPreviousTasks?: number | null, comment?: string | null, date: any, nextActionDate?: any | null, createdAt: any, dashboards: { __typename?: 'DashboardTypeConnection', edges: Array<{ __typename?: 'DashboardTypeEdge', node?: { __typename?: 'DashboardType', id: string, title: string } | null } | null> }, order?: { __typename?: 'OrderType', id: string, company?: { __typename?: 'CompanyType', id: string, name: string } | null, specification?: { __typename?: 'SpecificationType', id: string, positionTitle: string } | null } | null, category?: { __typename?: 'SACategoryType', id: string, title: string } | null, company?: { __typename?: 'CompanyType', id: string, name: string, status?: string | null, country?: { __typename?: 'CountryType', id: string, isoCode?: string | null } | null } | null, completedBy?: Array<{ __typename?: 'UserProfileMType', id: string, fullName: string, color?: string | null, user: { __typename?: 'UserType', id: string, firstName: string, lastName: string } } | null> | null, nextTaskAssignee?: { __typename?: 'UserProfileMType', id: string, fullName: string, color?: string | null, user: { __typename?: 'UserType', id: string, firstName: string, lastName: string } } | null, country?: { __typename?: 'CountryType', id: string, isoCode?: string | null } | null, candidate?: { __typename?: 'CandidateType', id: string, livasId: number, firstName: string, lastName: string, employeeLivasId?: number | null } | null, schedules: { __typename?: 'ScheduleTypeConnection', edges: Array<{ __typename?: 'ScheduleTypeEdge', node?: { __typename?: 'ScheduleType', id: string, endDate?: any | null, recurrencePeriod: ScheduleRecurrencePeriod, intervalCount: number, dayOfWeek?: number | null, weekOfMonth?: number | null, dayOfMonth?: number | null, parentTask: { __typename?: 'TaskType', id: string } } | null } | null> }, createdBySchedule?: { __typename?: 'ScheduleType', id: string, endDate?: any | null, recurrencePeriod: ScheduleRecurrencePeriod, intervalCount: number, dayOfWeek?: number | null, weekOfMonth?: number | null, dayOfMonth?: number | null, parentTask: { __typename?: 'TaskType', id: string } } | null, taskSet: { __typename?: 'TaskTypeConnection', edges: Array<{ __typename?: 'TaskTypeEdge', node?: { __typename?: 'TaskType', id: string, createdAt: any, date: any } | null } | null> }, dashboard?: { __typename?: 'DashboardType', id: string, title: string } | null, metricvalueSet: { __typename?: 'MetricValueTypeConnection', edges: Array<{ __typename?: 'MetricValueTypeEdge', node?: { __typename?: 'MetricValueType', id: string, value: number, date: any, manager?: { __typename?: 'UserProfileMType', id: string, fullName: string } | null, client?: { __typename?: 'CompanyType', id: string, name: string, livasId?: number | null } | null, candidate?: { __typename?: 'CandidateType', id: string, livasId: number, employeeLivasId?: number | null, firstName: string, lastName: string } | null, metricGroup?: { __typename?: 'MetricGroupType', id: string, title: string } | null, metricvaluecommentSet: { __typename?: 'MetricValueCommentTypeConnection', edges: Array<{ __typename?: 'MetricValueCommentTypeEdge', node?: { __typename?: 'MetricValueCommentType', id: string, comment: string, metricClientReason?: { __typename?: 'MetricValueClientReasonType', id: string, title: string } | null, clients: { __typename?: 'CompanyTypeConnection', edges: Array<{ __typename?: 'CompanyTypeEdge', node?: { __typename?: 'CompanyType', id: string, name: string } | null } | null> }, candidates: { __typename?: 'CandidateTypeConnection', edges: Array<{ __typename?: 'CandidateTypeEdge', node?: { __typename?: 'CandidateType', id: string, livasId: number, employeeLivasId?: number | null, firstName: string, lastName: string } | null } | null> } } | null } | null> } } | null } | null> }, metricvalueLevel2: { __typename?: 'MetricValueTypeConnection', edges: Array<{ __typename?: 'MetricValueTypeEdge', node?: { __typename?: 'MetricValueType', id: string, value: number, date: any, manager?: { __typename?: 'UserProfileMType', id: string, fullName: string } | null, client?: { __typename?: 'CompanyType', id: string, name: string, livasId?: number | null } | null, candidate?: { __typename?: 'CandidateType', id: string, livasId: number, employeeLivasId?: number | null, firstName: string, lastName: string } | null, metricGroup?: { __typename?: 'MetricGroupType', id: string, title: string } | null, metricvaluecommentSet: { __typename?: 'MetricValueCommentTypeConnection', edges: Array<{ __typename?: 'MetricValueCommentTypeEdge', node?: { __typename?: 'MetricValueCommentType', id: string, comment: string, metricClientReason?: { __typename?: 'MetricValueClientReasonType', id: string, title: string } | null, clients: { __typename?: 'CompanyTypeConnection', edges: Array<{ __typename?: 'CompanyTypeEdge', node?: { __typename?: 'CompanyType', id: string, name: string } | null } | null> }, candidates: { __typename?: 'CandidateTypeConnection', edges: Array<{ __typename?: 'CandidateTypeEdge', node?: { __typename?: 'CandidateType', id: string, livasId: number, employeeLivasId?: number | null, firstName: string, lastName: string } | null } | null> } } | null } | null> } } | null } | null> } } | null } | null };

export type CreateMetricValueCommentMutationVariables = Exact<{
  metricValue: Scalars['ID'];
  comment?: InputMaybe<Scalars['String']>;
}>;


export type CreateMetricValueCommentMutation = { __typename?: 'Mutation', createMetricValueComment?: { __typename?: 'CreateMetricValueCommentPayload', metricValueComment?: { __typename?: 'MetricValueCommentType', id: string } | null } | null };

export type CreateMetricValueInputMutationVariables = Exact<{
  client?: InputMaybe<Scalars['ID']>;
  createdBy?: InputMaybe<Scalars['ID']>;
  date: Scalars['Date'];
  isImportant: Scalars['Boolean'];
  manager?: InputMaybe<Scalars['ID']>;
  metricGroup: Scalars['ID'];
  order?: InputMaybe<Scalars['ID']>;
  value: Scalars['Float'];
}>;


export type CreateMetricValueInputMutation = { __typename?: 'Mutation', createMetricValue?: { __typename?: 'CreateMetricValuePayload', metricValue?: { __typename?: 'MetricValueType', id: string } | null } | null };

export type UpdateOperationsTaskMutationVariables = Exact<{
  taskId: Scalars['ID'];
  status?: InputMaybe<TaskStatus>;
  order?: InputMaybe<Scalars['ID']>;
  company?: InputMaybe<Scalars['ID']>;
  category?: InputMaybe<Scalars['ID']>;
  date?: InputMaybe<Scalars['Date']>;
  comment?: InputMaybe<Scalars['String']>;
  completedBy?: InputMaybe<Array<InputMaybe<Scalars['ID']>> | InputMaybe<Scalars['ID']>>;
  durationMinutes?: InputMaybe<Scalars['Int']>;
  country?: InputMaybe<Scalars['ID']>;
  nextActionCategory?: InputMaybe<Scalars['ID']>;
  nextActionDate?: InputMaybe<Scalars['Date']>;
  dashboard?: InputMaybe<Scalars['ID']>;
  nextTaskAssignee?: InputMaybe<Scalars['ID']>;
  isImportant?: InputMaybe<Scalars['Boolean']>;
  dashboards?: InputMaybe<Array<InputMaybe<Scalars['ID']>> | InputMaybe<Scalars['ID']>>;
}>;


export type UpdateOperationsTaskMutation = { __typename?: 'Mutation', updateOperationsTask?: { __typename?: 'UpdateOperationsTaskPayload', task?: { __typename?: 'TaskType', isImportant: boolean, id: string, status: TaskStatus, durationMinutes?: number | null, countryIsoCode?: string | null, numPreviousTasks?: number | null, comment?: string | null, date: any, nextActionDate?: any | null, createdAt: any, dashboards: { __typename?: 'DashboardTypeConnection', edges: Array<{ __typename?: 'DashboardTypeEdge', node?: { __typename?: 'DashboardType', id: string, title: string } | null } | null> }, order?: { __typename?: 'OrderType', id: string, company?: { __typename?: 'CompanyType', id: string, name: string } | null, specification?: { __typename?: 'SpecificationType', id: string, positionTitle: string } | null } | null, category?: { __typename?: 'SACategoryType', id: string, title: string } | null, company?: { __typename?: 'CompanyType', id: string, name: string, status?: string | null, country?: { __typename?: 'CountryType', id: string, isoCode?: string | null } | null } | null, completedBy?: Array<{ __typename?: 'UserProfileMType', id: string, fullName: string, color?: string | null, user: { __typename?: 'UserType', id: string, firstName: string, lastName: string } } | null> | null, nextTaskAssignee?: { __typename?: 'UserProfileMType', id: string, fullName: string, color?: string | null, user: { __typename?: 'UserType', id: string, firstName: string, lastName: string } } | null, country?: { __typename?: 'CountryType', id: string, isoCode?: string | null } | null, candidate?: { __typename?: 'CandidateType', id: string, livasId: number, firstName: string, lastName: string, employeeLivasId?: number | null } | null, schedules: { __typename?: 'ScheduleTypeConnection', edges: Array<{ __typename?: 'ScheduleTypeEdge', node?: { __typename?: 'ScheduleType', id: string, endDate?: any | null, recurrencePeriod: ScheduleRecurrencePeriod, intervalCount: number, dayOfWeek?: number | null, weekOfMonth?: number | null, dayOfMonth?: number | null, parentTask: { __typename?: 'TaskType', id: string } } | null } | null> }, createdBySchedule?: { __typename?: 'ScheduleType', id: string, endDate?: any | null, recurrencePeriod: ScheduleRecurrencePeriod, intervalCount: number, dayOfWeek?: number | null, weekOfMonth?: number | null, dayOfMonth?: number | null, parentTask: { __typename?: 'TaskType', id: string } } | null, taskSet: { __typename?: 'TaskTypeConnection', edges: Array<{ __typename?: 'TaskTypeEdge', node?: { __typename?: 'TaskType', id: string, createdAt: any, date: any } | null } | null> }, dashboard?: { __typename?: 'DashboardType', id: string, title: string } | null, metricvalueSet: { __typename?: 'MetricValueTypeConnection', edges: Array<{ __typename?: 'MetricValueTypeEdge', node?: { __typename?: 'MetricValueType', id: string, value: number, date: any, manager?: { __typename?: 'UserProfileMType', id: string, fullName: string } | null, client?: { __typename?: 'CompanyType', id: string, name: string, livasId?: number | null } | null, candidate?: { __typename?: 'CandidateType', id: string, livasId: number, employeeLivasId?: number | null, firstName: string, lastName: string } | null, metricGroup?: { __typename?: 'MetricGroupType', id: string, title: string } | null, metricvaluecommentSet: { __typename?: 'MetricValueCommentTypeConnection', edges: Array<{ __typename?: 'MetricValueCommentTypeEdge', node?: { __typename?: 'MetricValueCommentType', id: string, comment: string, metricClientReason?: { __typename?: 'MetricValueClientReasonType', id: string, title: string } | null, clients: { __typename?: 'CompanyTypeConnection', edges: Array<{ __typename?: 'CompanyTypeEdge', node?: { __typename?: 'CompanyType', id: string, name: string } | null } | null> }, candidates: { __typename?: 'CandidateTypeConnection', edges: Array<{ __typename?: 'CandidateTypeEdge', node?: { __typename?: 'CandidateType', id: string, livasId: number, employeeLivasId?: number | null, firstName: string, lastName: string } | null } | null> } } | null } | null> } } | null } | null> }, metricvalueLevel2: { __typename?: 'MetricValueTypeConnection', edges: Array<{ __typename?: 'MetricValueTypeEdge', node?: { __typename?: 'MetricValueType', id: string, value: number, date: any, manager?: { __typename?: 'UserProfileMType', id: string, fullName: string } | null, client?: { __typename?: 'CompanyType', id: string, name: string, livasId?: number | null } | null, candidate?: { __typename?: 'CandidateType', id: string, livasId: number, employeeLivasId?: number | null, firstName: string, lastName: string } | null, metricGroup?: { __typename?: 'MetricGroupType', id: string, title: string } | null, metricvaluecommentSet: { __typename?: 'MetricValueCommentTypeConnection', edges: Array<{ __typename?: 'MetricValueCommentTypeEdge', node?: { __typename?: 'MetricValueCommentType', id: string, comment: string, metricClientReason?: { __typename?: 'MetricValueClientReasonType', id: string, title: string } | null, clients: { __typename?: 'CompanyTypeConnection', edges: Array<{ __typename?: 'CompanyTypeEdge', node?: { __typename?: 'CompanyType', id: string, name: string } | null } | null> }, candidates: { __typename?: 'CandidateTypeConnection', edges: Array<{ __typename?: 'CandidateTypeEdge', node?: { __typename?: 'CandidateType', id: string, livasId: number, employeeLivasId?: number | null, firstName: string, lastName: string } | null } | null> } } | null } | null> } } | null } | null> } } | null } | null };

export type CreateTaskCopyMutationVariables = Exact<{
  input: CreateTaskCopyInput;
}>;


export type CreateTaskCopyMutation = { __typename?: 'Mutation', createTaskCopy?: { __typename?: 'CreateTaskCopyPayload', task?: { __typename?: 'TaskType', id: string, status: TaskStatus, durationMinutes?: number | null, countryIsoCode?: string | null, numPreviousTasks?: number | null, comment?: string | null, date: any, nextActionDate?: any | null, createdAt: any, dashboards: { __typename?: 'DashboardTypeConnection', edges: Array<{ __typename?: 'DashboardTypeEdge', node?: { __typename?: 'DashboardType', id: string, title: string } | null } | null> }, order?: { __typename?: 'OrderType', id: string, company?: { __typename?: 'CompanyType', id: string, name: string } | null, specification?: { __typename?: 'SpecificationType', id: string, positionTitle: string } | null } | null, category?: { __typename?: 'SACategoryType', id: string, title: string } | null, company?: { __typename?: 'CompanyType', id: string, name: string, status?: string | null, country?: { __typename?: 'CountryType', id: string, isoCode?: string | null } | null } | null, completedBy?: Array<{ __typename?: 'UserProfileMType', id: string, fullName: string, color?: string | null, user: { __typename?: 'UserType', id: string, firstName: string, lastName: string } } | null> | null, nextTaskAssignee?: { __typename?: 'UserProfileMType', id: string, fullName: string, color?: string | null, user: { __typename?: 'UserType', id: string, firstName: string, lastName: string } } | null, country?: { __typename?: 'CountryType', id: string, isoCode?: string | null } | null, candidate?: { __typename?: 'CandidateType', id: string, livasId: number, firstName: string, lastName: string, employeeLivasId?: number | null } | null, schedules: { __typename?: 'ScheduleTypeConnection', edges: Array<{ __typename?: 'ScheduleTypeEdge', node?: { __typename?: 'ScheduleType', id: string, endDate?: any | null, recurrencePeriod: ScheduleRecurrencePeriod, intervalCount: number, dayOfWeek?: number | null, weekOfMonth?: number | null, dayOfMonth?: number | null, parentTask: { __typename?: 'TaskType', id: string } } | null } | null> }, createdBySchedule?: { __typename?: 'ScheduleType', id: string, endDate?: any | null, recurrencePeriod: ScheduleRecurrencePeriod, intervalCount: number, dayOfWeek?: number | null, weekOfMonth?: number | null, dayOfMonth?: number | null, parentTask: { __typename?: 'TaskType', id: string } } | null, taskSet: { __typename?: 'TaskTypeConnection', edges: Array<{ __typename?: 'TaskTypeEdge', node?: { __typename?: 'TaskType', id: string, createdAt: any, date: any } | null } | null> }, dashboard?: { __typename?: 'DashboardType', id: string, title: string } | null, metricvalueSet: { __typename?: 'MetricValueTypeConnection', edges: Array<{ __typename?: 'MetricValueTypeEdge', node?: { __typename?: 'MetricValueType', id: string, value: number, date: any, manager?: { __typename?: 'UserProfileMType', id: string, fullName: string } | null, client?: { __typename?: 'CompanyType', id: string, name: string, livasId?: number | null } | null, candidate?: { __typename?: 'CandidateType', id: string, livasId: number, employeeLivasId?: number | null, firstName: string, lastName: string } | null, metricGroup?: { __typename?: 'MetricGroupType', id: string, title: string } | null, metricvaluecommentSet: { __typename?: 'MetricValueCommentTypeConnection', edges: Array<{ __typename?: 'MetricValueCommentTypeEdge', node?: { __typename?: 'MetricValueCommentType', id: string, comment: string, metricClientReason?: { __typename?: 'MetricValueClientReasonType', id: string, title: string } | null, clients: { __typename?: 'CompanyTypeConnection', edges: Array<{ __typename?: 'CompanyTypeEdge', node?: { __typename?: 'CompanyType', id: string, name: string } | null } | null> }, candidates: { __typename?: 'CandidateTypeConnection', edges: Array<{ __typename?: 'CandidateTypeEdge', node?: { __typename?: 'CandidateType', id: string, livasId: number, employeeLivasId?: number | null, firstName: string, lastName: string } | null } | null> } } | null } | null> } } | null } | null> }, metricvalueLevel2: { __typename?: 'MetricValueTypeConnection', edges: Array<{ __typename?: 'MetricValueTypeEdge', node?: { __typename?: 'MetricValueType', id: string, value: number, date: any, manager?: { __typename?: 'UserProfileMType', id: string, fullName: string } | null, client?: { __typename?: 'CompanyType', id: string, name: string, livasId?: number | null } | null, candidate?: { __typename?: 'CandidateType', id: string, livasId: number, employeeLivasId?: number | null, firstName: string, lastName: string } | null, metricGroup?: { __typename?: 'MetricGroupType', id: string, title: string } | null, metricvaluecommentSet: { __typename?: 'MetricValueCommentTypeConnection', edges: Array<{ __typename?: 'MetricValueCommentTypeEdge', node?: { __typename?: 'MetricValueCommentType', id: string, comment: string, metricClientReason?: { __typename?: 'MetricValueClientReasonType', id: string, title: string } | null, clients: { __typename?: 'CompanyTypeConnection', edges: Array<{ __typename?: 'CompanyTypeEdge', node?: { __typename?: 'CompanyType', id: string, name: string } | null } | null> }, candidates: { __typename?: 'CandidateTypeConnection', edges: Array<{ __typename?: 'CandidateTypeEdge', node?: { __typename?: 'CandidateType', id: string, livasId: number, employeeLivasId?: number | null, firstName: string, lastName: string } | null } | null> } } | null } | null> } } | null } | null> } } | null } | null };

export type CreateTaskScheduleMutationVariables = Exact<{
  input: CreateScheduleInput;
}>;


export type CreateTaskScheduleMutation = { __typename?: 'Mutation', createTaskSchedule?: { __typename?: 'CreateSchedulePayload', schedule?: { __typename?: 'ScheduleType', id: string, endDate?: any | null, recurrencePeriod: ScheduleRecurrencePeriod, intervalCount: number, dayOfWeek?: number | null, weekOfMonth?: number | null, dayOfMonth?: number | null, parentTask: { __typename?: 'TaskType', id: string } } | null } | null };

export type UpdateTaskScheduleMutationVariables = Exact<{
  input: UpdateScheduleInput;
}>;


export type UpdateTaskScheduleMutation = { __typename?: 'Mutation', updateTaskSchedule?: { __typename?: 'UpdateSchedulePayload', schedule?: { __typename?: 'ScheduleType', id: string, endDate?: any | null, recurrencePeriod: ScheduleRecurrencePeriod, intervalCount: number, dayOfWeek?: number | null, weekOfMonth?: number | null, dayOfMonth?: number | null, parentTask: { __typename?: 'TaskType', id: string } } | null } | null };

export type TaskCustomFieldUpdateValuesMutationVariables = Exact<{
  taskId: Scalars['ID'];
  customFieldValues: Array<CustomFieldValueInput> | CustomFieldValueInput;
}>;


export type TaskCustomFieldUpdateValuesMutation = { __typename?: 'Mutation', createUpdateCustomFieldValues?: { __typename?: 'CreateUpdateCustomFieldValuesMutation', customFieldValues?: Array<{ __typename?: 'CustomFieldValueType', id: string, textValue?: string | null, numericValue?: number | null, urlValue?: string | null, dateValue?: any | null, boolValue?: boolean | null, task: { __typename?: 'TaskType', id: string }, customField: { __typename?: 'CustomFieldType', id: string } } | null> | null } | null };

export type DeleteTaskMutationVariables = Exact<{
  taskId: Scalars['ID'];
}>;


export type DeleteTaskMutation = { __typename?: 'Mutation', deleteTask?: { __typename?: 'DeleteTaskPayload', task?: { __typename?: 'TaskType', id: string } | null } | null };

export type OperationsTaskFieldsFragment = { __typename?: 'TaskType', id: string, status: TaskStatus, durationMinutes?: number | null, countryIsoCode?: string | null, numPreviousTasks?: number | null, comment?: string | null, date: any, nextActionDate?: any | null, createdAt: any, order?: { __typename?: 'OrderType', id: string, company?: { __typename?: 'CompanyType', id: string, name: string } | null, specification?: { __typename?: 'SpecificationType', id: string, positionTitle: string } | null } | null, category?: { __typename?: 'SACategoryType', id: string, title: string } | null, company?: { __typename?: 'CompanyType', id: string, name: string, status?: string | null, country?: { __typename?: 'CountryType', id: string, isoCode?: string | null } | null } | null, completedBy?: Array<{ __typename?: 'UserProfileMType', id: string, fullName: string, color?: string | null, user: { __typename?: 'UserType', id: string, firstName: string, lastName: string } } | null> | null, nextTaskAssignee?: { __typename?: 'UserProfileMType', id: string, fullName: string, color?: string | null, user: { __typename?: 'UserType', id: string, firstName: string, lastName: string } } | null, country?: { __typename?: 'CountryType', id: string, isoCode?: string | null } | null, candidate?: { __typename?: 'CandidateType', id: string, livasId: number, firstName: string, lastName: string, employeeLivasId?: number | null } | null, schedules: { __typename?: 'ScheduleTypeConnection', edges: Array<{ __typename?: 'ScheduleTypeEdge', node?: { __typename?: 'ScheduleType', id: string, endDate?: any | null, recurrencePeriod: ScheduleRecurrencePeriod, intervalCount: number, dayOfWeek?: number | null, weekOfMonth?: number | null, dayOfMonth?: number | null, parentTask: { __typename?: 'TaskType', id: string } } | null } | null> }, createdBySchedule?: { __typename?: 'ScheduleType', id: string, endDate?: any | null, recurrencePeriod: ScheduleRecurrencePeriod, intervalCount: number, dayOfWeek?: number | null, weekOfMonth?: number | null, dayOfMonth?: number | null, parentTask: { __typename?: 'TaskType', id: string } } | null, taskSet: { __typename?: 'TaskTypeConnection', edges: Array<{ __typename?: 'TaskTypeEdge', node?: { __typename?: 'TaskType', id: string, createdAt: any, date: any } | null } | null> }, dashboard?: { __typename?: 'DashboardType', id: string, title: string } | null, metricvalueSet: { __typename?: 'MetricValueTypeConnection', edges: Array<{ __typename?: 'MetricValueTypeEdge', node?: { __typename?: 'MetricValueType', id: string, value: number, date: any, manager?: { __typename?: 'UserProfileMType', id: string, fullName: string } | null, client?: { __typename?: 'CompanyType', id: string, name: string, livasId?: number | null } | null, candidate?: { __typename?: 'CandidateType', id: string, livasId: number, employeeLivasId?: number | null, firstName: string, lastName: string } | null, metricGroup?: { __typename?: 'MetricGroupType', id: string, title: string } | null, metricvaluecommentSet: { __typename?: 'MetricValueCommentTypeConnection', edges: Array<{ __typename?: 'MetricValueCommentTypeEdge', node?: { __typename?: 'MetricValueCommentType', id: string, comment: string, metricClientReason?: { __typename?: 'MetricValueClientReasonType', id: string, title: string } | null, clients: { __typename?: 'CompanyTypeConnection', edges: Array<{ __typename?: 'CompanyTypeEdge', node?: { __typename?: 'CompanyType', id: string, name: string } | null } | null> }, candidates: { __typename?: 'CandidateTypeConnection', edges: Array<{ __typename?: 'CandidateTypeEdge', node?: { __typename?: 'CandidateType', id: string, livasId: number, employeeLivasId?: number | null, firstName: string, lastName: string } | null } | null> } } | null } | null> } } | null } | null> }, metricvalueLevel2: { __typename?: 'MetricValueTypeConnection', edges: Array<{ __typename?: 'MetricValueTypeEdge', node?: { __typename?: 'MetricValueType', id: string, value: number, date: any, manager?: { __typename?: 'UserProfileMType', id: string, fullName: string } | null, client?: { __typename?: 'CompanyType', id: string, name: string, livasId?: number | null } | null, candidate?: { __typename?: 'CandidateType', id: string, livasId: number, employeeLivasId?: number | null, firstName: string, lastName: string } | null, metricGroup?: { __typename?: 'MetricGroupType', id: string, title: string } | null, metricvaluecommentSet: { __typename?: 'MetricValueCommentTypeConnection', edges: Array<{ __typename?: 'MetricValueCommentTypeEdge', node?: { __typename?: 'MetricValueCommentType', id: string, comment: string, metricClientReason?: { __typename?: 'MetricValueClientReasonType', id: string, title: string } | null, clients: { __typename?: 'CompanyTypeConnection', edges: Array<{ __typename?: 'CompanyTypeEdge', node?: { __typename?: 'CompanyType', id: string, name: string } | null } | null> }, candidates: { __typename?: 'CandidateTypeConnection', edges: Array<{ __typename?: 'CandidateTypeEdge', node?: { __typename?: 'CandidateType', id: string, livasId: number, employeeLivasId?: number | null, firstName: string, lastName: string } | null } | null> } } | null } | null> } } | null } | null> } };

export type OperationsTaskFieldsNewFragment = { __typename?: 'TaskType', id: string, status: TaskStatus, durationMinutes?: number | null, countryIsoCode?: string | null, numPreviousTasks?: number | null, comment?: string | null, date: any, nextActionDate?: any | null, createdAt: any, order?: { __typename?: 'OrderType', id: string, company?: { __typename?: 'CompanyType', id: string, name: string, status?: string | null, country?: { __typename?: 'CountryType', id: string, isoCode?: string | null } | null } | null, specification?: { __typename?: 'SpecificationType', id: string, positionTitle: string } | null } | null, category?: { __typename?: 'SACategoryType', id: string, title: string } | null, company?: { __typename?: 'CompanyType', id: string, name: string, status?: string | null, country?: { __typename?: 'CountryType', id: string, isoCode?: string | null } | null } | null, completedBy?: Array<{ __typename?: 'UserProfileMType', id: string, fullName: string, color?: string | null, user: { __typename?: 'UserType', id: string, firstName: string, lastName: string } } | null> | null, nextTaskAssignee?: { __typename?: 'UserProfileMType', id: string, fullName: string, color?: string | null, user: { __typename?: 'UserType', id: string, firstName: string, lastName: string } } | null, country?: { __typename?: 'CountryType', id: string, isoCode?: string | null } | null, candidate?: { __typename?: 'CandidateType', id: string, livasId: number, firstName: string, lastName: string, employeeLivasId?: number | null } | null, schedules: { __typename?: 'ScheduleTypeConnection', edges: Array<{ __typename?: 'ScheduleTypeEdge', node?: { __typename?: 'ScheduleType', id: string, endDate?: any | null, recurrencePeriod: ScheduleRecurrencePeriod, intervalCount: number, dayOfWeek?: number | null, weekOfMonth?: number | null, dayOfMonth?: number | null, parentTask: { __typename?: 'TaskType', id: string } } | null } | null> }, createdBySchedule?: { __typename?: 'ScheduleType', id: string, endDate?: any | null, recurrencePeriod: ScheduleRecurrencePeriod, intervalCount: number, dayOfWeek?: number | null, weekOfMonth?: number | null, dayOfMonth?: number | null, parentTask: { __typename?: 'TaskType', id: string } } | null, taskSet: { __typename?: 'TaskTypeConnection', edges: Array<{ __typename?: 'TaskTypeEdge', node?: { __typename?: 'TaskType', id: string, createdAt: any, date: any } | null } | null> }, dashboard?: { __typename?: 'DashboardType', id: string, title: string } | null, metricvalueSet: { __typename?: 'MetricValueTypeConnection', edges: Array<{ __typename?: 'MetricValueTypeEdge', node?: { __typename?: 'MetricValueType', id: string, value: number, date: any, manager?: { __typename?: 'UserProfileMType', id: string, fullName: string } | null, client?: { __typename?: 'CompanyType', id: string, name: string, livasId?: number | null } | null, candidate?: { __typename?: 'CandidateType', id: string, livasId: number, employeeLivasId?: number | null, firstName: string, lastName: string } | null, metricGroup?: { __typename?: 'MetricGroupType', id: string, title: string } | null, metricvaluecommentSet: { __typename?: 'MetricValueCommentTypeConnection', edges: Array<{ __typename?: 'MetricValueCommentTypeEdge', node?: { __typename?: 'MetricValueCommentType', id: string, comment: string, metricClientReason?: { __typename?: 'MetricValueClientReasonType', id: string, title: string } | null, clients: { __typename?: 'CompanyTypeConnection', edges: Array<{ __typename?: 'CompanyTypeEdge', node?: { __typename?: 'CompanyType', id: string, name: string } | null } | null> }, candidates: { __typename?: 'CandidateTypeConnection', edges: Array<{ __typename?: 'CandidateTypeEdge', node?: { __typename?: 'CandidateType', id: string, livasId: number, employeeLivasId?: number | null, firstName: string, lastName: string } | null } | null> } } | null } | null> } } | null } | null> }, metricvalueLevel2: { __typename?: 'MetricValueTypeConnection', edges: Array<{ __typename?: 'MetricValueTypeEdge', node?: { __typename?: 'MetricValueType', id: string, value: number, date: any, manager?: { __typename?: 'UserProfileMType', id: string, fullName: string } | null, client?: { __typename?: 'CompanyType', id: string, name: string, livasId?: number | null } | null, candidate?: { __typename?: 'CandidateType', id: string, livasId: number, employeeLivasId?: number | null, firstName: string, lastName: string } | null, metricGroup?: { __typename?: 'MetricGroupType', id: string, title: string } | null, metricvaluecommentSet: { __typename?: 'MetricValueCommentTypeConnection', edges: Array<{ __typename?: 'MetricValueCommentTypeEdge', node?: { __typename?: 'MetricValueCommentType', id: string, comment: string, metricClientReason?: { __typename?: 'MetricValueClientReasonType', id: string, title: string } | null, clients: { __typename?: 'CompanyTypeConnection', edges: Array<{ __typename?: 'CompanyTypeEdge', node?: { __typename?: 'CompanyType', id: string, name: string } | null } | null> }, candidates: { __typename?: 'CandidateTypeConnection', edges: Array<{ __typename?: 'CandidateTypeEdge', node?: { __typename?: 'CandidateType', id: string, livasId: number, employeeLivasId?: number | null, firstName: string, lastName: string } | null } | null> } } | null } | null> } } | null } | null> } };

export type CategoryConfigFieldsFragment = { __typename?: 'SACategoryType', id: string, title: string, hint?: string | null, durationMinutes?: number | null, showDuration: boolean, showOrder: boolean, showCompany: boolean, showDescription: boolean, showCandidate: boolean, showNextTaskAssignee: boolean, customFields: { __typename?: 'CustomFieldTypeConnection', edges: Array<{ __typename?: 'CustomFieldTypeEdge', node?: { __typename?: 'CustomFieldType', id: string, name: string, hintText?: string | null, options?: any | null, fieldType: { __typename?: 'CustomFieldDefinitionType', id: string, name: string, fieldType: CustomFieldDefinitionFieldType } } | null } | null> } };

export type OverdueTaskTableFieldsFragment = { __typename?: 'TaskType', id: string, status: TaskStatus, nextActionDate?: any | null, overdueCount: number, date: any, comment?: string | null, durationMinutes?: number | null, company?: { __typename?: 'CompanyType', id: string, name: string, status?: string | null, country?: { __typename?: 'CountryType', id: string, isoCode?: string | null } | null } | null, category?: { __typename?: 'SACategoryType', id: string, title: string, hint?: string | null, durationMinutes?: number | null, showDuration: boolean, showOrder: boolean, showCompany: boolean, showDescription: boolean, showCandidate: boolean, showNextTaskAssignee: boolean, customFields: { __typename?: 'CustomFieldTypeConnection', edges: Array<{ __typename?: 'CustomFieldTypeEdge', node?: { __typename?: 'CustomFieldType', id: string, name: string, hintText?: string | null, options?: any | null, fieldType: { __typename?: 'CustomFieldDefinitionType', id: string, name: string, fieldType: CustomFieldDefinitionFieldType } } | null } | null> } } | null, candidate?: { __typename?: 'CandidateType', id: string, firstName: string, lastName: string, livasId: number, employeeLivasId?: number | null } | null, completedBy?: Array<{ __typename?: 'UserProfileMType', id: string, fullName: string, color?: string | null, user: { __typename?: 'UserType', id: string, firstName: string, lastName: string } } | null> | null, dashboard?: { __typename?: 'DashboardType', id: string, title: string } | null, metricvalueSet: { __typename?: 'MetricValueTypeConnection', edges: Array<{ __typename?: 'MetricValueTypeEdge', node?: { __typename?: 'MetricValueType', id: string, value: number, date: any, manager?: { __typename?: 'UserProfileMType', id: string, fullName: string } | null, client?: { __typename?: 'CompanyType', id: string, name: string, livasId?: number | null } | null, order?: { __typename?: 'OrderType', company?: { __typename?: 'CompanyType', name: string } | null } | null, candidate?: { __typename?: 'CandidateType', id: string, livasId: number, employeeLivasId?: number | null, firstName: string, lastName: string } | null, metricGroup?: { __typename?: 'MetricGroupType', id: string, title: string } | null, metricvaluecommentSet: { __typename?: 'MetricValueCommentTypeConnection', edges: Array<{ __typename?: 'MetricValueCommentTypeEdge', node?: { __typename?: 'MetricValueCommentType', id: string, comment: string, metricClientReason?: { __typename?: 'MetricValueClientReasonType', id: string, title: string } | null, clients: { __typename?: 'CompanyTypeConnection', edges: Array<{ __typename?: 'CompanyTypeEdge', node?: { __typename?: 'CompanyType', id: string, name: string } | null } | null> }, candidates: { __typename?: 'CandidateTypeConnection', edges: Array<{ __typename?: 'CandidateTypeEdge', node?: { __typename?: 'CandidateType', id: string, livasId: number, employeeLivasId?: number | null, firstName: string, lastName: string } | null } | null> } } | null } | null> } } | null } | null> }, metricvalueLevel2: { __typename?: 'MetricValueTypeConnection', edges: Array<{ __typename?: 'MetricValueTypeEdge', node?: { __typename?: 'MetricValueType', id: string, value: number, date: any, manager?: { __typename?: 'UserProfileMType', id: string, fullName: string } | null, client?: { __typename?: 'CompanyType', id: string, name: string, livasId?: number | null } | null, order?: { __typename?: 'OrderType', company?: { __typename?: 'CompanyType', name: string } | null } | null, candidate?: { __typename?: 'CandidateType', id: string, livasId: number, employeeLivasId?: number | null, firstName: string, lastName: string } | null, metricGroup?: { __typename?: 'MetricGroupType', id: string, title: string } | null, metricvaluecommentSet: { __typename?: 'MetricValueCommentTypeConnection', edges: Array<{ __typename?: 'MetricValueCommentTypeEdge', node?: { __typename?: 'MetricValueCommentType', id: string, comment: string, metricClientReason?: { __typename?: 'MetricValueClientReasonType', id: string, title: string } | null, clients: { __typename?: 'CompanyTypeConnection', edges: Array<{ __typename?: 'CompanyTypeEdge', node?: { __typename?: 'CompanyType', id: string, name: string } | null } | null> }, candidates: { __typename?: 'CandidateTypeConnection', edges: Array<{ __typename?: 'CandidateTypeEdge', node?: { __typename?: 'CandidateType', id: string, livasId: number, employeeLivasId?: number | null, firstName: string, lastName: string } | null } | null> } } | null } | null> } } | null } | null> }, nextActionCategory?: { __typename?: 'ActionCategoryType', id: string, title?: string | null } | null };

export type MeetingTaskTableFieldsFragment = { __typename?: 'TaskType', id: string, status: TaskStatus, overdueCount: number, date: any, comment?: string | null, durationMinutes?: number | null, company?: { __typename?: 'CompanyType', id: string, name: string, status?: string | null, country?: { __typename?: 'CountryType', id: string, isoCode?: string | null } | null } | null, category?: { __typename?: 'SACategoryType', id: string, title: string, hint?: string | null, durationMinutes?: number | null, showDuration: boolean, showOrder: boolean, showCompany: boolean, showDescription: boolean, showCandidate: boolean, showNextTaskAssignee: boolean, customFields: { __typename?: 'CustomFieldTypeConnection', edges: Array<{ __typename?: 'CustomFieldTypeEdge', node?: { __typename?: 'CustomFieldType', id: string, name: string, hintText?: string | null, options?: any | null, fieldType: { __typename?: 'CustomFieldDefinitionType', id: string, name: string, fieldType: CustomFieldDefinitionFieldType } } | null } | null> } } | null, candidate?: { __typename?: 'CandidateType', id: string, firstName: string, lastName: string, livasId: number, employeeLivasId?: number | null } | null, completedBy?: Array<{ __typename?: 'UserProfileMType', id: string, fullName: string, color?: string | null, user: { __typename?: 'UserType', id: string, firstName: string, lastName: string } } | null> | null, dashboard?: { __typename?: 'DashboardType', id: string, title: string } | null, metricvalueSet: { __typename?: 'MetricValueTypeConnection', edges: Array<{ __typename?: 'MetricValueTypeEdge', node?: { __typename?: 'MetricValueType', id: string, value: number, date: any, manager?: { __typename?: 'UserProfileMType', id: string, fullName: string } | null, client?: { __typename?: 'CompanyType', id: string, name: string, livasId?: number | null } | null, candidate?: { __typename?: 'CandidateType', id: string, livasId: number, employeeLivasId?: number | null, firstName: string, lastName: string } | null, metricGroup?: { __typename?: 'MetricGroupType', id: string, title: string } | null, metricvaluecommentSet: { __typename?: 'MetricValueCommentTypeConnection', edges: Array<{ __typename?: 'MetricValueCommentTypeEdge', node?: { __typename?: 'MetricValueCommentType', id: string, comment: string, metricClientReason?: { __typename?: 'MetricValueClientReasonType', id: string, title: string } | null, clients: { __typename?: 'CompanyTypeConnection', edges: Array<{ __typename?: 'CompanyTypeEdge', node?: { __typename?: 'CompanyType', id: string, name: string } | null } | null> }, candidates: { __typename?: 'CandidateTypeConnection', edges: Array<{ __typename?: 'CandidateTypeEdge', node?: { __typename?: 'CandidateType', id: string, livasId: number, employeeLivasId?: number | null, firstName: string, lastName: string } | null } | null> } } | null } | null> } } | null } | null> }, metricvalueLevel2: { __typename?: 'MetricValueTypeConnection', edges: Array<{ __typename?: 'MetricValueTypeEdge', node?: { __typename?: 'MetricValueType', id: string, value: number, date: any, manager?: { __typename?: 'UserProfileMType', id: string, fullName: string } | null, client?: { __typename?: 'CompanyType', id: string, name: string, livasId?: number | null } | null, candidate?: { __typename?: 'CandidateType', id: string, livasId: number, employeeLivasId?: number | null, firstName: string, lastName: string } | null, metricGroup?: { __typename?: 'MetricGroupType', id: string, title: string } | null, metricvaluecommentSet: { __typename?: 'MetricValueCommentTypeConnection', edges: Array<{ __typename?: 'MetricValueCommentTypeEdge', node?: { __typename?: 'MetricValueCommentType', id: string, comment: string, metricClientReason?: { __typename?: 'MetricValueClientReasonType', id: string, title: string } | null, clients: { __typename?: 'CompanyTypeConnection', edges: Array<{ __typename?: 'CompanyTypeEdge', node?: { __typename?: 'CompanyType', id: string, name: string } | null } | null> }, candidates: { __typename?: 'CandidateTypeConnection', edges: Array<{ __typename?: 'CandidateTypeEdge', node?: { __typename?: 'CandidateType', id: string, livasId: number, employeeLivasId?: number | null, firstName: string, lastName: string } | null } | null> } } | null } | null> } } | null } | null> }, nextActionCategory?: { __typename?: 'ActionCategoryType', id: string, title?: string | null } | null };

export type DynamicDashboardTaskTableFieldsFragment = { __typename?: 'TaskType', id: string, status: TaskStatus, nextActionDate?: any | null, overdueCount: number, date: any, comment?: string | null, durationMinutes?: number | null, company?: { __typename?: 'CompanyType', id: string, name: string, status?: string | null, country?: { __typename?: 'CountryType', id: string, isoCode?: string | null } | null } | null, order?: { __typename?: 'OrderType', id: string, specification?: { __typename?: 'SpecificationType', positionTitle: string } | null } | null, category?: { __typename?: 'SACategoryType', id: string, title: string, hint?: string | null, durationMinutes?: number | null, showDuration: boolean, showOrder: boolean, showCompany: boolean, showDescription: boolean, showCandidate: boolean, showNextTaskAssignee: boolean, customFields: { __typename?: 'CustomFieldTypeConnection', edges: Array<{ __typename?: 'CustomFieldTypeEdge', node?: { __typename?: 'CustomFieldType', id: string, name: string, hintText?: string | null, options?: any | null, fieldType: { __typename?: 'CustomFieldDefinitionType', id: string, name: string, fieldType: CustomFieldDefinitionFieldType } } | null } | null> } } | null, candidate?: { __typename?: 'CandidateType', id: string, firstName: string, lastName: string, livasId: number, employeeLivasId?: number | null } | null, completedBy?: Array<{ __typename?: 'UserProfileMType', id: string, fullName: string, color?: string | null, user: { __typename?: 'UserType', id: string, firstName: string, lastName: string } } | null> | null, dashboard?: { __typename?: 'DashboardType', id: string, title: string } | null, metricvalueSet: { __typename?: 'MetricValueTypeConnection', edges: Array<{ __typename?: 'MetricValueTypeEdge', node?: { __typename?: 'MetricValueType', id: string, value: number, date: any, manager?: { __typename?: 'UserProfileMType', id: string, fullName: string } | null, client?: { __typename?: 'CompanyType', id: string, name: string, livasId?: number | null } | null, order?: { __typename?: 'OrderType', company?: { __typename?: 'CompanyType', name: string } | null } | null, candidate?: { __typename?: 'CandidateType', id: string, livasId: number, employeeLivasId?: number | null, firstName: string, lastName: string } | null, metricGroup?: { __typename?: 'MetricGroupType', id: string, title: string } | null, metricvaluecommentSet: { __typename?: 'MetricValueCommentTypeConnection', edges: Array<{ __typename?: 'MetricValueCommentTypeEdge', node?: { __typename?: 'MetricValueCommentType', id: string, comment: string, metricClientReason?: { __typename?: 'MetricValueClientReasonType', id: string, title: string } | null, clients: { __typename?: 'CompanyTypeConnection', edges: Array<{ __typename?: 'CompanyTypeEdge', node?: { __typename?: 'CompanyType', id: string, name: string } | null } | null> }, candidates: { __typename?: 'CandidateTypeConnection', edges: Array<{ __typename?: 'CandidateTypeEdge', node?: { __typename?: 'CandidateType', id: string, livasId: number, employeeLivasId?: number | null, firstName: string, lastName: string } | null } | null> } } | null } | null> } } | null } | null> }, metricvalueLevel2: { __typename?: 'MetricValueTypeConnection', edges: Array<{ __typename?: 'MetricValueTypeEdge', node?: { __typename?: 'MetricValueType', id: string, value: number, date: any, manager?: { __typename?: 'UserProfileMType', id: string, fullName: string } | null, client?: { __typename?: 'CompanyType', id: string, name: string, livasId?: number | null } | null, order?: { __typename?: 'OrderType', company?: { __typename?: 'CompanyType', name: string } | null } | null, candidate?: { __typename?: 'CandidateType', id: string, livasId: number, employeeLivasId?: number | null, firstName: string, lastName: string } | null, metricGroup?: { __typename?: 'MetricGroupType', id: string, title: string } | null, metricvaluecommentSet: { __typename?: 'MetricValueCommentTypeConnection', edges: Array<{ __typename?: 'MetricValueCommentTypeEdge', node?: { __typename?: 'MetricValueCommentType', id: string, comment: string, metricClientReason?: { __typename?: 'MetricValueClientReasonType', id: string, title: string } | null, clients: { __typename?: 'CompanyTypeConnection', edges: Array<{ __typename?: 'CompanyTypeEdge', node?: { __typename?: 'CompanyType', id: string, name: string } | null } | null> }, candidates: { __typename?: 'CandidateTypeConnection', edges: Array<{ __typename?: 'CandidateTypeEdge', node?: { __typename?: 'CandidateType', id: string, livasId: number, employeeLivasId?: number | null, firstName: string, lastName: string } | null } | null> } } | null } | null> } } | null } | null> }, nextActionCategory?: { __typename?: 'ActionCategoryType', id: string, title?: string | null } | null };

export type TaskDetailViewFieldsFragment = { __typename?: 'TaskType', id: string, status: TaskStatus, durationMinutes?: number | null, numPreviousTasks?: number | null, comment?: string | null, date: any, createdAt: any, order?: { __typename?: 'OrderType', id: string, specification?: { __typename?: 'SpecificationType', id: string, positionTitle: string } | null, company?: { __typename?: 'CompanyType', id: string, name: string, country?: { __typename?: 'CountryType', id: string, title: string, isoCode?: string | null } | null } | null } | null, category?: { __typename?: 'SACategoryType', id: string, title: string, hint?: string | null, durationMinutes?: number | null, showDuration: boolean, showOrder: boolean, showCompany: boolean, showDescription: boolean, showCandidate: boolean, showNextTaskAssignee: boolean, customFields: { __typename?: 'CustomFieldTypeConnection', edges: Array<{ __typename?: 'CustomFieldTypeEdge', node?: { __typename?: 'CustomFieldType', id: string, name: string, hintText?: string | null, options?: any | null, fieldType: { __typename?: 'CustomFieldDefinitionType', id: string, name: string, fieldType: CustomFieldDefinitionFieldType } } | null } | null> } } | null, company?: { __typename?: 'CompanyType', id: string, name: string, status?: string | null, country?: { __typename?: 'CountryType', id: string, isoCode?: string | null } | null } | null, candidate?: { __typename?: 'CandidateType', id: string, livasId: number, firstName: string, lastName: string, employeeLivasId?: number | null } | null, dashboard?: { __typename?: 'DashboardType', id: string, title: string } | null, completedBy?: Array<{ __typename?: 'UserProfileMType', id: string, fullName: string, color?: string | null, user: { __typename?: 'UserType', id: string, firstName: string, lastName: string } } | null> | null, nextTaskAssignee?: { __typename?: 'UserProfileMType', id: string, fullName: string, color?: string | null, user: { __typename?: 'UserType', id: string, firstName: string, lastName: string } } | null, metricvalueSet: { __typename?: 'MetricValueTypeConnection', edges: Array<{ __typename?: 'MetricValueTypeEdge', node?: { __typename?: 'MetricValueType', id: string, value: number, date: any, manager?: { __typename?: 'UserProfileMType', id: string, fullName: string } | null, client?: { __typename?: 'CompanyType', id: string, name: string, livasId?: number | null } | null, order?: { __typename?: 'OrderType', company?: { __typename?: 'CompanyType', name: string } | null } | null, candidate?: { __typename?: 'CandidateType', id: string, livasId: number, employeeLivasId?: number | null, firstName: string, lastName: string } | null, metricGroup?: { __typename?: 'MetricGroupType', id: string, title: string } | null, metricvaluecommentSet: { __typename?: 'MetricValueCommentTypeConnection', edges: Array<{ __typename?: 'MetricValueCommentTypeEdge', node?: { __typename?: 'MetricValueCommentType', id: string, comment: string, metricClientReason?: { __typename?: 'MetricValueClientReasonType', id: string, title: string } | null, clients: { __typename?: 'CompanyTypeConnection', edges: Array<{ __typename?: 'CompanyTypeEdge', node?: { __typename?: 'CompanyType', id: string, name: string } | null } | null> }, candidates: { __typename?: 'CandidateTypeConnection', edges: Array<{ __typename?: 'CandidateTypeEdge', node?: { __typename?: 'CandidateType', id: string, livasId: number, employeeLivasId?: number | null, firstName: string, lastName: string } | null } | null> } } | null } | null> } } | null } | null> }, metricvalueLevel2: { __typename?: 'MetricValueTypeConnection', edges: Array<{ __typename?: 'MetricValueTypeEdge', node?: { __typename?: 'MetricValueType', id: string, value: number, date: any, manager?: { __typename?: 'UserProfileMType', id: string, fullName: string } | null, client?: { __typename?: 'CompanyType', id: string, name: string, livasId?: number | null } | null, order?: { __typename?: 'OrderType', company?: { __typename?: 'CompanyType', name: string } | null } | null, candidate?: { __typename?: 'CandidateType', id: string, livasId: number, employeeLivasId?: number | null, firstName: string, lastName: string } | null, metricGroup?: { __typename?: 'MetricGroupType', id: string, title: string } | null, metricvaluecommentSet: { __typename?: 'MetricValueCommentTypeConnection', edges: Array<{ __typename?: 'MetricValueCommentTypeEdge', node?: { __typename?: 'MetricValueCommentType', id: string, comment: string, metricClientReason?: { __typename?: 'MetricValueClientReasonType', id: string, title: string } | null, clients: { __typename?: 'CompanyTypeConnection', edges: Array<{ __typename?: 'CompanyTypeEdge', node?: { __typename?: 'CompanyType', id: string, name: string } | null } | null> }, candidates: { __typename?: 'CandidateTypeConnection', edges: Array<{ __typename?: 'CandidateTypeEdge', node?: { __typename?: 'CandidateType', id: string, livasId: number, employeeLivasId?: number | null, firstName: string, lastName: string } | null } | null> } } | null } | null> } } | null } | null> }, createdBySchedule?: { __typename?: 'ScheduleType', endDate?: any | null, id: string } | null, country?: { __typename?: 'CountryType', id: string, isoCode?: string | null } | null, schedules: { __typename?: 'ScheduleTypeConnection', edges: Array<{ __typename?: 'ScheduleTypeEdge', node?: { __typename?: 'ScheduleType', id: string, endDate?: any | null, recurrencePeriod: ScheduleRecurrencePeriod, intervalCount: number, dayOfWeek?: number | null, weekOfMonth?: number | null, dayOfMonth?: number | null, parentTask: { __typename?: 'TaskType', id: string } } | null } | null> } };

export type GetOverdueTasksQueryVariables = Exact<{
  orderBy?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  after?: InputMaybe<Scalars['String']>;
  date_Lte?: InputMaybe<Scalars['Date']>;
  date_Gte?: InputMaybe<Scalars['Date']>;
  country?: InputMaybe<Scalars['ID']>;
  company?: InputMaybe<Scalars['ID']>;
  category?: InputMaybe<Array<InputMaybe<Scalars['ID']>> | InputMaybe<Scalars['ID']>>;
  statuses?: InputMaybe<Scalars['String']>;
  search?: InputMaybe<Scalars['String']>;
  owners?: InputMaybe<Array<InputMaybe<Scalars['ID']>> | InputMaybe<Scalars['ID']>>;
  dashboardId?: InputMaybe<Scalars['ID']>;
  cardId?: InputMaybe<Scalars['ID']>;
  categoriesKeys?: InputMaybe<Scalars['String']>;
  excludeCategoriesKeys?: InputMaybe<Scalars['String']>;
  excludeStatuses?: InputMaybe<Scalars['String']>;
  isImportant?: InputMaybe<Scalars['Boolean']>;
  isFromMetric?: InputMaybe<Scalars['Boolean']>;
  dashboards?: InputMaybe<Array<InputMaybe<Scalars['ID']>> | InputMaybe<Scalars['ID']>>;
  ownerDashboardMode?: InputMaybe<Scalars['String']>;
}>;


export type GetOverdueTasksQuery = { __typename?: 'Query', tasks?: { __typename?: 'TaskTypeConnection', totalCount?: number | null, edges: Array<{ __typename?: 'TaskTypeEdge', node?: { __typename?: 'TaskType', isImportant: boolean, id: string, status: TaskStatus, nextActionDate?: any | null, overdueCount: number, date: any, comment?: string | null, durationMinutes?: number | null, dashboards: { __typename?: 'DashboardTypeConnection', edges: Array<{ __typename?: 'DashboardTypeEdge', node?: { __typename?: 'DashboardType', id: string, title: string } | null } | null> }, company?: { __typename?: 'CompanyType', id: string, name: string, status?: string | null, country?: { __typename?: 'CountryType', id: string, isoCode?: string | null } | null } | null, category?: { __typename?: 'SACategoryType', id: string, title: string, hint?: string | null, durationMinutes?: number | null, showDuration: boolean, showOrder: boolean, showCompany: boolean, showDescription: boolean, showCandidate: boolean, showNextTaskAssignee: boolean, customFields: { __typename?: 'CustomFieldTypeConnection', edges: Array<{ __typename?: 'CustomFieldTypeEdge', node?: { __typename?: 'CustomFieldType', id: string, name: string, hintText?: string | null, options?: any | null, fieldType: { __typename?: 'CustomFieldDefinitionType', id: string, name: string, fieldType: CustomFieldDefinitionFieldType } } | null } | null> } } | null, candidate?: { __typename?: 'CandidateType', id: string, firstName: string, lastName: string, livasId: number, employeeLivasId?: number | null } | null, completedBy?: Array<{ __typename?: 'UserProfileMType', id: string, fullName: string, color?: string | null, user: { __typename?: 'UserType', id: string, firstName: string, lastName: string } } | null> | null, dashboard?: { __typename?: 'DashboardType', id: string, title: string } | null, metricvalueSet: { __typename?: 'MetricValueTypeConnection', edges: Array<{ __typename?: 'MetricValueTypeEdge', node?: { __typename?: 'MetricValueType', id: string, value: number, date: any, manager?: { __typename?: 'UserProfileMType', id: string, fullName: string } | null, client?: { __typename?: 'CompanyType', id: string, name: string, livasId?: number | null } | null, order?: { __typename?: 'OrderType', company?: { __typename?: 'CompanyType', name: string } | null } | null, candidate?: { __typename?: 'CandidateType', id: string, livasId: number, employeeLivasId?: number | null, firstName: string, lastName: string } | null, metricGroup?: { __typename?: 'MetricGroupType', id: string, title: string } | null, metricvaluecommentSet: { __typename?: 'MetricValueCommentTypeConnection', edges: Array<{ __typename?: 'MetricValueCommentTypeEdge', node?: { __typename?: 'MetricValueCommentType', id: string, comment: string, metricClientReason?: { __typename?: 'MetricValueClientReasonType', id: string, title: string } | null, clients: { __typename?: 'CompanyTypeConnection', edges: Array<{ __typename?: 'CompanyTypeEdge', node?: { __typename?: 'CompanyType', id: string, name: string } | null } | null> }, candidates: { __typename?: 'CandidateTypeConnection', edges: Array<{ __typename?: 'CandidateTypeEdge', node?: { __typename?: 'CandidateType', id: string, livasId: number, employeeLivasId?: number | null, firstName: string, lastName: string } | null } | null> } } | null } | null> } } | null } | null> }, metricvalueLevel2: { __typename?: 'MetricValueTypeConnection', edges: Array<{ __typename?: 'MetricValueTypeEdge', node?: { __typename?: 'MetricValueType', id: string, value: number, date: any, manager?: { __typename?: 'UserProfileMType', id: string, fullName: string } | null, client?: { __typename?: 'CompanyType', id: string, name: string, livasId?: number | null } | null, order?: { __typename?: 'OrderType', company?: { __typename?: 'CompanyType', name: string } | null } | null, candidate?: { __typename?: 'CandidateType', id: string, livasId: number, employeeLivasId?: number | null, firstName: string, lastName: string } | null, metricGroup?: { __typename?: 'MetricGroupType', id: string, title: string } | null, metricvaluecommentSet: { __typename?: 'MetricValueCommentTypeConnection', edges: Array<{ __typename?: 'MetricValueCommentTypeEdge', node?: { __typename?: 'MetricValueCommentType', id: string, comment: string, metricClientReason?: { __typename?: 'MetricValueClientReasonType', id: string, title: string } | null, clients: { __typename?: 'CompanyTypeConnection', edges: Array<{ __typename?: 'CompanyTypeEdge', node?: { __typename?: 'CompanyType', id: string, name: string } | null } | null> }, candidates: { __typename?: 'CandidateTypeConnection', edges: Array<{ __typename?: 'CandidateTypeEdge', node?: { __typename?: 'CandidateType', id: string, livasId: number, employeeLivasId?: number | null, firstName: string, lastName: string } | null } | null> } } | null } | null> } } | null } | null> }, nextActionCategory?: { __typename?: 'ActionCategoryType', id: string, title?: string | null } | null } | null } | null> } | null };

export type GetMeetingTasksQueryVariables = Exact<{
  orderBy?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  after?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['ID']>;
  company?: InputMaybe<Scalars['ID']>;
  category?: InputMaybe<Array<InputMaybe<Scalars['ID']>> | InputMaybe<Scalars['ID']>>;
  statuses?: InputMaybe<Scalars['String']>;
  search?: InputMaybe<Scalars['String']>;
  owners?: InputMaybe<Array<InputMaybe<Scalars['ID']>> | InputMaybe<Scalars['ID']>>;
  dashboardId?: InputMaybe<Scalars['ID']>;
  categoriesKeys?: InputMaybe<Scalars['String']>;
  excludeCategoriesKeys?: InputMaybe<Scalars['String']>;
  excludeStatuses?: InputMaybe<Scalars['String']>;
  includeChildDashboards?: InputMaybe<Scalars['Boolean']>;
  dashboards?: InputMaybe<Array<InputMaybe<Scalars['ID']>> | InputMaybe<Scalars['ID']>>;
}>;


export type GetMeetingTasksQuery = { __typename?: 'Query', tasks?: { __typename?: 'TaskTypeConnection', totalCount?: number | null, edges: Array<{ __typename?: 'TaskTypeEdge', node?: { __typename?: 'TaskType', id: string, status: TaskStatus, overdueCount: number, date: any, comment?: string | null, durationMinutes?: number | null, dashboards: { __typename?: 'DashboardTypeConnection', edges: Array<{ __typename?: 'DashboardTypeEdge', node?: { __typename?: 'DashboardType', id: string, title: string } | null } | null> }, company?: { __typename?: 'CompanyType', id: string, name: string, status?: string | null, country?: { __typename?: 'CountryType', id: string, isoCode?: string | null } | null } | null, category?: { __typename?: 'SACategoryType', id: string, title: string, hint?: string | null, durationMinutes?: number | null, showDuration: boolean, showOrder: boolean, showCompany: boolean, showDescription: boolean, showCandidate: boolean, showNextTaskAssignee: boolean, customFields: { __typename?: 'CustomFieldTypeConnection', edges: Array<{ __typename?: 'CustomFieldTypeEdge', node?: { __typename?: 'CustomFieldType', id: string, name: string, hintText?: string | null, options?: any | null, fieldType: { __typename?: 'CustomFieldDefinitionType', id: string, name: string, fieldType: CustomFieldDefinitionFieldType } } | null } | null> } } | null, candidate?: { __typename?: 'CandidateType', id: string, firstName: string, lastName: string, livasId: number, employeeLivasId?: number | null } | null, completedBy?: Array<{ __typename?: 'UserProfileMType', id: string, fullName: string, color?: string | null, user: { __typename?: 'UserType', id: string, firstName: string, lastName: string } } | null> | null, dashboard?: { __typename?: 'DashboardType', id: string, title: string } | null, metricvalueSet: { __typename?: 'MetricValueTypeConnection', edges: Array<{ __typename?: 'MetricValueTypeEdge', node?: { __typename?: 'MetricValueType', id: string, value: number, date: any, manager?: { __typename?: 'UserProfileMType', id: string, fullName: string } | null, client?: { __typename?: 'CompanyType', id: string, name: string, livasId?: number | null } | null, candidate?: { __typename?: 'CandidateType', id: string, livasId: number, employeeLivasId?: number | null, firstName: string, lastName: string } | null, metricGroup?: { __typename?: 'MetricGroupType', id: string, title: string } | null, metricvaluecommentSet: { __typename?: 'MetricValueCommentTypeConnection', edges: Array<{ __typename?: 'MetricValueCommentTypeEdge', node?: { __typename?: 'MetricValueCommentType', id: string, comment: string, metricClientReason?: { __typename?: 'MetricValueClientReasonType', id: string, title: string } | null, clients: { __typename?: 'CompanyTypeConnection', edges: Array<{ __typename?: 'CompanyTypeEdge', node?: { __typename?: 'CompanyType', id: string, name: string } | null } | null> }, candidates: { __typename?: 'CandidateTypeConnection', edges: Array<{ __typename?: 'CandidateTypeEdge', node?: { __typename?: 'CandidateType', id: string, livasId: number, employeeLivasId?: number | null, firstName: string, lastName: string } | null } | null> } } | null } | null> } } | null } | null> }, metricvalueLevel2: { __typename?: 'MetricValueTypeConnection', edges: Array<{ __typename?: 'MetricValueTypeEdge', node?: { __typename?: 'MetricValueType', id: string, value: number, date: any, manager?: { __typename?: 'UserProfileMType', id: string, fullName: string } | null, client?: { __typename?: 'CompanyType', id: string, name: string, livasId?: number | null } | null, candidate?: { __typename?: 'CandidateType', id: string, livasId: number, employeeLivasId?: number | null, firstName: string, lastName: string } | null, metricGroup?: { __typename?: 'MetricGroupType', id: string, title: string } | null, metricvaluecommentSet: { __typename?: 'MetricValueCommentTypeConnection', edges: Array<{ __typename?: 'MetricValueCommentTypeEdge', node?: { __typename?: 'MetricValueCommentType', id: string, comment: string, metricClientReason?: { __typename?: 'MetricValueClientReasonType', id: string, title: string } | null, clients: { __typename?: 'CompanyTypeConnection', edges: Array<{ __typename?: 'CompanyTypeEdge', node?: { __typename?: 'CompanyType', id: string, name: string } | null } | null> }, candidates: { __typename?: 'CandidateTypeConnection', edges: Array<{ __typename?: 'CandidateTypeEdge', node?: { __typename?: 'CandidateType', id: string, livasId: number, employeeLivasId?: number | null, firstName: string, lastName: string } | null } | null> } } | null } | null> } } | null } | null> }, nextActionCategory?: { __typename?: 'ActionCategoryType', id: string, title?: string | null } | null } | null } | null> } | null };

export type GetDynamicDashboardTasksQueryVariables = Exact<{
  orderBy?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  after?: InputMaybe<Scalars['String']>;
  date_Lte?: InputMaybe<Scalars['Date']>;
  date_Gte?: InputMaybe<Scalars['Date']>;
  country?: InputMaybe<Scalars['ID']>;
  company?: InputMaybe<Scalars['ID']>;
  category?: InputMaybe<Array<InputMaybe<Scalars['ID']>> | InputMaybe<Scalars['ID']>>;
  statuses?: InputMaybe<Scalars['String']>;
  search?: InputMaybe<Scalars['String']>;
  owners?: InputMaybe<Array<InputMaybe<Scalars['ID']>> | InputMaybe<Scalars['ID']>>;
  dashboardId?: InputMaybe<Scalars['ID']>;
  categoriesKeys?: InputMaybe<Scalars['String']>;
  excludeCategoriesKeys?: InputMaybe<Scalars['String']>;
  excludeStatuses?: InputMaybe<Scalars['String']>;
  includeChildDashboards?: InputMaybe<Scalars['Boolean']>;
  customFields?: InputMaybe<Scalars['String']>;
  dashboards?: InputMaybe<Array<InputMaybe<Scalars['ID']>> | InputMaybe<Scalars['ID']>>;
}>;


export type GetDynamicDashboardTasksQuery = { __typename?: 'Query', tasks?: { __typename?: 'TaskTypeConnection', totalCount?: number | null, edges: Array<{ __typename?: 'TaskTypeEdge', node?: { __typename?: 'TaskType', id: string, status: TaskStatus, nextActionDate?: any | null, overdueCount: number, date: any, comment?: string | null, durationMinutes?: number | null, dashboards: { __typename?: 'DashboardTypeConnection', edges: Array<{ __typename?: 'DashboardTypeEdge', node?: { __typename?: 'DashboardType', id: string, title: string } | null } | null> }, company?: { __typename?: 'CompanyType', id: string, name: string, status?: string | null, country?: { __typename?: 'CountryType', id: string, isoCode?: string | null } | null } | null, order?: { __typename?: 'OrderType', id: string, specification?: { __typename?: 'SpecificationType', positionTitle: string } | null } | null, category?: { __typename?: 'SACategoryType', id: string, title: string, hint?: string | null, durationMinutes?: number | null, showDuration: boolean, showOrder: boolean, showCompany: boolean, showDescription: boolean, showCandidate: boolean, showNextTaskAssignee: boolean, customFields: { __typename?: 'CustomFieldTypeConnection', edges: Array<{ __typename?: 'CustomFieldTypeEdge', node?: { __typename?: 'CustomFieldType', id: string, name: string, hintText?: string | null, options?: any | null, fieldType: { __typename?: 'CustomFieldDefinitionType', id: string, name: string, fieldType: CustomFieldDefinitionFieldType } } | null } | null> } } | null, candidate?: { __typename?: 'CandidateType', id: string, firstName: string, lastName: string, livasId: number, employeeLivasId?: number | null } | null, completedBy?: Array<{ __typename?: 'UserProfileMType', id: string, fullName: string, color?: string | null, user: { __typename?: 'UserType', id: string, firstName: string, lastName: string } } | null> | null, dashboard?: { __typename?: 'DashboardType', id: string, title: string } | null, metricvalueSet: { __typename?: 'MetricValueTypeConnection', edges: Array<{ __typename?: 'MetricValueTypeEdge', node?: { __typename?: 'MetricValueType', id: string, value: number, date: any, manager?: { __typename?: 'UserProfileMType', id: string, fullName: string } | null, client?: { __typename?: 'CompanyType', id: string, name: string, livasId?: number | null } | null, order?: { __typename?: 'OrderType', company?: { __typename?: 'CompanyType', name: string } | null } | null, candidate?: { __typename?: 'CandidateType', id: string, livasId: number, employeeLivasId?: number | null, firstName: string, lastName: string } | null, metricGroup?: { __typename?: 'MetricGroupType', id: string, title: string } | null, metricvaluecommentSet: { __typename?: 'MetricValueCommentTypeConnection', edges: Array<{ __typename?: 'MetricValueCommentTypeEdge', node?: { __typename?: 'MetricValueCommentType', id: string, comment: string, metricClientReason?: { __typename?: 'MetricValueClientReasonType', id: string, title: string } | null, clients: { __typename?: 'CompanyTypeConnection', edges: Array<{ __typename?: 'CompanyTypeEdge', node?: { __typename?: 'CompanyType', id: string, name: string } | null } | null> }, candidates: { __typename?: 'CandidateTypeConnection', edges: Array<{ __typename?: 'CandidateTypeEdge', node?: { __typename?: 'CandidateType', id: string, livasId: number, employeeLivasId?: number | null, firstName: string, lastName: string } | null } | null> } } | null } | null> } } | null } | null> }, metricvalueLevel2: { __typename?: 'MetricValueTypeConnection', edges: Array<{ __typename?: 'MetricValueTypeEdge', node?: { __typename?: 'MetricValueType', id: string, value: number, date: any, manager?: { __typename?: 'UserProfileMType', id: string, fullName: string } | null, client?: { __typename?: 'CompanyType', id: string, name: string, livasId?: number | null } | null, order?: { __typename?: 'OrderType', company?: { __typename?: 'CompanyType', name: string } | null } | null, candidate?: { __typename?: 'CandidateType', id: string, livasId: number, employeeLivasId?: number | null, firstName: string, lastName: string } | null, metricGroup?: { __typename?: 'MetricGroupType', id: string, title: string } | null, metricvaluecommentSet: { __typename?: 'MetricValueCommentTypeConnection', edges: Array<{ __typename?: 'MetricValueCommentTypeEdge', node?: { __typename?: 'MetricValueCommentType', id: string, comment: string, metricClientReason?: { __typename?: 'MetricValueClientReasonType', id: string, title: string } | null, clients: { __typename?: 'CompanyTypeConnection', edges: Array<{ __typename?: 'CompanyTypeEdge', node?: { __typename?: 'CompanyType', id: string, name: string } | null } | null> }, candidates: { __typename?: 'CandidateTypeConnection', edges: Array<{ __typename?: 'CandidateTypeEdge', node?: { __typename?: 'CandidateType', id: string, livasId: number, employeeLivasId?: number | null, firstName: string, lastName: string } | null } | null> } } | null } | null> } } | null } | null> }, nextActionCategory?: { __typename?: 'ActionCategoryType', id: string, title?: string | null } | null } | null } | null> } | null };

export type GetOperationsTasksQueryVariables = Exact<{
  orderBy?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  after?: InputMaybe<Scalars['String']>;
  date_Lte?: InputMaybe<Scalars['Date']>;
  date_Gte?: InputMaybe<Scalars['Date']>;
  country?: InputMaybe<Scalars['ID']>;
  company?: InputMaybe<Scalars['ID']>;
  category?: InputMaybe<Array<InputMaybe<Scalars['ID']>> | InputMaybe<Scalars['ID']>>;
  statuses?: InputMaybe<Scalars['String']>;
  search?: InputMaybe<Scalars['String']>;
  owners?: InputMaybe<Array<InputMaybe<Scalars['ID']>> | InputMaybe<Scalars['ID']>>;
  dashboardId?: InputMaybe<Scalars['ID']>;
  firstTimeCall?: InputMaybe<Scalars['Boolean']>;
  noOwners?: InputMaybe<Scalars['Boolean']>;
  dashboards?: InputMaybe<Array<InputMaybe<Scalars['ID']>> | InputMaybe<Scalars['ID']>>;
}>;


export type GetOperationsTasksQuery = { __typename?: 'Query', tasks?: { __typename?: 'TaskTypeConnection', totalCount?: number | null, edges: Array<{ __typename?: 'TaskTypeEdge', node?: { __typename?: 'TaskType', id: string, status: TaskStatus, durationMinutes?: number | null, countryIsoCode?: string | null, numPreviousTasks?: number | null, comment?: string | null, date: any, nextActionDate?: any | null, createdAt: any, dashboards: { __typename?: 'DashboardTypeConnection', edges: Array<{ __typename?: 'DashboardTypeEdge', node?: { __typename?: 'DashboardType', id: string, title: string } | null } | null> }, order?: { __typename?: 'OrderType', id: string, company?: { __typename?: 'CompanyType', id: string, name: string } | null, specification?: { __typename?: 'SpecificationType', id: string, positionTitle: string } | null } | null, category?: { __typename?: 'SACategoryType', id: string, title: string } | null, company?: { __typename?: 'CompanyType', id: string, name: string, status?: string | null, country?: { __typename?: 'CountryType', id: string, isoCode?: string | null } | null } | null, completedBy?: Array<{ __typename?: 'UserProfileMType', id: string, fullName: string, color?: string | null, user: { __typename?: 'UserType', id: string, firstName: string, lastName: string } } | null> | null, nextTaskAssignee?: { __typename?: 'UserProfileMType', id: string, fullName: string, color?: string | null, user: { __typename?: 'UserType', id: string, firstName: string, lastName: string } } | null, country?: { __typename?: 'CountryType', id: string, isoCode?: string | null } | null, candidate?: { __typename?: 'CandidateType', id: string, livasId: number, firstName: string, lastName: string, employeeLivasId?: number | null } | null, schedules: { __typename?: 'ScheduleTypeConnection', edges: Array<{ __typename?: 'ScheduleTypeEdge', node?: { __typename?: 'ScheduleType', id: string, endDate?: any | null, recurrencePeriod: ScheduleRecurrencePeriod, intervalCount: number, dayOfWeek?: number | null, weekOfMonth?: number | null, dayOfMonth?: number | null, parentTask: { __typename?: 'TaskType', id: string } } | null } | null> }, createdBySchedule?: { __typename?: 'ScheduleType', id: string, endDate?: any | null, recurrencePeriod: ScheduleRecurrencePeriod, intervalCount: number, dayOfWeek?: number | null, weekOfMonth?: number | null, dayOfMonth?: number | null, parentTask: { __typename?: 'TaskType', id: string } } | null, taskSet: { __typename?: 'TaskTypeConnection', edges: Array<{ __typename?: 'TaskTypeEdge', node?: { __typename?: 'TaskType', id: string, createdAt: any, date: any } | null } | null> }, dashboard?: { __typename?: 'DashboardType', id: string, title: string } | null, metricvalueSet: { __typename?: 'MetricValueTypeConnection', edges: Array<{ __typename?: 'MetricValueTypeEdge', node?: { __typename?: 'MetricValueType', id: string, value: number, date: any, manager?: { __typename?: 'UserProfileMType', id: string, fullName: string } | null, client?: { __typename?: 'CompanyType', id: string, name: string, livasId?: number | null } | null, candidate?: { __typename?: 'CandidateType', id: string, livasId: number, employeeLivasId?: number | null, firstName: string, lastName: string } | null, metricGroup?: { __typename?: 'MetricGroupType', id: string, title: string } | null, metricvaluecommentSet: { __typename?: 'MetricValueCommentTypeConnection', edges: Array<{ __typename?: 'MetricValueCommentTypeEdge', node?: { __typename?: 'MetricValueCommentType', id: string, comment: string, metricClientReason?: { __typename?: 'MetricValueClientReasonType', id: string, title: string } | null, clients: { __typename?: 'CompanyTypeConnection', edges: Array<{ __typename?: 'CompanyTypeEdge', node?: { __typename?: 'CompanyType', id: string, name: string } | null } | null> }, candidates: { __typename?: 'CandidateTypeConnection', edges: Array<{ __typename?: 'CandidateTypeEdge', node?: { __typename?: 'CandidateType', id: string, livasId: number, employeeLivasId?: number | null, firstName: string, lastName: string } | null } | null> } } | null } | null> } } | null } | null> }, metricvalueLevel2: { __typename?: 'MetricValueTypeConnection', edges: Array<{ __typename?: 'MetricValueTypeEdge', node?: { __typename?: 'MetricValueType', id: string, value: number, date: any, manager?: { __typename?: 'UserProfileMType', id: string, fullName: string } | null, client?: { __typename?: 'CompanyType', id: string, name: string, livasId?: number | null } | null, candidate?: { __typename?: 'CandidateType', id: string, livasId: number, employeeLivasId?: number | null, firstName: string, lastName: string } | null, metricGroup?: { __typename?: 'MetricGroupType', id: string, title: string } | null, metricvaluecommentSet: { __typename?: 'MetricValueCommentTypeConnection', edges: Array<{ __typename?: 'MetricValueCommentTypeEdge', node?: { __typename?: 'MetricValueCommentType', id: string, comment: string, metricClientReason?: { __typename?: 'MetricValueClientReasonType', id: string, title: string } | null, clients: { __typename?: 'CompanyTypeConnection', edges: Array<{ __typename?: 'CompanyTypeEdge', node?: { __typename?: 'CompanyType', id: string, name: string } | null } | null> }, candidates: { __typename?: 'CandidateTypeConnection', edges: Array<{ __typename?: 'CandidateTypeEdge', node?: { __typename?: 'CandidateType', id: string, livasId: number, employeeLivasId?: number | null, firstName: string, lastName: string } | null } | null> } } | null } | null> } } | null } | null> } } | null } | null> } | null };

export type GetNextTaskDateQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GetNextTaskDateQuery = { __typename?: 'Query', nextTaskDate?: { __typename?: 'NextTaskType', date?: string | null, message?: string | null } | null };

export type GetOperationsTaskQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GetOperationsTaskQuery = { __typename?: 'Query', task?: { __typename?: 'TaskType', id: string, status: TaskStatus, durationMinutes?: number | null, numPreviousTasks?: number | null, comment?: string | null, date: any, createdAt: any, dashboards: { __typename?: 'DashboardTypeConnection', edges: Array<{ __typename?: 'DashboardTypeEdge', node?: { __typename?: 'DashboardType', id: string, title: string } | null } | null> }, order?: { __typename?: 'OrderType', id: string, specification?: { __typename?: 'SpecificationType', id: string, positionTitle: string } | null, company?: { __typename?: 'CompanyType', id: string, name: string, country?: { __typename?: 'CountryType', id: string, title: string, isoCode?: string | null } | null } | null } | null, category?: { __typename?: 'SACategoryType', id: string, title: string, hint?: string | null, durationMinutes?: number | null, showDuration: boolean, showOrder: boolean, showCompany: boolean, showDescription: boolean, showCandidate: boolean, showNextTaskAssignee: boolean, customFields: { __typename?: 'CustomFieldTypeConnection', edges: Array<{ __typename?: 'CustomFieldTypeEdge', node?: { __typename?: 'CustomFieldType', id: string, name: string, hintText?: string | null, options?: any | null, fieldType: { __typename?: 'CustomFieldDefinitionType', id: string, name: string, fieldType: CustomFieldDefinitionFieldType } } | null } | null> } } | null, company?: { __typename?: 'CompanyType', id: string, name: string, status?: string | null, country?: { __typename?: 'CountryType', id: string, isoCode?: string | null } | null } | null, candidate?: { __typename?: 'CandidateType', id: string, livasId: number, firstName: string, lastName: string, employeeLivasId?: number | null } | null, dashboard?: { __typename?: 'DashboardType', id: string, title: string } | null, completedBy?: Array<{ __typename?: 'UserProfileMType', id: string, fullName: string, color?: string | null, user: { __typename?: 'UserType', id: string, firstName: string, lastName: string } } | null> | null, nextTaskAssignee?: { __typename?: 'UserProfileMType', id: string, fullName: string, color?: string | null, user: { __typename?: 'UserType', id: string, firstName: string, lastName: string } } | null, metricvalueSet: { __typename?: 'MetricValueTypeConnection', edges: Array<{ __typename?: 'MetricValueTypeEdge', node?: { __typename?: 'MetricValueType', id: string, value: number, date: any, manager?: { __typename?: 'UserProfileMType', id: string, fullName: string } | null, client?: { __typename?: 'CompanyType', id: string, name: string, livasId?: number | null } | null, order?: { __typename?: 'OrderType', company?: { __typename?: 'CompanyType', name: string } | null } | null, candidate?: { __typename?: 'CandidateType', id: string, livasId: number, employeeLivasId?: number | null, firstName: string, lastName: string } | null, metricGroup?: { __typename?: 'MetricGroupType', id: string, title: string } | null, metricvaluecommentSet: { __typename?: 'MetricValueCommentTypeConnection', edges: Array<{ __typename?: 'MetricValueCommentTypeEdge', node?: { __typename?: 'MetricValueCommentType', id: string, comment: string, metricClientReason?: { __typename?: 'MetricValueClientReasonType', id: string, title: string } | null, clients: { __typename?: 'CompanyTypeConnection', edges: Array<{ __typename?: 'CompanyTypeEdge', node?: { __typename?: 'CompanyType', id: string, name: string } | null } | null> }, candidates: { __typename?: 'CandidateTypeConnection', edges: Array<{ __typename?: 'CandidateTypeEdge', node?: { __typename?: 'CandidateType', id: string, livasId: number, employeeLivasId?: number | null, firstName: string, lastName: string } | null } | null> } } | null } | null> } } | null } | null> }, metricvalueLevel2: { __typename?: 'MetricValueTypeConnection', edges: Array<{ __typename?: 'MetricValueTypeEdge', node?: { __typename?: 'MetricValueType', id: string, value: number, date: any, manager?: { __typename?: 'UserProfileMType', id: string, fullName: string } | null, client?: { __typename?: 'CompanyType', id: string, name: string, livasId?: number | null } | null, order?: { __typename?: 'OrderType', company?: { __typename?: 'CompanyType', name: string } | null } | null, candidate?: { __typename?: 'CandidateType', id: string, livasId: number, employeeLivasId?: number | null, firstName: string, lastName: string } | null, metricGroup?: { __typename?: 'MetricGroupType', id: string, title: string } | null, metricvaluecommentSet: { __typename?: 'MetricValueCommentTypeConnection', edges: Array<{ __typename?: 'MetricValueCommentTypeEdge', node?: { __typename?: 'MetricValueCommentType', id: string, comment: string, metricClientReason?: { __typename?: 'MetricValueClientReasonType', id: string, title: string } | null, clients: { __typename?: 'CompanyTypeConnection', edges: Array<{ __typename?: 'CompanyTypeEdge', node?: { __typename?: 'CompanyType', id: string, name: string } | null } | null> }, candidates: { __typename?: 'CandidateTypeConnection', edges: Array<{ __typename?: 'CandidateTypeEdge', node?: { __typename?: 'CandidateType', id: string, livasId: number, employeeLivasId?: number | null, firstName: string, lastName: string } | null } | null> } } | null } | null> } } | null } | null> }, createdBySchedule?: { __typename?: 'ScheduleType', endDate?: any | null, id: string } | null, country?: { __typename?: 'CountryType', id: string, isoCode?: string | null } | null, schedules: { __typename?: 'ScheduleTypeConnection', edges: Array<{ __typename?: 'ScheduleTypeEdge', node?: { __typename?: 'ScheduleType', id: string, endDate?: any | null, recurrencePeriod: ScheduleRecurrencePeriod, intervalCount: number, dayOfWeek?: number | null, weekOfMonth?: number | null, dayOfMonth?: number | null, parentTask: { __typename?: 'TaskType', id: string } } | null } | null> } } | null };

export type CustomFieldsValuesFieldsFragment = { __typename?: 'CustomFieldValueType', id: string, boolValue?: boolean | null, numericValue?: number | null, textValue?: string | null, dateValue?: any | null, urlValue?: string | null, customField: { __typename?: 'CustomFieldType', id: string, name: string, fieldType: { __typename?: 'CustomFieldDefinitionType', id: string, name: string, fieldType: CustomFieldDefinitionFieldType } } };

export type GetTaskCustomFieldValuesAndCategoriesQueryVariables = Exact<{
  taskId: Scalars['ID'];
}>;


export type GetTaskCustomFieldValuesAndCategoriesQuery = { __typename?: 'Query', task?: { __typename?: 'TaskType', id: string, customFieldValues: { __typename?: 'CustomFieldValueTypeConnection', edges: Array<{ __typename?: 'CustomFieldValueTypeEdge', node?: { __typename?: 'CustomFieldValueType', id: string, boolValue?: boolean | null, numericValue?: number | null, textValue?: string | null, dateValue?: any | null, urlValue?: string | null, customField: { __typename?: 'CustomFieldType', id: string, name: string, fieldType: { __typename?: 'CustomFieldDefinitionType', id: string, name: string, fieldType: CustomFieldDefinitionFieldType } } } | null } | null> } } | null, selectionActionCategoryGroups?: { __typename?: 'SACategoryGroupTypeConnection', totalCount?: number | null, edges: Array<{ __typename?: 'SACategoryGroupTypeEdge', node?: { __typename?: 'SACategoryGroupType', id: string, title: string, department?: SaCategoryGroupDepartment | null, country?: { __typename?: 'CountryType', id: string } | null, sacategorySet: { __typename?: 'SACategoryTypeConnection', edges: Array<{ __typename?: 'SACategoryTypeEdge', node?: { __typename?: 'SACategoryType', requiresDashboard: boolean, id: string, title: string, hint?: string | null, durationMinutes?: number | null, showDuration: boolean, showOrder: boolean, showCompany: boolean, showDescription: boolean, showCandidate: boolean, showNextTaskAssignee: boolean, customFields: { __typename?: 'CustomFieldTypeConnection', edges: Array<{ __typename?: 'CustomFieldTypeEdge', node?: { __typename?: 'CustomFieldType', id: string, name: string, hintText?: string | null, options?: any | null, fieldType: { __typename?: 'CustomFieldDefinitionType', id: string, name: string, fieldType: CustomFieldDefinitionFieldType } } | null } | null> } } | null } | null> } } | null } | null> } | null };

export type GetCustomFieldValuesByTasksQueryVariables = Exact<{
  taskIds?: InputMaybe<Array<InputMaybe<Scalars['ID']>> | InputMaybe<Scalars['ID']>>;
  keys?: InputMaybe<Scalars['String']>;
}>;


export type GetCustomFieldValuesByTasksQuery = { __typename?: 'Query', customFieldValues?: { __typename?: 'CustomFieldValueTypeConnection', edges: Array<{ __typename?: 'CustomFieldValueTypeEdge', node?: { __typename?: 'CustomFieldValueType', id: string, numericValue?: number | null, textValue?: string | null, customField: { __typename?: 'CustomFieldType', id: string, key?: string | null, options?: any | null }, task: { __typename?: 'TaskType', id: string } } | null } | null> } | null };

export type GetTasksByCandidateAndCategoryQueryVariables = Exact<{
  candidateId: Scalars['ID'];
  categoryId: Scalars['ID'];
}>;


export type GetTasksByCandidateAndCategoryQuery = { __typename?: 'Query', tasks?: { __typename?: 'TaskTypeConnection', totalCount?: number | null, edges: Array<{ __typename?: 'TaskTypeEdge', node?: { __typename?: 'TaskType', id: string, status: TaskStatus, durationMinutes?: number | null, countryIsoCode?: string | null, numPreviousTasks?: number | null, comment?: string | null, date: any, nextActionDate?: any | null, createdAt: any, dashboards: { __typename?: 'DashboardTypeConnection', edges: Array<{ __typename?: 'DashboardTypeEdge', node?: { __typename?: 'DashboardType', id: string, title: string } | null } | null> }, order?: { __typename?: 'OrderType', id: string, company?: { __typename?: 'CompanyType', id: string, name: string, status?: string | null, country?: { __typename?: 'CountryType', id: string, isoCode?: string | null } | null } | null, specification?: { __typename?: 'SpecificationType', id: string, positionTitle: string } | null } | null, category?: { __typename?: 'SACategoryType', id: string, title: string } | null, company?: { __typename?: 'CompanyType', id: string, name: string, status?: string | null, country?: { __typename?: 'CountryType', id: string, isoCode?: string | null } | null } | null, completedBy?: Array<{ __typename?: 'UserProfileMType', id: string, fullName: string, color?: string | null, user: { __typename?: 'UserType', id: string, firstName: string, lastName: string } } | null> | null, nextTaskAssignee?: { __typename?: 'UserProfileMType', id: string, fullName: string, color?: string | null, user: { __typename?: 'UserType', id: string, firstName: string, lastName: string } } | null, country?: { __typename?: 'CountryType', id: string, isoCode?: string | null } | null, candidate?: { __typename?: 'CandidateType', id: string, livasId: number, firstName: string, lastName: string, employeeLivasId?: number | null } | null, schedules: { __typename?: 'ScheduleTypeConnection', edges: Array<{ __typename?: 'ScheduleTypeEdge', node?: { __typename?: 'ScheduleType', id: string, endDate?: any | null, recurrencePeriod: ScheduleRecurrencePeriod, intervalCount: number, dayOfWeek?: number | null, weekOfMonth?: number | null, dayOfMonth?: number | null, parentTask: { __typename?: 'TaskType', id: string } } | null } | null> }, createdBySchedule?: { __typename?: 'ScheduleType', id: string, endDate?: any | null, recurrencePeriod: ScheduleRecurrencePeriod, intervalCount: number, dayOfWeek?: number | null, weekOfMonth?: number | null, dayOfMonth?: number | null, parentTask: { __typename?: 'TaskType', id: string } } | null, taskSet: { __typename?: 'TaskTypeConnection', edges: Array<{ __typename?: 'TaskTypeEdge', node?: { __typename?: 'TaskType', id: string, createdAt: any, date: any } | null } | null> }, dashboard?: { __typename?: 'DashboardType', id: string, title: string } | null, metricvalueSet: { __typename?: 'MetricValueTypeConnection', edges: Array<{ __typename?: 'MetricValueTypeEdge', node?: { __typename?: 'MetricValueType', id: string, value: number, date: any, manager?: { __typename?: 'UserProfileMType', id: string, fullName: string } | null, client?: { __typename?: 'CompanyType', id: string, name: string, livasId?: number | null } | null, candidate?: { __typename?: 'CandidateType', id: string, livasId: number, employeeLivasId?: number | null, firstName: string, lastName: string } | null, metricGroup?: { __typename?: 'MetricGroupType', id: string, title: string } | null, metricvaluecommentSet: { __typename?: 'MetricValueCommentTypeConnection', edges: Array<{ __typename?: 'MetricValueCommentTypeEdge', node?: { __typename?: 'MetricValueCommentType', id: string, comment: string, metricClientReason?: { __typename?: 'MetricValueClientReasonType', id: string, title: string } | null, clients: { __typename?: 'CompanyTypeConnection', edges: Array<{ __typename?: 'CompanyTypeEdge', node?: { __typename?: 'CompanyType', id: string, name: string } | null } | null> }, candidates: { __typename?: 'CandidateTypeConnection', edges: Array<{ __typename?: 'CandidateTypeEdge', node?: { __typename?: 'CandidateType', id: string, livasId: number, employeeLivasId?: number | null, firstName: string, lastName: string } | null } | null> } } | null } | null> } } | null } | null> }, metricvalueLevel2: { __typename?: 'MetricValueTypeConnection', edges: Array<{ __typename?: 'MetricValueTypeEdge', node?: { __typename?: 'MetricValueType', id: string, value: number, date: any, manager?: { __typename?: 'UserProfileMType', id: string, fullName: string } | null, client?: { __typename?: 'CompanyType', id: string, name: string, livasId?: number | null } | null, candidate?: { __typename?: 'CandidateType', id: string, livasId: number, employeeLivasId?: number | null, firstName: string, lastName: string } | null, metricGroup?: { __typename?: 'MetricGroupType', id: string, title: string } | null, metricvaluecommentSet: { __typename?: 'MetricValueCommentTypeConnection', edges: Array<{ __typename?: 'MetricValueCommentTypeEdge', node?: { __typename?: 'MetricValueCommentType', id: string, comment: string, metricClientReason?: { __typename?: 'MetricValueClientReasonType', id: string, title: string } | null, clients: { __typename?: 'CompanyTypeConnection', edges: Array<{ __typename?: 'CompanyTypeEdge', node?: { __typename?: 'CompanyType', id: string, name: string } | null } | null> }, candidates: { __typename?: 'CandidateTypeConnection', edges: Array<{ __typename?: 'CandidateTypeEdge', node?: { __typename?: 'CandidateType', id: string, livasId: number, employeeLivasId?: number | null, firstName: string, lastName: string } | null } | null> } } | null } | null> } } | null } | null> } } | null } | null> } | null };

export type GetReservedTimesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetReservedTimesQuery = { __typename?: 'Query', reservedTimes?: { __typename?: 'ReservedTimeTypeConnection', edges: Array<{ __typename?: 'ReservedTimeTypeEdge', node?: { __typename?: 'ReservedTimeType', title: string, dayOfTheWeek: ReservedTimeDayOfTheWeek, timeFrom: any, timeTo: any, region?: { __typename?: 'RegionType', id: string, title: string } | null } | null } | null> } | null };

export type GetRequestActivitiesQueryVariables = Exact<{
  createdBy?: InputMaybe<Scalars['String']>;
  createdAt_Gte?: InputMaybe<Scalars['Date']>;
  createdAt_Lte?: InputMaybe<Scalars['Date']>;
  phone?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  after?: InputMaybe<Scalars['String']>;
  orderBy?: InputMaybe<Scalars['String']>;
}>;


export type GetRequestActivitiesQuery = { __typename?: 'Query', requestsActivities?: { __typename?: 'RequestsActivityTypeConnection', totalCount?: number | null, pageInfo: { __typename?: 'PageInfo', endCursor?: string | null }, edges: Array<{ __typename?: 'RequestsActivityTypeEdge', cursor: string, node?: { __typename?: 'RequestsActivityType', id: string, createdAt: any, phone?: string | null, comment?: string | null, createdBy?: { __typename?: 'UserProfileMType', fullName: string } | null, contact?: { __typename?: 'CandidateType', firstName: string, lastName: string } | null, clientContact?: { __typename?: 'ContactType', firstName: string, lastName?: string | null, company: { __typename?: 'CompanyType', name: string } } | null, reason: { __typename?: 'ReasonType', title: string } } | null } | null> } | null };

export type UpdateContactRequestActivityMutationVariables = Exact<{
  input: UpdateRequestsActivityInput;
}>;


export type UpdateContactRequestActivityMutation = { __typename?: 'Mutation', updateRequestsActivity?: { __typename?: 'UpdateRequestsActivityPayload', requestsActivity?: { __typename?: 'RequestsActivityType', id: string, comment?: string | null, phone?: string | null, reason: { __typename?: 'ReasonType', id: string, title: string } } | null } | null };

export type GetAllReasonsQueryVariables = Exact<{
  id?: InputMaybe<Scalars['ID']>;
}>;


export type GetAllReasonsQuery = { __typename?: 'Query', allReasons?: { __typename?: 'ReasonTypeConnection', edges: Array<{ __typename?: 'ReasonTypeEdge', node?: { __typename?: 'ReasonType', id: string, title: string } | null } | null> } | null };

export type GetRiskFactorsQueryVariables = Exact<{
  title?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['ID']>;
}>;


export type GetRiskFactorsQuery = { __typename?: 'Query', riskFactors?: Array<{ __typename?: 'RiskFactorType', id: string, title: string, isDefault: boolean, country?: { __typename?: 'CountryType', id: string, isoCode?: string | null } | null } | null> | null };

export type SelectionActionListItemFieldsFragment = { __typename?: 'TaskType', id: string, comment?: string | null, durationMinutes?: number | null, date: any, status: TaskStatus, category?: { __typename?: 'SACategoryType', id: string, title: string } | null, createdBy?: { __typename?: 'UserProfileMType', id: string, fullName: string } | null, completedBy?: Array<{ __typename?: 'UserProfileMType', id: string, fullName: string, color?: string | null, user: { __typename?: 'UserType', id: string, firstName: string, lastName: string } } | null> | null, searchResults?: { __typename?: 'SearchResultsType', totalCount: number, touchedCount: number, successCount: number } | null };

export type SaCategoryFieldsFragment = { __typename?: 'SACategoryType', id: string, title: string, hint?: string | null, durationMinutes?: number | null };

export type SaCategoryGroupsFieldsFragment = { __typename?: 'SACategoryGroupType', id: string, title: string, department?: SaCategoryGroupDepartment | null, country?: { __typename?: 'CountryType', id: string } | null, sacategorySet: { __typename?: 'SACategoryTypeConnection', edges: Array<{ __typename?: 'SACategoryTypeEdge', node?: { __typename?: 'SACategoryType', requiresDashboard: boolean, id: string, title: string, hint?: string | null, durationMinutes?: number | null, showDuration: boolean, showOrder: boolean, showCompany: boolean, showDescription: boolean, showCandidate: boolean, showNextTaskAssignee: boolean, customFields: { __typename?: 'CustomFieldTypeConnection', edges: Array<{ __typename?: 'CustomFieldTypeEdge', node?: { __typename?: 'CustomFieldType', id: string, name: string, hintText?: string | null, options?: any | null, fieldType: { __typename?: 'CustomFieldDefinitionType', id: string, name: string, fieldType: CustomFieldDefinitionFieldType } } | null } | null> } } | null } | null> } };

export type CreateSeletionActionMutationVariables = Exact<{
  orderId: Scalars['ID'];
  comment: Scalars['String'];
  category?: InputMaybe<Scalars['ID']>;
  durationMinutes?: InputMaybe<Scalars['Int']>;
  date: Scalars['Date'];
  completedBy?: InputMaybe<Array<InputMaybe<Scalars['ID']>> | InputMaybe<Scalars['ID']>>;
}>;


export type CreateSeletionActionMutation = { __typename?: 'Mutation', createSelectionAction?: { __typename?: 'CreateSelectionActionPayload', task?: { __typename?: 'TaskType', id: string, comment?: string | null, durationMinutes?: number | null, date: any, status: TaskStatus, category?: { __typename?: 'SACategoryType', id: string, title: string } | null, createdBy?: { __typename?: 'UserProfileMType', id: string, fullName: string } | null, completedBy?: Array<{ __typename?: 'UserProfileMType', id: string, fullName: string, color?: string | null, user: { __typename?: 'UserType', id: string, firstName: string, lastName: string } } | null> | null, searchResults?: { __typename?: 'SearchResultsType', totalCount: number, touchedCount: number, successCount: number } | null } | null } | null };

export type UpdateSeletionActionMutationVariables = Exact<{
  id: Scalars['ID'];
  comment: Scalars['String'];
  date: Scalars['Date'];
  category?: InputMaybe<Scalars['ID']>;
  durationMinutes?: InputMaybe<Scalars['Int']>;
  completedBy?: InputMaybe<Array<InputMaybe<Scalars['ID']>> | InputMaybe<Scalars['ID']>>;
  status?: InputMaybe<TaskStatus>;
}>;


export type UpdateSeletionActionMutation = { __typename?: 'Mutation', updateSelectionAction?: { __typename?: 'UpdateSelectionActionPayload', task?: { __typename?: 'TaskType', id: string, comment?: string | null, durationMinutes?: number | null, date: any, status: TaskStatus, category?: { __typename?: 'SACategoryType', id: string, title: string } | null, createdBy?: { __typename?: 'UserProfileMType', id: string, fullName: string } | null, completedBy?: Array<{ __typename?: 'UserProfileMType', id: string, fullName: string, color?: string | null, user: { __typename?: 'UserType', id: string, firstName: string, lastName: string } } | null> | null, searchResults?: { __typename?: 'SearchResultsType', totalCount: number, touchedCount: number, successCount: number } | null } | null } | null };

export type DeleteSeletionActionMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DeleteSeletionActionMutation = { __typename?: 'Mutation', deleteSelectionAction?: { __typename?: 'DeleteSelectionActionPayload', task?: { __typename?: 'TaskType', id: string } | null } | null };

export type GetSelectionActionsQueryVariables = Exact<{
  orderId?: InputMaybe<Scalars['ID']>;
  company?: InputMaybe<Scalars['ID']>;
  orderBy?: InputMaybe<Scalars['String']>;
  date_Lte?: InputMaybe<Scalars['Date']>;
  date_Gte?: InputMaybe<Scalars['Date']>;
  categories?: InputMaybe<Array<InputMaybe<Scalars['ID']>> | InputMaybe<Scalars['ID']>>;
}>;


export type GetSelectionActionsQuery = { __typename?: 'Query', tasks?: { __typename?: 'TaskTypeConnection', totalCount?: number | null, edges: Array<{ __typename?: 'TaskTypeEdge', node?: { __typename?: 'TaskType', id: string, comment?: string | null, durationMinutes?: number | null, date: any, status: TaskStatus, category?: { __typename?: 'SACategoryType', id: string, title: string } | null, createdBy?: { __typename?: 'UserProfileMType', id: string, fullName: string } | null, completedBy?: Array<{ __typename?: 'UserProfileMType', id: string, fullName: string, color?: string | null, user: { __typename?: 'UserType', id: string, firstName: string, lastName: string } } | null> | null, searchResults?: { __typename?: 'SearchResultsType', totalCount: number, touchedCount: number, successCount: number } | null } | null } | null> } | null };

export type GetSelectionActionGroupedCategoriesQueryVariables = Exact<{
  country?: InputMaybe<Scalars['ID']>;
}>;


export type GetSelectionActionGroupedCategoriesQuery = { __typename?: 'Query', selectionActionCategoryGroups?: { __typename?: 'SACategoryGroupTypeConnection', totalCount?: number | null, edges: Array<{ __typename?: 'SACategoryGroupTypeEdge', node?: { __typename?: 'SACategoryGroupType', id: string, title: string, department?: SaCategoryGroupDepartment | null, country?: { __typename?: 'CountryType', id: string } | null, sacategorySet: { __typename?: 'SACategoryTypeConnection', edges: Array<{ __typename?: 'SACategoryTypeEdge', node?: { __typename?: 'SACategoryType', requiresDashboard: boolean, id: string, title: string, hint?: string | null, durationMinutes?: number | null, showDuration: boolean, showOrder: boolean, showCompany: boolean, showDescription: boolean, showCandidate: boolean, showNextTaskAssignee: boolean, customFields: { __typename?: 'CustomFieldTypeConnection', edges: Array<{ __typename?: 'CustomFieldTypeEdge', node?: { __typename?: 'CustomFieldType', id: string, name: string, hintText?: string | null, options?: any | null, fieldType: { __typename?: 'CustomFieldDefinitionType', id: string, name: string, fieldType: CustomFieldDefinitionFieldType } } | null } | null> } } | null } | null> } } | null } | null> } | null };

export type SpecificationDetailFieldsFragment = { __typename?: 'SpecificationType', id: string, name: string, positionTitle: string, workFunctions?: string | null, address?: string | null, intensity?: SpecificationIntensity | null, onboardingDuration?: string | null, male: boolean, female: boolean, ageFrom?: number | null, isQualificationImprovementPossible: boolean, clientWashesClothes?: boolean | null, ageTo?: number | null, allFunctionsFromFirstDay: boolean, isWorkplaceVideoAllowed: boolean, isWorkplaceVisitAllowed: boolean, isLogoPublicAllowed: boolean, isCompanyModern: boolean, isCompanyInternational: boolean, shiftDuration?: number | null, breakDuration?: number | null, scheduleType?: number | null, shiftPattern?: any | null, scheduleText?: string | null, minExperienceMonths?: number | null, experienceType: SpecificationExperienceType, isSecurityPostPresent?: boolean | null, isMagneticKeyIssued?: boolean | null, whoIssuesMagneticKey?: string | null, additionalRecruitementInformation?: string | null, careerPossibilities?: string | null, requirementsOther?: string | null, canEmployUa: boolean, healthcheckType?: SpecificationHealthcheckType | null, competences: { __typename?: 'CompetenceTypeConnection', edges: Array<{ __typename?: 'CompetenceTypeEdge', node?: { __typename?: 'CompetenceType', id: string, title: string, color?: string | null } | null } | null> }, certificates: Array<{ __typename?: 'CertificateType', id: string, title?: string | null }>, riskFactors: Array<{ __typename?: 'RiskFactorType', id: string, title: string, isDefault: boolean }>, scheduleTypes: Array<{ __typename?: 'ScheduleTypeType', id: string, title: string }>, mandatoryRequirements: Array<{ __typename?: 'RequirementType', id: string, requirement?: string | null }>, optionalRequirements: Array<{ __typename?: 'RequirementType', id: string, requirement?: string | null }>, tagassignmentSet: Array<{ __typename?: 'TagAssignmentType', id: string, comment: string, tag: { __typename?: 'TagType', id: string, key?: string | null, group?: { __typename?: 'TagGroupType', id: string, key: string } | null } }>, salary?: { __typename?: 'SpecificationSalaryType', id: string, hourlyNettoFrom?: number | null, hourlyNettoTo?: number | null, hourlyBruttoFrom?: number | null, hourlyBruttoTo?: number | null, monthlyNettoFrom?: number | null, monthlyNettoTo?: number | null, monthlyBruttoFrom?: number | null, monthlyBruttoTo?: number | null, hourlyNettoFromFilled: boolean, hourlyNettoToFilled: boolean, hourlyBruttoFromFilled: boolean, hourlyBruttoToFilled: boolean, monthlyNettoFromFilled: boolean, monthlyNettoToFilled: boolean, monthlyBruttoFromFilled: boolean, monthlyBruttoToFilled: boolean, useInTemplate: SpecificationSalaryUseInTemplate, description?: string | null, passDescriptionToTemplate?: boolean | null } | null, personalProtectiveEquipmentBiuro: Array<{ __typename?: 'PersonalProtectiveEquipmentType', id: string }>, personalProtectiveEquipmentClient: Array<{ __typename?: 'PersonalProtectiveEquipmentType', id: string }>, ppeItems?: Array<{ __typename?: 'SpecificationPPEType', customEquipment?: string | null, provider: SpecificationPpeProvider } | null> | null };

export type RequirementFieldsFragment = { __typename?: 'RequirementType', id: string, requirement?: string | null };

export type CompanyDetailFieldsFragment = { __typename?: 'CompanyType', id: string, name: string, status?: string | null, insightlyId?: number | null, color: HistoricalCompanyColor, contractSet: Array<{ __typename?: 'ContractType', id: string, validFromDate?: any | null, validTillDate?: any | null, contractor?: { __typename?: 'ContractorType', id: string, logoUrl?: string | null } | null }>, contactSet: { __typename?: 'ContactTypeConnection', edges: Array<{ __typename?: 'ContactTypeEdge', node?: { __typename?: 'ContactType', id: string, firstName: string, lastName?: string | null } | null } | null> }, specificationSet: Array<{ __typename?: 'SpecificationType', id: string, positionTitle: string }> };

export type PpeFieldsFragment = { __typename?: 'PersonalProtectiveEquipmentType', id: string, title: string, specificationppeSet: Array<{ __typename?: 'SpecificationPPEType', customEquipment?: string | null, provider: SpecificationPpeProvider }> };

export type TagsFieldsFragment = { __typename?: 'TagType', id: string, title: string, hint?: string | null, order: number };

export type CertificateFragment = { __typename?: 'CertificateType', id: string, title?: string | null };

export type CreateSpecificationMutationVariables = Exact<{
  input: SpecificationInput;
  companyId: Scalars['ID'];
}>;


export type CreateSpecificationMutation = { __typename?: 'Mutation', createSpecification?: { __typename?: 'CreateSpecification', specification?: { __typename?: 'SpecificationType', id: string, name: string, positionTitle: string, workFunctions?: string | null, address?: string | null, intensity?: SpecificationIntensity | null, onboardingDuration?: string | null, male: boolean, female: boolean, ageFrom?: number | null, isQualificationImprovementPossible: boolean, clientWashesClothes?: boolean | null, ageTo?: number | null, allFunctionsFromFirstDay: boolean, isWorkplaceVideoAllowed: boolean, isWorkplaceVisitAllowed: boolean, isLogoPublicAllowed: boolean, isCompanyModern: boolean, isCompanyInternational: boolean, shiftDuration?: number | null, breakDuration?: number | null, scheduleType?: number | null, shiftPattern?: any | null, scheduleText?: string | null, minExperienceMonths?: number | null, experienceType: SpecificationExperienceType, isSecurityPostPresent?: boolean | null, isMagneticKeyIssued?: boolean | null, whoIssuesMagneticKey?: string | null, additionalRecruitementInformation?: string | null, careerPossibilities?: string | null, requirementsOther?: string | null, canEmployUa: boolean, healthcheckType?: SpecificationHealthcheckType | null, competences: { __typename?: 'CompetenceTypeConnection', edges: Array<{ __typename?: 'CompetenceTypeEdge', node?: { __typename?: 'CompetenceType', id: string, title: string, color?: string | null } | null } | null> }, certificates: Array<{ __typename?: 'CertificateType', id: string, title?: string | null }>, riskFactors: Array<{ __typename?: 'RiskFactorType', id: string, title: string, isDefault: boolean }>, scheduleTypes: Array<{ __typename?: 'ScheduleTypeType', id: string, title: string }>, mandatoryRequirements: Array<{ __typename?: 'RequirementType', id: string, requirement?: string | null }>, optionalRequirements: Array<{ __typename?: 'RequirementType', id: string, requirement?: string | null }>, tagassignmentSet: Array<{ __typename?: 'TagAssignmentType', id: string, comment: string, tag: { __typename?: 'TagType', id: string, key?: string | null, group?: { __typename?: 'TagGroupType', id: string, key: string } | null } }>, salary?: { __typename?: 'SpecificationSalaryType', id: string, hourlyNettoFrom?: number | null, hourlyNettoTo?: number | null, hourlyBruttoFrom?: number | null, hourlyBruttoTo?: number | null, monthlyNettoFrom?: number | null, monthlyNettoTo?: number | null, monthlyBruttoFrom?: number | null, monthlyBruttoTo?: number | null, hourlyNettoFromFilled: boolean, hourlyNettoToFilled: boolean, hourlyBruttoFromFilled: boolean, hourlyBruttoToFilled: boolean, monthlyNettoFromFilled: boolean, monthlyNettoToFilled: boolean, monthlyBruttoFromFilled: boolean, monthlyBruttoToFilled: boolean, useInTemplate: SpecificationSalaryUseInTemplate, description?: string | null, passDescriptionToTemplate?: boolean | null } | null, personalProtectiveEquipmentBiuro: Array<{ __typename?: 'PersonalProtectiveEquipmentType', id: string }>, personalProtectiveEquipmentClient: Array<{ __typename?: 'PersonalProtectiveEquipmentType', id: string }>, ppeItems?: Array<{ __typename?: 'SpecificationPPEType', customEquipment?: string | null, provider: SpecificationPpeProvider } | null> | null } | null } | null };

export type SpecificationUpdateMutationVariables = Exact<{
  input: SpecificationModelUpdateMutationInput;
}>;


export type SpecificationUpdateMutation = { __typename?: 'Mutation', specificationUpdate?: { __typename?: 'SpecificationModelUpdateMutationPayload', specification?: { __typename?: 'SpecificationType', id: string, name: string, positionTitle: string, workFunctions?: string | null, address?: string | null, intensity?: SpecificationIntensity | null, onboardingDuration?: string | null, male: boolean, female: boolean, ageFrom?: number | null, isQualificationImprovementPossible: boolean, clientWashesClothes?: boolean | null, ageTo?: number | null, allFunctionsFromFirstDay: boolean, isWorkplaceVideoAllowed: boolean, isWorkplaceVisitAllowed: boolean, isLogoPublicAllowed: boolean, isCompanyModern: boolean, isCompanyInternational: boolean, shiftDuration?: number | null, breakDuration?: number | null, scheduleType?: number | null, shiftPattern?: any | null, scheduleText?: string | null, minExperienceMonths?: number | null, experienceType: SpecificationExperienceType, isSecurityPostPresent?: boolean | null, isMagneticKeyIssued?: boolean | null, whoIssuesMagneticKey?: string | null, additionalRecruitementInformation?: string | null, careerPossibilities?: string | null, requirementsOther?: string | null, canEmployUa: boolean, healthcheckType?: SpecificationHealthcheckType | null, competences: { __typename?: 'CompetenceTypeConnection', edges: Array<{ __typename?: 'CompetenceTypeEdge', node?: { __typename?: 'CompetenceType', id: string, title: string, color?: string | null } | null } | null> }, certificates: Array<{ __typename?: 'CertificateType', id: string, title?: string | null }>, riskFactors: Array<{ __typename?: 'RiskFactorType', id: string, title: string, isDefault: boolean }>, scheduleTypes: Array<{ __typename?: 'ScheduleTypeType', id: string, title: string }>, mandatoryRequirements: Array<{ __typename?: 'RequirementType', id: string, requirement?: string | null }>, optionalRequirements: Array<{ __typename?: 'RequirementType', id: string, requirement?: string | null }>, tagassignmentSet: Array<{ __typename?: 'TagAssignmentType', id: string, comment: string, tag: { __typename?: 'TagType', id: string, key?: string | null, group?: { __typename?: 'TagGroupType', id: string, key: string } | null } }>, salary?: { __typename?: 'SpecificationSalaryType', id: string, hourlyNettoFrom?: number | null, hourlyNettoTo?: number | null, hourlyBruttoFrom?: number | null, hourlyBruttoTo?: number | null, monthlyNettoFrom?: number | null, monthlyNettoTo?: number | null, monthlyBruttoFrom?: number | null, monthlyBruttoTo?: number | null, hourlyNettoFromFilled: boolean, hourlyNettoToFilled: boolean, hourlyBruttoFromFilled: boolean, hourlyBruttoToFilled: boolean, monthlyNettoFromFilled: boolean, monthlyNettoToFilled: boolean, monthlyBruttoFromFilled: boolean, monthlyBruttoToFilled: boolean, useInTemplate: SpecificationSalaryUseInTemplate, description?: string | null, passDescriptionToTemplate?: boolean | null } | null, personalProtectiveEquipmentBiuro: Array<{ __typename?: 'PersonalProtectiveEquipmentType', id: string }>, personalProtectiveEquipmentClient: Array<{ __typename?: 'PersonalProtectiveEquipmentType', id: string }>, ppeItems?: Array<{ __typename?: 'SpecificationPPEType', customEquipment?: string | null, provider: SpecificationPpeProvider } | null> | null } | null } | null };

export type SpecificationCreateMutationVariables = Exact<{
  input: SpecificationModelCreateMutationInput;
}>;


export type SpecificationCreateMutation = { __typename?: 'Mutation', specificationCreate?: { __typename?: 'SpecificationModelCreateMutationPayload', specification?: { __typename?: 'SpecificationType', id: string, name: string, positionTitle: string, workFunctions?: string | null, address?: string | null, intensity?: SpecificationIntensity | null, onboardingDuration?: string | null, male: boolean, female: boolean, ageFrom?: number | null, isQualificationImprovementPossible: boolean, clientWashesClothes?: boolean | null, ageTo?: number | null, allFunctionsFromFirstDay: boolean, isWorkplaceVideoAllowed: boolean, isWorkplaceVisitAllowed: boolean, isLogoPublicAllowed: boolean, isCompanyModern: boolean, isCompanyInternational: boolean, shiftDuration?: number | null, breakDuration?: number | null, scheduleType?: number | null, shiftPattern?: any | null, scheduleText?: string | null, minExperienceMonths?: number | null, experienceType: SpecificationExperienceType, isSecurityPostPresent?: boolean | null, isMagneticKeyIssued?: boolean | null, whoIssuesMagneticKey?: string | null, additionalRecruitementInformation?: string | null, careerPossibilities?: string | null, requirementsOther?: string | null, canEmployUa: boolean, healthcheckType?: SpecificationHealthcheckType | null, competences: { __typename?: 'CompetenceTypeConnection', edges: Array<{ __typename?: 'CompetenceTypeEdge', node?: { __typename?: 'CompetenceType', id: string, title: string, color?: string | null } | null } | null> }, certificates: Array<{ __typename?: 'CertificateType', id: string, title?: string | null }>, riskFactors: Array<{ __typename?: 'RiskFactorType', id: string, title: string, isDefault: boolean }>, scheduleTypes: Array<{ __typename?: 'ScheduleTypeType', id: string, title: string }>, mandatoryRequirements: Array<{ __typename?: 'RequirementType', id: string, requirement?: string | null }>, optionalRequirements: Array<{ __typename?: 'RequirementType', id: string, requirement?: string | null }>, tagassignmentSet: Array<{ __typename?: 'TagAssignmentType', id: string, comment: string, tag: { __typename?: 'TagType', id: string, key?: string | null, group?: { __typename?: 'TagGroupType', id: string, key: string } | null } }>, salary?: { __typename?: 'SpecificationSalaryType', id: string, hourlyNettoFrom?: number | null, hourlyNettoTo?: number | null, hourlyBruttoFrom?: number | null, hourlyBruttoTo?: number | null, monthlyNettoFrom?: number | null, monthlyNettoTo?: number | null, monthlyBruttoFrom?: number | null, monthlyBruttoTo?: number | null, hourlyNettoFromFilled: boolean, hourlyNettoToFilled: boolean, hourlyBruttoFromFilled: boolean, hourlyBruttoToFilled: boolean, monthlyNettoFromFilled: boolean, monthlyNettoToFilled: boolean, monthlyBruttoFromFilled: boolean, monthlyBruttoToFilled: boolean, useInTemplate: SpecificationSalaryUseInTemplate, description?: string | null, passDescriptionToTemplate?: boolean | null } | null, personalProtectiveEquipmentBiuro: Array<{ __typename?: 'PersonalProtectiveEquipmentType', id: string }>, personalProtectiveEquipmentClient: Array<{ __typename?: 'PersonalProtectiveEquipmentType', id: string }>, ppeItems?: Array<{ __typename?: 'SpecificationPPEType', customEquipment?: string | null, provider: SpecificationPpeProvider } | null> | null } | null, errors?: Array<{ __typename?: 'MutationErrorType', field?: string | null, message?: string | null }> | null } | null };

export type UpdateSpecificationMutationVariables = Exact<{
  specification: SpecificationInput;
  id: Scalars['ID'];
}>;


export type UpdateSpecificationMutation = { __typename?: 'Mutation', updateSpecification?: { __typename?: 'UpdateSpecification', specification?: { __typename?: 'SpecificationType', id: string, name: string, positionTitle: string, workFunctions?: string | null, address?: string | null, intensity?: SpecificationIntensity | null, onboardingDuration?: string | null, male: boolean, female: boolean, ageFrom?: number | null, isQualificationImprovementPossible: boolean, clientWashesClothes?: boolean | null, ageTo?: number | null, allFunctionsFromFirstDay: boolean, isWorkplaceVideoAllowed: boolean, isWorkplaceVisitAllowed: boolean, isLogoPublicAllowed: boolean, isCompanyModern: boolean, isCompanyInternational: boolean, shiftDuration?: number | null, breakDuration?: number | null, scheduleType?: number | null, shiftPattern?: any | null, scheduleText?: string | null, minExperienceMonths?: number | null, experienceType: SpecificationExperienceType, isSecurityPostPresent?: boolean | null, isMagneticKeyIssued?: boolean | null, whoIssuesMagneticKey?: string | null, additionalRecruitementInformation?: string | null, careerPossibilities?: string | null, requirementsOther?: string | null, canEmployUa: boolean, healthcheckType?: SpecificationHealthcheckType | null, competences: { __typename?: 'CompetenceTypeConnection', edges: Array<{ __typename?: 'CompetenceTypeEdge', node?: { __typename?: 'CompetenceType', id: string, title: string, color?: string | null } | null } | null> }, certificates: Array<{ __typename?: 'CertificateType', id: string, title?: string | null }>, riskFactors: Array<{ __typename?: 'RiskFactorType', id: string, title: string, isDefault: boolean }>, scheduleTypes: Array<{ __typename?: 'ScheduleTypeType', id: string, title: string }>, mandatoryRequirements: Array<{ __typename?: 'RequirementType', id: string, requirement?: string | null }>, optionalRequirements: Array<{ __typename?: 'RequirementType', id: string, requirement?: string | null }>, tagassignmentSet: Array<{ __typename?: 'TagAssignmentType', id: string, comment: string, tag: { __typename?: 'TagType', id: string, key?: string | null, group?: { __typename?: 'TagGroupType', id: string, key: string } | null } }>, salary?: { __typename?: 'SpecificationSalaryType', id: string, hourlyNettoFrom?: number | null, hourlyNettoTo?: number | null, hourlyBruttoFrom?: number | null, hourlyBruttoTo?: number | null, monthlyNettoFrom?: number | null, monthlyNettoTo?: number | null, monthlyBruttoFrom?: number | null, monthlyBruttoTo?: number | null, hourlyNettoFromFilled: boolean, hourlyNettoToFilled: boolean, hourlyBruttoFromFilled: boolean, hourlyBruttoToFilled: boolean, monthlyNettoFromFilled: boolean, monthlyNettoToFilled: boolean, monthlyBruttoFromFilled: boolean, monthlyBruttoToFilled: boolean, useInTemplate: SpecificationSalaryUseInTemplate, description?: string | null, passDescriptionToTemplate?: boolean | null } | null, personalProtectiveEquipmentBiuro: Array<{ __typename?: 'PersonalProtectiveEquipmentType', id: string }>, personalProtectiveEquipmentClient: Array<{ __typename?: 'PersonalProtectiveEquipmentType', id: string }>, ppeItems?: Array<{ __typename?: 'SpecificationPPEType', customEquipment?: string | null, provider: SpecificationPpeProvider } | null> | null } | null } | null };

export type CreateRequirementMutationVariables = Exact<{
  englishValue?: InputMaybe<Scalars['String']>;
  localValue?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['ID']>;
}>;


export type CreateRequirementMutation = { __typename?: 'Mutation', createRequirement?: { __typename?: 'CreateRequirement', requirement?: { __typename?: 'RequirementType', id: string, requirement?: string | null } | null } | null };

export type UpdateCompanyMutationVariables = Exact<{
  id: Scalars['Int'];
  livasId?: InputMaybe<Scalars['Int']>;
  contractorId: Scalars['ID'];
}>;


export type UpdateCompanyMutation = { __typename?: 'Mutation', updateCompany?: { __typename?: 'UpdateCompany', ok?: boolean | null, company?: { __typename?: 'CompanyType', id: string, name: string, status?: string | null, insightlyId?: number | null, color: HistoricalCompanyColor, contractSet: Array<{ __typename?: 'ContractType', id: string, validFromDate?: any | null, validTillDate?: any | null, contractor?: { __typename?: 'ContractorType', id: string, logoUrl?: string | null } | null }>, contactSet: { __typename?: 'ContactTypeConnection', edges: Array<{ __typename?: 'ContactTypeEdge', node?: { __typename?: 'ContactType', id: string, firstName: string, lastName?: string | null } | null } | null> }, specificationSet: Array<{ __typename?: 'SpecificationType', id: string, positionTitle: string }> } | null } | null };

export type CreateCompanyMutationVariables = Exact<{
  company: CompanyInput;
}>;


export type CreateCompanyMutation = { __typename?: 'Mutation', createCompany?: { __typename?: 'CreateCompany', ok?: boolean | null, company?: { __typename?: 'CompanyType', id: string, name: string, status?: string | null, insightlyId?: number | null, color: HistoricalCompanyColor, contractSet: Array<{ __typename?: 'ContractType', id: string, validFromDate?: any | null, validTillDate?: any | null, contractor?: { __typename?: 'ContractorType', id: string, logoUrl?: string | null } | null }>, contactSet: { __typename?: 'ContactTypeConnection', edges: Array<{ __typename?: 'ContactTypeEdge', node?: { __typename?: 'ContactType', id: string, firstName: string, lastName?: string | null } | null } | null> }, specificationSet: Array<{ __typename?: 'SpecificationType', id: string, positionTitle: string }> } | null } | null };

export type CopySpecificationMutationVariables = Exact<{
  id: Scalars['Int'];
}>;


export type CopySpecificationMutation = { __typename?: 'Mutation', copySpecification?: { __typename?: 'CopySpecification', specification?: { __typename?: 'SpecificationType', id: string } | null } | null };

export type CompetencesQueryVariables = Exact<{
  country?: InputMaybe<Scalars['ID']>;
}>;


export type CompetencesQuery = { __typename?: 'Query', competences?: { __typename?: 'CompetenceTypeConnection', edges: Array<{ __typename?: 'CompetenceTypeEdge', node?: { __typename?: 'CompetenceType', id: string, title: string, color?: string | null } | null } | null> } | null };

export type TagGroupsQueryVariables = Exact<{
  country?: InputMaybe<Scalars['ID']>;
}>;


export type TagGroupsQuery = { __typename?: 'Query', tagsGroups?: Array<{ __typename?: 'TagGroupType', key: string, tagSet: Array<{ __typename?: 'TagType', id: string, title: string, hint?: string | null, order: number }> } | null> | null };

export type GetTagsGroupsWithPpeQueryVariables = Exact<{
  country?: InputMaybe<Scalars['ID']>;
}>;


export type GetTagsGroupsWithPpeQuery = { __typename?: 'Query', tagsGroups?: Array<{ __typename?: 'TagGroupType', id: string, key: string, tagSet: Array<{ __typename?: 'TagType', id: string, title: string, hint?: string | null, order: number }> } | null> | null, personalProtectiveEquipment?: Array<{ __typename?: 'PersonalProtectiveEquipmentType', id: string, title: string, specificationppeSet: Array<{ __typename?: 'SpecificationPPEType', customEquipment?: string | null, provider: SpecificationPpeProvider }> } | null> | null };

export type RequirementsQueryVariables = Exact<{
  requirement?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['ID']>;
  language?: InputMaybe<Scalars['String']>;
}>;


export type RequirementsQuery = { __typename?: 'Query', requirements?: Array<{ __typename?: 'RequirementType', id: string, requirement?: string | null } | null> | null };

export type CertificatesQueryVariables = Exact<{
  country?: InputMaybe<Scalars['ID']>;
  language?: InputMaybe<Scalars['String']>;
}>;


export type CertificatesQuery = { __typename?: 'Query', certificates?: Array<{ __typename?: 'CertificateType', title?: string | null, id: string } | null> | null };

export type OrderListCandidatesStatsFieldsFragment = { __typename?: 'CandidateOrderStatsType', orderId?: string | null, toBeInterviewed?: number | null, toBeInterviewedClient?: number | null, healthCheckPending?: number | null, toBeEmployed?: number | null, offeredFromDate?: number | null, offeredLast7Days?: number | null, presentedClient?: number | null, presentedClientSuccess?: number | null, presentedClientFailed?: number | null, longListedLast7Days?: number | null, offeredLast1Day?: number | null, longListedLast1Day?: number | null };

export type OrderCandidateStatsQueryVariables = Exact<{
  orderIds?: InputMaybe<Array<InputMaybe<Scalars['ID']>> | InputMaybe<Scalars['ID']>>;
  dateFrom?: InputMaybe<Scalars['Date']>;
}>;


export type OrderCandidateStatsQuery = { __typename?: 'Query', candidateOrderStats?: Array<{ __typename?: 'CandidateOrderStatsType', orderId?: string | null, toBeInterviewed?: number | null, toBeInterviewedClient?: number | null, healthCheckPending?: number | null, toBeEmployed?: number | null, offeredFromDate?: number | null, offeredLast7Days?: number | null, presentedClient?: number | null, presentedClientSuccess?: number | null, presentedClientFailed?: number | null, longListedLast7Days?: number | null, offeredLast1Day?: number | null, longListedLast1Day?: number | null } | null> | null };

export type CandidateEventsFieldsFragment = { __typename?: 'CandidateEventType', id: string, startDatetime?: any | null, eventType: EventEventType, resolutionStatus?: EventResolutionStatus | null, candidate: { __typename?: 'CandidateType', id: string, firstName: string, lastName: string, livasId: number } };

export type CandidateEventsForOrderQueryVariables = Exact<{
  orderId?: InputMaybe<Scalars['ID']>;
  eventType?: InputMaybe<Scalars['String']>;
}>;


export type CandidateEventsForOrderQuery = { __typename?: 'Query', candidateEvents?: { __typename?: 'CandidateEventTypeConnection', edges: Array<{ __typename?: 'CandidateEventTypeEdge', node?: { __typename?: 'CandidateEventType', id: string, startDatetime?: any | null, eventType: EventEventType, resolutionStatus?: EventResolutionStatus | null, candidate: { __typename?: 'CandidateType', id: string, firstName: string, lastName: string, livasId: number } } | null } | null> } | null };

export type CandidateEventsForTableQueryVariables = Exact<{
  candidate?: InputMaybe<Scalars['ID']>;
}>;


export type CandidateEventsForTableQuery = { __typename?: 'Query', candidateEvents?: { __typename?: 'CandidateEventTypeConnection', edges: Array<{ __typename?: 'CandidateEventTypeEdge', node?: { __typename?: 'CandidateEventType', id: string, startDatetime?: any | null, eventType: EventEventType, resolutionStatus?: EventResolutionStatus | null, candidate: { __typename?: 'CandidateType', id: string, firstName: string, lastName: string, livasId: number } } | null } | null> } | null };

export type OrderStatsFieldsFragment = { __typename?: 'OfferPropositionStatsType', interestedCount?: number | null, notInterestedCount?: number | null, interestedCallCount?: number | null, notInterestedCallCount?: number | null, signed?: number | null, totalOffered?: number | null, totalInterested?: number | null, totalNotInterested?: number | null };

export type OrderStatsQueryVariables = Exact<{
  orderId?: InputMaybe<Scalars['Int']>;
  dateTo?: InputMaybe<Scalars['Date']>;
  dateFrom?: InputMaybe<Scalars['Date']>;
}>;


export type OrderStatsQuery = { __typename?: 'Query', offerPropositionStats?: { __typename?: 'OfferPropositionStatsType', interestedCount?: number | null, notInterestedCount?: number | null, interestedCallCount?: number | null, notInterestedCallCount?: number | null, signed?: number | null, totalOffered?: number | null, totalInterested?: number | null, totalNotInterested?: number | null } | null };

export type MeFieldsFragment = { __typename?: 'UserProfileMType', id: string, fullName: string, department?: UserProfileDepartment | null, color?: string | null, region?: { __typename?: 'RegionType', id: string, country?: { __typename?: 'CountryType', id: string, title: string } | null } | null, user: { __typename?: 'UserType', email: string } };

export type GetMeQueryVariables = Exact<{ [key: string]: never; }>;


export type GetMeQuery = { __typename?: 'Query', me?: { __typename?: 'UserProfileMType', id: string, fullName: string, department?: UserProfileDepartment | null, color?: string | null, region?: { __typename?: 'RegionType', id: string, country?: { __typename?: 'CountryType', id: string, title: string } | null } | null, user: { __typename?: 'UserType', email: string } } | null };

export type CheckSuperuserRightsQueryVariables = Exact<{ [key: string]: never; }>;


export type CheckSuperuserRightsQuery = { __typename?: 'Query', me?: { __typename?: 'UserProfileMType', user: { __typename?: 'UserType', isSuperuser: boolean } } | null };

export const CancellationReasonsGroupFieldsFragmentDoc = gql`
    fragment CancellationReasonsGroupFields on CancellationReasonGroupType {
  id
  title
  order
  cancellationReasons {
    edges {
      node {
        id
        title
        order
      }
    }
  }
}
    `;
export const CovidLabelsFieldsFragmentDoc = gql`
    fragment CovidLabelsFields on LabelType {
  id
  title
}
    `;
export const ContractorSelectFieldsFragmentDoc = gql`
    fragment ContractorSelectFields on ContractorType {
  id
  title
  externalId
  country {
    id
    isoCode
  }
}
    `;
export const CompanySelectFieldsFragmentDoc = gql`
    fragment CompanySelectFields on CompanyModelType {
  id
  livasId
  status
  name
  insightlyId
  description
  salesQuestionnaire
  contractSet {
    id
    validFromDate
  }
  country {
    id
    isoCode
    languageIsoCode
  }
}
    `;
export const CountryFieldsFragmentDoc = gql`
    fragment CountryFields on CountryType {
  id
  isoCode
  languageIsoCode
}
    `;
export const StandUpDashboardTaskFieldsFragmentDoc = gql`
    fragment StandUpDashboardTaskFields on TaskType {
  id
  date
  status
  comment
  durationMinutes
  completedBy {
    id
    fullName
    color
    user {
      id
      firstName
      lastName
    }
  }
  nextActionCategory {
    id
    title
  }
}
    `;
export const FreeVacanciesCalendarEventFieldsFragmentDoc = gql`
    fragment FreeVacanciesCalendarEventFields on EventType {
  id
  date
  status
  adId
  channels {
    id
    title
    icon
  }
  category {
    id
    title
    icon
  }
}
    `;
export const ContactFieldsShortFragmentDoc = gql`
    fragment ContactFieldsShort on ContactType {
  id
  firstName
  lastName
  email
  phone
}
    `;
export const UserMainFieldsFragmentDoc = gql`
    fragment UserMainFields on UserType {
  id
  email
  firstName
  lastName
}
    `;
export const CompanyMainFieldsFragmentDoc = gql`
    fragment CompanyMainFields on CompanyType {
  id
  name
  color
  description
  country {
    id
    isoCode
  }
  labels {
    edges {
      node {
        id
        title
      }
    }
  }
}
    `;
export const OrderPeriodFieldsFragmentDoc = gql`
    fragment OrderPeriodFields on OrderPeriodType {
  id
  demand
  dateTo
  dateFrom
  longTerm
}
    `;
export const FreeVacanciesSpecificationFieldsFragmentDoc = gql`
    fragment FreeVacanciesSpecificationFields on SpecificationType {
  id
  male
  female
  positionTitle
  address
  ageFrom
  ageTo
  additionalRecruitementInformation
  tagassignmentSet {
    id
    tag {
      id
      title
      order
      key
      group {
        id
        key
      }
    }
    comment
  }
  workFunctions
  mandatoryRequirements {
    id
    requirement
  }
  optionalRequirements {
    id
    requirement
  }
  isWorkplaceVideoAllowed
  isWorkplaceVisitAllowed
  shiftDuration
  breakDuration
  scheduleType
  scheduleTypes {
    id
    title
  }
  scheduleText
  shiftPattern
  intensity
  allFunctionsFromFirstDay
  onboardingDuration
  minExperienceMonths
  experienceType
  certificates {
    id
    title
  }
  riskFactors {
    id
    title
  }
  salary {
    id
    hourlyBruttoFrom
    hourlyBruttoTo
    hourlyNettoFrom
    hourlyNettoTo
    monthlyBruttoFrom
    monthlyBruttoTo
    monthlyNettoFrom
    monthlyNettoTo
    hourlyBruttoFromFilled
    hourlyBruttoToFilled
    hourlyNettoFromFilled
    hourlyNettoToFilled
    monthlyBruttoFromFilled
    monthlyBruttoToFilled
    monthlyNettoFromFilled
    monthlyNettoToFilled
    useInTemplate
  }
  canEmployUa
  healthcheckType
}
    `;
export const MarketingEventsFieldsFragmentDoc = gql`
    fragment MarketingEventsFields on EventType {
  id
  date
  status
  adId
  comment
  workisJobId
  externalPlatformId
  language
  channels {
    id
    title
    icon
  }
  category {
    id
    title
    icon
  }
}
    `;
export const FreeVacanciesListFieldsFragmentDoc = gql`
    fragment FreeVacanciesListFields on OrderType {
  id
  canGetBonuses
  canIncreaseSalary
  orderType
  toBeReviewed
  hourRateBruttoPermanent
  salaryInfo
  orderNumber
  orderPeriodFrom
  orderPeriodTo
  orderCanBeExtended
  isLongTerm
  demand
  status
  trafficGeneration
  nettoFrom
  nettoTo
  shortage
  isCompanyInternational
  isCompanyModern
  isLogoPublicAllowed
  statsFutureInterview
  clientContact {
    ...ContactFieldsShort
  }
  additionalClientContacts {
    edges {
      node {
        ...ContactFieldsShort
      }
    }
  }
  createdBy {
    id
    user {
      ...UserMainFields
    }
  }
  region {
    id
    title
  }
  company {
    ...CompanyMainFields
  }
  orderperiodSet {
    ...OrderPeriodFields
  }
  specification {
    ...FreeVacanciesSpecificationFields
  }
  eventSet {
    edges {
      node {
        ...MarketingEventsFields
      }
    }
  }
}
    ${ContactFieldsShortFragmentDoc}
${UserMainFieldsFragmentDoc}
${CompanyMainFieldsFragmentDoc}
${OrderPeriodFieldsFragmentDoc}
${FreeVacanciesSpecificationFieldsFragmentDoc}
${MarketingEventsFieldsFragmentDoc}`;
export const OfferEventFieldsFragmentDoc = gql`
    fragment OfferEventFields on CandidateEventType {
  id
  startDatetime
  resolutionStatus
  eventType
  deleted
  description
  isProblematicInterview
  relatedOffer {
    order {
      company {
        name
      }
    }
  }
}
    `;
export const InterviewWidgetOfferFieldsFragmentDoc = gql`
    fragment InterviewWidgetOfferFields on OfferPropositionType {
  id
  comment
  order {
    orderType
    id
  }
  candidate {
    id
  }
  personId
  interested
  interestedOnCall
  signed
  candidateEvents {
    edges {
      node {
        ...OfferEventFields
      }
    }
  }
  longListed
}
    ${OfferEventFieldsFragmentDoc}`;
export const InterviewWidgetRegionFieldsFragmentDoc = gql`
    fragment InterviewWidgetRegionFields on RegionType {
  title
  externalId
}
    `;
export const InterviewWidgetOrdersFieldsFragmentDoc = gql`
    fragment InterviewWidgetOrdersFields on OrderType {
  id
  orderType
  trafficGeneration
  specification {
    positionTitle
    address
    company {
      name
      color
      status
    }
  }
}
    `;
export const CandidateOfferFieldsFragmentDoc = gql`
    fragment CandidateOfferFields on CandidateType {
  id
  firstName
  lastName
  livasId
  livasStatus {
    id
    titleLt
    titleLv
    titleEe
  }
}
    `;
export const OfferFieldsFragmentDoc = gql`
    fragment OfferFields on OfferPropositionType {
  id
  personId
  interestedOnCall
  interested
  firstInterestedAt
  candidate {
    ...CandidateOfferFields
  }
  cancellationreasonassignmentSet {
    edges {
      node {
        id
        cancellationReason {
          id
          title
        }
      }
    }
  }
  offerpropositioncommentSet(orderBy: "-created_at") {
    totalCount
    edges {
      node {
        id
        text
        createdAt
      }
    }
  }
  candidateEvents {
    edges {
      node {
        ...OfferEventFields
      }
    }
  }
  signed
  signedAt
  comment
  eventSet(deleted: false) {
    edges {
      node {
        ...OfferEventFields
      }
    }
  }
}
    ${CandidateOfferFieldsFragmentDoc}
${OfferEventFieldsFragmentDoc}`;
export const OfferPropisitionOfferFieldsFragmentDoc = gql`
    fragment OfferPropisitionOfferFields on OfferPropositionType {
  id
  comment
  order {
    id
    orderType
    trafficGeneration
    specification {
      positionTitle
      address
      company {
        name
        color
        status
      }
    }
  }
  candidate {
    id
  }
  personId
  interested
  firstInterestedAt
  interestedOnCall
  signed
  candidateEvents {
    edges {
      node {
        ...OfferEventFields
      }
    }
  }
  longListed
  eventSet(deleted: false) {
    edges {
      node {
        ...OfferEventFields
      }
    }
  }
}
    ${OfferEventFieldsFragmentDoc}`;
export const OfferPropisitionRegionFieldsFragmentDoc = gql`
    fragment OfferPropisitionRegionFields on RegionType {
  title
  externalId
}
    `;
export const OfferPropisitionOrdersFieldsFragmentDoc = gql`
    fragment OfferPropisitionOrdersFields on OrderType {
  id
  orderType
  trafficGeneration
  specification {
    positionTitle
    address
    company {
      name
      color
      status
    }
  }
}
    `;
export const CancellationReasonAssignmentFieldsFragmentDoc = gql`
    fragment CancellationReasonAssignmentFields on CancellationReasonAssignmentType {
  id
  cancellationReason {
    id
    title
  }
}
    `;
export const CreateOrderDocumentFieldsFragmentDoc = gql`
    fragment CreateOrderDocumentFields on DocumentType {
  id
  order {
    id
    specification {
      id
      positionTitle
    }
  }
  documentDate
  confirmationMethod
  orderPeriods {
    id
  }
  generatedDocument
}
    `;
export const ContactFieldsFragmentDoc = gql`
    fragment ContactFields on ContactType {
  id
  firstName
  lastName
  email
  phone
  insightlyId
  comment
  canUseInOrder
}
    `;
export const ContractsMetaFieldsFragmentDoc = gql`
    fragment ContractsMetaFields on ContractType {
  id
  validFromDate
  validTillDate
  contractor {
    id
    logoUrl
  }
}
    `;
export const CompanyMetaFieldsFragmentDoc = gql`
    fragment CompanyMetaFields on CompanyType {
  id
  status
  name
  description
  contractSet {
    ...ContractsMetaFields
  }
  contactSet {
    edges {
      node {
        id
        firstName
        lastName
      }
    }
  }
  specificationSet {
    id
    positionTitle
  }
}
    ${ContractsMetaFieldsFragmentDoc}`;
export const RegionsList2FieldsFragmentDoc = gql`
    fragment RegionsList2Fields on RegionType {
  id
  title
  regionmetrics {
    id
    lifetime
  }
}
    `;
export const OrderSelectListFieldsFragmentDoc = gql`
    fragment OrderSelectListFields on OrderMType {
  id
  orderType
  specification {
    id
    positionTitle
  }
  region {
    id
    title
  }
  createdDate
}
    `;
export const OrderCommentFieldsFragmentDoc = gql`
    fragment OrderCommentFields on OrderCommentType {
  id
  comment
  createdAt
}
    `;
export const SalaryTableCellFieldsFragmentDoc = gql`
    fragment SalaryTableCellFields on SpecificationSalaryType {
  id
  hourlyBruttoFrom
  hourlyBruttoTo
  monthlyBruttoFrom
  monthlyBruttoTo
  hourlyBruttoFromFilled
  hourlyBruttoToFilled
  monthlyBruttoFromFilled
  monthlyBruttoToFilled
  useInTemplate
}
    `;
export const SpecFieldInOrderListFragmentDoc = gql`
    fragment SpecFieldInOrderList on SpecificationType {
  id
  positionTitle
  address
  salary {
    ...SalaryTableCellFields
  }
}
    ${SalaryTableCellFieldsFragmentDoc}`;
export const OrderDocumentFieldsFragmentDoc = gql`
    fragment OrderDocumentFields on DocumentType {
  id
  isSignedBiuro
  isSignedClient
  signingUrl
  confirmationMethod
  status
  createDate
  signedDocument
}
    `;
export const OrdersList2FieldsFragmentDoc = gql`
    fragment OrdersList2Fields on OrderType {
  id
  ordermetrics {
    id
    lifetime
    effortConversion
    totalCalls
    successfulCalls
    totalInterviews
    successfulInterviews
  }
  region {
    id
    title
    regionmetrics {
      id
      lifetime
      effortConversion
      totalCalls
      successfulCalls
      totalInverviews
      successfulInterviews
    }
    regionthresholdsettings {
      minOffersExpected
    }
  }
  hourRateBruttoPermanent
  orderNumber
  subtype
  dateFrom
  dateTo
  isLongTerm
  demand
  orderType
  orderDate
  priority
  ordercommentSet {
    edges {
      node {
        ...OrderCommentFields
      }
    }
  }
  projectManager {
    id
    user {
      id
      firstName
      lastName
    }
  }
  recruiter {
    id
    user {
      id
      firstName
      lastName
    }
  }
  trafficGeneration
  status
  nettoFrom
  nettoTo
  shortage
  specification {
    ...SpecFieldInOrderList
  }
  createdBy {
    id
    user {
      id
      email
      firstName
      lastName
    }
  }
  clientContact {
    id
    email
    firstName
    lastName
  }
  company {
    id
    status
    name
    color
    labels {
      edges {
        node {
          id
          title
        }
      }
    }
    country {
      id
      isoCode
    }
  }
  contract {
    id
  }
  lastDocument {
    ...OrderDocumentFields
  }
  orderclientcontactedSet {
    edges {
      node {
        id
        date
        createdBy {
          id
          fullName
          color
          profileImage
        }
      }
    }
  }
}
    ${OrderCommentFieldsFragmentDoc}
${SpecFieldInOrderListFragmentDoc}
${OrderDocumentFieldsFragmentDoc}`;
export const UserProfileFieldsFragmentDoc = gql`
    fragment UserProfileFields on UserProfileMType {
  id
  user {
    id
    firstName
    lastName
    email
  }
}
    `;
export const CompanyTypeFieldsFragmentDoc = gql`
    fragment CompanyTypeFields on CompanyType {
  id
  status
  name
  insightlyId
  description
  salesQuestionnaire
  contactSet {
    edges {
      node {
        id
        firstName
        lastName
        phone
        email
        insightlyId
      }
    }
  }
  contractSet {
    id
    validFromDate
    validTillDate
  }
  country {
    id
    isoCode
    languageIsoCode
  }
}
    `;
export const OffboardingRoleFragmentDoc = gql`
    fragment offboardingRole on OffboardingRoleType {
  id
  company {
    id
    name
  }
  name
  orders {
    edges {
      node {
        id
      }
    }
  }
  createdAt
  updatedAt
  orders {
    edges {
      node {
        id
      }
    }
  }
  actions {
    id
    description
    order
    createdAt
    role {
      id
    }
  }
}
    `;
export const SpecificationDetailFieldsFragmentDoc = gql`
    fragment SpecificationDetailFields on SpecificationType {
  id
  name
  positionTitle
  workFunctions
  address
  intensity
  onboardingDuration
  male
  female
  ageFrom
  isQualificationImprovementPossible
  clientWashesClothes
  ageTo
  competences {
    edges {
      node {
        id
        title
        color
      }
    }
  }
  certificates {
    id
    title
  }
  riskFactors {
    id
    title
    isDefault
  }
  scheduleTypes {
    id
    title
  }
  mandatoryRequirements {
    id
    requirement
  }
  optionalRequirements {
    id
    requirement
  }
  allFunctionsFromFirstDay
  isWorkplaceVideoAllowed
  isWorkplaceVisitAllowed
  isLogoPublicAllowed
  isCompanyModern
  isCompanyInternational
  shiftDuration
  breakDuration
  scheduleType
  shiftPattern
  scheduleText
  minExperienceMonths
  experienceType
  isSecurityPostPresent
  isMagneticKeyIssued
  whoIssuesMagneticKey
  additionalRecruitementInformation
  tagassignmentSet {
    id
    tag {
      id
      key
      group {
        id
        key
      }
    }
    comment
  }
  salary {
    id
    hourlyNettoFrom
    hourlyNettoTo
    hourlyBruttoFrom
    hourlyBruttoTo
    monthlyNettoFrom
    monthlyNettoTo
    monthlyBruttoFrom
    monthlyBruttoTo
    hourlyNettoFromFilled
    hourlyNettoToFilled
    hourlyBruttoFromFilled
    hourlyBruttoToFilled
    monthlyNettoFromFilled
    monthlyNettoToFilled
    monthlyBruttoFromFilled
    monthlyBruttoToFilled
    useInTemplate
    description
    passDescriptionToTemplate
  }
  personalProtectiveEquipmentBiuro {
    id
  }
  personalProtectiveEquipmentClient {
    id
  }
  ppeItems {
    customEquipment
    provider
  }
  careerPossibilities
  requirementsOther
  canEmployUa
  healthcheckType
}
    `;
export const ClientInterviewFieldsFragmentDoc = gql`
    fragment ClientInterviewFields on ClientInterviewType {
  id
  workFunctions
  requirements
  competences1
  competences2
  companyRepresentation
  workConditions
  selectionProcess
  agencyProcessStandart
}
    `;
export const BaseOrderFieldsFragmentDoc = gql`
    fragment BaseOrderFields on OrderMType {
  id
  company {
    ...CompanyTypeFields
  }
  clientContact {
    id
  }
  contract {
    id
  }
  offboardingRoles {
    edges {
      node {
        ...offboardingRole
      }
    }
  }
  orderNumber
  subtype
  orderType
  trafficGeneration
  projectManager {
    id
    fullName
    user {
      ...UserMainFields
    }
  }
  recruiter {
    id
  }
  biuroSignee {
    id
  }
  clientContact {
    ...ContactFieldsShort
  }
  additionalClientContacts {
    edges {
      node {
        ...ContactFieldsShort
      }
    }
  }
  region {
    id
    title
  }
  additionalRegions {
    id
    title
  }
  orderperiodSet {
    ...OrderPeriodFields
  }
  cancellationPeriod
  salaryInfo
  shortage
  compensationForRecruitment
  canIncreaseSalary
  passCommentToOrder
  canGetBonuses
  isLogoPublicAllowed
  isCompanyInternational
  isCompanyModern
  opportunityToEmployDirectly
  orderCanBeExtended
  orderCanBeExtendedComment
  specification {
    ...SpecificationDetailFields
  }
  plannedTermForProvision
  provisionOfInformationOnConclusion
  remunerationAmount
  warrantyPeriod
  candidatesToBeProvided
  minVsdfPayment
  otherInfo
  indefiniteOrderInfo
  workTimeRegistrationSystem
  language
  clientInterview {
    ...ClientInterviewFields
  }
  qualification
  displayPlannedTermForProvision
  exportFreetextRequirements
  recruitmentProgressReportFrequency
  reportingFrequencyStartDate
}
    ${CompanyTypeFieldsFragmentDoc}
${OffboardingRoleFragmentDoc}
${UserMainFieldsFragmentDoc}
${ContactFieldsShortFragmentDoc}
${OrderPeriodFieldsFragmentDoc}
${SpecificationDetailFieldsFragmentDoc}
${ClientInterviewFieldsFragmentDoc}`;
export const CompanyModelMetaFieldsFragmentDoc = gql`
    fragment CompanyModelMetaFields on CompanyModelType {
  id
  status
  name
  description
  salesQuestionnaire
  contractSet {
    ...ContractsMetaFields
  }
  contactSet {
    edges {
      node {
        id
        firstName
        lastName
        canUseInOrder
      }
    }
  }
  specificationSet {
    id
    positionTitle
  }
}
    ${ContractsMetaFieldsFragmentDoc}`;
export const CandidateRequirementsEvaluationFieldsFragmentDoc = gql`
    fragment CandidateRequirementsEvaluationFields on CandidateRequirementsEvaluationType {
  id
  offerProposition {
    id
  }
  requirement {
    id
  }
  description
  recordType
  createdBy {
    id
  }
  createdAt
}
    `;
export const TaskScheduleFieldsFragmentDoc = gql`
    fragment TaskScheduleFields on ScheduleType {
  id
  parentTask {
    id
  }
  endDate
  recurrencePeriod
  intervalCount
  dayOfWeek
  weekOfMonth
  dayOfMonth
}
    `;
export const OperationsTaskFieldsFragmentDoc = gql`
    fragment OperationsTaskFields on TaskType {
  id
  status
  durationMinutes
  countryIsoCode
  numPreviousTasks
  order {
    id
    company {
      id
      name
    }
    specification {
      id
      positionTitle
    }
  }
  category {
    id
    title
  }
  company {
    id
    name
    status
    country {
      id
      isoCode
    }
  }
  comment
  completedBy {
    id
    fullName
    color
    user {
      id
      firstName
      lastName
    }
  }
  nextTaskAssignee {
    id
    fullName
    color
    user {
      id
      firstName
      lastName
    }
  }
  date
  nextActionDate
  createdAt
  country {
    id
    isoCode
  }
  candidate {
    id
    livasId
    firstName
    lastName
    employeeLivasId
  }
  schedules {
    edges {
      node {
        ...TaskScheduleFields
      }
    }
  }
  createdBySchedule {
    ...TaskScheduleFields
  }
  taskSet {
    edges {
      node {
        id
        createdAt
        date
      }
    }
  }
  dashboard {
    id
    title
  }
  metricvalueSet {
    edges {
      node {
        id
        value
        date
        manager {
          id
          fullName
        }
        client {
          id
          name
          livasId
        }
        candidate {
          id
          livasId
          employeeLivasId
          firstName
          lastName
        }
        metricGroup {
          id
          title
        }
        metricvaluecommentSet {
          edges {
            node {
              id
              comment
              metricClientReason {
                id
                title
              }
              clients {
                edges {
                  node {
                    id
                    name
                  }
                }
              }
              candidates {
                edges {
                  node {
                    id
                    livasId
                    employeeLivasId
                    firstName
                    lastName
                  }
                }
              }
            }
          }
        }
      }
    }
  }
  metricvalueLevel2 {
    edges {
      node {
        id
        value
        date
        manager {
          id
          fullName
        }
        client {
          id
          name
          livasId
        }
        candidate {
          id
          livasId
          employeeLivasId
          firstName
          lastName
        }
        metricGroup {
          id
          title
        }
        metricvaluecommentSet {
          edges {
            node {
              id
              comment
              metricClientReason {
                id
                title
              }
              clients {
                edges {
                  node {
                    id
                    name
                  }
                }
              }
              candidates {
                edges {
                  node {
                    id
                    livasId
                    employeeLivasId
                    firstName
                    lastName
                  }
                }
              }
            }
          }
        }
      }
    }
  }
}
    ${TaskScheduleFieldsFragmentDoc}`;
export const OperationsTaskFieldsNewFragmentDoc = gql`
    fragment OperationsTaskFieldsNew on TaskType {
  id
  status
  durationMinutes
  countryIsoCode
  numPreviousTasks
  order {
    id
    company {
      id
      name
      status
      country {
        id
        isoCode
      }
    }
    specification {
      id
      positionTitle
    }
  }
  category {
    id
    title
  }
  company {
    id
    name
    status
    country {
      id
      isoCode
    }
  }
  comment
  completedBy {
    id
    fullName
    color
    user {
      id
      firstName
      lastName
    }
  }
  nextTaskAssignee {
    id
    fullName
    color
    user {
      id
      firstName
      lastName
    }
  }
  date
  nextActionDate
  createdAt
  country {
    id
    isoCode
  }
  candidate {
    id
    livasId
    firstName
    lastName
    employeeLivasId
  }
  schedules {
    edges {
      node {
        ...TaskScheduleFields
      }
    }
  }
  createdBySchedule {
    ...TaskScheduleFields
  }
  taskSet {
    edges {
      node {
        id
        createdAt
        date
      }
    }
  }
  dashboard {
    id
    title
  }
  metricvalueSet {
    edges {
      node {
        id
        value
        date
        manager {
          id
          fullName
        }
        client {
          id
          name
          livasId
        }
        candidate {
          id
          livasId
          employeeLivasId
          firstName
          lastName
        }
        metricGroup {
          id
          title
        }
        metricvaluecommentSet {
          edges {
            node {
              id
              comment
              metricClientReason {
                id
                title
              }
              clients {
                edges {
                  node {
                    id
                    name
                  }
                }
              }
              candidates {
                edges {
                  node {
                    id
                    livasId
                    employeeLivasId
                    firstName
                    lastName
                  }
                }
              }
            }
          }
        }
      }
    }
  }
  metricvalueLevel2 {
    edges {
      node {
        id
        value
        date
        manager {
          id
          fullName
        }
        client {
          id
          name
          livasId
        }
        candidate {
          id
          livasId
          employeeLivasId
          firstName
          lastName
        }
        metricGroup {
          id
          title
        }
        metricvaluecommentSet {
          edges {
            node {
              id
              comment
              metricClientReason {
                id
                title
              }
              clients {
                edges {
                  node {
                    id
                    name
                  }
                }
              }
              candidates {
                edges {
                  node {
                    id
                    livasId
                    employeeLivasId
                    firstName
                    lastName
                  }
                }
              }
            }
          }
        }
      }
    }
  }
}
    ${TaskScheduleFieldsFragmentDoc}`;
export const CategoryConfigFieldsFragmentDoc = gql`
    fragment CategoryConfigFields on SACategoryType {
  id
  title
  hint
  durationMinutes
  showDuration
  showOrder
  showCompany
  showDescription
  showOrder
  showCandidate
  showNextTaskAssignee
  customFields {
    edges {
      node {
        id
        name
        hintText
        options
        fieldType {
          id
          name
          fieldType
        }
      }
    }
  }
}
    `;
export const OverdueTaskTableFieldsFragmentDoc = gql`
    fragment OverdueTaskTableFields on TaskType {
  id
  status
  company {
    id
    name
    status
    country {
      id
      isoCode
    }
  }
  category {
    ...CategoryConfigFields
  }
  candidate {
    id
    firstName
    lastName
    livasId
    employeeLivasId
  }
  completedBy {
    id
    fullName
    color
    user {
      id
      firstName
      lastName
    }
  }
  dashboard {
    id
    title
  }
  metricvalueSet {
    edges {
      node {
        id
        value
        date
        manager {
          id
          fullName
        }
        client {
          id
          name
          livasId
        }
        order {
          company {
            name
          }
        }
        candidate {
          id
          livasId
          employeeLivasId
          firstName
          lastName
        }
        metricGroup {
          id
          title
        }
        metricvaluecommentSet {
          edges {
            node {
              id
              comment
              metricClientReason {
                id
                title
              }
              clients {
                edges {
                  node {
                    id
                    name
                  }
                }
              }
              candidates {
                edges {
                  node {
                    id
                    livasId
                    employeeLivasId
                    firstName
                    lastName
                  }
                }
              }
            }
          }
        }
      }
    }
  }
  metricvalueLevel2 {
    edges {
      node {
        id
        value
        date
        manager {
          id
          fullName
        }
        client {
          id
          name
          livasId
        }
        order {
          company {
            name
          }
        }
        candidate {
          id
          livasId
          employeeLivasId
          firstName
          lastName
        }
        metricGroup {
          id
          title
        }
        metricvaluecommentSet {
          edges {
            node {
              id
              comment
              metricClientReason {
                id
                title
              }
              clients {
                edges {
                  node {
                    id
                    name
                  }
                }
              }
              candidates {
                edges {
                  node {
                    id
                    livasId
                    employeeLivasId
                    firstName
                    lastName
                  }
                }
              }
            }
          }
        }
      }
    }
  }
  nextActionCategory {
    id
    title
  }
  nextActionDate
  overdueCount
  date
  comment
  durationMinutes
}
    ${CategoryConfigFieldsFragmentDoc}`;
export const MeetingTaskTableFieldsFragmentDoc = gql`
    fragment MeetingTaskTableFields on TaskType {
  id
  status
  company {
    id
    name
    status
    country {
      id
      isoCode
    }
  }
  category {
    ...CategoryConfigFields
  }
  candidate {
    id
    firstName
    lastName
    livasId
    employeeLivasId
  }
  completedBy {
    id
    fullName
    color
    user {
      id
      firstName
      lastName
    }
  }
  dashboard {
    id
    title
  }
  metricvalueSet {
    edges {
      node {
        id
        value
        date
        manager {
          id
          fullName
        }
        client {
          id
          name
          livasId
        }
        candidate {
          id
          livasId
          employeeLivasId
          firstName
          lastName
        }
        metricGroup {
          id
          title
        }
        metricvaluecommentSet {
          edges {
            node {
              id
              comment
              metricClientReason {
                id
                title
              }
              clients {
                edges {
                  node {
                    id
                    name
                  }
                }
              }
              candidates {
                edges {
                  node {
                    id
                    livasId
                    employeeLivasId
                    firstName
                    lastName
                  }
                }
              }
            }
          }
        }
      }
    }
  }
  metricvalueLevel2 {
    edges {
      node {
        id
        value
        date
        manager {
          id
          fullName
        }
        client {
          id
          name
          livasId
        }
        candidate {
          id
          livasId
          employeeLivasId
          firstName
          lastName
        }
        metricGroup {
          id
          title
        }
        metricvaluecommentSet {
          edges {
            node {
              id
              comment
              metricClientReason {
                id
                title
              }
              clients {
                edges {
                  node {
                    id
                    name
                  }
                }
              }
              candidates {
                edges {
                  node {
                    id
                    livasId
                    employeeLivasId
                    firstName
                    lastName
                  }
                }
              }
            }
          }
        }
      }
    }
  }
  nextActionCategory {
    id
    title
  }
  overdueCount
  date
  comment
  durationMinutes
}
    ${CategoryConfigFieldsFragmentDoc}`;
export const DynamicDashboardTaskTableFieldsFragmentDoc = gql`
    fragment DynamicDashboardTaskTableFields on TaskType {
  id
  status
  company {
    id
    name
    status
    country {
      id
      isoCode
    }
  }
  order {
    id
    specification {
      positionTitle
    }
  }
  category {
    ...CategoryConfigFields
  }
  candidate {
    id
    firstName
    lastName
    livasId
    employeeLivasId
  }
  completedBy {
    id
    fullName
    color
    user {
      id
      firstName
      lastName
    }
  }
  dashboard {
    id
    title
  }
  metricvalueSet {
    edges {
      node {
        id
        value
        date
        manager {
          id
          fullName
        }
        client {
          id
          name
          livasId
        }
        order {
          company {
            name
          }
        }
        candidate {
          id
          livasId
          employeeLivasId
          firstName
          lastName
        }
        metricGroup {
          id
          title
        }
        metricvaluecommentSet {
          edges {
            node {
              id
              comment
              metricClientReason {
                id
                title
              }
              clients {
                edges {
                  node {
                    id
                    name
                  }
                }
              }
              candidates {
                edges {
                  node {
                    id
                    livasId
                    employeeLivasId
                    firstName
                    lastName
                  }
                }
              }
            }
          }
        }
      }
    }
  }
  metricvalueLevel2 {
    edges {
      node {
        id
        value
        date
        manager {
          id
          fullName
        }
        client {
          id
          name
          livasId
        }
        order {
          company {
            name
          }
        }
        candidate {
          id
          livasId
          employeeLivasId
          firstName
          lastName
        }
        metricGroup {
          id
          title
        }
        metricvaluecommentSet {
          edges {
            node {
              id
              comment
              metricClientReason {
                id
                title
              }
              clients {
                edges {
                  node {
                    id
                    name
                  }
                }
              }
              candidates {
                edges {
                  node {
                    id
                    livasId
                    employeeLivasId
                    firstName
                    lastName
                  }
                }
              }
            }
          }
        }
      }
    }
  }
  nextActionCategory {
    id
    title
  }
  nextActionDate
  overdueCount
  date
  comment
  durationMinutes
}
    ${CategoryConfigFieldsFragmentDoc}`;
export const TaskDetailViewFieldsFragmentDoc = gql`
    fragment TaskDetailViewFields on TaskType {
  id
  status
  durationMinutes
  numPreviousTasks
  order {
    id
    specification {
      id
      positionTitle
    }
    company {
      id
      name
      country {
        id
        title
        isoCode
      }
    }
  }
  category {
    ...CategoryConfigFields
  }
  company {
    id
    name
    status
    country {
      id
      isoCode
    }
  }
  candidate {
    id
    livasId
    firstName
    lastName
    employeeLivasId
  }
  comment
  dashboard {
    id
    title
  }
  completedBy {
    id
    fullName
    color
    user {
      id
      firstName
      lastName
    }
  }
  nextTaskAssignee {
    id
    fullName
    color
    user {
      id
      firstName
      lastName
    }
  }
  date
  createdAt
  metricvalueSet {
    edges {
      node {
        id
        value
        date
        manager {
          id
          fullName
        }
        client {
          id
          name
          livasId
        }
        order {
          company {
            name
          }
        }
        candidate {
          id
          livasId
          employeeLivasId
          firstName
          lastName
        }
        metricGroup {
          id
          title
        }
        metricvaluecommentSet {
          edges {
            node {
              id
              comment
              metricClientReason {
                id
                title
              }
              clients {
                edges {
                  node {
                    id
                    name
                  }
                }
              }
              candidates {
                edges {
                  node {
                    id
                    livasId
                    employeeLivasId
                    firstName
                    lastName
                  }
                }
              }
            }
          }
        }
      }
    }
  }
  metricvalueLevel2 {
    edges {
      node {
        id
        value
        date
        manager {
          id
          fullName
        }
        client {
          id
          name
          livasId
        }
        order {
          company {
            name
          }
        }
        candidate {
          id
          livasId
          employeeLivasId
          firstName
          lastName
        }
        metricGroup {
          id
          title
        }
        metricvaluecommentSet {
          edges {
            node {
              id
              comment
              metricClientReason {
                id
                title
              }
              clients {
                edges {
                  node {
                    id
                    name
                  }
                }
              }
              candidates {
                edges {
                  node {
                    id
                    livasId
                    employeeLivasId
                    firstName
                    lastName
                  }
                }
              }
            }
          }
        }
      }
    }
  }
  createdBySchedule {
    endDate
    id
  }
  country {
    id
    isoCode
  }
  schedules {
    edges {
      node {
        ...TaskScheduleFields
      }
    }
  }
}
    ${CategoryConfigFieldsFragmentDoc}
${TaskScheduleFieldsFragmentDoc}`;
export const CustomFieldsValuesFieldsFragmentDoc = gql`
    fragment CustomFieldsValuesFields on CustomFieldValueType {
  id
  boolValue
  numericValue
  textValue
  dateValue
  urlValue
  customField {
    id
    name
    fieldType {
      id
      name
      fieldType
    }
  }
}
    `;
export const SelectionActionListItemFieldsFragmentDoc = gql`
    fragment SelectionActionListItemFields on TaskType {
  id
  comment
  durationMinutes
  date
  category {
    id
    title
  }
  createdBy {
    id
    fullName
  }
  completedBy {
    id
    fullName
    color
    user {
      id
      firstName
      lastName
    }
  }
  searchResults {
    totalCount
    touchedCount
    successCount
  }
  status
}
    `;
export const SaCategoryFieldsFragmentDoc = gql`
    fragment SACategoryFields on SACategoryType {
  id
  title
  hint
  durationMinutes
}
    `;
export const SaCategoryGroupsFieldsFragmentDoc = gql`
    fragment SACategoryGroupsFields on SACategoryGroupType {
  id
  title
  department
  country {
    id
  }
  sacategorySet {
    edges {
      node {
        ...CategoryConfigFields
        requiresDashboard
      }
    }
  }
}
    ${CategoryConfigFieldsFragmentDoc}`;
export const RequirementFieldsFragmentDoc = gql`
    fragment RequirementFields on RequirementType {
  id
  requirement
}
    `;
export const CompanyDetailFieldsFragmentDoc = gql`
    fragment CompanyDetailFields on CompanyType {
  id
  name
  status
  insightlyId
  color
  contractSet {
    ...ContractsMetaFields
  }
  contactSet {
    edges {
      node {
        id
        firstName
        lastName
      }
    }
  }
  specificationSet {
    id
    positionTitle
  }
}
    ${ContractsMetaFieldsFragmentDoc}`;
export const PpeFieldsFragmentDoc = gql`
    fragment PPEFields on PersonalProtectiveEquipmentType {
  id
  title
  specificationppeSet {
    customEquipment
    provider
  }
}
    `;
export const TagsFieldsFragmentDoc = gql`
    fragment TagsFields on TagType {
  id
  title
  hint
  order
}
    `;
export const CertificateFragmentDoc = gql`
    fragment Certificate on CertificateType {
  id
  title
}
    `;
export const OrderListCandidatesStatsFieldsFragmentDoc = gql`
    fragment OrderListCandidatesStatsFields on CandidateOrderStatsType {
  orderId
  toBeInterviewed
  toBeInterviewedClient
  healthCheckPending
  toBeEmployed
  offeredFromDate
  offeredLast7Days
  presentedClient
  presentedClientSuccess
  presentedClientFailed
  longListedLast7Days
  offeredLast1Day
  longListedLast1Day
}
    `;
export const CandidateEventsFieldsFragmentDoc = gql`
    fragment CandidateEventsFields on CandidateEventType {
  candidate {
    id
    firstName
    lastName
    livasId
  }
  id
  startDatetime
  eventType
  resolutionStatus
}
    `;
export const OrderStatsFieldsFragmentDoc = gql`
    fragment OrderStatsFields on OfferPropositionStatsType {
  interestedCount
  notInterestedCount
  interestedCallCount
  notInterestedCallCount
  signed
  totalOffered
  totalInterested
  totalNotInterested
}
    `;
export const MeFieldsFragmentDoc = gql`
    fragment MeFields on UserProfileMType {
  id
  fullName
  department
  color
  region {
    id
    country {
      id
      title
    }
  }
  user {
    email
  }
}
    `;
export const GetCancellationReasonsDocument = gql`
    query GetCancellationReasons($country: ID) {
  cancellationReasonGroups(country: $country) {
    edges {
      node {
        ...CancellationReasonsGroupFields
      }
    }
  }
}
    ${CancellationReasonsGroupFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class GetCancellationReasonsGQL extends Apollo.Query<GetCancellationReasonsQuery, GetCancellationReasonsQueryVariables> {
    document = GetCancellationReasonsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetCancellationReasonsForOfferDocument = gql`
    query GetCancellationReasonsForOffer($offerPropositionId: ID!) {
  cancellationReasonAssignments(offerProposition: $offerPropositionId) {
    edges {
      node {
        id
        cancellationReason {
          id
        }
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetCancellationReasonsForOfferGQL extends Apollo.Query<GetCancellationReasonsForOfferQuery, GetCancellationReasonsForOfferQueryVariables> {
    document = GetCancellationReasonsForOfferDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateCancellationReasonAssignmentsDocument = gql`
    mutation CreateCancellationReasonAssignments($offerProposition: ID!, $cancellationReasons: [ID]!) {
  createCancellationReasonAssignment(
    offerProposition: $offerProposition
    cancellationReasons: $cancellationReasons
  ) {
    ok
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateCancellationReasonAssignmentsGQL extends Apollo.Mutation<CreateCancellationReasonAssignmentsMutation, CreateCancellationReasonAssignmentsMutationVariables> {
    document = CreateCancellationReasonAssignmentsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CandidatesTableDataDocument = gql`
    query CandidatesTableData($first: Int, $after: String, $manager: [ID], $country: ID, $company: ID, $search: String) {
  offers(
    first: $first
    after: $after
    manager: $manager
    countryId: $country
    company: $company
    search: $search
    hasCandidate: true
    hasPlannedEvents: true
  ) {
    totalCount
    edges {
      node {
        id
        order {
          projectManager {
            fullName
          }
          company {
            name
            address
          }
        }
        candidate {
          firstName
          lastName
        }
        candidateEvents {
          edges {
            node {
              ...OfferEventFields
            }
          }
        }
        offerpropositioncommentSet {
          totalCount
          edges {
            node {
              text
            }
          }
        }
      }
    }
  }
}
    ${OfferEventFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class CandidatesTableDataGQL extends Apollo.Query<CandidatesTableDataQuery, CandidatesTableDataQueryVariables> {
    document = CandidatesTableDataDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetCandidatesDocument = gql`
    query getCandidates($first: Int, $after: String, $metricValueCommentId: ID) {
  candidates(
    first: $first
    after: $after
    metricValueCommentId: $metricValueCommentId
  ) {
    totalCount
    edges {
      node {
        firstName
        lastName
        livasStatus {
          key
        }
        employeeLivasId
        livasId
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetCandidatesGQL extends Apollo.Query<GetCandidatesQuery, GetCandidatesQueryVariables> {
    document = GetCandidatesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const FilterMetadataDocument = gql`
    query FilterMetadata {
  scheduleTypes {
    id
    title
    isPreselected
  }
  labels(group_Key: "covid") {
    edges {
      node {
        ...CovidLabelsFields
      }
    }
  }
}
    ${CovidLabelsFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class FilterMetadataGQL extends Apollo.Query<FilterMetadataQuery, FilterMetadataQueryVariables> {
    document = FilterMetadataDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetContractorsForSelectDocument = gql`
    query getContractorsForSelect {
  contractors {
    edges {
      node {
        ...ContractorSelectFields
      }
    }
  }
}
    ${ContractorSelectFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class GetContractorsForSelectGQL extends Apollo.Query<GetContractorsForSelectQuery, GetContractorsForSelectQueryVariables> {
    document = GetContractorsForSelectDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetOffboardingRolesDocument = gql`
    query getOffboardingRoles($company: ID) {
  offboardingRoles(company: $company) {
    edges {
      node {
        ...offboardingRole
      }
    }
  }
}
    ${OffboardingRoleFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class GetOffboardingRolesGQL extends Apollo.Query<GetOffboardingRolesQuery, GetOffboardingRolesQueryVariables> {
    document = GetOffboardingRolesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateOffboardingRoleDocument = gql`
    mutation createOffboardingRole($input: OffboardingRoleInput!) {
  createOffboardingRole(input: $input) {
    ok
    offboardingRole {
      ...offboardingRole
    }
  }
}
    ${OffboardingRoleFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateOffboardingRoleGQL extends Apollo.Mutation<CreateOffboardingRoleMutation, CreateOffboardingRoleMutationVariables> {
    document = CreateOffboardingRoleDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateOffboardingRoleDocument = gql`
    mutation updateOffboardingRole($id: ID!, $input: OffboardingRoleInput!) {
  updateOffboardingRole(id: $id, input: $input) {
    ok
    offboardingRole {
      ...offboardingRole
    }
  }
}
    ${OffboardingRoleFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateOffboardingRoleGQL extends Apollo.Mutation<UpdateOffboardingRoleMutation, UpdateOffboardingRoleMutationVariables> {
    document = UpdateOffboardingRoleDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DeleteOffboardingRoleDocument = gql`
    mutation deleteOffboardingRole($id: ID!) {
  deleteOffboardingRole(id: $id) {
    ok
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DeleteOffboardingRoleGQL extends Apollo.Mutation<DeleteOffboardingRoleMutation, DeleteOffboardingRoleMutationVariables> {
    document = DeleteOffboardingRoleDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetChangeColorPermissionDocument = gql`
    query GetChangeColorPermission {
  hasPermission(title: "company.change_color")
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetChangeColorPermissionGQL extends Apollo.Query<GetChangeColorPermissionQuery, GetChangeColorPermissionQueryVariables> {
    document = GetChangeColorPermissionDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const SearchCompaniesDocument = gql`
    query searchCompanies($search: String, $country: ID) {
  companyInstances(name: $search, country: $country) {
    edges {
      node {
        ...CompanySelectFields
      }
    }
  }
}
    ${CompanySelectFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class SearchCompaniesGQL extends Apollo.Query<SearchCompaniesQuery, SearchCompaniesQueryVariables> {
    document = SearchCompaniesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const SearchCompaniesTypeDocument = gql`
    query searchCompaniesType($search: String) {
  companyInstances(name: $search) {
    edges {
      node {
        ...CompanySelectFields
      }
    }
  }
}
    ${CompanySelectFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class SearchCompaniesTypeGQL extends Apollo.Query<SearchCompaniesTypeQuery, SearchCompaniesTypeQueryVariables> {
    document = SearchCompaniesTypeDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetCompaniesNamesDocument = gql`
    query getCompaniesNames {
  companies {
    edges {
      node {
        id
        name
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetCompaniesNamesGQL extends Apollo.Query<GetCompaniesNamesQuery, GetCompaniesNamesQueryVariables> {
    document = GetCompaniesNamesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetCompanyDocument = gql`
    query getCompany($id: ID!) {
  company(id: $id) {
    name
    status
    country {
      id
      isoCode
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetCompanyGQL extends Apollo.Query<GetCompanyQuery, GetCompanyQueryVariables> {
    document = GetCompanyDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateCompanyManagersDataDocument = gql`
    mutation updateCompanyManagersData($companyIds: [ID]!, $projectManager1: ID, $projectManager2: ID, $substituteManager1: ID, $substituteManager2: ID, $recruiter1: ID, $recruiter2: ID, $substituteRecruiter1: ID, $substituteRecruiter2: ID) {
  updateCompanyManagers(
    companyIds: $companyIds
    projectManager1: $projectManager1
    projectManager2: $projectManager2
    substituteManager1: $substituteManager1
    substituteManager2: $substituteManager2
    recruiter1: $recruiter1
    recruiter2: $recruiter2
    substituteRecruiter1: $substituteRecruiter1
    substituteRecruiter2: $substituteRecruiter2
  ) {
    ok
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateCompanyManagersDataGQL extends Apollo.Mutation<UpdateCompanyManagersDataMutation, UpdateCompanyManagersDataMutationVariables> {
    document = UpdateCompanyManagersDataDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CovidLabelsDocument = gql`
    query CovidLabels {
  labels(group_Key: "covid") {
    edges {
      node {
        id
        title
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CovidLabelsGQL extends Apollo.Query<CovidLabelsQuery, CovidLabelsQueryVariables> {
    document = CovidLabelsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const SaveCompanyLabelsDocument = gql`
    mutation SaveCompanyLabels($companyId: ID!, $labels: [ID]!) {
  updateCompanyModel(input: {id: $companyId, labels: $labels}) {
    company {
      id
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class SaveCompanyLabelsGQL extends Apollo.Mutation<SaveCompanyLabelsMutation, SaveCompanyLabelsMutationVariables> {
    document = SaveCompanyLabelsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateCompanyTagsInExternalSysDocument = gql`
    mutation UpdateCompanyTagsInExternalSys($companyId: ID!, $dateFrom: Date, $updateLivas: Boolean, $updateWorkis: Boolean) {
  syncCompanyLabels(
    companyId: $companyId
    date: $dateFrom
    syncLivas: $updateLivas
    syncWorkis: $updateWorkis
  ) {
    ok
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateCompanyTagsInExternalSysGQL extends Apollo.Mutation<UpdateCompanyTagsInExternalSysMutation, UpdateCompanyTagsInExternalSysMutationVariables> {
    document = UpdateCompanyTagsInExternalSysDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const AllContactsDocument = gql`
    query allContacts($first: Int, $after: String, $search: String, $phone: String, $company: ID, $canUseInOrder: Boolean, $id: ID) {
  contacts(
    first: $first
    after: $after
    search: $search
    phone: $phone
    company: $company
    canUseInOrder: $canUseInOrder
    id: $id
  ) {
    pageInfo {
      startCursor
      endCursor
      hasNextPage
    }
    totalCount
    edges {
      node {
        id
        firstName
        lastName
        phone
        email
        insightlyId
        comment
        canUseInOrder
        company {
          id
          name
        }
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class AllContactsGQL extends Apollo.Query<AllContactsQuery, AllContactsQueryVariables> {
    document = AllContactsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetCountriesDocument = gql`
    query getCountries {
  countries {
    edges {
      node {
        ...CountryFields
      }
    }
    totalCount
  }
}
    ${CountryFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class GetCountriesGQL extends Apollo.Query<GetCountriesQuery, GetCountriesQueryVariables> {
    document = GetCountriesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateCustomLinkDocument = gql`
    mutation CreateCustomLink($input: CreateCustomLinkInput!) {
  createCustomLink(input: $input) {
    customLink {
      id
      title
      url
      dashboard {
        id
        title
      }
      createdBy {
        id
        fullName
      }
      createdAt
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateCustomLinkGQL extends Apollo.Mutation<CreateCustomLinkMutation, CreateCustomLinkMutationVariables> {
    document = CreateCustomLinkDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const EscalateMetricValueToDashboardsMutationDocument = gql`
    mutation EscalateMetricValueToDashboardsMutation($metricValueId: ID!, $escalatedToIds: [ID!]!, $escalatedFromId: ID) {
  escalateMetricValueToDashboards(
    metricValueId: $metricValueId
    escalatedToIds: $escalatedToIds
    escalatedFromId: $escalatedFromId
  ) {
    metricValue {
      id
      value
      escalatedTo {
        id
        title
        meetingLevel
      }
      escalatedFrom {
        id
        title
      }
      escalatedAt
      escalatedBy {
        id
        fullName
      }
      escalations {
        edges {
          node {
            id
            escalatedTo {
              id
              title
              meetingLevel
            }
            escalatedFrom {
              id
              title
            }
            createdAt
            createdBy {
              id
              fullName
            }
            metricValue {
              id
            }
          }
        }
      }
    }
    errors
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class EscalateMetricValueToDashboardsMutationGQL extends Apollo.Mutation<EscalateMetricValueToDashboardsMutationMutation, EscalateMetricValueToDashboardsMutationMutationVariables> {
    document = EscalateMetricValueToDashboardsMutationDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UnEscalateMetricValueFromDashboardsDocument = gql`
    mutation unEscalateMetricValueFromDashboards($escalationId: ID!) {
  unEscalateMetricValueFromDashboards(escalationId: $escalationId) {
    metricValue {
      id
    }
    ok
    errors
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UnEscalateMetricValueFromDashboardsGQL extends Apollo.Mutation<UnEscalateMetricValueFromDashboardsMutation, UnEscalateMetricValueFromDashboardsMutationVariables> {
    document = UnEscalateMetricValueFromDashboardsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateMetricValueCommentMutationDocument = gql`
    mutation UpdateMetricValueCommentMutation($id: ID!, $comment: String, $reasonId: ID) {
  updateMetricValueComment(
    input: {id: $id, comment: $comment, metricClientReason: $reasonId}
  ) {
    metricValueComment {
      id
      comment
      metricClientReason {
        id
        title
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateMetricValueCommentMutationGQL extends Apollo.Mutation<UpdateMetricValueCommentMutationMutation, UpdateMetricValueCommentMutationMutationVariables> {
    document = UpdateMetricValueCommentMutationDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const SetMetricValueNextTaskMutationDocument = gql`
    mutation SetMetricValueNextTaskMutation($id: ID!, $taskId: ID!) {
  updateMetricValue(input: {id: $id, nextTask: $taskId}) {
    metricValue {
      id
      value
      nextTask {
        ...StandUpDashboardTaskFields
        customFieldValues {
          edges {
            node {
              ...CustomFieldsValuesFields
            }
          }
        }
      }
    }
  }
}
    ${StandUpDashboardTaskFieldsFragmentDoc}
${CustomFieldsValuesFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class SetMetricValueNextTaskMutationGQL extends Apollo.Mutation<SetMetricValueNextTaskMutationMutation, SetMetricValueNextTaskMutationMutationVariables> {
    document = SetMetricValueNextTaskMutationDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const SetMetricValueNextTaskL2MutationDocument = gql`
    mutation SetMetricValueNextTaskL2Mutation($id: ID!, $taskId: ID!) {
  updateMetricValue(input: {id: $id, nextTaskLevel2: $taskId}) {
    metricValue {
      id
      value
      nextTaskLevel2 {
        ...StandUpDashboardTaskFields
      }
    }
  }
}
    ${StandUpDashboardTaskFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class SetMetricValueNextTaskL2MutationGQL extends Apollo.Mutation<SetMetricValueNextTaskL2MutationMutation, SetMetricValueNextTaskL2MutationMutationVariables> {
    document = SetMetricValueNextTaskL2MutationDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateMetricValueImportanceMutationDocument = gql`
    mutation UpdateMetricValueImportanceMutation($id: ID!, $isImportant: Boolean!) {
  updateMetricValue(input: {id: $id, isImportant: $isImportant}) {
    metricValue {
      id
      isImportant
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateMetricValueImportanceMutationGQL extends Apollo.Mutation<UpdateMetricValueImportanceMutationMutation, UpdateMetricValueImportanceMutationMutationVariables> {
    document = UpdateMetricValueImportanceMutationDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const EscalateMetricValueMutationDocument = gql`
    mutation EscalateMetricValueMutation($input: UpdateMetricValueInput!) {
  updateMetricValue(input: $input) {
    metricValue {
      id
      escalatedTo {
        id
        title
      }
      escalatedBy {
        id
        fullName
      }
      escalatedAt
      escalatedFrom {
        id
        title
      }
      escalations {
        edges {
          node {
            id
            escalatedTo {
              id
              title
              meetingLevel
            }
            escalatedFrom {
              id
              title
            }
            createdAt
            createdBy {
              id
              fullName
            }
            metricValue {
              id
            }
          }
        }
      }
    }
    errors {
      field
      message
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class EscalateMetricValueMutationGQL extends Apollo.Mutation<EscalateMetricValueMutationMutation, EscalateMetricValueMutationMutationVariables> {
    document = EscalateMetricValueMutationDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateDashboardCardDocument = gql`
    mutation UpdateDashboardCard($input: UpdateDashboardCardInput!) {
  updateDashboardCard(input: $input) {
    dashboardCard {
      id
      barchartGoal
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateDashboardCardGQL extends Apollo.Mutation<UpdateDashboardCardMutation, UpdateDashboardCardMutationVariables> {
    document = UpdateDashboardCardDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const AggregatedMetricsDocument = gql`
    query AggregatedMetrics($regionGroupId: ID!, $dateFrom: Date!, $dateTo: Date!, $metricGroupIds: [ID!]!) {
  aggregatedMetrics(
    regionGroupId: $regionGroupId
    dateFrom: $dateFrom
    dateTo: $dateTo
    metricGroupIds: $metricGroupIds
  ) {
    id
    date
    isImportant
    manager {
      id
      fullName
    }
    client {
      id
      country {
        id
        isoCode
      }
      name
      livasId
    }
    candidate {
      id
      country {
        id
        isoCode
      }
      livasId
      employeeLivasId
      firstName
      lastName
    }
    order {
      id
      company {
        id
        name
      }
      specification {
        id
        positionTitle
      }
      priority
    }
    escalatedTo {
      id
      title
    }
    escalatedBy {
      id
      fullName
    }
    escalatedAt
    escalatedFrom {
      id
      title
    }
    value
    subvalue
    goal
    workis
    nextTaskId
    nextTaskLevel2Id
    metricvaluecommentSet {
      id
      comment
      metricClientReason {
        id
        title
      }
      clients {
        edges {
          node {
            country {
              id
              isoCode
            }
            id
            name
            livasId
          }
        }
      }
      candidates {
        edges {
          node {
            id
            country {
              id
              isoCode
            }
            livasId
            employeeLivasId
            firstName
            lastName
          }
        }
      }
    }
    metricGroup {
      id
      subvalueExplanation
      taskCategory {
        id
        title
        hint
        durationMinutes
        showDuration
        showOrder
        showCompany
        showDescription
        showOrder
        showCandidate
        customFields {
          edges {
            node {
              id
              name
              hintText
              options
              fieldType {
                id
                name
                fieldType
              }
            }
          }
        }
      }
      nextActions {
        edges {
          node {
            id
            title
            createCompletedTask
            taskCategory {
              id
              title
              hint
              durationMinutes
              showDuration
              showOrder
              showCompany
              showDescription
              showOrder
              showCandidate
              customFields {
                edges {
                  node {
                    id
                    name
                    hintText
                    options
                    fieldType {
                      id
                      name
                      fieldType
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class AggregatedMetricsGQL extends Apollo.Query<AggregatedMetricsQuery, AggregatedMetricsQueryVariables> {
    document = AggregatedMetricsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetDashboardsDocument = gql`
    query getDashboards {
  allDashboards {
    edges {
      node {
        regionGroup {
          id
        }
        id
        title
        meetingLevel
        escalateTo {
          id
          title
        }
        escalateToDashboards {
          id
          title
          meetingLevel
        }
        dashboardcardSet {
          edges {
            node {
              id
              barchartGoal
              card {
                id
                title
                description
                type
                filterTaskCategoriesKeys
                excludeTaskCategoriesKeys
                excludeTaskStatuses
                displayColumns
                lookForwardDays
                includeFromChildDashboards
                allDashboards
                additionalFilters
              }
              metricGroupForOtherProblem {
                id
              }
            }
          }
        }
        metricsUserprofiles {
          edges {
            node {
              id
              fullName
              color
            }
          }
        }
        customLinks {
          title
          url
        }
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetDashboardsGQL extends Apollo.Query<GetDashboardsQuery, GetDashboardsQueryVariables> {
    document = GetDashboardsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetDashboardsListDocument = gql`
    query getDashboardsList {
  allDashboards {
    edges {
      node {
        id
        title
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetDashboardsListGQL extends Apollo.Query<GetDashboardsListQuery, GetDashboardsListQueryVariables> {
    document = GetDashboardsListDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const MetricGroupReasonsDocument = gql`
    query MetricGroupReasons($id: ID!) {
  metricGroups(id: $id) {
    edges {
      node {
        metricclientreasonSet {
          edges {
            node {
              id
              title
            }
          }
        }
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class MetricGroupReasonsGQL extends Apollo.Query<MetricGroupReasonsQuery, MetricGroupReasonsQueryVariables> {
    document = MetricGroupReasonsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetMetricTableCardContentDocument = gql`
    query getMetricTableCardContent($id: ID!, $dashboardId: ID, $dateFrom: Date, $dateTo: Date) {
  metricGroupsAssignment(card: $id) {
    edges {
      node {
        id
        metricGroup {
          id
          title
          description
          highlightWhen
          metricvalueSet(
            dashboardId: $dashboardId
            cardId: $id
            dateFrom: $dateFrom
            dateTo: $dateTo
          ) {
            edges {
              node {
                id
                key
                date
                isImportant
                channel
                regionGroup {
                  title
                }
                manager {
                  id
                  fullName
                }
                client {
                  id
                  country {
                    id
                    isoCode
                  }
                  name
                  livasId
                }
                candidate {
                  id
                  country {
                    id
                    isoCode
                  }
                  livasId
                  employeeLivasId
                  firstName
                  lastName
                }
                order {
                  id
                  company {
                    id
                    name
                  }
                  specification {
                    id
                    positionTitle
                  }
                }
                escalatedTo {
                  id
                  title
                  meetingLevel
                }
                escalatedBy {
                  id
                  fullName
                }
                escalatedAt
                escalatedFrom {
                  id
                  title
                }
                escalations {
                  edges {
                    node {
                      id
                      escalatedTo {
                        id
                        title
                        meetingLevel
                      }
                      escalatedFrom {
                        id
                        title
                      }
                      createdAt
                      createdBy {
                        id
                        fullName
                      }
                    }
                  }
                }
                value
                goal
                workis
                nextTaskId
                nextTaskLevel2Id
                metricvaluecommentSet {
                  edges {
                    node {
                      id
                      comment
                    }
                  }
                }
              }
            }
          }
          taskCategory {
            id
            title
            hint
            durationMinutes
            showDuration
            showOrder
            showCompany
            showDescription
            showOrder
            showCandidate
            customFields {
              edges {
                node {
                  id
                  name
                  hintText
                  options
                  fieldType {
                    id
                    name
                    fieldType
                  }
                }
              }
            }
          }
          nextActions {
            edges {
              node {
                id
                title
                createCompletedTask
                taskCategory {
                  id
                  title
                  hint
                  durationMinutes
                  showDuration
                  showOrder
                  showCompany
                  showDescription
                  showOrder
                  showCandidate
                  customFields {
                    edges {
                      node {
                        id
                        name
                        hintText
                        options
                        fieldType {
                          id
                          name
                          fieldType
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetMetricTableCardContentGQL extends Apollo.Query<GetMetricTableCardContentQuery, GetMetricTableCardContentQueryVariables> {
    document = GetMetricTableCardContentDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetResourcesLvl2Document = gql`
    query getResourcesLvl2($id: ID!, $dashboardId: ID!, $dateFrom: Date, $dateTo: Date) {
  metricGroupsAssignment(card: $id) {
    edges {
      node {
        id
        metricGroup {
          id
          title
          description
          highlightWhen
          metricvalueSet(
            dashboardId: $dashboardId
            cardId: $id
            dateFrom: $dateFrom
            dateTo: $dateTo
          ) {
            edges {
              node {
                value
                date
                regionGroup {
                  id
                  title
                }
              }
            }
          }
        }
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetResourcesLvl2GQL extends Apollo.Query<GetResourcesLvl2Query, GetResourcesLvl2QueryVariables> {
    document = GetResourcesLvl2Document;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetConversionsDocument = gql`
    query getConversions($id: ID!, $dateFrom: Date, $dateTo: Date, $dashboardRegion: ID) {
  metricGroupsAssignment(card: $id) {
    edges {
      node {
        id
        metricGroup {
          id
          title
          metricvalueSet(
            dateFrom: $dateFrom
            dateTo: $dateTo
            dashboardRegion: $dashboardRegion
          ) {
            edges {
              node {
                id
                value
                key
                regionGroup {
                  id
                  title
                }
                order {
                  id
                  specification {
                    positionTitle
                    id
                  }
                }
              }
            }
          }
        }
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetConversionsGQL extends Apollo.Query<GetConversionsQuery, GetConversionsQueryVariables> {
    document = GetConversionsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetMetricValuesEscalatedDocument = gql`
    query getMetricValuesEscalated($escalatedTo: ID, $dateFrom: Date, $dateTo: Date) {
  metricValues(escalatedTo: $escalatedTo, dateFrom: $dateFrom, dateTo: $dateTo) {
    edges {
      node {
        id
        date
        isImportant
        channel
        escalatedTo {
          id
          title
          meetingLevel
        }
        escalatedBy {
          id
          fullName
        }
        escalatedAt
        escalatedFrom {
          id
          title
        }
        escalations {
          edges {
            node {
              id
              escalatedTo {
                id
                title
                meetingLevel
              }
              escalatedFrom {
                id
                title
              }
              createdAt
              createdBy {
                id
                fullName
              }
            }
          }
        }
        manager {
          id
          fullName
        }
        client {
          id
          name
          livasId
        }
        candidate {
          id
          livasId
          employeeLivasId
          firstName
          lastName
        }
        order {
          id
          company {
            id
            name
          }
          specification {
            id
            positionTitle
          }
        }
        value
        goal
        workis
        nextTaskId
        nextTaskLevel2Id
        metricvaluecommentSet {
          edges {
            node {
              id
            }
          }
        }
        metricGroup {
          id
          title
          description
          highlightWhen
          taskCategory {
            id
            title
            hint
            durationMinutes
            showDuration
            showOrder
            showCompany
            showDescription
            showOrder
            showCandidate
            customFields {
              edges {
                node {
                  id
                  name
                  hintText
                  options
                  fieldType {
                    id
                    name
                    fieldType
                  }
                }
              }
            }
          }
          nextActions {
            edges {
              node {
                id
                title
                createCompletedTask
                taskCategory {
                  id
                  title
                  hint
                  durationMinutes
                  showDuration
                  showOrder
                  showCompany
                  showDescription
                  showOrder
                  showCandidate
                  customFields {
                    edges {
                      node {
                        id
                        name
                        hintText
                        options
                        fieldType {
                          id
                          name
                          fieldType
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetMetricValuesEscalatedGQL extends Apollo.Query<GetMetricValuesEscalatedQuery, GetMetricValuesEscalatedQueryVariables> {
    document = GetMetricValuesEscalatedDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetMetricNextTaskDocument = gql`
    query getMetricNextTask($ids: [ID]) {
  tasks(ids: $ids) {
    edges {
      node {
        ...StandUpDashboardTaskFields
        customFieldValues {
          edges {
            node {
              ...CustomFieldsValuesFields
            }
          }
        }
      }
    }
  }
}
    ${StandUpDashboardTaskFieldsFragmentDoc}
${CustomFieldsValuesFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class GetMetricNextTaskGQL extends Apollo.Query<GetMetricNextTaskQuery, GetMetricNextTaskQueryVariables> {
    document = GetMetricNextTaskDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetMetricCommentsDocument = gql`
    query getMetricComments($ids: [ID]) {
  metricValueComments(metricValueIds: $ids) {
    edges {
      node {
        id
        comment
        metricClientReason {
          id
          title
        }
        clients {
          edges {
            node {
              id
              country {
                id
                isoCode
              }
              name
              livasId
            }
          }
        }
        candidates {
          edges {
            node {
              id
              country {
                id
                isoCode
              }
              livasId
              employeeLivasId
              firstName
              lastName
            }
          }
        }
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetMetricCommentsGQL extends Apollo.Query<GetMetricCommentsQuery, GetMetricCommentsQueryVariables> {
    document = GetMetricCommentsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetMetricTableCardNextTaskUpdateDocument = gql`
    query getMetricTableCardNextTaskUpdate($id: ID!) {
  tasks(id: $id) {
    edges {
      node {
        ...StandUpDashboardTaskFields
        nextActionCategory {
          id
          title
        }
      }
    }
  }
}
    ${StandUpDashboardTaskFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class GetMetricTableCardNextTaskUpdateGQL extends Apollo.Query<GetMetricTableCardNextTaskUpdateQuery, GetMetricTableCardNextTaskUpdateQueryVariables> {
    document = GetMetricTableCardNextTaskUpdateDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetWeeklyBarchartCardContentDocument = gql`
    query getWeeklyBarchartCardContent($id: ID!, $dashboardId: ID!, $dateFrom: Date, $dateTo: Date) {
  metricGroupsAssignment(card: $id) {
    edges {
      node {
        id
        metricGroup {
          id
          title
          description
          metricvalueSet(dashboardId: $dashboardId, dateFrom: $dateFrom, dateTo: $dateTo) {
            edges {
              node {
                id
                date
                value
              }
            }
          }
        }
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetWeeklyBarchartCardContentGQL extends Apollo.Query<GetWeeklyBarchartCardContentQuery, GetWeeklyBarchartCardContentQueryVariables> {
    document = GetWeeklyBarchartCardContentDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetMetricGroupsByDashboardCardDocument = gql`
    query getMetricGroupsByDashboardCard($cardId: ID!) {
  metricGroupsAssignment(card: $cardId) {
    edges {
      node {
        id
        metricGroup {
          id
        }
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetMetricGroupsByDashboardCardGQL extends Apollo.Query<GetMetricGroupsByDashboardCardQuery, GetMetricGroupsByDashboardCardQueryVariables> {
    document = GetMetricGroupsByDashboardCardDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetConversionRatesDocument = gql`
    query GetConversionRates($cardId: ID!, $dashboardId: ID!, $date: Date!) {
  conversionRatesTransregional(
    cardId: $cardId
    dashboardId: $dashboardId
    date: $date
  ) {
    regionGroupId
    regionGroup {
      id
      title
    }
    conversionType
    regionAverage
    ordersBelowAverageCount
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetConversionRatesGQL extends Apollo.Query<GetConversionRatesQuery, GetConversionRatesQueryVariables> {
    document = GetConversionRatesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetPromisesTasksDocument = gql`
    query getPromisesTasks($categoriesKeys: String, $owners: [ID], $date_Gte: Date, $excludeStatuses: String) {
  tasks(
    categoriesKeys: $categoriesKeys
    completedBy: $owners
    date_Gte: $date_Gte
    excludeStatuses: $excludeStatuses
  ) {
    edges {
      node {
        id
        isImportant
        status
        taskEscalations {
          edges {
            node {
              escalatedTo {
                id
                meetingLevel
              }
              escalatedFrom {
                id
                meetingLevel
              }
              id
              task {
                id
              }
            }
          }
        }
        category {
          id
          key
        }
        comment
        order {
          id
          company {
            id
            name
          }
          specification {
            id
            positionTitle
          }
        }
        company {
          id
          name
        }
        date
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetPromisesTasksGQL extends Apollo.Query<GetPromisesTasksQuery, GetPromisesTasksQueryVariables> {
    document = GetPromisesTasksDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetOrderCandidateStatsDocument = gql`
    query getOrderCandidateStats($orderIds: [ID], $dateFrom: Date, $companyIds: [ID]) {
  candidateOrderStats(
    orderIds: $orderIds
    companyIds: $companyIds
    dateTo: "2029-12-31"
    dateFrom: $dateFrom
  ) {
    orderId
    companyId
    toBeInterviewed
    toBeInterviewedClient
    healthCheckPending
    toBeEmployed
    offeredLast7Days
    offeredFromDate
    healthCheckPending
    presentedClient
    presentedClientSuccess
    presentedClientFailed
    longListedLast7Days
    offeredLast1Day
    longListedLast1Day
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetOrderCandidateStatsGQL extends Apollo.Query<GetOrderCandidateStatsQuery, GetOrderCandidateStatsQueryVariables> {
    document = GetOrderCandidateStatsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetUsersForCurrentAndChildDashboardsDocument = gql`
    query getUsersForCurrentAndChildDashboards($parentDashboardId: ID) {
  userprofiles(parentDashboardId: $parentDashboardId) {
    id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetUsersForCurrentAndChildDashboardsGQL extends Apollo.Query<GetUsersForCurrentAndChildDashboardsQuery, GetUsersForCurrentAndChildDashboardsQueryVariables> {
    document = GetUsersForCurrentAndChildDashboardsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const EscalateTaskToDashboardsDocument = gql`
    mutation escalateTaskToDashboards($escalatedFrom: ID, $escalatedTo: [ID]!, $taskId: ID!) {
  escalateTaskToDashboards(
    escalatedFromId: $escalatedFrom
    escalatedToIds: $escalatedTo
    taskId: $taskId
  ) {
    task {
      id
      taskEscalations {
        edges {
          node {
            escalatedTo {
              id
              meetingLevel
            }
            escalatedFrom {
              id
              meetingLevel
            }
            id
            task {
              id
            }
          }
        }
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class EscalateTaskToDashboardsGQL extends Apollo.Mutation<EscalateTaskToDashboardsMutation, EscalateTaskToDashboardsMutationVariables> {
    document = EscalateTaskToDashboardsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UnEscalateTaskToDashboardsDocument = gql`
    mutation unEscalateTaskToDashboards($escalation: ID!) {
  unEscalateTaskFromDashboards(escalationId: $escalation) {
    ok
    task {
      id
      taskEscalations {
        edges {
          node {
            escalatedTo {
              id
              meetingLevel
            }
            escalatedFrom {
              id
              meetingLevel
            }
            id
            task {
              id
            }
          }
        }
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UnEscalateTaskToDashboardsGQL extends Apollo.Mutation<UnEscalateTaskToDashboardsMutation, UnEscalateTaskToDashboardsMutationVariables> {
    document = UnEscalateTaskToDashboardsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const FreeVacanciesCalendarEventsDocument = gql`
    query FreeVacanciesCalendarEvents($dateFrom: Date) {
  plannerEvents(date_Gte: $dateFrom) {
    edges {
      node {
        externalPlatformId
        order {
          id
          specification {
            id
            positionTitle
          }
        }
        ...FreeVacanciesCalendarEventFields
      }
    }
  }
}
    ${FreeVacanciesCalendarEventFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class FreeVacanciesCalendarEventsGQL extends Apollo.Query<FreeVacanciesCalendarEventsQuery, FreeVacanciesCalendarEventsQueryVariables> {
    document = FreeVacanciesCalendarEventsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetFreeVacanciesOrderDocument = gql`
    query getFreeVacanciesOrder($status: String, $first: Int, $after: String, $search: String, $region: String, $sex: String, $trafficGeneration: String, $id: ID, $isLongTerm: Boolean, $nettoFrom: Float, $nettoTo: Float, $orderType: String, $covidPolicy: [ID], $scheduleTypes: String, $canEmployUa: Boolean, $country: ID, $date_Lte: Date, $date_Gte: Date) {
  ordersPaginated(
    status: $status
    first: $first
    after: $after
    search: $search
    region: $region
    sex: $sex
    id: $id
    trafficGeneration: $trafficGeneration
    isLongTerm: $isLongTerm
    nettoFrom: $nettoFrom
    nettoTo: $nettoTo
    orderType: $orderType
    scheduleTypesAll: $scheduleTypes
    country: $country
    covidPolicy: $covidPolicy
    canEmployUa: $canEmployUa
    orderBy: "company__color,company__name"
  ) {
    pageInfo {
      startCursor
      endCursor
      hasNextPage
    }
    totalCount
    edges {
      node {
        id
        canGetBonuses
        canIncreaseSalary
        orderType
        toBeReviewed
        hourRateBruttoPermanent
        salaryInfo
        orderNumber
        orderPeriodFrom
        orderPeriodTo
        orderCanBeExtended
        orderCanBeExtendedComment
        isLongTerm
        demand
        status
        trafficGeneration
        nettoFrom
        nettoTo
        shortage
        isCompanyInternational
        isCompanyModern
        isLogoPublicAllowed
        statsFutureInterview
        clientContact {
          ...ContactFieldsShort
        }
        additionalClientContacts {
          edges {
            node {
              ...ContactFieldsShort
            }
          }
        }
        createdBy {
          id
          user {
            ...UserMainFields
          }
        }
        region {
          id
          title
        }
        company {
          ...CompanyMainFields
        }
        orderperiodSet {
          ...OrderPeriodFields
        }
        specification {
          ...FreeVacanciesSpecificationFields
        }
        eventSet(date_Lte: $date_Lte, date_Gte: $date_Gte) {
          edges {
            node {
              ...MarketingEventsFields
            }
          }
        }
      }
    }
  }
}
    ${ContactFieldsShortFragmentDoc}
${UserMainFieldsFragmentDoc}
${CompanyMainFieldsFragmentDoc}
${OrderPeriodFieldsFragmentDoc}
${FreeVacanciesSpecificationFieldsFragmentDoc}
${MarketingEventsFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class GetFreeVacanciesOrderGQL extends Apollo.Query<GetFreeVacanciesOrderQuery, GetFreeVacanciesOrderQueryVariables> {
    document = GetFreeVacanciesOrderDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetPlannerEventsDocument = gql`
    query getPlannerEvents {
  plannerEvents {
    edges {
      node {
        externalPlatformId
        order {
          id
          specification {
            id
            positionTitle
          }
        }
        ...MarketingEventsFields
      }
    }
  }
}
    ${MarketingEventsFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class GetPlannerEventsGQL extends Apollo.Query<GetPlannerEventsQuery, GetPlannerEventsQueryVariables> {
    document = GetPlannerEventsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetPlannerEventsByOrderDocument = gql`
    query getPlannerEventsByOrder($orderId: ID!, $first: Int, $after: String, $date_Lte: Date, $date_Gte: Date, $ordering: String) {
  plannerEvents(
    order: $orderId
    first: $first
    after: $after
    date_Lte: $date_Lte
    date_Gte: $date_Gte
    ordering: $ordering
  ) {
    pageInfo {
      startCursor
      endCursor
      hasNextPage
    }
    totalCount
    edges {
      node {
        externalPlatformId
        durationMinutes
        price
        order {
          id
          specification {
            id
            positionTitle
          }
        }
        completedBy {
          id
          fullName
          user {
            id
            firstName
            lastName
          }
        }
        ...MarketingEventsFields
      }
    }
  }
}
    ${MarketingEventsFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class GetPlannerEventsByOrderGQL extends Apollo.Query<GetPlannerEventsByOrderQuery, GetPlannerEventsByOrderQueryVariables> {
    document = GetPlannerEventsByOrderDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetPlannerEventsByCompanyDocument = gql`
    query getPlannerEventsByCompany($order_Company: ID!, $first: Int, $after: String, $date_Lte: Date, $date_Gte: Date) {
  plannerEvents(
    order_Company: $order_Company
    first: $first
    after: $after
    date_Lte: $date_Lte
    date_Gte: $date_Gte
  ) {
    pageInfo {
      startCursor
      endCursor
      hasNextPage
    }
    totalCount
    edges {
      node {
        durationMinutes
        price
        externalPlatformId
        order {
          id
          specification {
            id
            positionTitle
          }
        }
        ...MarketingEventsFields
      }
    }
  }
}
    ${MarketingEventsFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class GetPlannerEventsByCompanyGQL extends Apollo.Query<GetPlannerEventsByCompanyQuery, GetPlannerEventsByCompanyQueryVariables> {
    document = GetPlannerEventsByCompanyDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const InterviewWidgetOffersDocument = gql`
    query InterviewWidgetOffers($sex: String, $personId: Int, $search: String, $region: String, $region_ExternalId: Int, $trafficGeneration: String, $country: String) {
  offers(personId: $personId) {
    edges {
      node {
        ...InterviewWidgetOfferFields
        createdAt
        cancellationreasonassignmentSet {
          edges {
            node {
              id
              cancellationReason {
                id
                title
              }
            }
          }
        }
        offerpropositioncommentSet {
          totalCount
          edges {
            node {
              text
            }
          }
        }
      }
    }
  }
  regions {
    ...InterviewWidgetRegionFields
  }
  ordersPaginated(
    sex: $sex
    search: $search
    region: $region
    region_Country: $country
    region_ExternalId: $region_ExternalId
    trafficGeneration: $trafficGeneration
    orderBy: "company__color"
  ) {
    edges {
      node {
        ...InterviewWidgetOrdersFields
      }
    }
  }
}
    ${InterviewWidgetOfferFieldsFragmentDoc}
${InterviewWidgetRegionFieldsFragmentDoc}
${InterviewWidgetOrdersFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class InterviewWidgetOffersGQL extends Apollo.Query<InterviewWidgetOffersQuery, InterviewWidgetOffersQueryVariables> {
    document = InterviewWidgetOffersDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CandidateEventByTimeAndPersonDocument = gql`
    query CandidateEventByTimeAndPerson($livasId: Float!, $orderId: ID!, $eventType: String) {
  candidateEvents(
    candidateLivasId: $livasId
    orderId: $orderId
    eventType: $eventType
  ) {
    edges {
      node {
        ...OfferEventFields
      }
    }
  }
}
    ${OfferEventFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class CandidateEventByTimeAndPersonGQL extends Apollo.Query<CandidateEventByTimeAndPersonQuery, CandidateEventByTimeAndPersonQueryVariables> {
    document = CandidateEventByTimeAndPersonDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateDocument = gql`
    mutation update($id: ID!, $status: EventResolutionStatus) {
  eventStatusUpdate(input: {id: $id, resolutionStatus: $status}) {
    event {
      id
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateGQL extends Apollo.Mutation<UpdateMutation, UpdateMutationVariables> {
    document = UpdateDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const SmsDocument = gql`
    mutation sms($id: ID!, $sms: String) {
  sendSms(candidateId: $id, text: $sms) {
    ok
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class SmsGQL extends Apollo.Mutation<SmsMutation, SmsMutationVariables> {
    document = SmsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const EventUpdateDocument = gql`
    mutation eventUpdate($id: ID!, $startDatetime: DateTime!) {
  eventUpdate(input: {id: $id, startDatetime: $startDatetime}) {
    event {
      id
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class EventUpdateGQL extends Apollo.Mutation<EventUpdateMutation, EventUpdateMutationVariables> {
    document = EventUpdateDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const InterviewWidgetCreateEventDocument = gql`
    mutation InterviewWidgetCreateEvent($eventType: EventEventType!, $offerPropositions: [ID]!, $startDatetime: DateTime, $livasStatusId: Int, $livasContactDate: Date, $updateLivasOfficeInterviewDate: Boolean, $updateLivasClientInterviewDate: Boolean, $updateLivasEmploymentDate: Boolean) {
  eventCreate(
    input: {eventType: $eventType, offerPropositions: $offerPropositions, startDatetime: $startDatetime, livasStatusId: $livasStatusId, livasContactDate: $livasContactDate, updateLivasOfficeInterviewDate: $updateLivasOfficeInterviewDate, updateLivasClientInterviewDate: $updateLivasClientInterviewDate, updateLivasEmploymentDate: $updateLivasEmploymentDate}
  ) {
    event {
      deleted
      id
      startDatetime
      resolutionStatus
      candidate {
        eventSet(deleted: false) {
          edges {
            node {
              id
              deleted
            }
          }
        }
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class InterviewWidgetCreateEventGQL extends Apollo.Mutation<InterviewWidgetCreateEventMutation, InterviewWidgetCreateEventMutationVariables> {
    document = InterviewWidgetCreateEventDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const InterviewWidgetEventUpdateDocument = gql`
    mutation InterviewWidgetEventUpdate($eventId: ID!, $eventType: EventEventType!, $offerPropositions: [ID]!, $startDatetime: DateTime, $livasStatusId: Int, $livasContactDate: Date, $updateLivasOfficeInterviewDate: Boolean, $updateLivasClientInterviewDate: Boolean, $updateLivasEmploymentDate: Boolean, $description: String, $isProblematicInterview: Boolean) {
  eventUpdate(
    input: {id: $eventId, eventType: $eventType, offerPropositions: $offerPropositions, startDatetime: $startDatetime, livasStatusId: $livasStatusId, livasContactDate: $livasContactDate, updateLivasOfficeInterviewDate: $updateLivasOfficeInterviewDate, updateLivasClientInterviewDate: $updateLivasClientInterviewDate, updateLivasEmploymentDate: $updateLivasEmploymentDate, description: $description, isProblematicInterview: $isProblematicInterview}
  ) {
    event {
      deleted
      id
      startDatetime
      resolutionStatus
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class InterviewWidgetEventUpdateGQL extends Apollo.Mutation<InterviewWidgetEventUpdateMutation, InterviewWidgetEventUpdateMutationVariables> {
    document = InterviewWidgetEventUpdateDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const InterviewWidgetChangeEventStatusMutationDocument = gql`
    mutation InterviewWidgetChangeEventStatusMutation($eventId: ID!, $resolutionStatus: EventResolutionStatus) {
  eventStatusUpdate(input: {id: $eventId, resolutionStatus: $resolutionStatus}) {
    event {
      deleted
      id
      startDatetime
      resolutionStatus
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class InterviewWidgetChangeEventStatusMutationGQL extends Apollo.Mutation<InterviewWidgetChangeEventStatusMutationMutation, InterviewWidgetChangeEventStatusMutationMutationVariables> {
    document = InterviewWidgetChangeEventStatusMutationDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateLivasCandidateStatusByOfferPropositionDocument = gql`
    mutation UpdateLivasCandidateStatusByOfferProposition($offerPropositionId: ID!, $livasStatusId: Int!) {
  updateLivasCandidateStatus(
    offerProposition: $offerPropositionId
    livasStatusId: $livasStatusId
  ) {
    ok
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateLivasCandidateStatusByOfferPropositionGQL extends Apollo.Mutation<UpdateLivasCandidateStatusByOfferPropositionMutation, UpdateLivasCandidateStatusByOfferPropositionMutationVariables> {
    document = UpdateLivasCandidateStatusByOfferPropositionDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateLivasOfferPropositionSignedDocument = gql`
    mutation UpdateLivasOfferPropositionSigned($offerPropositionId: ID!) {
  offerPropositionUpdate(input: {id: $offerPropositionId, signed: true}) {
    offerProposition {
      id
      signed
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateLivasOfferPropositionSignedGQL extends Apollo.Mutation<UpdateLivasOfferPropositionSignedMutation, UpdateLivasOfferPropositionSignedMutationVariables> {
    document = UpdateLivasOfferPropositionSignedDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateEventProblematicInterviewDocument = gql`
    mutation UpdateEventProblematicInterview($id: ID!, $isProblematicInterview: Boolean!, $description: String) {
  eventProblematicInterviewUpdate(
    input: {id: $id, isProblematicInterview: $isProblematicInterview, description: $description}
  ) {
    event {
      id
      description
      isProblematicInterview
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateEventProblematicInterviewGQL extends Apollo.Mutation<UpdateEventProblematicInterviewMutation, UpdateEventProblematicInterviewMutationVariables> {
    document = UpdateEventProblematicInterviewDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetJobAdAiVersionsDocument = gql`
    query GetJobAdAIVersions($orderId: Int!) {
  jobAdsContentAi(orderId: $orderId) {
    id
    status
    response
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetJobAdAiVersionsGQL extends Apollo.Query<GetJobAdAiVersionsQuery, GetJobAdAiVersionsQueryVariables> {
    document = GetJobAdAiVersionsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const LivasJobAdsDocument = gql`
    query LivasJobAds($orderId: ID!) {
  livasJobAds(orderId: $orderId) {
    advertTitle
    description2
    descriptionDsc
    requirementsDsc
    offerDsc
    seoTitle
    contactsCount
    updatedAt
    categoryId
    workingHours
    locationId
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class LivasJobAdsGQL extends Apollo.Query<LivasJobAdsQuery, LivasJobAdsQueryVariables> {
    document = LivasJobAdsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateJobAdLivasDocument = gql`
    mutation CreateJobAdLivas($orderId: ID!, $advertTitle: String!, $summary: String, $offerDsc: String!, $descriptionDsc: String!, $requirementsDsc: String!, $seoTitle: String!, $address: String, $companyTitle: String, $categoryId: Int, $locationId: Int, $position: String, $workingHours: String, $salaryFrom: Float, $salaryTo: Float, $salaryType: String) {
  createJobAdLivas(
    orderId: $orderId
    advertTitle: $advertTitle
    summary: $summary
    offerDsc: $offerDsc
    descriptionDsc: $descriptionDsc
    requirementsDsc: $requirementsDsc
    seoTitle: $seoTitle
    address: $address
    companyTitle: $companyTitle
    categoryId: $categoryId
    position: $position
    workingHours: $workingHours
    salaryFrom: $salaryFrom
    salaryTo: $salaryTo
    salaryType: $salaryType
    locationId: $locationId
  ) {
    response
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateJobAdLivasGQL extends Apollo.Mutation<CreateJobAdLivasMutation, CreateJobAdLivasMutationVariables> {
    document = CreateJobAdLivasDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const JobAdDialogMetaDocument = gql`
    query JobAdDialogMeta {
  jobCategories {
    edges {
      node {
        id
        title
        externalId
      }
    }
  }
  cities {
    edges {
      node {
        id
        title
        externalId
        region {
          id
          externalId
          title
        }
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class JobAdDialogMetaGQL extends Apollo.Query<JobAdDialogMetaQuery, JobAdDialogMetaQueryVariables> {
    document = JobAdDialogMetaDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const OffersDocument = gql`
    query offers($orderId: ID!, $first: Int, $after: String, $orderBy: String, $createdAt_Gte: Date, $createdAt_Lte: Date) {
  offers(
    orderId: $orderId
    first: $first
    after: $after
    orderBy: $orderBy
    createdAt_Gte: $createdAt_Gte
    createdAt_Lte: $createdAt_Lte
  ) {
    pageInfo {
      startCursor
      endCursor
      hasNextPage
      hasPreviousPage
    }
    totalCount
    edges {
      node {
        ...OfferFields
      }
    }
  }
  orderModel(id: $orderId) {
    id
    company {
      id
      country {
        id
        isoCode
      }
    }
  }
}
    ${OfferFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class OffersGQL extends Apollo.Query<OffersQuery, OffersQueryVariables> {
    document = OffersDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const OfferPospositionOffersDocument = gql`
    query OfferPospositionOffers($sex: String, $personId: Int, $region: String, $region_ExternalId: Int, $trafficGeneration: String, $country: String, $orderBy: String) {
  offers(personId: $personId, country: $country, orderBy: $orderBy) {
    edges {
      node {
        ...OfferPropisitionOfferFields
        createdAt
        cancellationreasonassignmentSet {
          edges {
            node {
              ...CancellationReasonAssignmentFields
            }
          }
        }
        offerpropositioncommentSet {
          totalCount
          edges {
            node {
              text
            }
          }
        }
      }
    }
  }
  regions {
    ...OfferPropisitionRegionFields
  }
  ordersPaginated(
    sex: $sex
    region: $region
    region_Country: $country
    region_ExternalId: $region_ExternalId
    trafficGeneration: $trafficGeneration
    orderBy: "company__color"
  ) {
    edges {
      node {
        ...OfferPropisitionOrdersFields
      }
    }
  }
}
    ${OfferPropisitionOfferFieldsFragmentDoc}
${CancellationReasonAssignmentFieldsFragmentDoc}
${OfferPropisitionRegionFieldsFragmentDoc}
${OfferPropisitionOrdersFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class OfferPospositionOffersGQL extends Apollo.Query<OfferPospositionOffersQuery, OfferPospositionOffersQueryVariables> {
    document = OfferPospositionOffersDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateOfferPropositionCommentDocument = gql`
    mutation CreateOfferPropositionComment($input: CreateOfferPropositionCommentInput!) {
  createOfferPropositionComment(input: $input) {
    offerPropositionComment {
      id
      text
      createdAt
      createdBy {
        id
        user {
          ...UserMainFields
        }
      }
    }
  }
}
    ${UserMainFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateOfferPropositionCommentGQL extends Apollo.Mutation<CreateOfferPropositionCommentMutation, CreateOfferPropositionCommentMutationVariables> {
    document = CreateOfferPropositionCommentDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const OfferPropositionCommentsDocument = gql`
    query OfferPropositionComments($offerId: ID!) {
  offerPropositionComments(offerProposition: $offerId) {
    edges {
      node {
        id
        text
        createdAt
        createdBy {
          id
          user {
            ...UserMainFields
          }
        }
      }
    }
  }
}
    ${UserMainFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class OfferPropositionCommentsGQL extends Apollo.Query<OfferPropositionCommentsQuery, OfferPropositionCommentsQueryVariables> {
    document = OfferPropositionCommentsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateOfferPropositionCommentDocument = gql`
    mutation UpdateOfferPropositionComment($input: UpdateOfferPropositionCommentInput!) {
  updateOfferPropositionComment(input: $input) {
    offerPropositionComment {
      id
      text
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateOfferPropositionCommentGQL extends Apollo.Mutation<UpdateOfferPropositionCommentMutation, UpdateOfferPropositionCommentMutationVariables> {
    document = UpdateOfferPropositionCommentDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateContactDocument = gql`
    mutation createContact($input: ContactInput!) {
  createContact(input: $input) {
    contact {
      ...ContactFields
    }
  }
}
    ${ContactFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateContactGQL extends Apollo.Mutation<CreateContactMutation, CreateContactMutationVariables> {
    document = CreateContactDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateContactDocument = gql`
    mutation updateContact($id: Int!, $input: ContactInput!) {
  updateContact(id: $id, input: $input) {
    contact {
      ...ContactFields
    }
  }
}
    ${ContactFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateContactGQL extends Apollo.Mutation<UpdateContactMutation, UpdateContactMutationVariables> {
    document = UpdateContactDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateOrderDocument = gql`
    mutation createOrder($order: OrderInput!, $periods: [OrderPeriodInput]) {
  createOrder(input: $order, periods: $periods) {
    ok
    order {
      id
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateOrderGQL extends Apollo.Mutation<CreateOrderMutation, CreateOrderMutationVariables> {
    document = CreateOrderDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const SubmitOrder2Document = gql`
    mutation submitOrder2($input: Int) {
  submitOrder(input: $input) {
    ok
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class SubmitOrder2GQL extends Apollo.Mutation<SubmitOrder2Mutation, SubmitOrder2MutationVariables> {
    document = SubmitOrder2Document;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UploadOrderForSigningDocument = gql`
    mutation uploadOrderForSigning($id: ID!) {
  initOrderSigning(id: $id) {
    ok
    order {
      id
      status
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UploadOrderForSigningGQL extends Apollo.Mutation<UploadOrderForSigningMutation, UploadOrderForSigningMutationVariables> {
    document = UploadOrderForSigningDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ResendOrderForSigningDocument = gql`
    mutation resendOrderForSigning($id: ID!) {
  resendOrderSigning(id: $id) {
    ok
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ResendOrderForSigningGQL extends Apollo.Mutation<ResendOrderForSigningMutation, ResendOrderForSigningMutationVariables> {
    document = ResendOrderForSigningDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const OfferPropositionCreateDocument = gql`
    mutation offerPropositionCreate($input: OfferPropositionCreateMutationInput!) {
  offerPropositionCreate(input: $input) {
    offerProposition {
      id
      comment
      order {
        id
      }
      candidate {
        id
      }
      personId
      interested
      interestedOnCall
      signed
      longListed
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class OfferPropositionCreateGQL extends Apollo.Mutation<OfferPropositionCreateMutation, OfferPropositionCreateMutationVariables> {
    document = OfferPropositionCreateDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const OfferPropositionUpdateDocument = gql`
    mutation offerPropositionUpdate($input: OfferPropositionUpdateMutationInput!) {
  offerPropositionUpdate(input: $input) {
    offerProposition {
      id
      comment
      order {
        id
      }
      candidate {
        id
      }
      personId
      interested
      interestedOnCall
      signed
      longListed
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class OfferPropositionUpdateGQL extends Apollo.Mutation<OfferPropositionUpdateMutation, OfferPropositionUpdateMutationVariables> {
    document = OfferPropositionUpdateDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateOrderCommentDocument = gql`
    mutation createOrderComment($comment: String!, $orderId: ID!) {
  createOrderComment(input: {comment: $comment, order: $orderId}) {
    orderComment {
      ...OrderCommentFields
    }
  }
}
    ${OrderCommentFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateOrderCommentGQL extends Apollo.Mutation<CreateOrderCommentMutation, CreateOrderCommentMutationVariables> {
    document = CreateOrderCommentDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ClientInterviewCreateDocument = gql`
    mutation clientInterviewCreate($clientInterview: ClientInterviewCreateMutationInput!) {
  clientInterviewCreate(input: $clientInterview) {
    clientInterview {
      id
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ClientInterviewCreateGQL extends Apollo.Mutation<ClientInterviewCreateMutation, ClientInterviewCreateMutationVariables> {
    document = ClientInterviewCreateDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ClientInterviewUpdateDocument = gql`
    mutation clientInterviewUpdate($clientInterview: ClientInterviewUpdateMutationInput!) {
  clientInterviewUpdate(input: $clientInterview) {
    clientInterview {
      id
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ClientInterviewUpdateGQL extends Apollo.Mutation<ClientInterviewUpdateMutation, ClientInterviewUpdateMutationVariables> {
    document = ClientInterviewUpdateDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const OrderDocumentCreateDocument = gql`
    mutation OrderDocumentCreate($orderId: ID!, $documentDate: Date, $confirmationMethod: DocumentConfirmationMethod!, $orderPeriodIds: [ID!]!) {
  sendOrderDocumentToClient(
    input: {order: $orderId, documentDate: $documentDate, confirmationMethod: $confirmationMethod, orderPeriods: $orderPeriodIds}
  ) {
    document {
      ...CreateOrderDocumentFields
    }
  }
}
    ${CreateOrderDocumentFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class OrderDocumentCreateGQL extends Apollo.Mutation<OrderDocumentCreateMutation, OrderDocumentCreateMutationVariables> {
    document = OrderDocumentCreateDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const SaveRequirementsMutationDocument = gql`
    mutation SaveRequirementsMutation($input: [CandidateRequirementsEvaluationInput!]!) {
  saveRequirements(inputList: $input) {
    candidateRequirementsEvaluations {
      ...CandidateRequirementsEvaluationFields
    }
  }
}
    ${CandidateRequirementsEvaluationFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class SaveRequirementsMutationGQL extends Apollo.Mutation<SaveRequirementsMutationMutation, SaveRequirementsMutationMutationVariables> {
    document = SaveRequirementsMutationDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const SendOrderSummariesMutationDocument = gql`
    mutation SendOrderSummariesMutation($companyId: ID, $dateFrom: Date, $dateTo: Date, $orderIds: [ID], $emails: [String]) {
  sendOrderSummaries(
    companyId: $companyId
    dateFrom: $dateFrom
    dateTo: $dateTo
    orderIds: $orderIds
    emails: $emails
  ) {
    ok
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class SendOrderSummariesMutationGQL extends Apollo.Mutation<SendOrderSummariesMutationMutation, SendOrderSummariesMutationMutationVariables> {
    document = SendOrderSummariesMutationDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateOrderClientContactedDocument = gql`
    mutation CreateOrderClientContacted($order: ID!, $date: Date!) {
  createOrderClientContacted(input: {order: $order, date: $date}) {
    orderClientContacted {
      id
      date
      createdBy {
        id
        fullName
        color
        profileImage
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateOrderClientContactedGQL extends Apollo.Mutation<CreateOrderClientContactedMutation, CreateOrderClientContactedMutationVariables> {
    document = CreateOrderClientContactedDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateOrderErrorDocument = gql`
    mutation CreateOrderError($order: ID!, $category: ID!, $comment: String!) {
  createOrderError(input: {order: $order, category: $category, comment: $comment}) {
    orderError {
      id
      comment
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateOrderErrorGQL extends Apollo.Mutation<CreateOrderErrorMutation, CreateOrderErrorMutationVariables> {
    document = CreateOrderErrorDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetOrderForTaskCreateDocument = gql`
    query getOrderForTaskCreate($id: Int) {
  order(id: $id) {
    id
    company {
      ...CompanyTypeFields
    }
    specification {
      positionTitle
    }
  }
}
    ${CompanyTypeFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class GetOrderForTaskCreateGQL extends Apollo.Query<GetOrderForTaskCreateQuery, GetOrderForTaskCreateQueryVariables> {
    document = GetOrderForTaskCreateDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetSpecificationsDocument = gql`
    query getSpecifications($id: Int) {
  specification(id: $id) {
    ...SpecificationDetailFields
    certificates {
      id
    }
    optionalRequirements {
      id
    }
    personalProtectiveEquipmentBiuro {
      id
    }
    personalProtectiveEquipmentClient {
      id
    }
    riskFactors {
      id
    }
  }
}
    ${SpecificationDetailFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class GetSpecificationsGQL extends Apollo.Query<GetSpecificationsQuery, GetSpecificationsQueryVariables> {
    document = GetSpecificationsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetPaginatedOrderForTableDocument = gql`
    query getPaginatedOrderForTable($status: String, $first: Int, $after: String, $search: String, $region: String, $specification: String, $unseenProcessedOrders: Boolean, $companies: String, $orderBy: String, $orderType: String, $keyAccountManager: ID, $trafficGeneration: String, $covidPolicy: [ID], $country: ID, $periodDateFrom: Date, $periodDateTo: Date) {
  regions {
    ...RegionsList2Fields
  }
  ordersPaginated(
    status: $status
    first: $first
    after: $after
    search: $search
    region: $region
    specification: $specification
    unseenProcessedOrders: $unseenProcessedOrders
    companies: $companies
    orderBy: $orderBy
    orderType: $orderType
    keyAccountManager: $keyAccountManager
    trafficGeneration: $trafficGeneration
    covidPolicy: $covidPolicy
    country: $country
    periodDateFrom: $periodDateFrom
    periodDateTo: $periodDateTo
  ) {
    pageInfo {
      startCursor
      endCursor
      hasNextPage
    }
    totalCount
    edges {
      node {
        ...OrdersList2Fields
      }
    }
  }
}
    ${RegionsList2FieldsFragmentDoc}
${OrdersList2FieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class GetPaginatedOrderForTableGQL extends Apollo.Query<GetPaginatedOrderForTableQuery, GetPaginatedOrderForTableQueryVariables> {
    document = GetPaginatedOrderForTableDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetOrderForTaskCreateSearchDocument = gql`
    query getOrderForTaskCreateSearch($search: String, $first: Int) {
  ordersPaginated(search: $search, first: $first) {
    edges {
      node {
        id
        company {
          ...CompanyTypeFields
        }
        specification {
          positionTitle
        }
      }
    }
  }
}
    ${CompanyTypeFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class GetOrderForTaskCreateSearchGQL extends Apollo.Query<GetOrderForTaskCreateSearchQuery, GetOrderForTaskCreateSearchQueryVariables> {
    document = GetOrderForTaskCreateSearchDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetOrderCommentsDocument = gql`
    query getOrderComments($orderId: ID) {
  orderComments(orderId: $orderId) {
    edges {
      node {
        ...OrderCommentFields
      }
    }
  }
}
    ${OrderCommentFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class GetOrderCommentsGQL extends Apollo.Query<GetOrderCommentsQuery, GetOrderCommentsQueryVariables> {
    document = GetOrderCommentsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetOrderPeriodsDocument = gql`
    query getOrderPeriods($orderId: ID!) {
  orderModel(id: $orderId) {
    id
    orderperiodSet {
      ...OrderPeriodFields
    }
  }
}
    ${OrderPeriodFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class GetOrderPeriodsGQL extends Apollo.Query<GetOrderPeriodsQuery, GetOrderPeriodsQueryVariables> {
    document = GetOrderPeriodsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetUserProfilesDocument = gql`
    query getUserProfiles {
  userprofiles {
    ...UserProfileFields
  }
}
    ${UserProfileFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class GetUserProfilesGQL extends Apollo.Query<GetUserProfilesQuery, GetUserProfilesQueryVariables> {
    document = GetUserProfilesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetUserProfileCountryDocument = gql`
    query getUserProfileCountry {
  userprofile {
    region {
      country {
        id
        isoCode
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetUserProfileCountryGQL extends Apollo.Query<GetUserProfileCountryQuery, GetUserProfileCountryQueryVariables> {
    document = GetUserProfileCountryDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetLastOrdersCreatedDocument = gql`
    query getLastOrdersCreated($companyId: ID!, $orderBy: String) {
  orders(company: $companyId, orderBy: $orderBy) {
    edges {
      node {
        ...OrderSelectListFields
      }
    }
  }
}
    ${OrderSelectListFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class GetLastOrdersCreatedGQL extends Apollo.Query<GetLastOrdersCreatedQuery, GetLastOrdersCreatedQueryVariables> {
    document = GetLastOrdersCreatedDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const OrderEditCompanyDataDocument = gql`
    query OrderEditCompanyData($companyId: ID!) {
  userprofiles {
    ...UserProfileFields
  }
  regions {
    ...RegionsList2Fields
  }
  company(id: $companyId) {
    ...CompanyModelMetaFields
  }
}
    ${UserProfileFieldsFragmentDoc}
${RegionsList2FieldsFragmentDoc}
${CompanyModelMetaFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class OrderEditCompanyDataGQL extends Apollo.Query<OrderEditCompanyDataQuery, OrderEditCompanyDataQueryVariables> {
    document = OrderEditCompanyDataDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const OrderEditMetadataDocument = gql`
    query OrderEditMetadata($companyId: ID!) {
  userprofiles {
    ...UserProfileFields
  }
  regions {
    ...RegionsList2Fields
  }
  companies(id: $companyId) {
    pageInfo {
      startCursor
      endCursor
      hasNextPage
    }
    totalCount
    edges {
      node {
        ...CompanyMetaFields
      }
    }
  }
}
    ${UserProfileFieldsFragmentDoc}
${RegionsList2FieldsFragmentDoc}
${CompanyMetaFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class OrderEditMetadataGQL extends Apollo.Query<OrderEditMetadataQuery, OrderEditMetadataQueryVariables> {
    document = OrderEditMetadataDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetOrderForPrefillDocument = gql`
    query getOrderForPrefill($id: ID!) {
  orderModel(id: $id) {
    ...BaseOrderFields
    ordererrorSet {
      edges {
        node {
          id
          comment
          category {
            title
          }
          createdAt
        }
      }
    }
  }
}
    ${BaseOrderFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class GetOrderForPrefillGQL extends Apollo.Query<GetOrderForPrefillQuery, GetOrderForPrefillQueryVariables> {
    document = GetOrderForPrefillDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetRegionsRelayDocument = gql`
    query getRegionsRelay($country: ID!) {
  regionsRelay(country: $country) {
    edges {
      node {
        id
        title
        isActive
        country {
          id
          title
          isoCode
        }
      }
    }
    totalCount
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetRegionsRelayGQL extends Apollo.Query<GetRegionsRelayQuery, GetRegionsRelayQueryVariables> {
    document = GetRegionsRelayDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetOrderDocumentsDocument = gql`
    query getOrderDocuments($id: ID!) {
  documents(order: $id, orderBy: "-create_date") {
    edges {
      node {
        ...OrderDocumentFields
      }
    }
  }
}
    ${OrderDocumentFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class GetOrderDocumentsGQL extends Apollo.Query<GetOrderDocumentsQuery, GetOrderDocumentsQueryVariables> {
    document = GetOrderDocumentsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetOrderRequirementsAndCandidateEvaluationsDocument = gql`
    query getOrderRequirementsAndCandidateEvaluations($orderId: ID!, $offerPropositionId: ID!) {
  orderModel(id: $orderId) {
    id
    language
    specification {
      id
      mandatoryRequirements {
        id
        requirement
      }
    }
  }
  candidateEvaluations(offerProposition: $offerPropositionId) {
    edges {
      node {
        id
        requirement {
          id
          requirement
        }
        recordType
        description
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetOrderRequirementsAndCandidateEvaluationsGQL extends Apollo.Query<GetOrderRequirementsAndCandidateEvaluationsQuery, GetOrderRequirementsAndCandidateEvaluationsQueryVariables> {
    document = GetOrderRequirementsAndCandidateEvaluationsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetCandidateNameDocument = gql`
    query getCandidateName($livasId: Int!) {
  candidate(livasId: $livasId) {
    id
    livasId
    firstName
    lastName
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetCandidateNameGQL extends Apollo.Query<GetCandidateNameQuery, GetCandidateNameQueryVariables> {
    document = GetCandidateNameDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetCandidatesEvaluationsDocument = gql`
    query getCandidatesEvaluations($orderId: ID!) {
  candidateEvaluations(order: $orderId) {
    edges {
      node {
        id
        offerProposition {
          id
          candidate {
            id
            livasId
            firstName
            lastName
            country {
              id
              isoCode
            }
          }
        }
        requirement {
          id
          requirement
        }
        recordType
        description
      }
    }
  }
  orderModel(id: $orderId) {
    id
    language
    specification {
      id
      mandatoryRequirements {
        id
        requirement
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetCandidatesEvaluationsGQL extends Apollo.Query<GetCandidatesEvaluationsQuery, GetCandidatesEvaluationsQueryVariables> {
    document = GetCandidatesEvaluationsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetOrderErrorCategoriesDocument = gql`
    query getOrderErrorCategories($isActive: Boolean) {
  orderErrorCategories(isActive: $isActive) {
    edges {
      node {
        id
        title
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetOrderErrorCategoriesGQL extends Apollo.Query<GetOrderErrorCategoriesQuery, GetOrderErrorCategoriesQueryVariables> {
    document = GetOrderErrorCategoriesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetFilterRegionDocument = gql`
    query getFilterRegion {
  userprofile {
    id
    region {
      country {
        id
        isoCode
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetFilterRegionGQL extends Apollo.Query<GetFilterRegionQuery, GetFilterRegionQueryVariables> {
    document = GetFilterRegionDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateOperationsTaskDocument = gql`
    mutation CreateOperationsTask($company: ID, $country: ID, $category: ID, $nextActionCategory: ID, $order: ID, $date: Date!, $comment: String!, $completedBy: [ID], $durationMinutes: Int, $status: TaskStatus, $sendNotificationToAssignee: Boolean, $dashboard: ID, $nextTaskAssignee: ID, $candidateLivasEmployeeId: ID, $dashboards: [ID]) {
  createOperationsTask(
    input: {company: $company, country: $country, date: $date, comment: $comment, completedBy: $completedBy, durationMinutes: $durationMinutes, order: $order, status: $status, category: $category, nextActionCategory: $nextActionCategory, sendNotificationToAssignee: $sendNotificationToAssignee, dashboard: $dashboard, nextTaskAssignee: $nextTaskAssignee, candidateLivasEmployeeId: $candidateLivasEmployeeId, dashboards: $dashboards}
  ) {
    task {
      ...OperationsTaskFields
      dashboards {
        edges {
          node {
            id
            title
          }
        }
      }
    }
  }
}
    ${OperationsTaskFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateOperationsTaskGQL extends Apollo.Mutation<CreateOperationsTaskMutation, CreateOperationsTaskMutationVariables> {
    document = CreateOperationsTaskDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateMetricValueCommentDocument = gql`
    mutation CreateMetricValueComment($metricValue: ID!, $comment: String) {
  createMetricValueComment(input: {metricValue: $metricValue, comment: $comment}) {
    metricValueComment {
      id
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateMetricValueCommentGQL extends Apollo.Mutation<CreateMetricValueCommentMutation, CreateMetricValueCommentMutationVariables> {
    document = CreateMetricValueCommentDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateMetricValueInputDocument = gql`
    mutation CreateMetricValueInput($client: ID, $createdBy: ID, $date: Date!, $isImportant: Boolean!, $manager: ID, $metricGroup: ID!, $order: ID, $value: Float!) {
  createMetricValue(
    input: {client: $client, createdBy: $createdBy, date: $date, isImportant: $isImportant, manager: $manager, metricGroup: $metricGroup, order: $order, value: $value}
  ) {
    metricValue {
      id
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateMetricValueInputGQL extends Apollo.Mutation<CreateMetricValueInputMutation, CreateMetricValueInputMutationVariables> {
    document = CreateMetricValueInputDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateOperationsTaskDocument = gql`
    mutation UpdateOperationsTask($taskId: ID!, $status: TaskStatus, $order: ID, $company: ID, $category: ID, $date: Date, $comment: String, $completedBy: [ID], $durationMinutes: Int, $country: ID, $nextActionCategory: ID, $nextActionDate: Date, $dashboard: ID, $nextTaskAssignee: ID, $isImportant: Boolean, $dashboards: [ID]) {
  updateOperationsTask(
    input: {id: $taskId, order: $order, status: $status, company: $company, date: $date, comment: $comment, completedBy: $completedBy, durationMinutes: $durationMinutes, category: $category, country: $country, nextActionCategory: $nextActionCategory, nextActionDate: $nextActionDate, dashboard: $dashboard, nextTaskAssignee: $nextTaskAssignee, isImportant: $isImportant, dashboards: $dashboards}
  ) {
    task {
      ...OperationsTaskFields
      isImportant
      dashboards {
        edges {
          node {
            id
            title
          }
        }
      }
    }
  }
}
    ${OperationsTaskFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateOperationsTaskGQL extends Apollo.Mutation<UpdateOperationsTaskMutation, UpdateOperationsTaskMutationVariables> {
    document = UpdateOperationsTaskDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateTaskCopyDocument = gql`
    mutation CreateTaskCopy($input: CreateTaskCopyInput!) {
  createTaskCopy(input: $input) {
    task {
      ...OperationsTaskFields
      dashboards {
        edges {
          node {
            id
            title
          }
        }
      }
    }
  }
}
    ${OperationsTaskFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateTaskCopyGQL extends Apollo.Mutation<CreateTaskCopyMutation, CreateTaskCopyMutationVariables> {
    document = CreateTaskCopyDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateTaskScheduleDocument = gql`
    mutation CreateTaskSchedule($input: CreateScheduleInput!) {
  createTaskSchedule(input: $input) {
    schedule {
      ...TaskScheduleFields
    }
  }
}
    ${TaskScheduleFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateTaskScheduleGQL extends Apollo.Mutation<CreateTaskScheduleMutation, CreateTaskScheduleMutationVariables> {
    document = CreateTaskScheduleDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateTaskScheduleDocument = gql`
    mutation UpdateTaskSchedule($input: UpdateScheduleInput!) {
  updateTaskSchedule(input: $input) {
    schedule {
      ...TaskScheduleFields
    }
  }
}
    ${TaskScheduleFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateTaskScheduleGQL extends Apollo.Mutation<UpdateTaskScheduleMutation, UpdateTaskScheduleMutationVariables> {
    document = UpdateTaskScheduleDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const TaskCustomFieldUpdateValuesDocument = gql`
    mutation TaskCustomFieldUpdateValues($taskId: ID!, $customFieldValues: [CustomFieldValueInput!]!) {
  createUpdateCustomFieldValues(
    taskId: $taskId
    customFieldValues: $customFieldValues
  ) {
    customFieldValues {
      id
      task {
        id
      }
      customField {
        id
      }
      textValue
      numericValue
      urlValue
      dateValue
      boolValue
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class TaskCustomFieldUpdateValuesGQL extends Apollo.Mutation<TaskCustomFieldUpdateValuesMutation, TaskCustomFieldUpdateValuesMutationVariables> {
    document = TaskCustomFieldUpdateValuesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DeleteTaskDocument = gql`
    mutation DeleteTask($taskId: ID!) {
  deleteTask(input: {id: $taskId}) {
    task {
      id
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DeleteTaskGQL extends Apollo.Mutation<DeleteTaskMutation, DeleteTaskMutationVariables> {
    document = DeleteTaskDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetOverdueTasksDocument = gql`
    query GetOverdueTasks($orderBy: String, $first: Int, $after: String, $date_Lte: Date, $date_Gte: Date, $country: ID, $company: ID, $category: [ID], $statuses: String, $search: String, $owners: [ID], $dashboardId: ID, $cardId: ID, $categoriesKeys: String, $excludeCategoriesKeys: String, $excludeStatuses: String, $isImportant: Boolean, $isFromMetric: Boolean, $dashboards: [ID], $ownerDashboardMode: String) {
  tasks(
    orderBy: $orderBy
    first: $first
    after: $after
    date_Lte: $date_Lte
    date_Gte: $date_Gte
    country: $country
    company: $company
    statuses: $statuses
    completedBy: $owners
    categories: $category
    search: $search
    dashboard: $dashboardId
    cardId: $cardId
    categoriesKeys: $categoriesKeys
    excludeCategoriesKeys: $excludeCategoriesKeys
    excludeStatuses: $excludeStatuses
    isImportant: $isImportant
    isFromMetric: $isFromMetric
    dashboards: $dashboards
    ownerDashboardMode: $ownerDashboardMode
  ) {
    totalCount
    edges {
      node {
        ...OverdueTaskTableFields
        isImportant
        dashboards {
          edges {
            node {
              id
              title
            }
          }
        }
      }
    }
  }
}
    ${OverdueTaskTableFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class GetOverdueTasksGQL extends Apollo.Query<GetOverdueTasksQuery, GetOverdueTasksQueryVariables> {
    document = GetOverdueTasksDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetMeetingTasksDocument = gql`
    query GetMeetingTasks($orderBy: String, $first: Int, $after: String, $country: ID, $company: ID, $category: [ID], $statuses: String, $search: String, $owners: [ID], $dashboardId: ID, $categoriesKeys: String, $excludeCategoriesKeys: String, $excludeStatuses: String, $includeChildDashboards: Boolean, $dashboards: [ID]) {
  tasks(
    orderBy: $orderBy
    first: $first
    after: $after
    country: $country
    company: $company
    statuses: $statuses
    completedBy: $owners
    categories: $category
    search: $search
    dashboard: $dashboardId
    categoriesKeys: $categoriesKeys
    excludeCategoriesKeys: $excludeCategoriesKeys
    excludeStatuses: $excludeStatuses
    includeChildDashboards: $includeChildDashboards
    dashboards: $dashboards
  ) {
    totalCount
    edges {
      node {
        ...MeetingTaskTableFields
        dashboards {
          edges {
            node {
              id
              title
            }
          }
        }
      }
    }
  }
}
    ${MeetingTaskTableFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class GetMeetingTasksGQL extends Apollo.Query<GetMeetingTasksQuery, GetMeetingTasksQueryVariables> {
    document = GetMeetingTasksDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetDynamicDashboardTasksDocument = gql`
    query GetDynamicDashboardTasks($orderBy: String, $first: Int, $after: String, $date_Lte: Date, $date_Gte: Date, $country: ID, $company: ID, $category: [ID], $statuses: String, $search: String, $owners: [ID], $dashboardId: ID, $categoriesKeys: String, $excludeCategoriesKeys: String, $excludeStatuses: String, $includeChildDashboards: Boolean, $customFields: String, $dashboards: [ID]) {
  tasks(
    orderBy: $orderBy
    first: $first
    after: $after
    date_Lte: $date_Lte
    date_Gte: $date_Gte
    country: $country
    company: $company
    statuses: $statuses
    completedBy: $owners
    categories: $category
    search: $search
    dashboard: $dashboardId
    categoriesKeys: $categoriesKeys
    excludeCategoriesKeys: $excludeCategoriesKeys
    excludeStatuses: $excludeStatuses
    includeChildDashboards: $includeChildDashboards
    customFields: $customFields
    dashboards: $dashboards
  ) {
    totalCount
    edges {
      node {
        ...DynamicDashboardTaskTableFields
        dashboards {
          edges {
            node {
              id
              title
            }
          }
        }
      }
    }
  }
}
    ${DynamicDashboardTaskTableFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class GetDynamicDashboardTasksGQL extends Apollo.Query<GetDynamicDashboardTasksQuery, GetDynamicDashboardTasksQueryVariables> {
    document = GetDynamicDashboardTasksDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetOperationsTasksDocument = gql`
    query GetOperationsTasks($orderBy: String, $first: Int, $after: String, $date_Lte: Date, $date_Gte: Date, $country: ID, $company: ID, $category: [ID], $statuses: String, $search: String, $owners: [ID], $dashboardId: ID, $firstTimeCall: Boolean, $noOwners: Boolean, $dashboards: [ID]) {
  tasks(
    orderBy: $orderBy
    first: $first
    after: $after
    date_Lte: $date_Lte
    date_Gte: $date_Gte
    country: $country
    company: $company
    statuses: $statuses
    completedBy: $owners
    categories: $category
    search: $search
    dashboard: $dashboardId
    firstTimeSameCategoryPerCandidate: $firstTimeCall
    noOwners: $noOwners
    dashboards: $dashboards
  ) {
    totalCount
    edges {
      node {
        ...OperationsTaskFields
        dashboards {
          edges {
            node {
              id
              title
            }
          }
        }
      }
    }
  }
}
    ${OperationsTaskFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class GetOperationsTasksGQL extends Apollo.Query<GetOperationsTasksQuery, GetOperationsTasksQueryVariables> {
    document = GetOperationsTasksDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetNextTaskDateDocument = gql`
    query GetNextTaskDate($id: ID!) {
  nextTaskDate(taskGlobalId: $id) {
    date
    message
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetNextTaskDateGQL extends Apollo.Query<GetNextTaskDateQuery, GetNextTaskDateQueryVariables> {
    document = GetNextTaskDateDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetOperationsTaskDocument = gql`
    query GetOperationsTask($id: ID!) {
  task(id: $id) {
    ...TaskDetailViewFields
    dashboards {
      edges {
        node {
          id
          title
        }
      }
    }
  }
}
    ${TaskDetailViewFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class GetOperationsTaskGQL extends Apollo.Query<GetOperationsTaskQuery, GetOperationsTaskQueryVariables> {
    document = GetOperationsTaskDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetTaskCustomFieldValuesAndCategoriesDocument = gql`
    query GetTaskCustomFieldValuesAndCategories($taskId: ID!) {
  task(id: $taskId) {
    id
    customFieldValues {
      edges {
        node {
          ...CustomFieldsValuesFields
        }
      }
    }
  }
  selectionActionCategoryGroups {
    totalCount
    edges {
      node {
        ...SACategoryGroupsFields
      }
    }
  }
}
    ${CustomFieldsValuesFieldsFragmentDoc}
${SaCategoryGroupsFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class GetTaskCustomFieldValuesAndCategoriesGQL extends Apollo.Query<GetTaskCustomFieldValuesAndCategoriesQuery, GetTaskCustomFieldValuesAndCategoriesQueryVariables> {
    document = GetTaskCustomFieldValuesAndCategoriesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetCustomFieldValuesByTasksDocument = gql`
    query GetCustomFieldValuesByTasks($taskIds: [ID], $keys: String) {
  customFieldValues(taskIds: $taskIds, keys: $keys) {
    edges {
      node {
        id
        customField {
          id
          key
          options
        }
        task {
          id
        }
        numericValue
        textValue
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetCustomFieldValuesByTasksGQL extends Apollo.Query<GetCustomFieldValuesByTasksQuery, GetCustomFieldValuesByTasksQueryVariables> {
    document = GetCustomFieldValuesByTasksDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetTasksByCandidateAndCategoryDocument = gql`
    query GetTasksByCandidateAndCategory($candidateId: ID!, $categoryId: ID!) {
  tasks(candidate: $candidateId, category: $categoryId) {
    totalCount
    edges {
      node {
        ...OperationsTaskFieldsNew
        dashboards {
          edges {
            node {
              id
              title
            }
          }
        }
      }
    }
  }
}
    ${OperationsTaskFieldsNewFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class GetTasksByCandidateAndCategoryGQL extends Apollo.Query<GetTasksByCandidateAndCategoryQuery, GetTasksByCandidateAndCategoryQueryVariables> {
    document = GetTasksByCandidateAndCategoryDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetReservedTimesDocument = gql`
    query getReservedTimes {
  reservedTimes {
    edges {
      node {
        title
        dayOfTheWeek
        region {
          id
          title
        }
        timeFrom
        timeTo
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetReservedTimesGQL extends Apollo.Query<GetReservedTimesQuery, GetReservedTimesQueryVariables> {
    document = GetReservedTimesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetRequestActivitiesDocument = gql`
    query getRequestActivities($createdBy: String, $createdAt_Gte: Date, $createdAt_Lte: Date, $phone: String, $first: Int, $after: String, $orderBy: String) {
  requestsActivities(
    createdBy: $createdBy
    createdAt_Gte: $createdAt_Gte
    createdAt_Lte: $createdAt_Lte
    phone: $phone
    first: $first
    after: $after
    orderBy: $orderBy
  ) {
    totalCount
    pageInfo {
      endCursor
    }
    edges {
      cursor
      node {
        id
        createdAt
        createdBy {
          fullName
        }
        contact {
          firstName
          lastName
        }
        clientContact {
          firstName
          lastName
          company {
            name
          }
        }
        phone
        reason {
          title
        }
        comment
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetRequestActivitiesGQL extends Apollo.Query<GetRequestActivitiesQuery, GetRequestActivitiesQueryVariables> {
    document = GetRequestActivitiesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateContactRequestActivityDocument = gql`
    mutation updateContactRequestActivity($input: UpdateRequestsActivityInput!) {
  updateRequestsActivity(input: $input) {
    requestsActivity {
      id
      comment
      phone
      reason {
        id
        title
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateContactRequestActivityGQL extends Apollo.Mutation<UpdateContactRequestActivityMutation, UpdateContactRequestActivityMutationVariables> {
    document = UpdateContactRequestActivityDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetAllReasonsDocument = gql`
    query getAllReasons($id: ID) {
  allReasons(id: $id) {
    edges {
      node {
        id
        title
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetAllReasonsGQL extends Apollo.Query<GetAllReasonsQuery, GetAllReasonsQueryVariables> {
    document = GetAllReasonsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetRiskFactorsDocument = gql`
    query getRiskFactors($title: String, $country: ID) {
  riskFactors(title: $title, country: $country) {
    id
    title
    isDefault
    country {
      id
      isoCode
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetRiskFactorsGQL extends Apollo.Query<GetRiskFactorsQuery, GetRiskFactorsQueryVariables> {
    document = GetRiskFactorsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateSeletionActionDocument = gql`
    mutation CreateSeletionAction($orderId: ID!, $comment: String!, $category: ID, $durationMinutes: Int, $date: Date!, $completedBy: [ID]) {
  createSelectionAction(
    input: {order: $orderId, comment: $comment, category: $category, durationMinutes: $durationMinutes, date: $date, completedBy: $completedBy}
  ) {
    task {
      ...SelectionActionListItemFields
    }
  }
}
    ${SelectionActionListItemFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateSeletionActionGQL extends Apollo.Mutation<CreateSeletionActionMutation, CreateSeletionActionMutationVariables> {
    document = CreateSeletionActionDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateSeletionActionDocument = gql`
    mutation UpdateSeletionAction($id: ID!, $comment: String!, $date: Date!, $category: ID, $durationMinutes: Int, $completedBy: [ID], $status: TaskStatus) {
  updateSelectionAction(
    input: {id: $id, comment: $comment, category: $category, durationMinutes: $durationMinutes, date: $date, completedBy: $completedBy, status: $status}
  ) {
    task {
      ...SelectionActionListItemFields
    }
  }
}
    ${SelectionActionListItemFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateSeletionActionGQL extends Apollo.Mutation<UpdateSeletionActionMutation, UpdateSeletionActionMutationVariables> {
    document = UpdateSeletionActionDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DeleteSeletionActionDocument = gql`
    mutation DeleteSeletionAction($id: ID!) {
  deleteSelectionAction(input: {id: $id}) {
    task {
      id
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DeleteSeletionActionGQL extends Apollo.Mutation<DeleteSeletionActionMutation, DeleteSeletionActionMutationVariables> {
    document = DeleteSeletionActionDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetSelectionActionsDocument = gql`
    query GetSelectionActions($orderId: ID, $company: ID, $orderBy: String, $date_Lte: Date, $date_Gte: Date, $categories: [ID]) {
  tasks(
    order: $orderId
    company: $company
    orderBy: $orderBy
    date_Lte: $date_Lte
    date_Gte: $date_Gte
    categories: $categories
  ) {
    totalCount
    edges {
      node {
        ...SelectionActionListItemFields
      }
    }
  }
}
    ${SelectionActionListItemFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class GetSelectionActionsGQL extends Apollo.Query<GetSelectionActionsQuery, GetSelectionActionsQueryVariables> {
    document = GetSelectionActionsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetSelectionActionGroupedCategoriesDocument = gql`
    query GetSelectionActionGroupedCategories($country: ID) {
  selectionActionCategoryGroups(country: $country) {
    totalCount
    edges {
      node {
        ...SACategoryGroupsFields
      }
    }
  }
}
    ${SaCategoryGroupsFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class GetSelectionActionGroupedCategoriesGQL extends Apollo.Query<GetSelectionActionGroupedCategoriesQuery, GetSelectionActionGroupedCategoriesQueryVariables> {
    document = GetSelectionActionGroupedCategoriesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateSpecificationDocument = gql`
    mutation createSpecification($input: SpecificationInput!, $companyId: ID!) {
  createSpecification(input: $input, companyId: $companyId) {
    specification {
      ...SpecificationDetailFields
    }
  }
}
    ${SpecificationDetailFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateSpecificationGQL extends Apollo.Mutation<CreateSpecificationMutation, CreateSpecificationMutationVariables> {
    document = CreateSpecificationDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const SpecificationUpdateDocument = gql`
    mutation specificationUpdate($input: SpecificationModelUpdateMutationInput!) {
  specificationUpdate(input: $input) {
    specification {
      ...SpecificationDetailFields
    }
  }
}
    ${SpecificationDetailFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class SpecificationUpdateGQL extends Apollo.Mutation<SpecificationUpdateMutation, SpecificationUpdateMutationVariables> {
    document = SpecificationUpdateDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const SpecificationCreateDocument = gql`
    mutation specificationCreate($input: SpecificationModelCreateMutationInput!) {
  specificationCreate(input: $input) {
    specification {
      ...SpecificationDetailFields
    }
    errors {
      field
      message
    }
  }
}
    ${SpecificationDetailFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class SpecificationCreateGQL extends Apollo.Mutation<SpecificationCreateMutation, SpecificationCreateMutationVariables> {
    document = SpecificationCreateDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateSpecificationDocument = gql`
    mutation updateSpecification($specification: SpecificationInput!, $id: ID!) {
  updateSpecification(input: $specification, id: $id) {
    specification {
      ...SpecificationDetailFields
    }
  }
}
    ${SpecificationDetailFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateSpecificationGQL extends Apollo.Mutation<UpdateSpecificationMutation, UpdateSpecificationMutationVariables> {
    document = UpdateSpecificationDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateRequirementDocument = gql`
    mutation createRequirement($englishValue: String, $localValue: String, $country: ID) {
  createRequirement(
    englishValue: $englishValue
    localValue: $localValue
    country: $country
  ) {
    requirement {
      ...RequirementFields
    }
  }
}
    ${RequirementFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateRequirementGQL extends Apollo.Mutation<CreateRequirementMutation, CreateRequirementMutationVariables> {
    document = CreateRequirementDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateCompanyDocument = gql`
    mutation updateCompany($id: Int!, $livasId: Int, $contractorId: ID!) {
  updateCompany(id: $id, livasId: $livasId, contractorId: $contractorId) {
    ok
    company {
      ...CompanyDetailFields
    }
  }
}
    ${CompanyDetailFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateCompanyGQL extends Apollo.Mutation<UpdateCompanyMutation, UpdateCompanyMutationVariables> {
    document = UpdateCompanyDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateCompanyDocument = gql`
    mutation createCompany($company: CompanyInput!) {
  createCompany(input: $company) {
    ok
    company {
      ...CompanyDetailFields
    }
  }
}
    ${CompanyDetailFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateCompanyGQL extends Apollo.Mutation<CreateCompanyMutation, CreateCompanyMutationVariables> {
    document = CreateCompanyDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CopySpecificationDocument = gql`
    mutation copySpecification($id: Int!) {
  copySpecification(input: $id) {
    specification {
      id
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CopySpecificationGQL extends Apollo.Mutation<CopySpecificationMutation, CopySpecificationMutationVariables> {
    document = CopySpecificationDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CompetencesDocument = gql`
    query competences($country: ID) {
  competences(country: $country) {
    edges {
      node {
        id
        title
        color
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CompetencesGQL extends Apollo.Query<CompetencesQuery, CompetencesQueryVariables> {
    document = CompetencesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const TagGroupsDocument = gql`
    query tagGroups($country: ID) {
  tagsGroups(country: $country) {
    key
    tagSet {
      ...TagsFields
    }
  }
}
    ${TagsFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class TagGroupsGQL extends Apollo.Query<TagGroupsQuery, TagGroupsQueryVariables> {
    document = TagGroupsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetTagsGroupsWithPpeDocument = gql`
    query getTagsGroupsWithPPE($country: ID) {
  tagsGroups(country: $country) {
    id
    key
    tagSet {
      ...TagsFields
    }
  }
  personalProtectiveEquipment(country: $country) {
    ...PPEFields
  }
}
    ${TagsFieldsFragmentDoc}
${PpeFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class GetTagsGroupsWithPpeGQL extends Apollo.Query<GetTagsGroupsWithPpeQuery, GetTagsGroupsWithPpeQueryVariables> {
    document = GetTagsGroupsWithPpeDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const RequirementsDocument = gql`
    query requirements($requirement: String, $country: ID, $language: String) {
  requirements(requirement: $requirement, country: $country, language: $language) {
    id
    requirement
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class RequirementsGQL extends Apollo.Query<RequirementsQuery, RequirementsQueryVariables> {
    document = RequirementsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CertificatesDocument = gql`
    query certificates($country: ID, $language: String) {
  certificates(country: $country, language: $language) {
    title
    id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CertificatesGQL extends Apollo.Query<CertificatesQuery, CertificatesQueryVariables> {
    document = CertificatesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const OrderCandidateStatsDocument = gql`
    query OrderCandidateStats($orderIds: [ID], $dateFrom: Date) {
  candidateOrderStats(
    orderIds: $orderIds
    dateTo: "2029-12-31"
    dateFrom: $dateFrom
  ) {
    ...OrderListCandidatesStatsFields
  }
}
    ${OrderListCandidatesStatsFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class OrderCandidateStatsGQL extends Apollo.Query<OrderCandidateStatsQuery, OrderCandidateStatsQueryVariables> {
    document = OrderCandidateStatsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CandidateEventsForOrderDocument = gql`
    query CandidateEventsForOrder($orderId: ID, $eventType: String) {
  candidateEvents(
    orderId: $orderId
    eventType: $eventType
    orderBy: "-start_datetime"
    first: 100
  ) {
    edges {
      node {
        ...CandidateEventsFields
      }
    }
  }
}
    ${CandidateEventsFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class CandidateEventsForOrderGQL extends Apollo.Query<CandidateEventsForOrderQuery, CandidateEventsForOrderQueryVariables> {
    document = CandidateEventsForOrderDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CandidateEventsForTableDocument = gql`
    query CandidateEventsForTable($candidate: ID) {
  candidateEvents(candidate: $candidate) {
    edges {
      node {
        ...CandidateEventsFields
      }
    }
  }
}
    ${CandidateEventsFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class CandidateEventsForTableGQL extends Apollo.Query<CandidateEventsForTableQuery, CandidateEventsForTableQueryVariables> {
    document = CandidateEventsForTableDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const OrderStatsDocument = gql`
    query OrderStats($orderId: Int, $dateTo: Date, $dateFrom: Date) {
  offerPropositionStats(orderId: $orderId, dateTo: $dateTo, dateFrom: $dateFrom) {
    ...OrderStatsFields
  }
}
    ${OrderStatsFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class OrderStatsGQL extends Apollo.Query<OrderStatsQuery, OrderStatsQueryVariables> {
    document = OrderStatsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetMeDocument = gql`
    query GetMe {
  me {
    ...MeFields
  }
}
    ${MeFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class GetMeGQL extends Apollo.Query<GetMeQuery, GetMeQueryVariables> {
    document = GetMeDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CheckSuperuserRightsDocument = gql`
    query checkSuperuserRights {
  me {
    user {
      isSuperuser
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CheckSuperuserRightsGQL extends Apollo.Query<CheckSuperuserRightsQuery, CheckSuperuserRightsQueryVariables> {
    document = CheckSuperuserRightsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CancellationReasonsGroupFields = gql`
    fragment CancellationReasonsGroupFields on CancellationReasonGroupType {
  id
  title
  order
  cancellationReasons {
    edges {
      node {
        id
        title
        order
      }
    }
  }
}
    `;
export const CovidLabelsFields = gql`
    fragment CovidLabelsFields on LabelType {
  id
  title
}
    `;
export const ContractorSelectFields = gql`
    fragment ContractorSelectFields on ContractorType {
  id
  title
  externalId
  country {
    id
    isoCode
  }
}
    `;
export const CompanySelectFields = gql`
    fragment CompanySelectFields on CompanyModelType {
  id
  livasId
  status
  name
  insightlyId
  description
  salesQuestionnaire
  contractSet {
    id
    validFromDate
  }
  country {
    id
    isoCode
    languageIsoCode
  }
}
    `;
export const CountryFields = gql`
    fragment CountryFields on CountryType {
  id
  isoCode
  languageIsoCode
}
    `;
export const StandUpDashboardTaskFields = gql`
    fragment StandUpDashboardTaskFields on TaskType {
  id
  date
  status
  comment
  durationMinutes
  completedBy {
    id
    fullName
    color
    user {
      id
      firstName
      lastName
    }
  }
  nextActionCategory {
    id
    title
  }
}
    `;
export const FreeVacanciesCalendarEventFields = gql`
    fragment FreeVacanciesCalendarEventFields on EventType {
  id
  date
  status
  adId
  channels {
    id
    title
    icon
  }
  category {
    id
    title
    icon
  }
}
    `;
export const ContactFieldsShort = gql`
    fragment ContactFieldsShort on ContactType {
  id
  firstName
  lastName
  email
  phone
}
    `;
export const UserMainFields = gql`
    fragment UserMainFields on UserType {
  id
  email
  firstName
  lastName
}
    `;
export const CompanyMainFields = gql`
    fragment CompanyMainFields on CompanyType {
  id
  name
  color
  description
  country {
    id
    isoCode
  }
  labels {
    edges {
      node {
        id
        title
      }
    }
  }
}
    `;
export const OrderPeriodFields = gql`
    fragment OrderPeriodFields on OrderPeriodType {
  id
  demand
  dateTo
  dateFrom
  longTerm
}
    `;
export const FreeVacanciesSpecificationFields = gql`
    fragment FreeVacanciesSpecificationFields on SpecificationType {
  id
  male
  female
  positionTitle
  address
  ageFrom
  ageTo
  additionalRecruitementInformation
  tagassignmentSet {
    id
    tag {
      id
      title
      order
      key
      group {
        id
        key
      }
    }
    comment
  }
  workFunctions
  mandatoryRequirements {
    id
    requirement
  }
  optionalRequirements {
    id
    requirement
  }
  isWorkplaceVideoAllowed
  isWorkplaceVisitAllowed
  shiftDuration
  breakDuration
  scheduleType
  scheduleTypes {
    id
    title
  }
  scheduleText
  shiftPattern
  intensity
  allFunctionsFromFirstDay
  onboardingDuration
  minExperienceMonths
  experienceType
  certificates {
    id
    title
  }
  riskFactors {
    id
    title
  }
  salary {
    id
    hourlyBruttoFrom
    hourlyBruttoTo
    hourlyNettoFrom
    hourlyNettoTo
    monthlyBruttoFrom
    monthlyBruttoTo
    monthlyNettoFrom
    monthlyNettoTo
    hourlyBruttoFromFilled
    hourlyBruttoToFilled
    hourlyNettoFromFilled
    hourlyNettoToFilled
    monthlyBruttoFromFilled
    monthlyBruttoToFilled
    monthlyNettoFromFilled
    monthlyNettoToFilled
    useInTemplate
  }
  canEmployUa
  healthcheckType
}
    `;
export const MarketingEventsFields = gql`
    fragment MarketingEventsFields on EventType {
  id
  date
  status
  adId
  comment
  workisJobId
  externalPlatformId
  language
  channels {
    id
    title
    icon
  }
  category {
    id
    title
    icon
  }
}
    `;
export const FreeVacanciesListFields = gql`
    fragment FreeVacanciesListFields on OrderType {
  id
  canGetBonuses
  canIncreaseSalary
  orderType
  toBeReviewed
  hourRateBruttoPermanent
  salaryInfo
  orderNumber
  orderPeriodFrom
  orderPeriodTo
  orderCanBeExtended
  isLongTerm
  demand
  status
  trafficGeneration
  nettoFrom
  nettoTo
  shortage
  isCompanyInternational
  isCompanyModern
  isLogoPublicAllowed
  statsFutureInterview
  clientContact {
    ...ContactFieldsShort
  }
  additionalClientContacts {
    edges {
      node {
        ...ContactFieldsShort
      }
    }
  }
  createdBy {
    id
    user {
      ...UserMainFields
    }
  }
  region {
    id
    title
  }
  company {
    ...CompanyMainFields
  }
  orderperiodSet {
    ...OrderPeriodFields
  }
  specification {
    ...FreeVacanciesSpecificationFields
  }
  eventSet {
    edges {
      node {
        ...MarketingEventsFields
      }
    }
  }
}
    ${ContactFieldsShort}
${UserMainFields}
${CompanyMainFields}
${OrderPeriodFields}
${FreeVacanciesSpecificationFields}
${MarketingEventsFields}`;
export const OfferEventFields = gql`
    fragment OfferEventFields on CandidateEventType {
  id
  startDatetime
  resolutionStatus
  eventType
  deleted
  description
  isProblematicInterview
  relatedOffer {
    order {
      company {
        name
      }
    }
  }
}
    `;
export const InterviewWidgetOfferFields = gql`
    fragment InterviewWidgetOfferFields on OfferPropositionType {
  id
  comment
  order {
    orderType
    id
  }
  candidate {
    id
  }
  personId
  interested
  interestedOnCall
  signed
  candidateEvents {
    edges {
      node {
        ...OfferEventFields
      }
    }
  }
  longListed
}
    ${OfferEventFields}`;
export const InterviewWidgetRegionFields = gql`
    fragment InterviewWidgetRegionFields on RegionType {
  title
  externalId
}
    `;
export const InterviewWidgetOrdersFields = gql`
    fragment InterviewWidgetOrdersFields on OrderType {
  id
  orderType
  trafficGeneration
  specification {
    positionTitle
    address
    company {
      name
      color
      status
    }
  }
}
    `;
export const CandidateOfferFields = gql`
    fragment CandidateOfferFields on CandidateType {
  id
  firstName
  lastName
  livasId
  livasStatus {
    id
    titleLt
    titleLv
    titleEe
  }
}
    `;
export const OfferFields = gql`
    fragment OfferFields on OfferPropositionType {
  id
  personId
  interestedOnCall
  interested
  firstInterestedAt
  candidate {
    ...CandidateOfferFields
  }
  cancellationreasonassignmentSet {
    edges {
      node {
        id
        cancellationReason {
          id
          title
        }
      }
    }
  }
  offerpropositioncommentSet(orderBy: "-created_at") {
    totalCount
    edges {
      node {
        id
        text
        createdAt
      }
    }
  }
  candidateEvents {
    edges {
      node {
        ...OfferEventFields
      }
    }
  }
  signed
  signedAt
  comment
  eventSet(deleted: false) {
    edges {
      node {
        ...OfferEventFields
      }
    }
  }
}
    ${CandidateOfferFields}
${OfferEventFields}`;
export const OfferPropisitionOfferFields = gql`
    fragment OfferPropisitionOfferFields on OfferPropositionType {
  id
  comment
  order {
    id
    orderType
    trafficGeneration
    specification {
      positionTitle
      address
      company {
        name
        color
        status
      }
    }
  }
  candidate {
    id
  }
  personId
  interested
  firstInterestedAt
  interestedOnCall
  signed
  candidateEvents {
    edges {
      node {
        ...OfferEventFields
      }
    }
  }
  longListed
  eventSet(deleted: false) {
    edges {
      node {
        ...OfferEventFields
      }
    }
  }
}
    ${OfferEventFields}`;
export const OfferPropisitionRegionFields = gql`
    fragment OfferPropisitionRegionFields on RegionType {
  title
  externalId
}
    `;
export const OfferPropisitionOrdersFields = gql`
    fragment OfferPropisitionOrdersFields on OrderType {
  id
  orderType
  trafficGeneration
  specification {
    positionTitle
    address
    company {
      name
      color
      status
    }
  }
}
    `;
export const CancellationReasonAssignmentFields = gql`
    fragment CancellationReasonAssignmentFields on CancellationReasonAssignmentType {
  id
  cancellationReason {
    id
    title
  }
}
    `;
export const CreateOrderDocumentFields = gql`
    fragment CreateOrderDocumentFields on DocumentType {
  id
  order {
    id
    specification {
      id
      positionTitle
    }
  }
  documentDate
  confirmationMethod
  orderPeriods {
    id
  }
  generatedDocument
}
    `;
export const ContactFields = gql`
    fragment ContactFields on ContactType {
  id
  firstName
  lastName
  email
  phone
  insightlyId
  comment
  canUseInOrder
}
    `;
export const ContractsMetaFields = gql`
    fragment ContractsMetaFields on ContractType {
  id
  validFromDate
  validTillDate
  contractor {
    id
    logoUrl
  }
}
    `;
export const CompanyMetaFields = gql`
    fragment CompanyMetaFields on CompanyType {
  id
  status
  name
  description
  contractSet {
    ...ContractsMetaFields
  }
  contactSet {
    edges {
      node {
        id
        firstName
        lastName
      }
    }
  }
  specificationSet {
    id
    positionTitle
  }
}
    ${ContractsMetaFields}`;
export const RegionsList2Fields = gql`
    fragment RegionsList2Fields on RegionType {
  id
  title
  regionmetrics {
    id
    lifetime
  }
}
    `;
export const OrderSelectListFields = gql`
    fragment OrderSelectListFields on OrderMType {
  id
  orderType
  specification {
    id
    positionTitle
  }
  region {
    id
    title
  }
  createdDate
}
    `;
export const OrderCommentFields = gql`
    fragment OrderCommentFields on OrderCommentType {
  id
  comment
  createdAt
}
    `;
export const SalaryTableCellFields = gql`
    fragment SalaryTableCellFields on SpecificationSalaryType {
  id
  hourlyBruttoFrom
  hourlyBruttoTo
  monthlyBruttoFrom
  monthlyBruttoTo
  hourlyBruttoFromFilled
  hourlyBruttoToFilled
  monthlyBruttoFromFilled
  monthlyBruttoToFilled
  useInTemplate
}
    `;
export const SpecFieldInOrderList = gql`
    fragment SpecFieldInOrderList on SpecificationType {
  id
  positionTitle
  address
  salary {
    ...SalaryTableCellFields
  }
}
    ${SalaryTableCellFields}`;
export const OrderDocumentFields = gql`
    fragment OrderDocumentFields on DocumentType {
  id
  isSignedBiuro
  isSignedClient
  signingUrl
  confirmationMethod
  status
  createDate
  signedDocument
}
    `;
export const OrdersList2Fields = gql`
    fragment OrdersList2Fields on OrderType {
  id
  ordermetrics {
    id
    lifetime
    effortConversion
    totalCalls
    successfulCalls
    totalInterviews
    successfulInterviews
  }
  region {
    id
    title
    regionmetrics {
      id
      lifetime
      effortConversion
      totalCalls
      successfulCalls
      totalInverviews
      successfulInterviews
    }
    regionthresholdsettings {
      minOffersExpected
    }
  }
  hourRateBruttoPermanent
  orderNumber
  subtype
  dateFrom
  dateTo
  isLongTerm
  demand
  orderType
  orderDate
  priority
  ordercommentSet {
    edges {
      node {
        ...OrderCommentFields
      }
    }
  }
  projectManager {
    id
    user {
      id
      firstName
      lastName
    }
  }
  recruiter {
    id
    user {
      id
      firstName
      lastName
    }
  }
  trafficGeneration
  status
  nettoFrom
  nettoTo
  shortage
  specification {
    ...SpecFieldInOrderList
  }
  createdBy {
    id
    user {
      id
      email
      firstName
      lastName
    }
  }
  clientContact {
    id
    email
    firstName
    lastName
  }
  company {
    id
    status
    name
    color
    labels {
      edges {
        node {
          id
          title
        }
      }
    }
    country {
      id
      isoCode
    }
  }
  contract {
    id
  }
  lastDocument {
    ...OrderDocumentFields
  }
  orderclientcontactedSet {
    edges {
      node {
        id
        date
        createdBy {
          id
          fullName
          color
          profileImage
        }
      }
    }
  }
}
    ${OrderCommentFields}
${SpecFieldInOrderList}
${OrderDocumentFields}`;
export const UserProfileFields = gql`
    fragment UserProfileFields on UserProfileMType {
  id
  user {
    id
    firstName
    lastName
    email
  }
}
    `;
export const CompanyTypeFields = gql`
    fragment CompanyTypeFields on CompanyType {
  id
  status
  name
  insightlyId
  description
  salesQuestionnaire
  contactSet {
    edges {
      node {
        id
        firstName
        lastName
        phone
        email
        insightlyId
      }
    }
  }
  contractSet {
    id
    validFromDate
    validTillDate
  }
  country {
    id
    isoCode
    languageIsoCode
  }
}
    `;
export const OffboardingRole = gql`
    fragment offboardingRole on OffboardingRoleType {
  id
  company {
    id
    name
  }
  name
  orders {
    edges {
      node {
        id
      }
    }
  }
  createdAt
  updatedAt
  orders {
    edges {
      node {
        id
      }
    }
  }
  actions {
    id
    description
    order
    createdAt
    role {
      id
    }
  }
}
    `;
export const SpecificationDetailFields = gql`
    fragment SpecificationDetailFields on SpecificationType {
  id
  name
  positionTitle
  workFunctions
  address
  intensity
  onboardingDuration
  male
  female
  ageFrom
  isQualificationImprovementPossible
  clientWashesClothes
  ageTo
  competences {
    edges {
      node {
        id
        title
        color
      }
    }
  }
  certificates {
    id
    title
  }
  riskFactors {
    id
    title
    isDefault
  }
  scheduleTypes {
    id
    title
  }
  mandatoryRequirements {
    id
    requirement
  }
  optionalRequirements {
    id
    requirement
  }
  allFunctionsFromFirstDay
  isWorkplaceVideoAllowed
  isWorkplaceVisitAllowed
  isLogoPublicAllowed
  isCompanyModern
  isCompanyInternational
  shiftDuration
  breakDuration
  scheduleType
  shiftPattern
  scheduleText
  minExperienceMonths
  experienceType
  isSecurityPostPresent
  isMagneticKeyIssued
  whoIssuesMagneticKey
  additionalRecruitementInformation
  tagassignmentSet {
    id
    tag {
      id
      key
      group {
        id
        key
      }
    }
    comment
  }
  salary {
    id
    hourlyNettoFrom
    hourlyNettoTo
    hourlyBruttoFrom
    hourlyBruttoTo
    monthlyNettoFrom
    monthlyNettoTo
    monthlyBruttoFrom
    monthlyBruttoTo
    hourlyNettoFromFilled
    hourlyNettoToFilled
    hourlyBruttoFromFilled
    hourlyBruttoToFilled
    monthlyNettoFromFilled
    monthlyNettoToFilled
    monthlyBruttoFromFilled
    monthlyBruttoToFilled
    useInTemplate
    description
    passDescriptionToTemplate
  }
  personalProtectiveEquipmentBiuro {
    id
  }
  personalProtectiveEquipmentClient {
    id
  }
  ppeItems {
    customEquipment
    provider
  }
  careerPossibilities
  requirementsOther
  canEmployUa
  healthcheckType
}
    `;
export const ClientInterviewFields = gql`
    fragment ClientInterviewFields on ClientInterviewType {
  id
  workFunctions
  requirements
  competences1
  competences2
  companyRepresentation
  workConditions
  selectionProcess
  agencyProcessStandart
}
    `;
export const BaseOrderFields = gql`
    fragment BaseOrderFields on OrderMType {
  id
  company {
    ...CompanyTypeFields
  }
  clientContact {
    id
  }
  contract {
    id
  }
  offboardingRoles {
    edges {
      node {
        ...offboardingRole
      }
    }
  }
  orderNumber
  subtype
  orderType
  trafficGeneration
  projectManager {
    id
    fullName
    user {
      ...UserMainFields
    }
  }
  recruiter {
    id
  }
  biuroSignee {
    id
  }
  clientContact {
    ...ContactFieldsShort
  }
  additionalClientContacts {
    edges {
      node {
        ...ContactFieldsShort
      }
    }
  }
  region {
    id
    title
  }
  additionalRegions {
    id
    title
  }
  orderperiodSet {
    ...OrderPeriodFields
  }
  cancellationPeriod
  salaryInfo
  shortage
  compensationForRecruitment
  canIncreaseSalary
  passCommentToOrder
  canGetBonuses
  isLogoPublicAllowed
  isCompanyInternational
  isCompanyModern
  opportunityToEmployDirectly
  orderCanBeExtended
  orderCanBeExtendedComment
  specification {
    ...SpecificationDetailFields
  }
  plannedTermForProvision
  provisionOfInformationOnConclusion
  remunerationAmount
  warrantyPeriod
  candidatesToBeProvided
  minVsdfPayment
  otherInfo
  indefiniteOrderInfo
  workTimeRegistrationSystem
  language
  clientInterview {
    ...ClientInterviewFields
  }
  qualification
  displayPlannedTermForProvision
  exportFreetextRequirements
  recruitmentProgressReportFrequency
  reportingFrequencyStartDate
}
    ${CompanyTypeFields}
${OffboardingRole}
${UserMainFields}
${ContactFieldsShort}
${OrderPeriodFields}
${SpecificationDetailFields}
${ClientInterviewFields}`;
export const CompanyModelMetaFields = gql`
    fragment CompanyModelMetaFields on CompanyModelType {
  id
  status
  name
  description
  salesQuestionnaire
  contractSet {
    ...ContractsMetaFields
  }
  contactSet {
    edges {
      node {
        id
        firstName
        lastName
        canUseInOrder
      }
    }
  }
  specificationSet {
    id
    positionTitle
  }
}
    ${ContractsMetaFields}`;
export const CandidateRequirementsEvaluationFields = gql`
    fragment CandidateRequirementsEvaluationFields on CandidateRequirementsEvaluationType {
  id
  offerProposition {
    id
  }
  requirement {
    id
  }
  description
  recordType
  createdBy {
    id
  }
  createdAt
}
    `;
export const TaskScheduleFields = gql`
    fragment TaskScheduleFields on ScheduleType {
  id
  parentTask {
    id
  }
  endDate
  recurrencePeriod
  intervalCount
  dayOfWeek
  weekOfMonth
  dayOfMonth
}
    `;
export const OperationsTaskFields = gql`
    fragment OperationsTaskFields on TaskType {
  id
  status
  durationMinutes
  countryIsoCode
  numPreviousTasks
  order {
    id
    company {
      id
      name
    }
    specification {
      id
      positionTitle
    }
  }
  category {
    id
    title
  }
  company {
    id
    name
    status
    country {
      id
      isoCode
    }
  }
  comment
  completedBy {
    id
    fullName
    color
    user {
      id
      firstName
      lastName
    }
  }
  nextTaskAssignee {
    id
    fullName
    color
    user {
      id
      firstName
      lastName
    }
  }
  date
  nextActionDate
  createdAt
  country {
    id
    isoCode
  }
  candidate {
    id
    livasId
    firstName
    lastName
    employeeLivasId
  }
  schedules {
    edges {
      node {
        ...TaskScheduleFields
      }
    }
  }
  createdBySchedule {
    ...TaskScheduleFields
  }
  taskSet {
    edges {
      node {
        id
        createdAt
        date
      }
    }
  }
  dashboard {
    id
    title
  }
  metricvalueSet {
    edges {
      node {
        id
        value
        date
        manager {
          id
          fullName
        }
        client {
          id
          name
          livasId
        }
        candidate {
          id
          livasId
          employeeLivasId
          firstName
          lastName
        }
        metricGroup {
          id
          title
        }
        metricvaluecommentSet {
          edges {
            node {
              id
              comment
              metricClientReason {
                id
                title
              }
              clients {
                edges {
                  node {
                    id
                    name
                  }
                }
              }
              candidates {
                edges {
                  node {
                    id
                    livasId
                    employeeLivasId
                    firstName
                    lastName
                  }
                }
              }
            }
          }
        }
      }
    }
  }
  metricvalueLevel2 {
    edges {
      node {
        id
        value
        date
        manager {
          id
          fullName
        }
        client {
          id
          name
          livasId
        }
        candidate {
          id
          livasId
          employeeLivasId
          firstName
          lastName
        }
        metricGroup {
          id
          title
        }
        metricvaluecommentSet {
          edges {
            node {
              id
              comment
              metricClientReason {
                id
                title
              }
              clients {
                edges {
                  node {
                    id
                    name
                  }
                }
              }
              candidates {
                edges {
                  node {
                    id
                    livasId
                    employeeLivasId
                    firstName
                    lastName
                  }
                }
              }
            }
          }
        }
      }
    }
  }
}
    ${TaskScheduleFields}`;
export const OperationsTaskFieldsNew = gql`
    fragment OperationsTaskFieldsNew on TaskType {
  id
  status
  durationMinutes
  countryIsoCode
  numPreviousTasks
  order {
    id
    company {
      id
      name
      status
      country {
        id
        isoCode
      }
    }
    specification {
      id
      positionTitle
    }
  }
  category {
    id
    title
  }
  company {
    id
    name
    status
    country {
      id
      isoCode
    }
  }
  comment
  completedBy {
    id
    fullName
    color
    user {
      id
      firstName
      lastName
    }
  }
  nextTaskAssignee {
    id
    fullName
    color
    user {
      id
      firstName
      lastName
    }
  }
  date
  nextActionDate
  createdAt
  country {
    id
    isoCode
  }
  candidate {
    id
    livasId
    firstName
    lastName
    employeeLivasId
  }
  schedules {
    edges {
      node {
        ...TaskScheduleFields
      }
    }
  }
  createdBySchedule {
    ...TaskScheduleFields
  }
  taskSet {
    edges {
      node {
        id
        createdAt
        date
      }
    }
  }
  dashboard {
    id
    title
  }
  metricvalueSet {
    edges {
      node {
        id
        value
        date
        manager {
          id
          fullName
        }
        client {
          id
          name
          livasId
        }
        candidate {
          id
          livasId
          employeeLivasId
          firstName
          lastName
        }
        metricGroup {
          id
          title
        }
        metricvaluecommentSet {
          edges {
            node {
              id
              comment
              metricClientReason {
                id
                title
              }
              clients {
                edges {
                  node {
                    id
                    name
                  }
                }
              }
              candidates {
                edges {
                  node {
                    id
                    livasId
                    employeeLivasId
                    firstName
                    lastName
                  }
                }
              }
            }
          }
        }
      }
    }
  }
  metricvalueLevel2 {
    edges {
      node {
        id
        value
        date
        manager {
          id
          fullName
        }
        client {
          id
          name
          livasId
        }
        candidate {
          id
          livasId
          employeeLivasId
          firstName
          lastName
        }
        metricGroup {
          id
          title
        }
        metricvaluecommentSet {
          edges {
            node {
              id
              comment
              metricClientReason {
                id
                title
              }
              clients {
                edges {
                  node {
                    id
                    name
                  }
                }
              }
              candidates {
                edges {
                  node {
                    id
                    livasId
                    employeeLivasId
                    firstName
                    lastName
                  }
                }
              }
            }
          }
        }
      }
    }
  }
}
    ${TaskScheduleFields}`;
export const CategoryConfigFields = gql`
    fragment CategoryConfigFields on SACategoryType {
  id
  title
  hint
  durationMinutes
  showDuration
  showOrder
  showCompany
  showDescription
  showOrder
  showCandidate
  showNextTaskAssignee
  customFields {
    edges {
      node {
        id
        name
        hintText
        options
        fieldType {
          id
          name
          fieldType
        }
      }
    }
  }
}
    `;
export const OverdueTaskTableFields = gql`
    fragment OverdueTaskTableFields on TaskType {
  id
  status
  company {
    id
    name
    status
    country {
      id
      isoCode
    }
  }
  category {
    ...CategoryConfigFields
  }
  candidate {
    id
    firstName
    lastName
    livasId
    employeeLivasId
  }
  completedBy {
    id
    fullName
    color
    user {
      id
      firstName
      lastName
    }
  }
  dashboard {
    id
    title
  }
  metricvalueSet {
    edges {
      node {
        id
        value
        date
        manager {
          id
          fullName
        }
        client {
          id
          name
          livasId
        }
        order {
          company {
            name
          }
        }
        candidate {
          id
          livasId
          employeeLivasId
          firstName
          lastName
        }
        metricGroup {
          id
          title
        }
        metricvaluecommentSet {
          edges {
            node {
              id
              comment
              metricClientReason {
                id
                title
              }
              clients {
                edges {
                  node {
                    id
                    name
                  }
                }
              }
              candidates {
                edges {
                  node {
                    id
                    livasId
                    employeeLivasId
                    firstName
                    lastName
                  }
                }
              }
            }
          }
        }
      }
    }
  }
  metricvalueLevel2 {
    edges {
      node {
        id
        value
        date
        manager {
          id
          fullName
        }
        client {
          id
          name
          livasId
        }
        order {
          company {
            name
          }
        }
        candidate {
          id
          livasId
          employeeLivasId
          firstName
          lastName
        }
        metricGroup {
          id
          title
        }
        metricvaluecommentSet {
          edges {
            node {
              id
              comment
              metricClientReason {
                id
                title
              }
              clients {
                edges {
                  node {
                    id
                    name
                  }
                }
              }
              candidates {
                edges {
                  node {
                    id
                    livasId
                    employeeLivasId
                    firstName
                    lastName
                  }
                }
              }
            }
          }
        }
      }
    }
  }
  nextActionCategory {
    id
    title
  }
  nextActionDate
  overdueCount
  date
  comment
  durationMinutes
}
    ${CategoryConfigFields}`;
export const MeetingTaskTableFields = gql`
    fragment MeetingTaskTableFields on TaskType {
  id
  status
  company {
    id
    name
    status
    country {
      id
      isoCode
    }
  }
  category {
    ...CategoryConfigFields
  }
  candidate {
    id
    firstName
    lastName
    livasId
    employeeLivasId
  }
  completedBy {
    id
    fullName
    color
    user {
      id
      firstName
      lastName
    }
  }
  dashboard {
    id
    title
  }
  metricvalueSet {
    edges {
      node {
        id
        value
        date
        manager {
          id
          fullName
        }
        client {
          id
          name
          livasId
        }
        candidate {
          id
          livasId
          employeeLivasId
          firstName
          lastName
        }
        metricGroup {
          id
          title
        }
        metricvaluecommentSet {
          edges {
            node {
              id
              comment
              metricClientReason {
                id
                title
              }
              clients {
                edges {
                  node {
                    id
                    name
                  }
                }
              }
              candidates {
                edges {
                  node {
                    id
                    livasId
                    employeeLivasId
                    firstName
                    lastName
                  }
                }
              }
            }
          }
        }
      }
    }
  }
  metricvalueLevel2 {
    edges {
      node {
        id
        value
        date
        manager {
          id
          fullName
        }
        client {
          id
          name
          livasId
        }
        candidate {
          id
          livasId
          employeeLivasId
          firstName
          lastName
        }
        metricGroup {
          id
          title
        }
        metricvaluecommentSet {
          edges {
            node {
              id
              comment
              metricClientReason {
                id
                title
              }
              clients {
                edges {
                  node {
                    id
                    name
                  }
                }
              }
              candidates {
                edges {
                  node {
                    id
                    livasId
                    employeeLivasId
                    firstName
                    lastName
                  }
                }
              }
            }
          }
        }
      }
    }
  }
  nextActionCategory {
    id
    title
  }
  overdueCount
  date
  comment
  durationMinutes
}
    ${CategoryConfigFields}`;
export const DynamicDashboardTaskTableFields = gql`
    fragment DynamicDashboardTaskTableFields on TaskType {
  id
  status
  company {
    id
    name
    status
    country {
      id
      isoCode
    }
  }
  order {
    id
    specification {
      positionTitle
    }
  }
  category {
    ...CategoryConfigFields
  }
  candidate {
    id
    firstName
    lastName
    livasId
    employeeLivasId
  }
  completedBy {
    id
    fullName
    color
    user {
      id
      firstName
      lastName
    }
  }
  dashboard {
    id
    title
  }
  metricvalueSet {
    edges {
      node {
        id
        value
        date
        manager {
          id
          fullName
        }
        client {
          id
          name
          livasId
        }
        order {
          company {
            name
          }
        }
        candidate {
          id
          livasId
          employeeLivasId
          firstName
          lastName
        }
        metricGroup {
          id
          title
        }
        metricvaluecommentSet {
          edges {
            node {
              id
              comment
              metricClientReason {
                id
                title
              }
              clients {
                edges {
                  node {
                    id
                    name
                  }
                }
              }
              candidates {
                edges {
                  node {
                    id
                    livasId
                    employeeLivasId
                    firstName
                    lastName
                  }
                }
              }
            }
          }
        }
      }
    }
  }
  metricvalueLevel2 {
    edges {
      node {
        id
        value
        date
        manager {
          id
          fullName
        }
        client {
          id
          name
          livasId
        }
        order {
          company {
            name
          }
        }
        candidate {
          id
          livasId
          employeeLivasId
          firstName
          lastName
        }
        metricGroup {
          id
          title
        }
        metricvaluecommentSet {
          edges {
            node {
              id
              comment
              metricClientReason {
                id
                title
              }
              clients {
                edges {
                  node {
                    id
                    name
                  }
                }
              }
              candidates {
                edges {
                  node {
                    id
                    livasId
                    employeeLivasId
                    firstName
                    lastName
                  }
                }
              }
            }
          }
        }
      }
    }
  }
  nextActionCategory {
    id
    title
  }
  nextActionDate
  overdueCount
  date
  comment
  durationMinutes
}
    ${CategoryConfigFields}`;
export const TaskDetailViewFields = gql`
    fragment TaskDetailViewFields on TaskType {
  id
  status
  durationMinutes
  numPreviousTasks
  order {
    id
    specification {
      id
      positionTitle
    }
    company {
      id
      name
      country {
        id
        title
        isoCode
      }
    }
  }
  category {
    ...CategoryConfigFields
  }
  company {
    id
    name
    status
    country {
      id
      isoCode
    }
  }
  candidate {
    id
    livasId
    firstName
    lastName
    employeeLivasId
  }
  comment
  dashboard {
    id
    title
  }
  completedBy {
    id
    fullName
    color
    user {
      id
      firstName
      lastName
    }
  }
  nextTaskAssignee {
    id
    fullName
    color
    user {
      id
      firstName
      lastName
    }
  }
  date
  createdAt
  metricvalueSet {
    edges {
      node {
        id
        value
        date
        manager {
          id
          fullName
        }
        client {
          id
          name
          livasId
        }
        order {
          company {
            name
          }
        }
        candidate {
          id
          livasId
          employeeLivasId
          firstName
          lastName
        }
        metricGroup {
          id
          title
        }
        metricvaluecommentSet {
          edges {
            node {
              id
              comment
              metricClientReason {
                id
                title
              }
              clients {
                edges {
                  node {
                    id
                    name
                  }
                }
              }
              candidates {
                edges {
                  node {
                    id
                    livasId
                    employeeLivasId
                    firstName
                    lastName
                  }
                }
              }
            }
          }
        }
      }
    }
  }
  metricvalueLevel2 {
    edges {
      node {
        id
        value
        date
        manager {
          id
          fullName
        }
        client {
          id
          name
          livasId
        }
        order {
          company {
            name
          }
        }
        candidate {
          id
          livasId
          employeeLivasId
          firstName
          lastName
        }
        metricGroup {
          id
          title
        }
        metricvaluecommentSet {
          edges {
            node {
              id
              comment
              metricClientReason {
                id
                title
              }
              clients {
                edges {
                  node {
                    id
                    name
                  }
                }
              }
              candidates {
                edges {
                  node {
                    id
                    livasId
                    employeeLivasId
                    firstName
                    lastName
                  }
                }
              }
            }
          }
        }
      }
    }
  }
  createdBySchedule {
    endDate
    id
  }
  country {
    id
    isoCode
  }
  schedules {
    edges {
      node {
        ...TaskScheduleFields
      }
    }
  }
}
    ${CategoryConfigFields}
${TaskScheduleFields}`;
export const CustomFieldsValuesFields = gql`
    fragment CustomFieldsValuesFields on CustomFieldValueType {
  id
  boolValue
  numericValue
  textValue
  dateValue
  urlValue
  customField {
    id
    name
    fieldType {
      id
      name
      fieldType
    }
  }
}
    `;
export const SelectionActionListItemFields = gql`
    fragment SelectionActionListItemFields on TaskType {
  id
  comment
  durationMinutes
  date
  category {
    id
    title
  }
  createdBy {
    id
    fullName
  }
  completedBy {
    id
    fullName
    color
    user {
      id
      firstName
      lastName
    }
  }
  searchResults {
    totalCount
    touchedCount
    successCount
  }
  status
}
    `;
export const SaCategoryFields = gql`
    fragment SACategoryFields on SACategoryType {
  id
  title
  hint
  durationMinutes
}
    `;
export const SaCategoryGroupsFields = gql`
    fragment SACategoryGroupsFields on SACategoryGroupType {
  id
  title
  department
  country {
    id
  }
  sacategorySet {
    edges {
      node {
        ...CategoryConfigFields
        requiresDashboard
      }
    }
  }
}
    ${CategoryConfigFields}`;
export const RequirementFields = gql`
    fragment RequirementFields on RequirementType {
  id
  requirement
}
    `;
export const CompanyDetailFields = gql`
    fragment CompanyDetailFields on CompanyType {
  id
  name
  status
  insightlyId
  color
  contractSet {
    ...ContractsMetaFields
  }
  contactSet {
    edges {
      node {
        id
        firstName
        lastName
      }
    }
  }
  specificationSet {
    id
    positionTitle
  }
}
    ${ContractsMetaFields}`;
export const PpeFields = gql`
    fragment PPEFields on PersonalProtectiveEquipmentType {
  id
  title
  specificationppeSet {
    customEquipment
    provider
  }
}
    `;
export const TagsFields = gql`
    fragment TagsFields on TagType {
  id
  title
  hint
  order
}
    `;
export const Certificate = gql`
    fragment Certificate on CertificateType {
  id
  title
}
    `;
export const OrderListCandidatesStatsFields = gql`
    fragment OrderListCandidatesStatsFields on CandidateOrderStatsType {
  orderId
  toBeInterviewed
  toBeInterviewedClient
  healthCheckPending
  toBeEmployed
  offeredFromDate
  offeredLast7Days
  presentedClient
  presentedClientSuccess
  presentedClientFailed
  longListedLast7Days
  offeredLast1Day
  longListedLast1Day
}
    `;
export const CandidateEventsFields = gql`
    fragment CandidateEventsFields on CandidateEventType {
  candidate {
    id
    firstName
    lastName
    livasId
  }
  id
  startDatetime
  eventType
  resolutionStatus
}
    `;
export const OrderStatsFields = gql`
    fragment OrderStatsFields on OfferPropositionStatsType {
  interestedCount
  notInterestedCount
  interestedCallCount
  notInterestedCallCount
  signed
  totalOffered
  totalInterested
  totalNotInterested
}
    `;
export const MeFields = gql`
    fragment MeFields on UserProfileMType {
  id
  fullName
  department
  color
  region {
    id
    country {
      id
      title
    }
  }
  user {
    email
  }
}
    `;
export const GetCancellationReasons = gql`
    query GetCancellationReasons($country: ID) {
  cancellationReasonGroups(country: $country) {
    edges {
      node {
        ...CancellationReasonsGroupFields
      }
    }
  }
}
    ${CancellationReasonsGroupFields}`;
export const GetCancellationReasonsForOffer = gql`
    query GetCancellationReasonsForOffer($offerPropositionId: ID!) {
  cancellationReasonAssignments(offerProposition: $offerPropositionId) {
    edges {
      node {
        id
        cancellationReason {
          id
        }
      }
    }
  }
}
    `;
export const CreateCancellationReasonAssignments = gql`
    mutation CreateCancellationReasonAssignments($offerProposition: ID!, $cancellationReasons: [ID]!) {
  createCancellationReasonAssignment(
    offerProposition: $offerProposition
    cancellationReasons: $cancellationReasons
  ) {
    ok
  }
}
    `;
export const CandidatesTableData = gql`
    query CandidatesTableData($first: Int, $after: String, $manager: [ID], $country: ID, $company: ID, $search: String) {
  offers(
    first: $first
    after: $after
    manager: $manager
    countryId: $country
    company: $company
    search: $search
    hasCandidate: true
    hasPlannedEvents: true
  ) {
    totalCount
    edges {
      node {
        id
        order {
          projectManager {
            fullName
          }
          company {
            name
            address
          }
        }
        candidate {
          firstName
          lastName
        }
        candidateEvents {
          edges {
            node {
              ...OfferEventFields
            }
          }
        }
        offerpropositioncommentSet {
          totalCount
          edges {
            node {
              text
            }
          }
        }
      }
    }
  }
}
    ${OfferEventFields}`;
export const GetCandidates = gql`
    query getCandidates($first: Int, $after: String, $metricValueCommentId: ID) {
  candidates(
    first: $first
    after: $after
    metricValueCommentId: $metricValueCommentId
  ) {
    totalCount
    edges {
      node {
        firstName
        lastName
        livasStatus {
          key
        }
        employeeLivasId
        livasId
      }
    }
  }
}
    `;
export const FilterMetadata = gql`
    query FilterMetadata {
  scheduleTypes {
    id
    title
    isPreselected
  }
  labels(group_Key: "covid") {
    edges {
      node {
        ...CovidLabelsFields
      }
    }
  }
}
    ${CovidLabelsFields}`;
export const GetContractorsForSelect = gql`
    query getContractorsForSelect {
  contractors {
    edges {
      node {
        ...ContractorSelectFields
      }
    }
  }
}
    ${ContractorSelectFields}`;
export const GetOffboardingRoles = gql`
    query getOffboardingRoles($company: ID) {
  offboardingRoles(company: $company) {
    edges {
      node {
        ...offboardingRole
      }
    }
  }
}
    ${OffboardingRole}`;
export const CreateOffboardingRole = gql`
    mutation createOffboardingRole($input: OffboardingRoleInput!) {
  createOffboardingRole(input: $input) {
    ok
    offboardingRole {
      ...offboardingRole
    }
  }
}
    ${OffboardingRole}`;
export const UpdateOffboardingRole = gql`
    mutation updateOffboardingRole($id: ID!, $input: OffboardingRoleInput!) {
  updateOffboardingRole(id: $id, input: $input) {
    ok
    offboardingRole {
      ...offboardingRole
    }
  }
}
    ${OffboardingRole}`;
export const DeleteOffboardingRole = gql`
    mutation deleteOffboardingRole($id: ID!) {
  deleteOffboardingRole(id: $id) {
    ok
  }
}
    `;
export const GetChangeColorPermission = gql`
    query GetChangeColorPermission {
  hasPermission(title: "company.change_color")
}
    `;
export const SearchCompanies = gql`
    query searchCompanies($search: String, $country: ID) {
  companyInstances(name: $search, country: $country) {
    edges {
      node {
        ...CompanySelectFields
      }
    }
  }
}
    ${CompanySelectFields}`;
export const SearchCompaniesType = gql`
    query searchCompaniesType($search: String) {
  companyInstances(name: $search) {
    edges {
      node {
        ...CompanySelectFields
      }
    }
  }
}
    ${CompanySelectFields}`;
export const GetCompaniesNames = gql`
    query getCompaniesNames {
  companies {
    edges {
      node {
        id
        name
      }
    }
  }
}
    `;
export const GetCompany = gql`
    query getCompany($id: ID!) {
  company(id: $id) {
    name
    status
    country {
      id
      isoCode
    }
  }
}
    `;
export const UpdateCompanyManagersData = gql`
    mutation updateCompanyManagersData($companyIds: [ID]!, $projectManager1: ID, $projectManager2: ID, $substituteManager1: ID, $substituteManager2: ID, $recruiter1: ID, $recruiter2: ID, $substituteRecruiter1: ID, $substituteRecruiter2: ID) {
  updateCompanyManagers(
    companyIds: $companyIds
    projectManager1: $projectManager1
    projectManager2: $projectManager2
    substituteManager1: $substituteManager1
    substituteManager2: $substituteManager2
    recruiter1: $recruiter1
    recruiter2: $recruiter2
    substituteRecruiter1: $substituteRecruiter1
    substituteRecruiter2: $substituteRecruiter2
  ) {
    ok
  }
}
    `;
export const CovidLabels = gql`
    query CovidLabels {
  labels(group_Key: "covid") {
    edges {
      node {
        id
        title
      }
    }
  }
}
    `;
export const SaveCompanyLabels = gql`
    mutation SaveCompanyLabels($companyId: ID!, $labels: [ID]!) {
  updateCompanyModel(input: {id: $companyId, labels: $labels}) {
    company {
      id
    }
  }
}
    `;
export const UpdateCompanyTagsInExternalSys = gql`
    mutation UpdateCompanyTagsInExternalSys($companyId: ID!, $dateFrom: Date, $updateLivas: Boolean, $updateWorkis: Boolean) {
  syncCompanyLabels(
    companyId: $companyId
    date: $dateFrom
    syncLivas: $updateLivas
    syncWorkis: $updateWorkis
  ) {
    ok
  }
}
    `;
export const AllContacts = gql`
    query allContacts($first: Int, $after: String, $search: String, $phone: String, $company: ID, $canUseInOrder: Boolean, $id: ID) {
  contacts(
    first: $first
    after: $after
    search: $search
    phone: $phone
    company: $company
    canUseInOrder: $canUseInOrder
    id: $id
  ) {
    pageInfo {
      startCursor
      endCursor
      hasNextPage
    }
    totalCount
    edges {
      node {
        id
        firstName
        lastName
        phone
        email
        insightlyId
        comment
        canUseInOrder
        company {
          id
          name
        }
      }
    }
  }
}
    `;
export const GetCountries = gql`
    query getCountries {
  countries {
    edges {
      node {
        ...CountryFields
      }
    }
    totalCount
  }
}
    ${CountryFields}`;
export const CreateCustomLink = gql`
    mutation CreateCustomLink($input: CreateCustomLinkInput!) {
  createCustomLink(input: $input) {
    customLink {
      id
      title
      url
      dashboard {
        id
        title
      }
      createdBy {
        id
        fullName
      }
      createdAt
    }
  }
}
    `;
export const EscalateMetricValueToDashboardsMutation = gql`
    mutation EscalateMetricValueToDashboardsMutation($metricValueId: ID!, $escalatedToIds: [ID!]!, $escalatedFromId: ID) {
  escalateMetricValueToDashboards(
    metricValueId: $metricValueId
    escalatedToIds: $escalatedToIds
    escalatedFromId: $escalatedFromId
  ) {
    metricValue {
      id
      value
      escalatedTo {
        id
        title
        meetingLevel
      }
      escalatedFrom {
        id
        title
      }
      escalatedAt
      escalatedBy {
        id
        fullName
      }
      escalations {
        edges {
          node {
            id
            escalatedTo {
              id
              title
              meetingLevel
            }
            escalatedFrom {
              id
              title
            }
            createdAt
            createdBy {
              id
              fullName
            }
            metricValue {
              id
            }
          }
        }
      }
    }
    errors
  }
}
    `;
export const UnEscalateMetricValueFromDashboards = gql`
    mutation unEscalateMetricValueFromDashboards($escalationId: ID!) {
  unEscalateMetricValueFromDashboards(escalationId: $escalationId) {
    metricValue {
      id
    }
    ok
    errors
  }
}
    `;
export const UpdateMetricValueCommentMutation = gql`
    mutation UpdateMetricValueCommentMutation($id: ID!, $comment: String, $reasonId: ID) {
  updateMetricValueComment(
    input: {id: $id, comment: $comment, metricClientReason: $reasonId}
  ) {
    metricValueComment {
      id
      comment
      metricClientReason {
        id
        title
      }
    }
  }
}
    `;
export const SetMetricValueNextTaskMutation = gql`
    mutation SetMetricValueNextTaskMutation($id: ID!, $taskId: ID!) {
  updateMetricValue(input: {id: $id, nextTask: $taskId}) {
    metricValue {
      id
      value
      nextTask {
        ...StandUpDashboardTaskFields
        customFieldValues {
          edges {
            node {
              ...CustomFieldsValuesFields
            }
          }
        }
      }
    }
  }
}
    ${StandUpDashboardTaskFields}
${CustomFieldsValuesFields}`;
export const SetMetricValueNextTaskL2Mutation = gql`
    mutation SetMetricValueNextTaskL2Mutation($id: ID!, $taskId: ID!) {
  updateMetricValue(input: {id: $id, nextTaskLevel2: $taskId}) {
    metricValue {
      id
      value
      nextTaskLevel2 {
        ...StandUpDashboardTaskFields
      }
    }
  }
}
    ${StandUpDashboardTaskFields}`;
export const UpdateMetricValueImportanceMutation = gql`
    mutation UpdateMetricValueImportanceMutation($id: ID!, $isImportant: Boolean!) {
  updateMetricValue(input: {id: $id, isImportant: $isImportant}) {
    metricValue {
      id
      isImportant
    }
  }
}
    `;
export const EscalateMetricValueMutation = gql`
    mutation EscalateMetricValueMutation($input: UpdateMetricValueInput!) {
  updateMetricValue(input: $input) {
    metricValue {
      id
      escalatedTo {
        id
        title
      }
      escalatedBy {
        id
        fullName
      }
      escalatedAt
      escalatedFrom {
        id
        title
      }
      escalations {
        edges {
          node {
            id
            escalatedTo {
              id
              title
              meetingLevel
            }
            escalatedFrom {
              id
              title
            }
            createdAt
            createdBy {
              id
              fullName
            }
            metricValue {
              id
            }
          }
        }
      }
    }
    errors {
      field
      message
    }
  }
}
    `;
export const UpdateDashboardCard = gql`
    mutation UpdateDashboardCard($input: UpdateDashboardCardInput!) {
  updateDashboardCard(input: $input) {
    dashboardCard {
      id
      barchartGoal
    }
  }
}
    `;
export const AggregatedMetrics = gql`
    query AggregatedMetrics($regionGroupId: ID!, $dateFrom: Date!, $dateTo: Date!, $metricGroupIds: [ID!]!) {
  aggregatedMetrics(
    regionGroupId: $regionGroupId
    dateFrom: $dateFrom
    dateTo: $dateTo
    metricGroupIds: $metricGroupIds
  ) {
    id
    date
    isImportant
    manager {
      id
      fullName
    }
    client {
      id
      country {
        id
        isoCode
      }
      name
      livasId
    }
    candidate {
      id
      country {
        id
        isoCode
      }
      livasId
      employeeLivasId
      firstName
      lastName
    }
    order {
      id
      company {
        id
        name
      }
      specification {
        id
        positionTitle
      }
      priority
    }
    escalatedTo {
      id
      title
    }
    escalatedBy {
      id
      fullName
    }
    escalatedAt
    escalatedFrom {
      id
      title
    }
    value
    subvalue
    goal
    workis
    nextTaskId
    nextTaskLevel2Id
    metricvaluecommentSet {
      id
      comment
      metricClientReason {
        id
        title
      }
      clients {
        edges {
          node {
            country {
              id
              isoCode
            }
            id
            name
            livasId
          }
        }
      }
      candidates {
        edges {
          node {
            id
            country {
              id
              isoCode
            }
            livasId
            employeeLivasId
            firstName
            lastName
          }
        }
      }
    }
    metricGroup {
      id
      subvalueExplanation
      taskCategory {
        id
        title
        hint
        durationMinutes
        showDuration
        showOrder
        showCompany
        showDescription
        showOrder
        showCandidate
        customFields {
          edges {
            node {
              id
              name
              hintText
              options
              fieldType {
                id
                name
                fieldType
              }
            }
          }
        }
      }
      nextActions {
        edges {
          node {
            id
            title
            createCompletedTask
            taskCategory {
              id
              title
              hint
              durationMinutes
              showDuration
              showOrder
              showCompany
              showDescription
              showOrder
              showCandidate
              customFields {
                edges {
                  node {
                    id
                    name
                    hintText
                    options
                    fieldType {
                      id
                      name
                      fieldType
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
}
    `;
export const GetDashboards = gql`
    query getDashboards {
  allDashboards {
    edges {
      node {
        regionGroup {
          id
        }
        id
        title
        meetingLevel
        escalateTo {
          id
          title
        }
        escalateToDashboards {
          id
          title
          meetingLevel
        }
        dashboardcardSet {
          edges {
            node {
              id
              barchartGoal
              card {
                id
                title
                description
                type
                filterTaskCategoriesKeys
                excludeTaskCategoriesKeys
                excludeTaskStatuses
                displayColumns
                lookForwardDays
                includeFromChildDashboards
                allDashboards
                additionalFilters
              }
              metricGroupForOtherProblem {
                id
              }
            }
          }
        }
        metricsUserprofiles {
          edges {
            node {
              id
              fullName
              color
            }
          }
        }
        customLinks {
          title
          url
        }
      }
    }
  }
}
    `;
export const GetDashboardsList = gql`
    query getDashboardsList {
  allDashboards {
    edges {
      node {
        id
        title
      }
    }
  }
}
    `;
export const MetricGroupReasons = gql`
    query MetricGroupReasons($id: ID!) {
  metricGroups(id: $id) {
    edges {
      node {
        metricclientreasonSet {
          edges {
            node {
              id
              title
            }
          }
        }
      }
    }
  }
}
    `;
export const GetMetricTableCardContent = gql`
    query getMetricTableCardContent($id: ID!, $dashboardId: ID, $dateFrom: Date, $dateTo: Date) {
  metricGroupsAssignment(card: $id) {
    edges {
      node {
        id
        metricGroup {
          id
          title
          description
          highlightWhen
          metricvalueSet(
            dashboardId: $dashboardId
            cardId: $id
            dateFrom: $dateFrom
            dateTo: $dateTo
          ) {
            edges {
              node {
                id
                key
                date
                isImportant
                channel
                regionGroup {
                  title
                }
                manager {
                  id
                  fullName
                }
                client {
                  id
                  country {
                    id
                    isoCode
                  }
                  name
                  livasId
                }
                candidate {
                  id
                  country {
                    id
                    isoCode
                  }
                  livasId
                  employeeLivasId
                  firstName
                  lastName
                }
                order {
                  id
                  company {
                    id
                    name
                  }
                  specification {
                    id
                    positionTitle
                  }
                }
                escalatedTo {
                  id
                  title
                  meetingLevel
                }
                escalatedBy {
                  id
                  fullName
                }
                escalatedAt
                escalatedFrom {
                  id
                  title
                }
                escalations {
                  edges {
                    node {
                      id
                      escalatedTo {
                        id
                        title
                        meetingLevel
                      }
                      escalatedFrom {
                        id
                        title
                      }
                      createdAt
                      createdBy {
                        id
                        fullName
                      }
                    }
                  }
                }
                value
                goal
                workis
                nextTaskId
                nextTaskLevel2Id
                metricvaluecommentSet {
                  edges {
                    node {
                      id
                      comment
                    }
                  }
                }
              }
            }
          }
          taskCategory {
            id
            title
            hint
            durationMinutes
            showDuration
            showOrder
            showCompany
            showDescription
            showOrder
            showCandidate
            customFields {
              edges {
                node {
                  id
                  name
                  hintText
                  options
                  fieldType {
                    id
                    name
                    fieldType
                  }
                }
              }
            }
          }
          nextActions {
            edges {
              node {
                id
                title
                createCompletedTask
                taskCategory {
                  id
                  title
                  hint
                  durationMinutes
                  showDuration
                  showOrder
                  showCompany
                  showDescription
                  showOrder
                  showCandidate
                  customFields {
                    edges {
                      node {
                        id
                        name
                        hintText
                        options
                        fieldType {
                          id
                          name
                          fieldType
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
}
    `;
export const GetResourcesLvl2 = gql`
    query getResourcesLvl2($id: ID!, $dashboardId: ID!, $dateFrom: Date, $dateTo: Date) {
  metricGroupsAssignment(card: $id) {
    edges {
      node {
        id
        metricGroup {
          id
          title
          description
          highlightWhen
          metricvalueSet(
            dashboardId: $dashboardId
            cardId: $id
            dateFrom: $dateFrom
            dateTo: $dateTo
          ) {
            edges {
              node {
                value
                date
                regionGroup {
                  id
                  title
                }
              }
            }
          }
        }
      }
    }
  }
}
    `;
export const GetConversions = gql`
    query getConversions($id: ID!, $dateFrom: Date, $dateTo: Date, $dashboardRegion: ID) {
  metricGroupsAssignment(card: $id) {
    edges {
      node {
        id
        metricGroup {
          id
          title
          metricvalueSet(
            dateFrom: $dateFrom
            dateTo: $dateTo
            dashboardRegion: $dashboardRegion
          ) {
            edges {
              node {
                id
                value
                key
                regionGroup {
                  id
                  title
                }
                order {
                  id
                  specification {
                    positionTitle
                    id
                  }
                }
              }
            }
          }
        }
      }
    }
  }
}
    `;
export const GetMetricValuesEscalated = gql`
    query getMetricValuesEscalated($escalatedTo: ID, $dateFrom: Date, $dateTo: Date) {
  metricValues(escalatedTo: $escalatedTo, dateFrom: $dateFrom, dateTo: $dateTo) {
    edges {
      node {
        id
        date
        isImportant
        channel
        escalatedTo {
          id
          title
          meetingLevel
        }
        escalatedBy {
          id
          fullName
        }
        escalatedAt
        escalatedFrom {
          id
          title
        }
        escalations {
          edges {
            node {
              id
              escalatedTo {
                id
                title
                meetingLevel
              }
              escalatedFrom {
                id
                title
              }
              createdAt
              createdBy {
                id
                fullName
              }
            }
          }
        }
        manager {
          id
          fullName
        }
        client {
          id
          name
          livasId
        }
        candidate {
          id
          livasId
          employeeLivasId
          firstName
          lastName
        }
        order {
          id
          company {
            id
            name
          }
          specification {
            id
            positionTitle
          }
        }
        value
        goal
        workis
        nextTaskId
        nextTaskLevel2Id
        metricvaluecommentSet {
          edges {
            node {
              id
            }
          }
        }
        metricGroup {
          id
          title
          description
          highlightWhen
          taskCategory {
            id
            title
            hint
            durationMinutes
            showDuration
            showOrder
            showCompany
            showDescription
            showOrder
            showCandidate
            customFields {
              edges {
                node {
                  id
                  name
                  hintText
                  options
                  fieldType {
                    id
                    name
                    fieldType
                  }
                }
              }
            }
          }
          nextActions {
            edges {
              node {
                id
                title
                createCompletedTask
                taskCategory {
                  id
                  title
                  hint
                  durationMinutes
                  showDuration
                  showOrder
                  showCompany
                  showDescription
                  showOrder
                  showCandidate
                  customFields {
                    edges {
                      node {
                        id
                        name
                        hintText
                        options
                        fieldType {
                          id
                          name
                          fieldType
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
}
    `;
export const GetMetricNextTask = gql`
    query getMetricNextTask($ids: [ID]) {
  tasks(ids: $ids) {
    edges {
      node {
        ...StandUpDashboardTaskFields
        customFieldValues {
          edges {
            node {
              ...CustomFieldsValuesFields
            }
          }
        }
      }
    }
  }
}
    ${StandUpDashboardTaskFields}
${CustomFieldsValuesFields}`;
export const GetMetricComments = gql`
    query getMetricComments($ids: [ID]) {
  metricValueComments(metricValueIds: $ids) {
    edges {
      node {
        id
        comment
        metricClientReason {
          id
          title
        }
        clients {
          edges {
            node {
              id
              country {
                id
                isoCode
              }
              name
              livasId
            }
          }
        }
        candidates {
          edges {
            node {
              id
              country {
                id
                isoCode
              }
              livasId
              employeeLivasId
              firstName
              lastName
            }
          }
        }
      }
    }
  }
}
    `;
export const GetMetricTableCardNextTaskUpdate = gql`
    query getMetricTableCardNextTaskUpdate($id: ID!) {
  tasks(id: $id) {
    edges {
      node {
        ...StandUpDashboardTaskFields
        nextActionCategory {
          id
          title
        }
      }
    }
  }
}
    ${StandUpDashboardTaskFields}`;
export const GetWeeklyBarchartCardContent = gql`
    query getWeeklyBarchartCardContent($id: ID!, $dashboardId: ID!, $dateFrom: Date, $dateTo: Date) {
  metricGroupsAssignment(card: $id) {
    edges {
      node {
        id
        metricGroup {
          id
          title
          description
          metricvalueSet(dashboardId: $dashboardId, dateFrom: $dateFrom, dateTo: $dateTo) {
            edges {
              node {
                id
                date
                value
              }
            }
          }
        }
      }
    }
  }
}
    `;
export const GetMetricGroupsByDashboardCard = gql`
    query getMetricGroupsByDashboardCard($cardId: ID!) {
  metricGroupsAssignment(card: $cardId) {
    edges {
      node {
        id
        metricGroup {
          id
        }
      }
    }
  }
}
    `;
export const GetConversionRates = gql`
    query GetConversionRates($cardId: ID!, $dashboardId: ID!, $date: Date!) {
  conversionRatesTransregional(
    cardId: $cardId
    dashboardId: $dashboardId
    date: $date
  ) {
    regionGroupId
    regionGroup {
      id
      title
    }
    conversionType
    regionAverage
    ordersBelowAverageCount
  }
}
    `;
export const GetPromisesTasks = gql`
    query getPromisesTasks($categoriesKeys: String, $owners: [ID], $date_Gte: Date, $excludeStatuses: String) {
  tasks(
    categoriesKeys: $categoriesKeys
    completedBy: $owners
    date_Gte: $date_Gte
    excludeStatuses: $excludeStatuses
  ) {
    edges {
      node {
        id
        isImportant
        status
        taskEscalations {
          edges {
            node {
              escalatedTo {
                id
                meetingLevel
              }
              escalatedFrom {
                id
                meetingLevel
              }
              id
              task {
                id
              }
            }
          }
        }
        category {
          id
          key
        }
        comment
        order {
          id
          company {
            id
            name
          }
          specification {
            id
            positionTitle
          }
        }
        company {
          id
          name
        }
        date
      }
    }
  }
}
    `;
export const GetOrderCandidateStats = gql`
    query getOrderCandidateStats($orderIds: [ID], $dateFrom: Date, $companyIds: [ID]) {
  candidateOrderStats(
    orderIds: $orderIds
    companyIds: $companyIds
    dateTo: "2029-12-31"
    dateFrom: $dateFrom
  ) {
    orderId
    companyId
    toBeInterviewed
    toBeInterviewedClient
    healthCheckPending
    toBeEmployed
    offeredLast7Days
    offeredFromDate
    healthCheckPending
    presentedClient
    presentedClientSuccess
    presentedClientFailed
    longListedLast7Days
    offeredLast1Day
    longListedLast1Day
  }
}
    `;
export const GetUsersForCurrentAndChildDashboards = gql`
    query getUsersForCurrentAndChildDashboards($parentDashboardId: ID) {
  userprofiles(parentDashboardId: $parentDashboardId) {
    id
  }
}
    `;
export const EscalateTaskToDashboards = gql`
    mutation escalateTaskToDashboards($escalatedFrom: ID, $escalatedTo: [ID]!, $taskId: ID!) {
  escalateTaskToDashboards(
    escalatedFromId: $escalatedFrom
    escalatedToIds: $escalatedTo
    taskId: $taskId
  ) {
    task {
      id
      taskEscalations {
        edges {
          node {
            escalatedTo {
              id
              meetingLevel
            }
            escalatedFrom {
              id
              meetingLevel
            }
            id
            task {
              id
            }
          }
        }
      }
    }
  }
}
    `;
export const UnEscalateTaskToDashboards = gql`
    mutation unEscalateTaskToDashboards($escalation: ID!) {
  unEscalateTaskFromDashboards(escalationId: $escalation) {
    ok
    task {
      id
      taskEscalations {
        edges {
          node {
            escalatedTo {
              id
              meetingLevel
            }
            escalatedFrom {
              id
              meetingLevel
            }
            id
            task {
              id
            }
          }
        }
      }
    }
  }
}
    `;
export const FreeVacanciesCalendarEvents = gql`
    query FreeVacanciesCalendarEvents($dateFrom: Date) {
  plannerEvents(date_Gte: $dateFrom) {
    edges {
      node {
        externalPlatformId
        order {
          id
          specification {
            id
            positionTitle
          }
        }
        ...FreeVacanciesCalendarEventFields
      }
    }
  }
}
    ${FreeVacanciesCalendarEventFields}`;
export const GetFreeVacanciesOrder = gql`
    query getFreeVacanciesOrder($status: String, $first: Int, $after: String, $search: String, $region: String, $sex: String, $trafficGeneration: String, $id: ID, $isLongTerm: Boolean, $nettoFrom: Float, $nettoTo: Float, $orderType: String, $covidPolicy: [ID], $scheduleTypes: String, $canEmployUa: Boolean, $country: ID, $date_Lte: Date, $date_Gte: Date) {
  ordersPaginated(
    status: $status
    first: $first
    after: $after
    search: $search
    region: $region
    sex: $sex
    id: $id
    trafficGeneration: $trafficGeneration
    isLongTerm: $isLongTerm
    nettoFrom: $nettoFrom
    nettoTo: $nettoTo
    orderType: $orderType
    scheduleTypesAll: $scheduleTypes
    country: $country
    covidPolicy: $covidPolicy
    canEmployUa: $canEmployUa
    orderBy: "company__color,company__name"
  ) {
    pageInfo {
      startCursor
      endCursor
      hasNextPage
    }
    totalCount
    edges {
      node {
        id
        canGetBonuses
        canIncreaseSalary
        orderType
        toBeReviewed
        hourRateBruttoPermanent
        salaryInfo
        orderNumber
        orderPeriodFrom
        orderPeriodTo
        orderCanBeExtended
        orderCanBeExtendedComment
        isLongTerm
        demand
        status
        trafficGeneration
        nettoFrom
        nettoTo
        shortage
        isCompanyInternational
        isCompanyModern
        isLogoPublicAllowed
        statsFutureInterview
        clientContact {
          ...ContactFieldsShort
        }
        additionalClientContacts {
          edges {
            node {
              ...ContactFieldsShort
            }
          }
        }
        createdBy {
          id
          user {
            ...UserMainFields
          }
        }
        region {
          id
          title
        }
        company {
          ...CompanyMainFields
        }
        orderperiodSet {
          ...OrderPeriodFields
        }
        specification {
          ...FreeVacanciesSpecificationFields
        }
        eventSet(date_Lte: $date_Lte, date_Gte: $date_Gte) {
          edges {
            node {
              ...MarketingEventsFields
            }
          }
        }
      }
    }
  }
}
    ${ContactFieldsShort}
${UserMainFields}
${CompanyMainFields}
${OrderPeriodFields}
${FreeVacanciesSpecificationFields}
${MarketingEventsFields}`;
export const GetPlannerEvents = gql`
    query getPlannerEvents {
  plannerEvents {
    edges {
      node {
        externalPlatformId
        order {
          id
          specification {
            id
            positionTitle
          }
        }
        ...MarketingEventsFields
      }
    }
  }
}
    ${MarketingEventsFields}`;
export const GetPlannerEventsByOrder = gql`
    query getPlannerEventsByOrder($orderId: ID!, $first: Int, $after: String, $date_Lte: Date, $date_Gte: Date, $ordering: String) {
  plannerEvents(
    order: $orderId
    first: $first
    after: $after
    date_Lte: $date_Lte
    date_Gte: $date_Gte
    ordering: $ordering
  ) {
    pageInfo {
      startCursor
      endCursor
      hasNextPage
    }
    totalCount
    edges {
      node {
        externalPlatformId
        durationMinutes
        price
        order {
          id
          specification {
            id
            positionTitle
          }
        }
        completedBy {
          id
          fullName
          user {
            id
            firstName
            lastName
          }
        }
        ...MarketingEventsFields
      }
    }
  }
}
    ${MarketingEventsFields}`;
export const GetPlannerEventsByCompany = gql`
    query getPlannerEventsByCompany($order_Company: ID!, $first: Int, $after: String, $date_Lte: Date, $date_Gte: Date) {
  plannerEvents(
    order_Company: $order_Company
    first: $first
    after: $after
    date_Lte: $date_Lte
    date_Gte: $date_Gte
  ) {
    pageInfo {
      startCursor
      endCursor
      hasNextPage
    }
    totalCount
    edges {
      node {
        durationMinutes
        price
        externalPlatformId
        order {
          id
          specification {
            id
            positionTitle
          }
        }
        ...MarketingEventsFields
      }
    }
  }
}
    ${MarketingEventsFields}`;
export const InterviewWidgetOffers = gql`
    query InterviewWidgetOffers($sex: String, $personId: Int, $search: String, $region: String, $region_ExternalId: Int, $trafficGeneration: String, $country: String) {
  offers(personId: $personId) {
    edges {
      node {
        ...InterviewWidgetOfferFields
        createdAt
        cancellationreasonassignmentSet {
          edges {
            node {
              id
              cancellationReason {
                id
                title
              }
            }
          }
        }
        offerpropositioncommentSet {
          totalCount
          edges {
            node {
              text
            }
          }
        }
      }
    }
  }
  regions {
    ...InterviewWidgetRegionFields
  }
  ordersPaginated(
    sex: $sex
    search: $search
    region: $region
    region_Country: $country
    region_ExternalId: $region_ExternalId
    trafficGeneration: $trafficGeneration
    orderBy: "company__color"
  ) {
    edges {
      node {
        ...InterviewWidgetOrdersFields
      }
    }
  }
}
    ${InterviewWidgetOfferFields}
${InterviewWidgetRegionFields}
${InterviewWidgetOrdersFields}`;
export const CandidateEventByTimeAndPerson = gql`
    query CandidateEventByTimeAndPerson($livasId: Float!, $orderId: ID!, $eventType: String) {
  candidateEvents(
    candidateLivasId: $livasId
    orderId: $orderId
    eventType: $eventType
  ) {
    edges {
      node {
        ...OfferEventFields
      }
    }
  }
}
    ${OfferEventFields}`;
export const Update = gql`
    mutation update($id: ID!, $status: EventResolutionStatus) {
  eventStatusUpdate(input: {id: $id, resolutionStatus: $status}) {
    event {
      id
    }
  }
}
    `;
export const Sms = gql`
    mutation sms($id: ID!, $sms: String) {
  sendSms(candidateId: $id, text: $sms) {
    ok
  }
}
    `;
export const EventUpdate = gql`
    mutation eventUpdate($id: ID!, $startDatetime: DateTime!) {
  eventUpdate(input: {id: $id, startDatetime: $startDatetime}) {
    event {
      id
    }
  }
}
    `;
export const InterviewWidgetCreateEvent = gql`
    mutation InterviewWidgetCreateEvent($eventType: EventEventType!, $offerPropositions: [ID]!, $startDatetime: DateTime, $livasStatusId: Int, $livasContactDate: Date, $updateLivasOfficeInterviewDate: Boolean, $updateLivasClientInterviewDate: Boolean, $updateLivasEmploymentDate: Boolean) {
  eventCreate(
    input: {eventType: $eventType, offerPropositions: $offerPropositions, startDatetime: $startDatetime, livasStatusId: $livasStatusId, livasContactDate: $livasContactDate, updateLivasOfficeInterviewDate: $updateLivasOfficeInterviewDate, updateLivasClientInterviewDate: $updateLivasClientInterviewDate, updateLivasEmploymentDate: $updateLivasEmploymentDate}
  ) {
    event {
      deleted
      id
      startDatetime
      resolutionStatus
      candidate {
        eventSet(deleted: false) {
          edges {
            node {
              id
              deleted
            }
          }
        }
      }
    }
  }
}
    `;
export const InterviewWidgetEventUpdate = gql`
    mutation InterviewWidgetEventUpdate($eventId: ID!, $eventType: EventEventType!, $offerPropositions: [ID]!, $startDatetime: DateTime, $livasStatusId: Int, $livasContactDate: Date, $updateLivasOfficeInterviewDate: Boolean, $updateLivasClientInterviewDate: Boolean, $updateLivasEmploymentDate: Boolean, $description: String, $isProblematicInterview: Boolean) {
  eventUpdate(
    input: {id: $eventId, eventType: $eventType, offerPropositions: $offerPropositions, startDatetime: $startDatetime, livasStatusId: $livasStatusId, livasContactDate: $livasContactDate, updateLivasOfficeInterviewDate: $updateLivasOfficeInterviewDate, updateLivasClientInterviewDate: $updateLivasClientInterviewDate, updateLivasEmploymentDate: $updateLivasEmploymentDate, description: $description, isProblematicInterview: $isProblematicInterview}
  ) {
    event {
      deleted
      id
      startDatetime
      resolutionStatus
    }
  }
}
    `;
export const InterviewWidgetChangeEventStatusMutation = gql`
    mutation InterviewWidgetChangeEventStatusMutation($eventId: ID!, $resolutionStatus: EventResolutionStatus) {
  eventStatusUpdate(input: {id: $eventId, resolutionStatus: $resolutionStatus}) {
    event {
      deleted
      id
      startDatetime
      resolutionStatus
    }
  }
}
    `;
export const UpdateLivasCandidateStatusByOfferProposition = gql`
    mutation UpdateLivasCandidateStatusByOfferProposition($offerPropositionId: ID!, $livasStatusId: Int!) {
  updateLivasCandidateStatus(
    offerProposition: $offerPropositionId
    livasStatusId: $livasStatusId
  ) {
    ok
  }
}
    `;
export const UpdateLivasOfferPropositionSigned = gql`
    mutation UpdateLivasOfferPropositionSigned($offerPropositionId: ID!) {
  offerPropositionUpdate(input: {id: $offerPropositionId, signed: true}) {
    offerProposition {
      id
      signed
    }
  }
}
    `;
export const UpdateEventProblematicInterview = gql`
    mutation UpdateEventProblematicInterview($id: ID!, $isProblematicInterview: Boolean!, $description: String) {
  eventProblematicInterviewUpdate(
    input: {id: $id, isProblematicInterview: $isProblematicInterview, description: $description}
  ) {
    event {
      id
      description
      isProblematicInterview
    }
  }
}
    `;
export const GetJobAdAiVersions = gql`
    query GetJobAdAIVersions($orderId: Int!) {
  jobAdsContentAi(orderId: $orderId) {
    id
    status
    response
  }
}
    `;
export const LivasJobAds = gql`
    query LivasJobAds($orderId: ID!) {
  livasJobAds(orderId: $orderId) {
    advertTitle
    description2
    descriptionDsc
    requirementsDsc
    offerDsc
    seoTitle
    contactsCount
    updatedAt
    categoryId
    workingHours
    locationId
  }
}
    `;
export const CreateJobAdLivas = gql`
    mutation CreateJobAdLivas($orderId: ID!, $advertTitle: String!, $summary: String, $offerDsc: String!, $descriptionDsc: String!, $requirementsDsc: String!, $seoTitle: String!, $address: String, $companyTitle: String, $categoryId: Int, $locationId: Int, $position: String, $workingHours: String, $salaryFrom: Float, $salaryTo: Float, $salaryType: String) {
  createJobAdLivas(
    orderId: $orderId
    advertTitle: $advertTitle
    summary: $summary
    offerDsc: $offerDsc
    descriptionDsc: $descriptionDsc
    requirementsDsc: $requirementsDsc
    seoTitle: $seoTitle
    address: $address
    companyTitle: $companyTitle
    categoryId: $categoryId
    position: $position
    workingHours: $workingHours
    salaryFrom: $salaryFrom
    salaryTo: $salaryTo
    salaryType: $salaryType
    locationId: $locationId
  ) {
    response
  }
}
    `;
export const JobAdDialogMeta = gql`
    query JobAdDialogMeta {
  jobCategories {
    edges {
      node {
        id
        title
        externalId
      }
    }
  }
  cities {
    edges {
      node {
        id
        title
        externalId
        region {
          id
          externalId
          title
        }
      }
    }
  }
}
    `;
export const Offers = gql`
    query offers($orderId: ID!, $first: Int, $after: String, $orderBy: String, $createdAt_Gte: Date, $createdAt_Lte: Date) {
  offers(
    orderId: $orderId
    first: $first
    after: $after
    orderBy: $orderBy
    createdAt_Gte: $createdAt_Gte
    createdAt_Lte: $createdAt_Lte
  ) {
    pageInfo {
      startCursor
      endCursor
      hasNextPage
      hasPreviousPage
    }
    totalCount
    edges {
      node {
        ...OfferFields
      }
    }
  }
  orderModel(id: $orderId) {
    id
    company {
      id
      country {
        id
        isoCode
      }
    }
  }
}
    ${OfferFields}`;
export const OfferPospositionOffers = gql`
    query OfferPospositionOffers($sex: String, $personId: Int, $region: String, $region_ExternalId: Int, $trafficGeneration: String, $country: String, $orderBy: String) {
  offers(personId: $personId, country: $country, orderBy: $orderBy) {
    edges {
      node {
        ...OfferPropisitionOfferFields
        createdAt
        cancellationreasonassignmentSet {
          edges {
            node {
              ...CancellationReasonAssignmentFields
            }
          }
        }
        offerpropositioncommentSet {
          totalCount
          edges {
            node {
              text
            }
          }
        }
      }
    }
  }
  regions {
    ...OfferPropisitionRegionFields
  }
  ordersPaginated(
    sex: $sex
    region: $region
    region_Country: $country
    region_ExternalId: $region_ExternalId
    trafficGeneration: $trafficGeneration
    orderBy: "company__color"
  ) {
    edges {
      node {
        ...OfferPropisitionOrdersFields
      }
    }
  }
}
    ${OfferPropisitionOfferFields}
${CancellationReasonAssignmentFields}
${OfferPropisitionRegionFields}
${OfferPropisitionOrdersFields}`;
export const CreateOfferPropositionComment = gql`
    mutation CreateOfferPropositionComment($input: CreateOfferPropositionCommentInput!) {
  createOfferPropositionComment(input: $input) {
    offerPropositionComment {
      id
      text
      createdAt
      createdBy {
        id
        user {
          ...UserMainFields
        }
      }
    }
  }
}
    ${UserMainFields}`;
export const OfferPropositionComments = gql`
    query OfferPropositionComments($offerId: ID!) {
  offerPropositionComments(offerProposition: $offerId) {
    edges {
      node {
        id
        text
        createdAt
        createdBy {
          id
          user {
            ...UserMainFields
          }
        }
      }
    }
  }
}
    ${UserMainFields}`;
export const UpdateOfferPropositionComment = gql`
    mutation UpdateOfferPropositionComment($input: UpdateOfferPropositionCommentInput!) {
  updateOfferPropositionComment(input: $input) {
    offerPropositionComment {
      id
      text
    }
  }
}
    `;
export const CreateContact = gql`
    mutation createContact($input: ContactInput!) {
  createContact(input: $input) {
    contact {
      ...ContactFields
    }
  }
}
    ${ContactFields}`;
export const UpdateContact = gql`
    mutation updateContact($id: Int!, $input: ContactInput!) {
  updateContact(id: $id, input: $input) {
    contact {
      ...ContactFields
    }
  }
}
    ${ContactFields}`;
export const CreateOrder = gql`
    mutation createOrder($order: OrderInput!, $periods: [OrderPeriodInput]) {
  createOrder(input: $order, periods: $periods) {
    ok
    order {
      id
    }
  }
}
    `;
export const SubmitOrder2 = gql`
    mutation submitOrder2($input: Int) {
  submitOrder(input: $input) {
    ok
  }
}
    `;
export const UploadOrderForSigning = gql`
    mutation uploadOrderForSigning($id: ID!) {
  initOrderSigning(id: $id) {
    ok
    order {
      id
      status
    }
  }
}
    `;
export const ResendOrderForSigning = gql`
    mutation resendOrderForSigning($id: ID!) {
  resendOrderSigning(id: $id) {
    ok
  }
}
    `;
export const OfferPropositionCreate = gql`
    mutation offerPropositionCreate($input: OfferPropositionCreateMutationInput!) {
  offerPropositionCreate(input: $input) {
    offerProposition {
      id
      comment
      order {
        id
      }
      candidate {
        id
      }
      personId
      interested
      interestedOnCall
      signed
      longListed
    }
  }
}
    `;
export const OfferPropositionUpdate = gql`
    mutation offerPropositionUpdate($input: OfferPropositionUpdateMutationInput!) {
  offerPropositionUpdate(input: $input) {
    offerProposition {
      id
      comment
      order {
        id
      }
      candidate {
        id
      }
      personId
      interested
      interestedOnCall
      signed
      longListed
    }
  }
}
    `;
export const CreateOrderComment = gql`
    mutation createOrderComment($comment: String!, $orderId: ID!) {
  createOrderComment(input: {comment: $comment, order: $orderId}) {
    orderComment {
      ...OrderCommentFields
    }
  }
}
    ${OrderCommentFields}`;
export const ClientInterviewCreate = gql`
    mutation clientInterviewCreate($clientInterview: ClientInterviewCreateMutationInput!) {
  clientInterviewCreate(input: $clientInterview) {
    clientInterview {
      id
    }
  }
}
    `;
export const ClientInterviewUpdate = gql`
    mutation clientInterviewUpdate($clientInterview: ClientInterviewUpdateMutationInput!) {
  clientInterviewUpdate(input: $clientInterview) {
    clientInterview {
      id
    }
  }
}
    `;
export const OrderDocumentCreate = gql`
    mutation OrderDocumentCreate($orderId: ID!, $documentDate: Date, $confirmationMethod: DocumentConfirmationMethod!, $orderPeriodIds: [ID!]!) {
  sendOrderDocumentToClient(
    input: {order: $orderId, documentDate: $documentDate, confirmationMethod: $confirmationMethod, orderPeriods: $orderPeriodIds}
  ) {
    document {
      ...CreateOrderDocumentFields
    }
  }
}
    ${CreateOrderDocumentFields}`;
export const SaveRequirementsMutation = gql`
    mutation SaveRequirementsMutation($input: [CandidateRequirementsEvaluationInput!]!) {
  saveRequirements(inputList: $input) {
    candidateRequirementsEvaluations {
      ...CandidateRequirementsEvaluationFields
    }
  }
}
    ${CandidateRequirementsEvaluationFields}`;
export const SendOrderSummariesMutation = gql`
    mutation SendOrderSummariesMutation($companyId: ID, $dateFrom: Date, $dateTo: Date, $orderIds: [ID], $emails: [String]) {
  sendOrderSummaries(
    companyId: $companyId
    dateFrom: $dateFrom
    dateTo: $dateTo
    orderIds: $orderIds
    emails: $emails
  ) {
    ok
  }
}
    `;
export const CreateOrderClientContacted = gql`
    mutation CreateOrderClientContacted($order: ID!, $date: Date!) {
  createOrderClientContacted(input: {order: $order, date: $date}) {
    orderClientContacted {
      id
      date
      createdBy {
        id
        fullName
        color
        profileImage
      }
    }
  }
}
    `;
export const CreateOrderError = gql`
    mutation CreateOrderError($order: ID!, $category: ID!, $comment: String!) {
  createOrderError(input: {order: $order, category: $category, comment: $comment}) {
    orderError {
      id
      comment
    }
  }
}
    `;
export const GetOrderForTaskCreate = gql`
    query getOrderForTaskCreate($id: Int) {
  order(id: $id) {
    id
    company {
      ...CompanyTypeFields
    }
    specification {
      positionTitle
    }
  }
}
    ${CompanyTypeFields}`;
export const GetSpecifications = gql`
    query getSpecifications($id: Int) {
  specification(id: $id) {
    ...SpecificationDetailFields
    certificates {
      id
    }
    optionalRequirements {
      id
    }
    personalProtectiveEquipmentBiuro {
      id
    }
    personalProtectiveEquipmentClient {
      id
    }
    riskFactors {
      id
    }
  }
}
    ${SpecificationDetailFields}`;
export const GetPaginatedOrderForTable = gql`
    query getPaginatedOrderForTable($status: String, $first: Int, $after: String, $search: String, $region: String, $specification: String, $unseenProcessedOrders: Boolean, $companies: String, $orderBy: String, $orderType: String, $keyAccountManager: ID, $trafficGeneration: String, $covidPolicy: [ID], $country: ID, $periodDateFrom: Date, $periodDateTo: Date) {
  regions {
    ...RegionsList2Fields
  }
  ordersPaginated(
    status: $status
    first: $first
    after: $after
    search: $search
    region: $region
    specification: $specification
    unseenProcessedOrders: $unseenProcessedOrders
    companies: $companies
    orderBy: $orderBy
    orderType: $orderType
    keyAccountManager: $keyAccountManager
    trafficGeneration: $trafficGeneration
    covidPolicy: $covidPolicy
    country: $country
    periodDateFrom: $periodDateFrom
    periodDateTo: $periodDateTo
  ) {
    pageInfo {
      startCursor
      endCursor
      hasNextPage
    }
    totalCount
    edges {
      node {
        ...OrdersList2Fields
      }
    }
  }
}
    ${RegionsList2Fields}
${OrdersList2Fields}`;
export const GetOrderForTaskCreateSearch = gql`
    query getOrderForTaskCreateSearch($search: String, $first: Int) {
  ordersPaginated(search: $search, first: $first) {
    edges {
      node {
        id
        company {
          ...CompanyTypeFields
        }
        specification {
          positionTitle
        }
      }
    }
  }
}
    ${CompanyTypeFields}`;
export const GetOrderComments = gql`
    query getOrderComments($orderId: ID) {
  orderComments(orderId: $orderId) {
    edges {
      node {
        ...OrderCommentFields
      }
    }
  }
}
    ${OrderCommentFields}`;
export const GetOrderPeriods = gql`
    query getOrderPeriods($orderId: ID!) {
  orderModel(id: $orderId) {
    id
    orderperiodSet {
      ...OrderPeriodFields
    }
  }
}
    ${OrderPeriodFields}`;
export const GetUserProfiles = gql`
    query getUserProfiles {
  userprofiles {
    ...UserProfileFields
  }
}
    ${UserProfileFields}`;
export const GetUserProfileCountry = gql`
    query getUserProfileCountry {
  userprofile {
    region {
      country {
        id
        isoCode
      }
    }
  }
}
    `;
export const GetLastOrdersCreated = gql`
    query getLastOrdersCreated($companyId: ID!, $orderBy: String) {
  orders(company: $companyId, orderBy: $orderBy) {
    edges {
      node {
        ...OrderSelectListFields
      }
    }
  }
}
    ${OrderSelectListFields}`;
export const OrderEditCompanyData = gql`
    query OrderEditCompanyData($companyId: ID!) {
  userprofiles {
    ...UserProfileFields
  }
  regions {
    ...RegionsList2Fields
  }
  company(id: $companyId) {
    ...CompanyModelMetaFields
  }
}
    ${UserProfileFields}
${RegionsList2Fields}
${CompanyModelMetaFields}`;
export const OrderEditMetadata = gql`
    query OrderEditMetadata($companyId: ID!) {
  userprofiles {
    ...UserProfileFields
  }
  regions {
    ...RegionsList2Fields
  }
  companies(id: $companyId) {
    pageInfo {
      startCursor
      endCursor
      hasNextPage
    }
    totalCount
    edges {
      node {
        ...CompanyMetaFields
      }
    }
  }
}
    ${UserProfileFields}
${RegionsList2Fields}
${CompanyMetaFields}`;
export const GetOrderForPrefill = gql`
    query getOrderForPrefill($id: ID!) {
  orderModel(id: $id) {
    ...BaseOrderFields
    ordererrorSet {
      edges {
        node {
          id
          comment
          category {
            title
          }
          createdAt
        }
      }
    }
  }
}
    ${BaseOrderFields}`;
export const GetRegionsRelay = gql`
    query getRegionsRelay($country: ID!) {
  regionsRelay(country: $country) {
    edges {
      node {
        id
        title
        isActive
        country {
          id
          title
          isoCode
        }
      }
    }
    totalCount
  }
}
    `;
export const GetOrderDocuments = gql`
    query getOrderDocuments($id: ID!) {
  documents(order: $id, orderBy: "-create_date") {
    edges {
      node {
        ...OrderDocumentFields
      }
    }
  }
}
    ${OrderDocumentFields}`;
export const GetOrderRequirementsAndCandidateEvaluations = gql`
    query getOrderRequirementsAndCandidateEvaluations($orderId: ID!, $offerPropositionId: ID!) {
  orderModel(id: $orderId) {
    id
    language
    specification {
      id
      mandatoryRequirements {
        id
        requirement
      }
    }
  }
  candidateEvaluations(offerProposition: $offerPropositionId) {
    edges {
      node {
        id
        requirement {
          id
          requirement
        }
        recordType
        description
      }
    }
  }
}
    `;
export const GetCandidateName = gql`
    query getCandidateName($livasId: Int!) {
  candidate(livasId: $livasId) {
    id
    livasId
    firstName
    lastName
  }
}
    `;
export const GetCandidatesEvaluations = gql`
    query getCandidatesEvaluations($orderId: ID!) {
  candidateEvaluations(order: $orderId) {
    edges {
      node {
        id
        offerProposition {
          id
          candidate {
            id
            livasId
            firstName
            lastName
            country {
              id
              isoCode
            }
          }
        }
        requirement {
          id
          requirement
        }
        recordType
        description
      }
    }
  }
  orderModel(id: $orderId) {
    id
    language
    specification {
      id
      mandatoryRequirements {
        id
        requirement
      }
    }
  }
}
    `;
export const GetOrderErrorCategories = gql`
    query getOrderErrorCategories($isActive: Boolean) {
  orderErrorCategories(isActive: $isActive) {
    edges {
      node {
        id
        title
      }
    }
  }
}
    `;
export const GetFilterRegion = gql`
    query getFilterRegion {
  userprofile {
    id
    region {
      country {
        id
        isoCode
      }
    }
  }
}
    `;
export const CreateOperationsTask = gql`
    mutation CreateOperationsTask($company: ID, $country: ID, $category: ID, $nextActionCategory: ID, $order: ID, $date: Date!, $comment: String!, $completedBy: [ID], $durationMinutes: Int, $status: TaskStatus, $sendNotificationToAssignee: Boolean, $dashboard: ID, $nextTaskAssignee: ID, $candidateLivasEmployeeId: ID, $dashboards: [ID]) {
  createOperationsTask(
    input: {company: $company, country: $country, date: $date, comment: $comment, completedBy: $completedBy, durationMinutes: $durationMinutes, order: $order, status: $status, category: $category, nextActionCategory: $nextActionCategory, sendNotificationToAssignee: $sendNotificationToAssignee, dashboard: $dashboard, nextTaskAssignee: $nextTaskAssignee, candidateLivasEmployeeId: $candidateLivasEmployeeId, dashboards: $dashboards}
  ) {
    task {
      ...OperationsTaskFields
      dashboards {
        edges {
          node {
            id
            title
          }
        }
      }
    }
  }
}
    ${OperationsTaskFields}`;
export const CreateMetricValueComment = gql`
    mutation CreateMetricValueComment($metricValue: ID!, $comment: String) {
  createMetricValueComment(input: {metricValue: $metricValue, comment: $comment}) {
    metricValueComment {
      id
    }
  }
}
    `;
export const CreateMetricValueInput = gql`
    mutation CreateMetricValueInput($client: ID, $createdBy: ID, $date: Date!, $isImportant: Boolean!, $manager: ID, $metricGroup: ID!, $order: ID, $value: Float!) {
  createMetricValue(
    input: {client: $client, createdBy: $createdBy, date: $date, isImportant: $isImportant, manager: $manager, metricGroup: $metricGroup, order: $order, value: $value}
  ) {
    metricValue {
      id
    }
  }
}
    `;
export const UpdateOperationsTask = gql`
    mutation UpdateOperationsTask($taskId: ID!, $status: TaskStatus, $order: ID, $company: ID, $category: ID, $date: Date, $comment: String, $completedBy: [ID], $durationMinutes: Int, $country: ID, $nextActionCategory: ID, $nextActionDate: Date, $dashboard: ID, $nextTaskAssignee: ID, $isImportant: Boolean, $dashboards: [ID]) {
  updateOperationsTask(
    input: {id: $taskId, order: $order, status: $status, company: $company, date: $date, comment: $comment, completedBy: $completedBy, durationMinutes: $durationMinutes, category: $category, country: $country, nextActionCategory: $nextActionCategory, nextActionDate: $nextActionDate, dashboard: $dashboard, nextTaskAssignee: $nextTaskAssignee, isImportant: $isImportant, dashboards: $dashboards}
  ) {
    task {
      ...OperationsTaskFields
      isImportant
      dashboards {
        edges {
          node {
            id
            title
          }
        }
      }
    }
  }
}
    ${OperationsTaskFields}`;
export const CreateTaskCopy = gql`
    mutation CreateTaskCopy($input: CreateTaskCopyInput!) {
  createTaskCopy(input: $input) {
    task {
      ...OperationsTaskFields
      dashboards {
        edges {
          node {
            id
            title
          }
        }
      }
    }
  }
}
    ${OperationsTaskFields}`;
export const CreateTaskSchedule = gql`
    mutation CreateTaskSchedule($input: CreateScheduleInput!) {
  createTaskSchedule(input: $input) {
    schedule {
      ...TaskScheduleFields
    }
  }
}
    ${TaskScheduleFields}`;
export const UpdateTaskSchedule = gql`
    mutation UpdateTaskSchedule($input: UpdateScheduleInput!) {
  updateTaskSchedule(input: $input) {
    schedule {
      ...TaskScheduleFields
    }
  }
}
    ${TaskScheduleFields}`;
export const TaskCustomFieldUpdateValues = gql`
    mutation TaskCustomFieldUpdateValues($taskId: ID!, $customFieldValues: [CustomFieldValueInput!]!) {
  createUpdateCustomFieldValues(
    taskId: $taskId
    customFieldValues: $customFieldValues
  ) {
    customFieldValues {
      id
      task {
        id
      }
      customField {
        id
      }
      textValue
      numericValue
      urlValue
      dateValue
      boolValue
    }
  }
}
    `;
export const DeleteTask = gql`
    mutation DeleteTask($taskId: ID!) {
  deleteTask(input: {id: $taskId}) {
    task {
      id
    }
  }
}
    `;
export const GetOverdueTasks = gql`
    query GetOverdueTasks($orderBy: String, $first: Int, $after: String, $date_Lte: Date, $date_Gte: Date, $country: ID, $company: ID, $category: [ID], $statuses: String, $search: String, $owners: [ID], $dashboardId: ID, $cardId: ID, $categoriesKeys: String, $excludeCategoriesKeys: String, $excludeStatuses: String, $isImportant: Boolean, $isFromMetric: Boolean, $dashboards: [ID], $ownerDashboardMode: String) {
  tasks(
    orderBy: $orderBy
    first: $first
    after: $after
    date_Lte: $date_Lte
    date_Gte: $date_Gte
    country: $country
    company: $company
    statuses: $statuses
    completedBy: $owners
    categories: $category
    search: $search
    dashboard: $dashboardId
    cardId: $cardId
    categoriesKeys: $categoriesKeys
    excludeCategoriesKeys: $excludeCategoriesKeys
    excludeStatuses: $excludeStatuses
    isImportant: $isImportant
    isFromMetric: $isFromMetric
    dashboards: $dashboards
    ownerDashboardMode: $ownerDashboardMode
  ) {
    totalCount
    edges {
      node {
        ...OverdueTaskTableFields
        isImportant
        dashboards {
          edges {
            node {
              id
              title
            }
          }
        }
      }
    }
  }
}
    ${OverdueTaskTableFields}`;
export const GetMeetingTasks = gql`
    query GetMeetingTasks($orderBy: String, $first: Int, $after: String, $country: ID, $company: ID, $category: [ID], $statuses: String, $search: String, $owners: [ID], $dashboardId: ID, $categoriesKeys: String, $excludeCategoriesKeys: String, $excludeStatuses: String, $includeChildDashboards: Boolean, $dashboards: [ID]) {
  tasks(
    orderBy: $orderBy
    first: $first
    after: $after
    country: $country
    company: $company
    statuses: $statuses
    completedBy: $owners
    categories: $category
    search: $search
    dashboard: $dashboardId
    categoriesKeys: $categoriesKeys
    excludeCategoriesKeys: $excludeCategoriesKeys
    excludeStatuses: $excludeStatuses
    includeChildDashboards: $includeChildDashboards
    dashboards: $dashboards
  ) {
    totalCount
    edges {
      node {
        ...MeetingTaskTableFields
        dashboards {
          edges {
            node {
              id
              title
            }
          }
        }
      }
    }
  }
}
    ${MeetingTaskTableFields}`;
export const GetDynamicDashboardTasks = gql`
    query GetDynamicDashboardTasks($orderBy: String, $first: Int, $after: String, $date_Lte: Date, $date_Gte: Date, $country: ID, $company: ID, $category: [ID], $statuses: String, $search: String, $owners: [ID], $dashboardId: ID, $categoriesKeys: String, $excludeCategoriesKeys: String, $excludeStatuses: String, $includeChildDashboards: Boolean, $customFields: String, $dashboards: [ID]) {
  tasks(
    orderBy: $orderBy
    first: $first
    after: $after
    date_Lte: $date_Lte
    date_Gte: $date_Gte
    country: $country
    company: $company
    statuses: $statuses
    completedBy: $owners
    categories: $category
    search: $search
    dashboard: $dashboardId
    categoriesKeys: $categoriesKeys
    excludeCategoriesKeys: $excludeCategoriesKeys
    excludeStatuses: $excludeStatuses
    includeChildDashboards: $includeChildDashboards
    customFields: $customFields
    dashboards: $dashboards
  ) {
    totalCount
    edges {
      node {
        ...DynamicDashboardTaskTableFields
        dashboards {
          edges {
            node {
              id
              title
            }
          }
        }
      }
    }
  }
}
    ${DynamicDashboardTaskTableFields}`;
export const GetOperationsTasks = gql`
    query GetOperationsTasks($orderBy: String, $first: Int, $after: String, $date_Lte: Date, $date_Gte: Date, $country: ID, $company: ID, $category: [ID], $statuses: String, $search: String, $owners: [ID], $dashboardId: ID, $firstTimeCall: Boolean, $noOwners: Boolean, $dashboards: [ID]) {
  tasks(
    orderBy: $orderBy
    first: $first
    after: $after
    date_Lte: $date_Lte
    date_Gte: $date_Gte
    country: $country
    company: $company
    statuses: $statuses
    completedBy: $owners
    categories: $category
    search: $search
    dashboard: $dashboardId
    firstTimeSameCategoryPerCandidate: $firstTimeCall
    noOwners: $noOwners
    dashboards: $dashboards
  ) {
    totalCount
    edges {
      node {
        ...OperationsTaskFields
        dashboards {
          edges {
            node {
              id
              title
            }
          }
        }
      }
    }
  }
}
    ${OperationsTaskFields}`;
export const GetNextTaskDate = gql`
    query GetNextTaskDate($id: ID!) {
  nextTaskDate(taskGlobalId: $id) {
    date
    message
  }
}
    `;
export const GetOperationsTask = gql`
    query GetOperationsTask($id: ID!) {
  task(id: $id) {
    ...TaskDetailViewFields
    dashboards {
      edges {
        node {
          id
          title
        }
      }
    }
  }
}
    ${TaskDetailViewFields}`;
export const GetTaskCustomFieldValuesAndCategories = gql`
    query GetTaskCustomFieldValuesAndCategories($taskId: ID!) {
  task(id: $taskId) {
    id
    customFieldValues {
      edges {
        node {
          ...CustomFieldsValuesFields
        }
      }
    }
  }
  selectionActionCategoryGroups {
    totalCount
    edges {
      node {
        ...SACategoryGroupsFields
      }
    }
  }
}
    ${CustomFieldsValuesFields}
${SaCategoryGroupsFields}`;
export const GetCustomFieldValuesByTasks = gql`
    query GetCustomFieldValuesByTasks($taskIds: [ID], $keys: String) {
  customFieldValues(taskIds: $taskIds, keys: $keys) {
    edges {
      node {
        id
        customField {
          id
          key
          options
        }
        task {
          id
        }
        numericValue
        textValue
      }
    }
  }
}
    `;
export const GetTasksByCandidateAndCategory = gql`
    query GetTasksByCandidateAndCategory($candidateId: ID!, $categoryId: ID!) {
  tasks(candidate: $candidateId, category: $categoryId) {
    totalCount
    edges {
      node {
        ...OperationsTaskFieldsNew
        dashboards {
          edges {
            node {
              id
              title
            }
          }
        }
      }
    }
  }
}
    ${OperationsTaskFieldsNew}`;
export const GetReservedTimes = gql`
    query getReservedTimes {
  reservedTimes {
    edges {
      node {
        title
        dayOfTheWeek
        region {
          id
          title
        }
        timeFrom
        timeTo
      }
    }
  }
}
    `;
export const GetRequestActivities = gql`
    query getRequestActivities($createdBy: String, $createdAt_Gte: Date, $createdAt_Lte: Date, $phone: String, $first: Int, $after: String, $orderBy: String) {
  requestsActivities(
    createdBy: $createdBy
    createdAt_Gte: $createdAt_Gte
    createdAt_Lte: $createdAt_Lte
    phone: $phone
    first: $first
    after: $after
    orderBy: $orderBy
  ) {
    totalCount
    pageInfo {
      endCursor
    }
    edges {
      cursor
      node {
        id
        createdAt
        createdBy {
          fullName
        }
        contact {
          firstName
          lastName
        }
        clientContact {
          firstName
          lastName
          company {
            name
          }
        }
        phone
        reason {
          title
        }
        comment
      }
    }
  }
}
    `;
export const UpdateContactRequestActivity = gql`
    mutation updateContactRequestActivity($input: UpdateRequestsActivityInput!) {
  updateRequestsActivity(input: $input) {
    requestsActivity {
      id
      comment
      phone
      reason {
        id
        title
      }
    }
  }
}
    `;
export const GetAllReasons = gql`
    query getAllReasons($id: ID) {
  allReasons(id: $id) {
    edges {
      node {
        id
        title
      }
    }
  }
}
    `;
export const GetRiskFactors = gql`
    query getRiskFactors($title: String, $country: ID) {
  riskFactors(title: $title, country: $country) {
    id
    title
    isDefault
    country {
      id
      isoCode
    }
  }
}
    `;
export const CreateSeletionAction = gql`
    mutation CreateSeletionAction($orderId: ID!, $comment: String!, $category: ID, $durationMinutes: Int, $date: Date!, $completedBy: [ID]) {
  createSelectionAction(
    input: {order: $orderId, comment: $comment, category: $category, durationMinutes: $durationMinutes, date: $date, completedBy: $completedBy}
  ) {
    task {
      ...SelectionActionListItemFields
    }
  }
}
    ${SelectionActionListItemFields}`;
export const UpdateSeletionAction = gql`
    mutation UpdateSeletionAction($id: ID!, $comment: String!, $date: Date!, $category: ID, $durationMinutes: Int, $completedBy: [ID], $status: TaskStatus) {
  updateSelectionAction(
    input: {id: $id, comment: $comment, category: $category, durationMinutes: $durationMinutes, date: $date, completedBy: $completedBy, status: $status}
  ) {
    task {
      ...SelectionActionListItemFields
    }
  }
}
    ${SelectionActionListItemFields}`;
export const DeleteSeletionAction = gql`
    mutation DeleteSeletionAction($id: ID!) {
  deleteSelectionAction(input: {id: $id}) {
    task {
      id
    }
  }
}
    `;
export const GetSelectionActions = gql`
    query GetSelectionActions($orderId: ID, $company: ID, $orderBy: String, $date_Lte: Date, $date_Gte: Date, $categories: [ID]) {
  tasks(
    order: $orderId
    company: $company
    orderBy: $orderBy
    date_Lte: $date_Lte
    date_Gte: $date_Gte
    categories: $categories
  ) {
    totalCount
    edges {
      node {
        ...SelectionActionListItemFields
      }
    }
  }
}
    ${SelectionActionListItemFields}`;
export const GetSelectionActionGroupedCategories = gql`
    query GetSelectionActionGroupedCategories($country: ID) {
  selectionActionCategoryGroups(country: $country) {
    totalCount
    edges {
      node {
        ...SACategoryGroupsFields
      }
    }
  }
}
    ${SaCategoryGroupsFields}`;
export const CreateSpecification = gql`
    mutation createSpecification($input: SpecificationInput!, $companyId: ID!) {
  createSpecification(input: $input, companyId: $companyId) {
    specification {
      ...SpecificationDetailFields
    }
  }
}
    ${SpecificationDetailFields}`;
export const SpecificationUpdate = gql`
    mutation specificationUpdate($input: SpecificationModelUpdateMutationInput!) {
  specificationUpdate(input: $input) {
    specification {
      ...SpecificationDetailFields
    }
  }
}
    ${SpecificationDetailFields}`;
export const SpecificationCreate = gql`
    mutation specificationCreate($input: SpecificationModelCreateMutationInput!) {
  specificationCreate(input: $input) {
    specification {
      ...SpecificationDetailFields
    }
    errors {
      field
      message
    }
  }
}
    ${SpecificationDetailFields}`;
export const UpdateSpecification = gql`
    mutation updateSpecification($specification: SpecificationInput!, $id: ID!) {
  updateSpecification(input: $specification, id: $id) {
    specification {
      ...SpecificationDetailFields
    }
  }
}
    ${SpecificationDetailFields}`;
export const CreateRequirement = gql`
    mutation createRequirement($englishValue: String, $localValue: String, $country: ID) {
  createRequirement(
    englishValue: $englishValue
    localValue: $localValue
    country: $country
  ) {
    requirement {
      ...RequirementFields
    }
  }
}
    ${RequirementFields}`;
export const UpdateCompany = gql`
    mutation updateCompany($id: Int!, $livasId: Int, $contractorId: ID!) {
  updateCompany(id: $id, livasId: $livasId, contractorId: $contractorId) {
    ok
    company {
      ...CompanyDetailFields
    }
  }
}
    ${CompanyDetailFields}`;
export const CreateCompany = gql`
    mutation createCompany($company: CompanyInput!) {
  createCompany(input: $company) {
    ok
    company {
      ...CompanyDetailFields
    }
  }
}
    ${CompanyDetailFields}`;
export const CopySpecification = gql`
    mutation copySpecification($id: Int!) {
  copySpecification(input: $id) {
    specification {
      id
    }
  }
}
    `;
export const Competences = gql`
    query competences($country: ID) {
  competences(country: $country) {
    edges {
      node {
        id
        title
        color
      }
    }
  }
}
    `;
export const TagGroups = gql`
    query tagGroups($country: ID) {
  tagsGroups(country: $country) {
    key
    tagSet {
      ...TagsFields
    }
  }
}
    ${TagsFields}`;
export const GetTagsGroupsWithPpe = gql`
    query getTagsGroupsWithPPE($country: ID) {
  tagsGroups(country: $country) {
    id
    key
    tagSet {
      ...TagsFields
    }
  }
  personalProtectiveEquipment(country: $country) {
    ...PPEFields
  }
}
    ${TagsFields}
${PpeFields}`;
export const Requirements = gql`
    query requirements($requirement: String, $country: ID, $language: String) {
  requirements(requirement: $requirement, country: $country, language: $language) {
    id
    requirement
  }
}
    `;
export const Certificates = gql`
    query certificates($country: ID, $language: String) {
  certificates(country: $country, language: $language) {
    title
    id
  }
}
    `;
export const OrderCandidateStats = gql`
    query OrderCandidateStats($orderIds: [ID], $dateFrom: Date) {
  candidateOrderStats(
    orderIds: $orderIds
    dateTo: "2029-12-31"
    dateFrom: $dateFrom
  ) {
    ...OrderListCandidatesStatsFields
  }
}
    ${OrderListCandidatesStatsFields}`;
export const CandidateEventsForOrder = gql`
    query CandidateEventsForOrder($orderId: ID, $eventType: String) {
  candidateEvents(
    orderId: $orderId
    eventType: $eventType
    orderBy: "-start_datetime"
    first: 100
  ) {
    edges {
      node {
        ...CandidateEventsFields
      }
    }
  }
}
    ${CandidateEventsFields}`;
export const CandidateEventsForTable = gql`
    query CandidateEventsForTable($candidate: ID) {
  candidateEvents(candidate: $candidate) {
    edges {
      node {
        ...CandidateEventsFields
      }
    }
  }
}
    ${CandidateEventsFields}`;
export const OrderStats = gql`
    query OrderStats($orderId: Int, $dateTo: Date, $dateFrom: Date) {
  offerPropositionStats(orderId: $orderId, dateTo: $dateTo, dateFrom: $dateFrom) {
    ...OrderStatsFields
  }
}
    ${OrderStatsFields}`;
export const GetMe = gql`
    query GetMe {
  me {
    ...MeFields
  }
}
    ${MeFields}`;
export const CheckSuperuserRights = gql`
    query checkSuperuserRights {
  me {
    user {
      isSuperuser
    }
  }
}
    `;